// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"gDrcj":[function(require,module,exports,__globalThis) {
var _indexLoaded = require("@/indexLoaded");
(0, _indexLoaded.indexLoaded)();

},{"@/indexLoaded":"4uRGf"}],"4uRGf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "indexLoaded", ()=>indexLoaded);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _client = require("react-dom/client");
var _app = require("@/app/App");
var _appDefault = parcelHelpers.interopDefault(_app);
function indexLoaded() {
    const container = document.getElementById("app");
    if (!container) throw new Error("No container found");
    const root = (0, _client.createRoot)(container);
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.StrictMode), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {})
    }));
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","react-dom/client":"iMUP7","@/app/App":"jri1T","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1xKTF":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d3cc7009e73a7470");

},{"d3cc7009e73a7470":"c1tMP"}],"c1tMP":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"erQJb":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("6c7cf85beaa2d6d4");

},{"6c7cf85beaa2d6d4":"4WPJk"}],"4WPJk":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.2.4";

},{}],"iMUP7":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("3e2f0592ef1ae779");

},{"3e2f0592ef1ae779":"jm1O5"}],"jm1O5":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("34889e2d9d2e5ad0"), React = require("4ca5dbf165264c00"), ReactDOM = require("d9c4e38f4a220051");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    track(element);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    track(element);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function noop$1() {}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM) {
        var isSupported$jscomp$inline_427 = "oninput" in document;
        if (!isSupported$jscomp$inline_427) {
            var element$jscomp$inline_428 = document.createElement("div");
            element$jscomp$inline_428.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
        }
        JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber, !0);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
function resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
        throw x;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushDehydratedActivitySuspenseHandler(fiber) {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
}
function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        onActionError(actionQueue, node, error$66);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
        destroy: void 0
    }, actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function noop() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$69 = enqueueUpdate(provider, fiber, lane);
                null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
};
ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
var HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
var HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnRerender.useEffectEvent = updateEvent;
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function mountActivityChildren(workInProgress, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if (isHydrating) {
            if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
            pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error(formatProdErrorMessage(558));
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
            nextProps = workInProgressRoot;
            if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
            renderDidSuspendDelayIfPossible();
            workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, nextProps));
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(nextPrimaryChildren.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    push(suspenseStackCursor, suspenseContext);
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(current) || current;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                pushProvider(workInProgress, CacheContext, props);
                props !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError($$typeof);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), props[internalInstanceKey] = workInProgress, props[internalPropsKey] = current, setInitialProperties(props, renderLanes, current), markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(props.firstChild), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = $$typeof);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, props.value), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = prevState.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[internalInstanceKey] = workInProgress;
                    nextResource[internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch(setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress, !0);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error(formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error(formatProdErrorMessage(557));
                        current[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now(), current.sibling = null, renderLanes = suspenseStackCursor.current, push(suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            retryIfBlockedOn(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 31:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, !0) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
}
function requestDeferredLane() {
    if (0 === workInProgressDeferredLane) {
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
            var lane = nextTransitionDeferredLane;
            nextTransitionDeferredLane <<= 1;
            0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
            workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
    }
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: noop$1
        };
        accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
        timeoutOffset = waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$170, root$170 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++){
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1579, "on" + capitalizedEvent$jscomp$inline_1580);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(hydrationInstance);
}
function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$243 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$249)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var estimatedBytesWithinLimit = 0;
function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane();
        lane = getBumpedLaneForHydrationByLane(lane);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1840 = React.version;
if ("19.2.4" !== isomorphicReactPackageVersion$jscomp$inline_1840) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber) try {
        rendererID = hook$jscomp$inline_2348.inject(internals$jscomp$inline_2347), injectedHook = hook$jscomp$inline_2348;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.2.4";

},{"34889e2d9d2e5ad0":"fHUHx","4ca5dbf165264c00":"erQJb","d9c4e38f4a220051":"kVyn3"}],"fHUHx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e6285b476bd633d9");

},{"e6285b476bd633d9":"jio3Y"}],"jio3Y":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"kVyn3":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("f5dc546b1b485681");

},{"f5dc546b1b485681":"8OHxx"}],"8OHxx":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("cac5e30c76bdcd20");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.2.4";

},{"cac5e30c76bdcd20":"erQJb"}],"jri1T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Main);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _stylesLayerCss = require("@mantine/core/styles.layer.css");
var _stylesLayerCss1 = require("@mantine/notifications/styles.layer.css");
var _stylesLayerCss2 = require("mantine-datatable/styles.layer.css");
var _appScss = require("@/app/app.scss");
var _routes = require("@/app/Routes");
var _routesDefault = parcelHelpers.interopDefault(_routes);
function Main() {
    const $ = (0, _compilerRuntime.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "root",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _routesDefault.default), {})
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core/styles.layer.css":"kVCqQ","@mantine/notifications/styles.layer.css":"bfIIW","mantine-datatable/styles.layer.css":"iNXF9","@/app/app.scss":"iqm5T","@/app/Routes":"2mbD8","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6JKhP":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
module.exports = require("773c7e4c3b4d06df");

},{"773c7e4c3b4d06df":"6DFqx"}],"6DFqx":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-compiler-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactSharedInternals = require("68dcdc2664c53bd9").__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
exports.c = function(size) {
    return ReactSharedInternals.H.useMemoCache(size);
};

},{"68dcdc2664c53bd9":"erQJb"}],"kVCqQ":[function() {},{}],"bfIIW":[function() {},{}],"iNXF9":[function() {},{}],"iqm5T":[function() {},{}],"2mbD8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Routes);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _react = require("react");
var _wouter = require("wouter");
var _mainLayout = require("@/shared/components/MainLayout");
var _mainLayoutDefault = parcelHelpers.interopDefault(_mainLayout);
var _notFoundPage = require("@/shared/components/NotFoundPage");
var _notFoundPageDefault = parcelHelpers.interopDefault(_notFoundPage);
var _adminAuthGuard = require("@/features/admin/components/AdminAuthGuard");
var _adminAuthGuardDefault = parcelHelpers.interopDefault(_adminAuthGuard);
var _adminLayout = require("@/features/admin/components/AdminLayout");
var _adminLayoutDefault = parcelHelpers.interopDefault(_adminLayout);
const Wizard = /*#__PURE__*/ (0, _react.lazy)(()=>require("c58033bbb81c027a"));
const AdminLogin = /*#__PURE__*/ (0, _react.lazy)(()=>require("37d5e8649019c145"));
const Admin = /*#__PURE__*/ (0, _react.lazy)(()=>require("8bf480619126c596"));
const AdminQueueJobs = /*#__PURE__*/ (0, _react.lazy)(()=>require("929e7d0a52a7b7cb"));
const AdminDataArchives = /*#__PURE__*/ (0, _react.lazy)(()=>require("3f2bc7b159cc6663"));
const AdminTestGemini = /*#__PURE__*/ (0, _react.lazy)(()=>require("4104df1b34f579f1"));
const AdminConfigs = /*#__PURE__*/ (0, _react.lazy)(()=>require("f91c3f6a57b2d470"));
const AdminConfigValue = /*#__PURE__*/ (0, _react.lazy)(()=>require("8f03296506b80f6b"));
const AdminConfigSchema = /*#__PURE__*/ (0, _react.lazy)(()=>require("ab8711beb7f92e26"));
const AdminStats = /*#__PURE__*/ (0, _react.lazy)(()=>require("a2ff9ea756741dd1"));
const PhotoView = /*#__PURE__*/ (0, _react.lazy)(()=>require("d12c40ac6f6626d5"));
const SocialWall = /*#__PURE__*/ (0, _react.lazy)(()=>require("696ea006a08f615e"));
function Routes() {
    const $ = (0, _compilerRuntime.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
            path: "/login",
            component: AdminLogin
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /(?!\/$)/;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
            path: "/admin",
            nest: true,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wouter.Switch), {
                children: [
                    t0,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                        path: t1,
                        nest: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminLayoutDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminAuthGuardDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wouter.Switch), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/",
                                            component: Admin
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/queue-jobs",
                                            component: AdminQueueJobs
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/data-archives",
                                            component: AdminDataArchives
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/test-gemini",
                                            component: AdminTestGemini
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/configs",
                                            component: AdminConfigs
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/stats",
                                            component: AdminStats
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/config/:key/value",
                                            component: AdminConfigValue
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                            path: "/config/:key/schema",
                                            component: AdminConfigSchema
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Router), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wouter.Switch), {
                children: [
                    t2,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                        path: "/",
                        nest: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainLayoutDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wouter.Switch), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                        path: /^\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i,
                                        component: PhotoView
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                        path: "/social-wall",
                                        component: SocialWall
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                        path: "/form",
                                        component: Wizard
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                                        component: (0, _notFoundPageDefault.default)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _wouter.Route), {
                        component: (0, _notFoundPageDefault.default)
                    })
                ]
            })
        });
        $[3] = t3;
    } else t3 = $[3];
    return t3;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","react":"erQJb","wouter":"3dLPT","@/shared/components/MainLayout":"ciULO","@/shared/components/NotFoundPage":"7rU0V","@/features/admin/components/AdminAuthGuard":"hMmjB","@/features/admin/components/AdminLayout":"6yJTw","c58033bbb81c027a":"jZifc","37d5e8649019c145":"dLZ70","8bf480619126c596":"1vE0l","929e7d0a52a7b7cb":"dQUU1","3f2bc7b159cc6663":"2KPu7","4104df1b34f579f1":"cPaHf","f91c3f6a57b2d470":"3P1Jb","8f03296506b80f6b":"1hmSF","ab8711beb7f92e26":"7rAYb","a2ff9ea756741dd1":"kVNTm","d12c40ac6f6626d5":"8E3pS","696ea006a08f615e":"goWE4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3dLPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouter", ()=>useRouter);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useSearch", ()=>useSearch);
parcelHelpers.export(exports, "matchRoute", ()=>matchRoute);
parcelHelpers.export(exports, "useRoute", ()=>useRoute);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
var _regexparam = require("regexparam");
var _useBrowserLocationJs = require("./use-browser-location.js");
var _reactDepsJs = require("./react-deps.js");
var _pathsJs = require("./paths.js");
/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const defaultRouter = {
    hook: (0, _useBrowserLocationJs.useBrowserLocation),
    searchHook: (0, _useBrowserLocationJs.useSearch),
    parser: (0, _regexparam.parse),
    base: "",
    // this option is used to override the current location during SSR
    ssrPath: undefined,
    ssrSearch: undefined,
    // optional context to track render state during SSR
    ssrContext: undefined,
    // customizes how `href` props are transformed for <Link />
    hrefs: (x)=>x,
    // wraps navigate calls, useful for view transitions
    aroundNav: (n, t, o)=>n(t, o)
};
const RouterCtx = (0, _reactDepsJs.createContext)(defaultRouter);
const useRouter = ()=>(0, _reactDepsJs.useContext)(RouterCtx);
/**
 * Parameters context. Used by `useParams()` to get the
 * matched params from the innermost `Route` component.
 */ const Params0 = {}, ParamsCtx = (0, _reactDepsJs.createContext)(Params0);
const useParams = ()=>(0, _reactDepsJs.useContext)(ParamsCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const useLocationFromRouter = (router)=>{
    const [location, navigate] = router.hook(router);
    // the function reference should stay the same between re-renders, so that
    // it can be passed down as an element prop without any performance concerns.
    // (This is achieved via `useEvent`.)
    return [
        (0, _pathsJs.relativePath)(router.base, location),
        (0, _reactDepsJs.useEvent)((to, opts)=>router.aroundNav(navigate, (0, _pathsJs.absolutePath)(to, router.base), opts))
    ];
};
const useLocation = ()=>useLocationFromRouter(useRouter());
const useSearch = ()=>{
    const router = useRouter();
    return (0, _pathsJs.sanitizeSearch)(router.searchHook(router));
};
const matchRoute = (parser, route, path, loose)=>{
    // if the input is a regexp, skip parsing
    const { pattern, keys } = route instanceof RegExp ? {
        keys: false,
        pattern: route
    } : parser(route || "*", loose);
    // array destructuring loses keys, so this is done in two steps
    const result = pattern.exec(path) || [];
    // when parser is in "loose" mode, `$base` is equal to the
    // first part of the route that matches the pattern
    // (e.g. for pattern `/a/:b` and path `/a/1/2/3` the `$base` is `a/1`)
    // we use this for route nesting
    const [$base, ...matches] = result;
    return $base !== undefined ? [
        true,
        (()=>{
            // for regex paths, `keys` will always be false
            // an object with parameters matched, e.g. { foo: "bar" } for "/:foo"
            // we "zip" two arrays here to construct the object
            // ["foo"], ["bar"] → { foo: "bar" }
            const groups = keys !== false ? Object.fromEntries(keys.map((key, i)=>[
                    key,
                    matches[i]
                ])) : result.groups;
            // convert the array to an instance of object
            // this makes it easier to integrate with the existing param implementation
            let obj = {
                ...matches
            };
            // merge named capture groups with matches array
            groups && Object.assign(obj, groups);
            return obj;
        })(),
        // the third value if only present when parser is in "loose" mode,
        // so that we can extract the base path for nested routes
        ...loose ? [
            $base
        ] : []
    ] : [
        false,
        null
    ];
};
const useRoute = (pattern)=>matchRoute(useRouter().parser, pattern, useLocation()[0]);
const Router = ({ children, ...props })=>{
    // the router we will inherit from - it is the closest router in the tree,
    // unless the custom `hook` is provided (in that case it's the default one)
    const parent_ = useRouter();
    const parent = props.hook ? defaultRouter : parent_;
    // holds to the context value: the router object
    let value = parent;
    // when `ssrPath` contains a `?` character, we can extract the search from it.
    // also, ensure ssrSearch is always defined when ssrPath is provided, so that
    // useSearch behavior matches usePathname (proper SSR hydration when client
    // renders <Router> without props after server rendered with ssrPath/ssrSearch)
    const [path, search = props.ssrSearch ?? ""] = props.ssrPath?.split("?") ?? [];
    if (path) props.ssrSearch = search, props.ssrPath = path;
    // hooks can define their own `href` formatter (e.g. for hash location)
    props.hrefs = props.hrefs ?? props.hook?.hrefs;
    // hooks can define their own search hook (e.g. for memory location)
    props.searchHook = props.searchHook ?? props.hook?.searchHook;
    // what is happening below: to avoid unnecessary rerenders in child components,
    // we ensure that the router object reference is stable, unless there are any
    // changes that require reload (e.g. `base` prop changes -> all components that
    // get the router from the context should rerender, even if the component is memoized).
    // the expected behaviour is:
    //
    //   1) when the resulted router is no different from the parent, use parent
    //   2) if the custom `hook` prop is provided, we always inherit from the
    //      default router instead. this resets all previously overridden options.
    //   3) when the router is customized here, it should stay stable between renders
    let ref = (0, _reactDepsJs.useRef)({}), prev = ref.current, next = prev;
    for(let k in parent){
        const option = k === "base" ? /* base is special case, it is appended to the parent's base */ parent[k] + (props[k] ?? "") : props[k] ?? parent[k];
        if (prev === next && option !== next[k]) ref.current = next = {
            ...next
        };
        next[k] = option;
        // the new router is no different from the parent or from the memoized value, use parent
        if (option !== parent[k] || option !== value[k]) value = next;
    }
    return (0, _reactDepsJs.createElement)(RouterCtx.Provider, {
        value,
        children
    });
};
const h_route = ({ children, component }, params)=>{
    // React-Router style `component` prop
    if (component) return (0, _reactDepsJs.createElement)(component, {
        params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
// Cache params object between renders if values are shallow equal
const useCachedParams = (value)=>{
    let prev = (0, _reactDepsJs.useRef)(Params0);
    const curr = prev.current;
    return prev.current = // Update cache if number of params changed or any value changed
    Object.keys(value).length !== Object.keys(curr).length || Object.entries(value).some(([k, v])=>v !== curr[k]) ? value // Return new value if there are changes
     : curr; // Return cached value if nothing changed
};
function useSearchParams() {
    const [location, navigate] = useLocation();
    const search = useSearch();
    const searchParams = (0, _reactDepsJs.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    // cached value before next render, so you can call setSearchParams multiple times
    let tempSearchParams = searchParams;
    const setSearchParams = (0, _reactDepsJs.useEvent)((nextInit, options)=>{
        tempSearchParams = new URLSearchParams(typeof nextInit === "function" ? nextInit(tempSearchParams) : nextInit);
        navigate(location + "?" + tempSearchParams, options);
    });
    return [
        searchParams,
        setSearchParams
    ];
}
const Route = ({ path, nest, match, ...renderProps })=>{
    const router = useRouter();
    const [location] = useLocationFromRouter(router);
    const [matches, routeParams, base] = // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    match ?? matchRoute(router.parser, path, location, nest);
    // when `routeParams` is `null` (there was no match), the argument
    // below becomes {...null} = {}, see the Object Spread specs
    // https://tc39.es/proposal-object-rest-spread/#AbstractOperations-CopyDataProperties
    const params = useCachedParams({
        ...useParams(),
        ...routeParams
    });
    if (!matches) return null;
    const children = base ? (0, _reactDepsJs.createElement)(Router, {
        base
    }, h_route(renderProps, params)) : h_route(renderProps, params);
    return (0, _reactDepsJs.createElement)(ParamsCtx.Provider, {
        value: params,
        children
    });
};
const Link = (0, _reactDepsJs.forwardRef)((props, ref)=>{
    const router = useRouter();
    const [currentPath, navigate] = useLocationFromRouter(router);
    const { to = "", href: targetPath = to, onClick: _onClick, asChild, children, className: cls, /* eslint-disable no-unused-vars */ replace/* ignore nav props */ , state/* ignore nav props */ , transition/* ignore nav props */ , /* eslint-enable no-unused-vars */ ...restProps } = props;
    const onClick = (0, _reactDepsJs.useEvent)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        _onClick?.(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(targetPath, props);
        }
    });
    // handle nested routers and absolute paths
    const href = router.hrefs(targetPath[0] === "~" ? targetPath.slice(1) : router.base + targetPath, router // pass router as a second argument for convinience
    );
    return asChild && (0, _reactDepsJs.isValidElement)(children) ? (0, _reactDepsJs.cloneElement)(children, {
        onClick,
        href
    }) : (0, _reactDepsJs.createElement)("a", {
        ...restProps,
        onClick,
        href,
        // `className` can be a function to apply the class if this link is active
        className: cls?.call ? cls(currentPath === targetPath) : cls,
        children,
        ref
    });
});
const flattenChildren = (children)=>Array.isArray(children) ? children.flatMap((c)=>flattenChildren(c && c.type === (0, _reactDepsJs.Fragment) ? c.props.children : c)) : [
        children
    ];
const Switch = ({ children, location })=>{
    const router = useRouter();
    const [originalLocation] = useLocationFromRouter(router);
    for (const element of flattenChildren(children)){
        let match = 0;
        if ((0, _reactDepsJs.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = matchRoute(router.parser, element.props.path, location || originalLocation, element.props.nest))[0]) return (0, _reactDepsJs.cloneElement)(element, {
            match
        });
    }
    return null;
};
const Redirect = (props)=>{
    const { to, href = to } = props;
    const router = useRouter();
    const [, navigate] = useLocationFromRouter(router);
    const redirect = (0, _reactDepsJs.useEvent)(()=>navigate(to || href, props));
    const { ssrContext } = router;
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, _reactDepsJs.useIsomorphicLayoutEffect)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (ssrContext) ssrContext.redirectTo = to;
    return null;
};

},{"regexparam":"bYGw0","./use-browser-location.js":"8Hthi","./react-deps.js":"fHpBR","./paths.js":"jRAqt","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bYGw0":[function(require,module,exports,__globalThis) {
/**
 * @param {string|RegExp} input The route pattern
 * @param {boolean} [loose] Allow open-ended matching. Ignored with `RegExp` input.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parse", ()=>parse);
// error if key missing?
parcelHelpers.export(exports, "inject", ()=>inject);
function parse(input, loose) {
    if (input instanceof RegExp) return {
        keys: false,
        pattern: input
    };
    var c, o, tmp, ext, keys = [], pattern = '', arr = input.split('/');
    arr[0] || arr.shift();
    while(tmp = arr.shift()){
        c = tmp[0];
        if (c === '*') {
            keys.push(c);
            pattern += tmp[1] === '?' ? '(?:/(.*))?' : '/(.*)';
        } else if (c === ':') {
            o = tmp.indexOf('?', 1);
            ext = tmp.indexOf('.', 1);
            keys.push(tmp.substring(1, !!~o ? o : !!~ext ? ext : tmp.length));
            pattern += !!~o && !~ext ? '(?:/([^/]+?))?' : '/([^/]+?)';
            if (!!~ext) pattern += (!!~o ? '?' : '') + '\\' + tmp.substring(ext);
        } else pattern += '/' + tmp;
    }
    return {
        keys: keys,
        pattern: new RegExp('^' + pattern + (loose ? '(?=$|\/)' : '\/?$'), 'i')
    };
}
var RGX = /(\/|^)([:*][^/]*?)(\?)?(?=[/.]|$)/g;
function inject(route, values) {
    return route.replace(RGX, (x, lead, key, optional)=>{
        x = values[key == '*' ? key : key.substring(1)];
        return x ? '/' + x : optional || key == '*' ? '' : '/' + key;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8c1Nw":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"8Hthi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocationProperty", ()=>useLocationProperty);
parcelHelpers.export(exports, "useSearch", ()=>useSearch);
parcelHelpers.export(exports, "usePathname", ()=>usePathname);
parcelHelpers.export(exports, "useHistoryState", ()=>useHistoryState);
parcelHelpers.export(exports, "navigate", ()=>navigate);
parcelHelpers.export(exports, "useBrowserLocation", ()=>useBrowserLocation);
var _reactDepsJs = require("./react-deps.js");
/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const eventPopstate = "popstate";
const eventPushState = "pushState";
const eventReplaceState = "replaceState";
const eventHashchange = "hashchange";
const events = [
    eventPopstate,
    eventPushState,
    eventReplaceState,
    eventHashchange
];
const subscribeToLocationUpdates = (callback)=>{
    for (const event of events)addEventListener(event, callback);
    return ()=>{
        for (const event of events)removeEventListener(event, callback);
    };
};
const useLocationProperty = (fn, ssrFn)=>(0, _reactDepsJs.useSyncExternalStore)(subscribeToLocationUpdates, fn, ssrFn);
const currentSearch = ()=>location.search;
const useSearch = ({ ssrSearch } = {})=>useLocationProperty(currentSearch, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrSearch="?foo",
    // client hydrates with just <Router /> and reads from location.search
    ssrSearch != null ? ()=>ssrSearch : currentSearch);
const currentPathname = ()=>location.pathname;
const usePathname = ({ ssrPath } = {})=>useLocationProperty(currentPathname, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrPath="/foo",
    // client hydrates with just <Router /> and reads from location.pathname
    ssrPath != null ? ()=>ssrPath : currentPathname);
const currentHistoryState = ()=>history.state;
const useHistoryState = ()=>useLocationProperty(currentHistoryState, ()=>null);
const navigate = (to, { replace = false, state = null } = {})=>history[replace ? eventReplaceState : eventPushState](state, "", to);
const useBrowserLocation = (opts = {})=>[
        usePathname(opts),
        navigate
    ];
const patchKey = Symbol.for("wouter_v3");
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined" && typeof window[patchKey] === "undefined") {
    for (const type of [
        eventPushState,
        eventReplaceState
    ]){
        const original = history[type];
        // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
        // however that will require an additional peer dependency on react-dom.
        // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
        history[type] = function() {
            const result = original.apply(this, arguments);
            const event = new Event(type);
            event.arguments = arguments;
            dispatchEvent(event);
            return result;
        };
    }
    // patch history object only once
    // See: https://github.com/molefrog/wouter/issues/167
    Object.defineProperty(window, patchKey, {
        value: true
    });
}

},{"./react-deps.js":"fHpBR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fHpBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMemo", ()=>(0, _react.useMemo));
parcelHelpers.export(exports, "useRef", ()=>(0, _react.useRef));
parcelHelpers.export(exports, "useState", ()=>(0, _react.useState));
parcelHelpers.export(exports, "useContext", ()=>(0, _react.useContext));
parcelHelpers.export(exports, "createContext", ()=>(0, _react.createContext));
parcelHelpers.export(exports, "isValidElement", ()=>(0, _react.isValidElement));
parcelHelpers.export(exports, "cloneElement", ()=>(0, _react.cloneElement));
parcelHelpers.export(exports, "createElement", ()=>(0, _react.createElement));
parcelHelpers.export(exports, "Fragment", ()=>(0, _react.Fragment));
parcelHelpers.export(exports, "forwardRef", ()=>(0, _react.forwardRef));
// To resolve webpack 5 errors, while not presenting problems for native,
// we copy the approaches from https://github.com/TanStack/query/pull/3561
// and https://github.com/TanStack/query/pull/3601
// ~ Show this aging PR some love to remove the need for this hack:
//   https://github.com/facebook/react/pull/25231 ~
parcelHelpers.export(exports, "useSyncExternalStore", ()=>(0, _useSyncExternalStoreJs.useSyncExternalStore));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useInsertionEffect", ()=>useInsertionEffect);
parcelHelpers.export(exports, "useEvent", ()=>useEvent);
var _react = require("react");
var _useSyncExternalStoreJs = require("./use-sync-external-store.js");
// React.useInsertionEffect is not available in React <18
// This hack fixes a transpilation issue on some apps
const useBuiltinInsertionEffect = _react["useInsertionEffect"];
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const useIsomorphicLayoutEffect = canUseDOM ? _react.useLayoutEffect : _react.useEffect;
const useInsertionEffect = useBuiltinInsertionEffect || useIsomorphicLayoutEffect;
const useEvent = (fn)=>{
    const ref = _react.useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    useInsertionEffect(()=>{
        ref[0] = fn;
    });
    return ref[1];
};

},{"react":"erQJb","./use-sync-external-store.js":"6GABr","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6GABr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>(0, _indexJs.useSyncExternalStore));
var _indexJs = require("use-sync-external-store/shim/index.js");

},{"use-sync-external-store/shim/index.js":"j2NXm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"j2NXm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("928c1a79610a9cd4");

},{"928c1a79610a9cd4":"bYZPu"}],"bYZPu":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("cee1516e06d3a8d6");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"cee1516e06d3a8d6":"erQJb"}],"jRAqt":[function(require,module,exports,__globalThis) {
/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "absolutePath", ()=>absolutePath);
parcelHelpers.export(exports, "relativePath", ()=>relativePath);
parcelHelpers.export(exports, "sanitizeSearch", ()=>sanitizeSearch);
const _relativePath = (base, path)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
/**
 * When basepath is `undefined` or '/' it is ignored (we assume it's empty string)
 */ const baseDefaults = (base = "")=>base === "/" ? "" : base;
const absolutePath = (to, base)=>to[0] === "~" ? to.slice(1) : baseDefaults(base) + to;
const relativePath = (base = "", path)=>_relativePath(unescape(baseDefaults(base)), unescape(path));
/*
 * Removes leading question mark
 */ const stripQm = (str)=>str[0] === "?" ? str.slice(1) : str;
/*
 * decodes escape sequences such as %20
 */ const unescape = (str)=>{
    try {
        return decodeURI(str);
    } catch (_e) {
        // fail-safe mode: if string can't be decoded do nothing
        return str;
    }
};
const sanitizeSearch = (search)=>unescape(stripQm(search));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ciULO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MainLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _react = require("react");
var _reactErrorBoundary = require("react-error-boundary");
var _theme = require("@/app/theme");
var _errorFallback = require("@/shared/components/ErrorFallback");
function MainLayout(t0) {
    const $ = (0, _compilerRuntime.c)(4);
    const { children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    (0, _react.useEffect)(_temp2, t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Center), {
            mih: "100dvh",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Loader), {
                size: "lg"
            })
        });
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.MantineProvider), {
            theme: (0, _theme.theme),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactErrorBoundary.ErrorBoundary), {
                FallbackComponent: (0, _errorFallback.ErrorFallback),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                    fallback: t2,
                    children: children
                })
            })
        });
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
}
function _temp2() {
    document.body.classList.add("mainLayout");
    return _temp;
}
function _temp() {
    document.body.classList.remove("mainLayout");
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["Center","haski"],["Loader","7aA6l"],["MantineProvider","2TSc8"]],"react":"erQJb","react-error-boundary":"9NmbP","@/app/theme":"8HxbR","@/shared/components/ErrorFallback":"3pGYY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"haski":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Center", ()=>Center);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _centerModuleCssMjs = require("./Center.module.css.mjs");
var _centerModuleCssMjsDefault = parcelHelpers.interopDefault(_centerModuleCssMjs);
'use client';
const Center = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Center", null, _props);
    const { classNames, className, style, styles, unstyled, vars, inline, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Center",
        props,
        classes: (0, _centerModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        mod: [
            {
                inline
            },
            mod
        ],
        ...getStyles("root"),
        ...others
    });
});
Center.classes = (0, _centerModuleCssMjsDefault.default);
Center.displayName = "@mantine/core/Center";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Center.module.css.mjs":"fLjoL","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c70Xm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "em", ()=>em);
parcelHelpers.export(exports, "rem", ()=>rem);
function scaleRem(remValue) {
    if (remValue === "0rem") return "0rem";
    return `calc(${remValue} * var(--mantine-scale))`;
}
function createConverter(units, { shouldScale = false } = {}) {
    function converter(value) {
        if (value === 0 || value === "0") return `0${units}`;
        if (typeof value === "number") {
            const val = `${value / 16}${units}`;
            return shouldScale ? scaleRem(val) : val;
        }
        if (typeof value === "string") {
            if (value === "") return value;
            if (value.startsWith("calc(") || value.startsWith("clamp(") || value.includes("rgba(")) return value;
            if (value.includes(",")) return value.split(",").map((val)=>converter(val)).join(",");
            if (value.includes(" ")) return value.split(" ").map((val)=>converter(val)).join(" ");
            const replaced = value.replace("px", "");
            if (!Number.isNaN(Number(replaced))) {
                const val = `${Number(replaced) / 16}${units}`;
                return shouldScale ? scaleRem(val) : val;
            }
        }
        return value;
    }
    return converter;
}
const rem = createConverter("rem", {
    shouldScale: true
});
const em = createConverter("em");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cPWeR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>(0, _clampMjs.clamp));
parcelHelpers.export(exports, "lowerFirst", ()=>(0, _lowerFirstMjs.lowerFirst));
parcelHelpers.export(exports, "randomId", ()=>(0, _randomIdMjs.randomId));
parcelHelpers.export(exports, "range", ()=>(0, _rangeMjs.range));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualMjs.shallowEqual));
parcelHelpers.export(exports, "upperFirst", ()=>(0, _upperFirstMjs.upperFirst));
parcelHelpers.export(exports, "useCallbackRef", ()=>(0, _useCallbackRefMjs.useCallbackRef));
parcelHelpers.export(exports, "useDebouncedCallback", ()=>(0, _useDebouncedCallbackMjs.useDebouncedCallback));
parcelHelpers.export(exports, "useClickOutside", ()=>(0, _useClickOutsideMjs.useClickOutside));
parcelHelpers.export(exports, "useClipboard", ()=>(0, _useClipboardMjs.useClipboard));
parcelHelpers.export(exports, "useColorScheme", ()=>(0, _useColorSchemeMjs.useColorScheme));
parcelHelpers.export(exports, "useCounter", ()=>(0, _useCounterMjs.useCounter));
parcelHelpers.export(exports, "useDebouncedState", ()=>(0, _useDebouncedStateMjs.useDebouncedState));
parcelHelpers.export(exports, "useDebouncedValue", ()=>(0, _useDebouncedValueMjs.useDebouncedValue));
parcelHelpers.export(exports, "useDocumentTitle", ()=>(0, _useDocumentTitleMjs.useDocumentTitle));
parcelHelpers.export(exports, "useDocumentVisibility", ()=>(0, _useDocumentVisibilityMjs.useDocumentVisibility));
parcelHelpers.export(exports, "useFocusReturn", ()=>(0, _useFocusReturnMjs.useFocusReturn));
parcelHelpers.export(exports, "useDidUpdate", ()=>(0, _useDidUpdateMjs.useDidUpdate));
parcelHelpers.export(exports, "useFocusTrap", ()=>(0, _useFocusTrapMjs.useFocusTrap));
parcelHelpers.export(exports, "useForceUpdate", ()=>(0, _useForceUpdateMjs.useForceUpdate));
parcelHelpers.export(exports, "useId", ()=>(0, _useIdMjs.useId));
parcelHelpers.export(exports, "useIdle", ()=>(0, _useIdleMjs.useIdle));
parcelHelpers.export(exports, "useInterval", ()=>(0, _useIntervalMjs.useInterval));
parcelHelpers.export(exports, "useIsomorphicEffect", ()=>(0, _useIsomorphicEffectMjs.useIsomorphicEffect));
parcelHelpers.export(exports, "useListState", ()=>(0, _useListStateMjs.useListState));
parcelHelpers.export(exports, "readLocalStorageValue", ()=>(0, _useLocalStorageMjs.readLocalStorageValue));
parcelHelpers.export(exports, "useLocalStorage", ()=>(0, _useLocalStorageMjs.useLocalStorage));
parcelHelpers.export(exports, "readSessionStorageValue", ()=>(0, _useSessionStorageMjs.readSessionStorageValue));
parcelHelpers.export(exports, "useSessionStorage", ()=>(0, _useSessionStorageMjs.useSessionStorage));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQueryMjs.useMediaQuery));
parcelHelpers.export(exports, "assignRef", ()=>(0, _useMergedRefMjs.assignRef));
parcelHelpers.export(exports, "mergeRefs", ()=>(0, _useMergedRefMjs.mergeRefs));
parcelHelpers.export(exports, "useMergedRef", ()=>(0, _useMergedRefMjs.useMergedRef));
parcelHelpers.export(exports, "useMouse", ()=>(0, _useMouseMjs.useMouse));
parcelHelpers.export(exports, "clampUseMovePosition", ()=>(0, _useMoveMjs.clampUseMovePosition));
parcelHelpers.export(exports, "useMove", ()=>(0, _useMoveMjs.useMove));
parcelHelpers.export(exports, "usePagination", ()=>(0, _usePaginationMjs.usePagination));
parcelHelpers.export(exports, "useQueue", ()=>(0, _useQueueMjs.useQueue));
parcelHelpers.export(exports, "usePageLeave", ()=>(0, _usePageLeaveMjs.usePageLeave));
parcelHelpers.export(exports, "useReducedMotion", ()=>(0, _useReducedMotionMjs.useReducedMotion));
parcelHelpers.export(exports, "useScrollIntoView", ()=>(0, _useScrollIntoViewMjs.useScrollIntoView));
parcelHelpers.export(exports, "useElementSize", ()=>(0, _useResizeObserverMjs.useElementSize));
parcelHelpers.export(exports, "useResizeObserver", ()=>(0, _useResizeObserverMjs.useResizeObserver));
parcelHelpers.export(exports, "useShallowEffect", ()=>(0, _useShallowEffectMjs.useShallowEffect));
parcelHelpers.export(exports, "useToggle", ()=>(0, _useToggleMjs.useToggle));
parcelHelpers.export(exports, "useUncontrolled", ()=>(0, _useUncontrolledMjs.useUncontrolled));
parcelHelpers.export(exports, "useViewportSize", ()=>(0, _useViewportSizeMjs.useViewportSize));
parcelHelpers.export(exports, "useWindowEvent", ()=>(0, _useWindowEventMjs.useWindowEvent));
parcelHelpers.export(exports, "useWindowScroll", ()=>(0, _useWindowScrollMjs.useWindowScroll));
parcelHelpers.export(exports, "useIntersection", ()=>(0, _useIntersectionMjs.useIntersection));
parcelHelpers.export(exports, "useHash", ()=>(0, _useHashMjs.useHash));
parcelHelpers.export(exports, "useHotkeys", ()=>(0, _useHotkeysMjs.useHotkeys));
parcelHelpers.export(exports, "useFullscreen", ()=>(0, _useFullscreenMjs.useFullscreen));
parcelHelpers.export(exports, "useLogger", ()=>(0, _useLoggerMjs.useLogger));
parcelHelpers.export(exports, "useHover", ()=>(0, _useHoverMjs.useHover));
parcelHelpers.export(exports, "useValidatedState", ()=>(0, _useValidatedStateMjs.useValidatedState));
parcelHelpers.export(exports, "useOs", ()=>(0, _useOsMjs.useOs));
parcelHelpers.export(exports, "useSetState", ()=>(0, _useSetStateMjs.useSetState));
parcelHelpers.export(exports, "useInputState", ()=>(0, _useInputStateMjs.useInputState));
parcelHelpers.export(exports, "useEventListener", ()=>(0, _useEventListenerMjs.useEventListener));
parcelHelpers.export(exports, "useDisclosure", ()=>(0, _useDisclosureMjs.useDisclosure));
parcelHelpers.export(exports, "useFocusWithin", ()=>(0, _useFocusWithinMjs.useFocusWithin));
parcelHelpers.export(exports, "useNetwork", ()=>(0, _useNetworkMjs.useNetwork));
parcelHelpers.export(exports, "useTimeout", ()=>(0, _useTimeoutMjs.useTimeout));
parcelHelpers.export(exports, "useTextSelection", ()=>(0, _useTextSelectionMjs.useTextSelection));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePreviousMjs.usePrevious));
parcelHelpers.export(exports, "useFavicon", ()=>(0, _useFaviconMjs.useFavicon));
parcelHelpers.export(exports, "useHeadroom", ()=>(0, _useHeadroomMjs.useHeadroom));
parcelHelpers.export(exports, "useEyeDropper", ()=>(0, _useEyeDropperMjs.useEyeDropper));
parcelHelpers.export(exports, "useInViewport", ()=>(0, _useInViewportMjs.useInViewport));
parcelHelpers.export(exports, "useMutationObserver", ()=>(0, _useMutationObserverMjs.useMutationObserver));
parcelHelpers.export(exports, "useMounted", ()=>(0, _useMountedMjs.useMounted));
parcelHelpers.export(exports, "useStateHistory", ()=>(0, _useStateHistoryMjs.useStateHistory));
parcelHelpers.export(exports, "useMap", ()=>(0, _useMapMjs.useMap));
parcelHelpers.export(exports, "useSet", ()=>(0, _useSetMjs.useSet));
parcelHelpers.export(exports, "useThrottledCallback", ()=>(0, _useThrottledCallbackMjs.useThrottledCallback));
parcelHelpers.export(exports, "useThrottledState", ()=>(0, _useThrottledStateMjs.useThrottledState));
parcelHelpers.export(exports, "useThrottledValue", ()=>(0, _useThrottledValueMjs.useThrottledValue));
parcelHelpers.export(exports, "useIsFirstRender", ()=>(0, _useIsFirstRenderMjs.useIsFirstRender));
parcelHelpers.export(exports, "useOrientation", ()=>(0, _useOrientationMjs.useOrientation));
parcelHelpers.export(exports, "useFetch", ()=>(0, _useFetchMjs.useFetch));
parcelHelpers.export(exports, "normalizeRadialValue", ()=>(0, _useRadialMoveMjs.normalizeRadialValue));
parcelHelpers.export(exports, "useRadialMove", ()=>(0, _useRadialMoveMjs.useRadialMove));
parcelHelpers.export(exports, "useScrollSpy", ()=>(0, _useScrollSpyMjs.useScrollSpy));
parcelHelpers.export(exports, "useFileDialog", ()=>(0, _useFileDialogMjs.useFileDialog));
parcelHelpers.export(exports, "useLongPress", ()=>(0, _useLongPressMjs.useLongPress));
parcelHelpers.export(exports, "useSelection", ()=>(0, _useSelectionMjs.useSelection));
parcelHelpers.export(exports, "getHotkeyHandler", ()=>(0, _parseHotkeyMjs.getHotkeyHandler));
var _clampMjs = require("./utils/clamp/clamp.mjs");
var _lowerFirstMjs = require("./utils/lower-first/lower-first.mjs");
var _randomIdMjs = require("./utils/random-id/random-id.mjs");
var _rangeMjs = require("./utils/range/range.mjs");
var _shallowEqualMjs = require("./utils/shallow-equal/shallow-equal.mjs");
var _upperFirstMjs = require("./utils/upper-first/upper-first.mjs");
var _useCallbackRefMjs = require("./utils/use-callback-ref/use-callback-ref.mjs");
var _useDebouncedCallbackMjs = require("./use-debounced-callback/use-debounced-callback.mjs");
var _useClickOutsideMjs = require("./use-click-outside/use-click-outside.mjs");
var _useClipboardMjs = require("./use-clipboard/use-clipboard.mjs");
var _useColorSchemeMjs = require("./use-color-scheme/use-color-scheme.mjs");
var _useCounterMjs = require("./use-counter/use-counter.mjs");
var _useDebouncedStateMjs = require("./use-debounced-state/use-debounced-state.mjs");
var _useDebouncedValueMjs = require("./use-debounced-value/use-debounced-value.mjs");
var _useDocumentTitleMjs = require("./use-document-title/use-document-title.mjs");
var _useDocumentVisibilityMjs = require("./use-document-visibility/use-document-visibility.mjs");
var _useFocusReturnMjs = require("./use-focus-return/use-focus-return.mjs");
var _useDidUpdateMjs = require("./use-did-update/use-did-update.mjs");
var _useFocusTrapMjs = require("./use-focus-trap/use-focus-trap.mjs");
var _useForceUpdateMjs = require("./use-force-update/use-force-update.mjs");
var _useIdMjs = require("./use-id/use-id.mjs");
var _useIdleMjs = require("./use-idle/use-idle.mjs");
var _useIntervalMjs = require("./use-interval/use-interval.mjs");
var _useIsomorphicEffectMjs = require("./use-isomorphic-effect/use-isomorphic-effect.mjs");
var _useListStateMjs = require("./use-list-state/use-list-state.mjs");
var _useLocalStorageMjs = require("./use-local-storage/use-local-storage.mjs");
var _useSessionStorageMjs = require("./use-session-storage/use-session-storage.mjs");
var _useMediaQueryMjs = require("./use-media-query/use-media-query.mjs");
var _useMergedRefMjs = require("./use-merged-ref/use-merged-ref.mjs");
var _useMouseMjs = require("./use-mouse/use-mouse.mjs");
var _useMoveMjs = require("./use-move/use-move.mjs");
var _usePaginationMjs = require("./use-pagination/use-pagination.mjs");
var _useQueueMjs = require("./use-queue/use-queue.mjs");
var _usePageLeaveMjs = require("./use-page-leave/use-page-leave.mjs");
var _useReducedMotionMjs = require("./use-reduced-motion/use-reduced-motion.mjs");
var _useScrollIntoViewMjs = require("./use-scroll-into-view/use-scroll-into-view.mjs");
var _useResizeObserverMjs = require("./use-resize-observer/use-resize-observer.mjs");
var _useShallowEffectMjs = require("./use-shallow-effect/use-shallow-effect.mjs");
var _useToggleMjs = require("./use-toggle/use-toggle.mjs");
var _useUncontrolledMjs = require("./use-uncontrolled/use-uncontrolled.mjs");
var _useViewportSizeMjs = require("./use-viewport-size/use-viewport-size.mjs");
var _useWindowEventMjs = require("./use-window-event/use-window-event.mjs");
var _useWindowScrollMjs = require("./use-window-scroll/use-window-scroll.mjs");
var _useIntersectionMjs = require("./use-intersection/use-intersection.mjs");
var _useHashMjs = require("./use-hash/use-hash.mjs");
var _useHotkeysMjs = require("./use-hotkeys/use-hotkeys.mjs");
var _useFullscreenMjs = require("./use-fullscreen/use-fullscreen.mjs");
var _useLoggerMjs = require("./use-logger/use-logger.mjs");
var _useHoverMjs = require("./use-hover/use-hover.mjs");
var _useValidatedStateMjs = require("./use-validated-state/use-validated-state.mjs");
var _useOsMjs = require("./use-os/use-os.mjs");
var _useSetStateMjs = require("./use-set-state/use-set-state.mjs");
var _useInputStateMjs = require("./use-input-state/use-input-state.mjs");
var _useEventListenerMjs = require("./use-event-listener/use-event-listener.mjs");
var _useDisclosureMjs = require("./use-disclosure/use-disclosure.mjs");
var _useFocusWithinMjs = require("./use-focus-within/use-focus-within.mjs");
var _useNetworkMjs = require("./use-network/use-network.mjs");
var _useTimeoutMjs = require("./use-timeout/use-timeout.mjs");
var _useTextSelectionMjs = require("./use-text-selection/use-text-selection.mjs");
var _usePreviousMjs = require("./use-previous/use-previous.mjs");
var _useFaviconMjs = require("./use-favicon/use-favicon.mjs");
var _useHeadroomMjs = require("./use-headroom/use-headroom.mjs");
var _useEyeDropperMjs = require("./use-eye-dropper/use-eye-dropper.mjs");
var _useInViewportMjs = require("./use-in-viewport/use-in-viewport.mjs");
var _useMutationObserverMjs = require("./use-mutation-observer/use-mutation-observer.mjs");
var _useMountedMjs = require("./use-mounted/use-mounted.mjs");
var _useStateHistoryMjs = require("./use-state-history/use-state-history.mjs");
var _useMapMjs = require("./use-map/use-map.mjs");
var _useSetMjs = require("./use-set/use-set.mjs");
var _useThrottledCallbackMjs = require("./use-throttled-callback/use-throttled-callback.mjs");
var _useThrottledStateMjs = require("./use-throttled-state/use-throttled-state.mjs");
var _useThrottledValueMjs = require("./use-throttled-value/use-throttled-value.mjs");
var _useIsFirstRenderMjs = require("./use-is-first-render/use-is-first-render.mjs");
var _useOrientationMjs = require("./use-orientation/use-orientation.mjs");
var _useFetchMjs = require("./use-fetch/use-fetch.mjs");
var _useRadialMoveMjs = require("./use-radial-move/use-radial-move.mjs");
var _useScrollSpyMjs = require("./use-scroll-spy/use-scroll-spy.mjs");
var _useFileDialogMjs = require("./use-file-dialog/use-file-dialog.mjs");
var _useLongPressMjs = require("./use-long-press/use-long-press.mjs");
var _useSelectionMjs = require("./use-selection/use-selection.mjs");
var _parseHotkeyMjs = require("./use-hotkeys/parse-hotkey.mjs");

},{"./utils/clamp/clamp.mjs":"bNBKV","./utils/lower-first/lower-first.mjs":"22WW1","./utils/random-id/random-id.mjs":"3bLBD","./utils/range/range.mjs":"1zYPc","./utils/shallow-equal/shallow-equal.mjs":"g7ba9","./utils/upper-first/upper-first.mjs":"2vV91","./utils/use-callback-ref/use-callback-ref.mjs":"1inGi","./use-debounced-callback/use-debounced-callback.mjs":"9VIlA","./use-click-outside/use-click-outside.mjs":"1okWM","./use-clipboard/use-clipboard.mjs":"33IuP","./use-color-scheme/use-color-scheme.mjs":"dounS","./use-counter/use-counter.mjs":"lmsXx","./use-debounced-state/use-debounced-state.mjs":"3W9Dg","./use-debounced-value/use-debounced-value.mjs":"9g5zq","./use-document-title/use-document-title.mjs":"9WLNK","./use-document-visibility/use-document-visibility.mjs":"jXGng","./use-focus-return/use-focus-return.mjs":"lTHUc","./use-did-update/use-did-update.mjs":"bzSpx","./use-focus-trap/use-focus-trap.mjs":"hpsZx","./use-force-update/use-force-update.mjs":"3vpJH","./use-id/use-id.mjs":"H2nB9","./use-idle/use-idle.mjs":"3Ferq","./use-interval/use-interval.mjs":"8Kq6J","./use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","./use-list-state/use-list-state.mjs":"49dQQ","./use-local-storage/use-local-storage.mjs":"jBaZ9","./use-session-storage/use-session-storage.mjs":"7ASi3","./use-media-query/use-media-query.mjs":"gNbAU","./use-merged-ref/use-merged-ref.mjs":"3QtIc","./use-mouse/use-mouse.mjs":"cXXGV","./use-move/use-move.mjs":"j02md","./use-pagination/use-pagination.mjs":"bMmGY","./use-queue/use-queue.mjs":"bSrOl","./use-page-leave/use-page-leave.mjs":"kN6EH","./use-reduced-motion/use-reduced-motion.mjs":"F0OXZ","./use-scroll-into-view/use-scroll-into-view.mjs":"7RRnA","./use-resize-observer/use-resize-observer.mjs":"1qaJJ","./use-shallow-effect/use-shallow-effect.mjs":"3I1EC","./use-toggle/use-toggle.mjs":"3jxCj","./use-uncontrolled/use-uncontrolled.mjs":"bBNEa","./use-viewport-size/use-viewport-size.mjs":"dKpSR","./use-window-event/use-window-event.mjs":"6GqGu","./use-window-scroll/use-window-scroll.mjs":"iy20W","./use-intersection/use-intersection.mjs":"87Req","./use-hash/use-hash.mjs":"d9BOv","./use-hotkeys/use-hotkeys.mjs":"jkWab","./use-fullscreen/use-fullscreen.mjs":"erxqp","./use-logger/use-logger.mjs":"adklo","./use-hover/use-hover.mjs":"iFgvC","./use-validated-state/use-validated-state.mjs":"83dFa","./use-os/use-os.mjs":"kSudd","./use-set-state/use-set-state.mjs":"QGAdx","./use-input-state/use-input-state.mjs":"d5ocs","./use-event-listener/use-event-listener.mjs":"2ATId","./use-disclosure/use-disclosure.mjs":"9UqII","./use-focus-within/use-focus-within.mjs":"2fZm7","./use-network/use-network.mjs":"gcOC6","./use-timeout/use-timeout.mjs":"irMHj","./use-text-selection/use-text-selection.mjs":"5kClW","./use-previous/use-previous.mjs":"atULC","./use-favicon/use-favicon.mjs":"j9Mzm","./use-headroom/use-headroom.mjs":"lNCsW","./use-eye-dropper/use-eye-dropper.mjs":"8TPz4","./use-in-viewport/use-in-viewport.mjs":"jWoOE","./use-mutation-observer/use-mutation-observer.mjs":"9VXPX","./use-mounted/use-mounted.mjs":"9EYwU","./use-state-history/use-state-history.mjs":"2Qtj3","./use-map/use-map.mjs":"99i0p","./use-set/use-set.mjs":"4pmBe","./use-throttled-callback/use-throttled-callback.mjs":"1zIHG","./use-throttled-state/use-throttled-state.mjs":"2l1dL","./use-throttled-value/use-throttled-value.mjs":"1BPvC","./use-is-first-render/use-is-first-render.mjs":"ND8KV","./use-orientation/use-orientation.mjs":"d2qsB","./use-fetch/use-fetch.mjs":"3sZf1","./use-radial-move/use-radial-move.mjs":"dc1My","./use-scroll-spy/use-scroll-spy.mjs":"1RYNc","./use-file-dialog/use-file-dialog.mjs":"hnL8x","./use-long-press/use-long-press.mjs":"2QBuK","./use-selection/use-selection.mjs":"7wT8V","./use-hotkeys/parse-hotkey.mjs":"fzlL7","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bNBKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
'use client';
function clamp(value, min, max) {
    if (min === void 0 && max === void 0) return value;
    if (min !== void 0 && max === void 0) return Math.max(value, min);
    if (min === void 0 && max !== void 0) return Math.min(value, max);
    return Math.min(Math.max(value, min), max);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"22WW1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lowerFirst", ()=>lowerFirst);
'use client';
function lowerFirst(value) {
    return typeof value !== "string" ? "" : value.charAt(0).toLowerCase() + value.slice(1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3bLBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomId", ()=>randomId);
'use client';
function randomId(prefix = "mantine-") {
    return `${prefix}${Math.random().toString(36).slice(2, 11)}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1zYPc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
'use client';
function range(start, end) {
    const length = Math.abs(end - start) + 1;
    const reversed = start > end;
    if (!reversed) return Array.from({
        length
    }, (_, index)=>index + start);
    return Array.from({
        length
    }, (_, index)=>start - index);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"g7ba9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
'use client';
function shallowEqual(a, b) {
    if (a === b) return true;
    if (Number.isNaN(a) && Number.isNaN(b)) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    const keys = Object.keys(a);
    const { length } = keys;
    if (length !== Object.keys(b).length) return false;
    for(let i = 0; i < length; i += 1){
        const key = keys[i];
        if (!(key in b)) return false;
        if (a[key] !== b[key] && !(Number.isNaN(a[key]) && Number.isNaN(b[key]))) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2vV91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
'use client';
function upperFirst(value) {
    return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1inGi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
'use client';
function useCallbackRef(callback) {
    const callbackRef = (0, _react.useRef)(callback);
    (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    });
    return (0, _react.useMemo)(()=>(...args)=>callbackRef.current?.(...args), []);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9VIlA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebouncedCallback", ()=>useDebouncedCallback);
var _react = require("react");
var _useCallbackRefMjs = require("../utils/use-callback-ref/use-callback-ref.mjs");
'use client';
function useDebouncedCallback(callback, options) {
    const { delay, flushOnUnmount, leading } = typeof options === "number" ? {
        delay: options,
        flushOnUnmount: false,
        leading: false
    } : options;
    const handleCallback = (0, _useCallbackRefMjs.useCallbackRef)(callback);
    const debounceTimerRef = (0, _react.useRef)(0);
    const lastCallback = (0, _react.useMemo)(()=>{
        const currentCallback = Object.assign((...args)=>{
            window.clearTimeout(debounceTimerRef.current);
            const isFirstCall = currentCallback._isFirstCall;
            currentCallback._isFirstCall = false;
            function clearTimeoutAndLeadingRef() {
                window.clearTimeout(debounceTimerRef.current);
                debounceTimerRef.current = 0;
                currentCallback._isFirstCall = true;
            }
            if (leading && isFirstCall) {
                handleCallback(...args);
                const resetLeadingState = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                const flush2 = ()=>{
                    if (debounceTimerRef.current !== 0) {
                        clearTimeoutAndLeadingRef();
                        handleCallback(...args);
                    }
                };
                const cancel2 = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                currentCallback.flush = flush2;
                currentCallback.cancel = cancel2;
                debounceTimerRef.current = window.setTimeout(resetLeadingState, delay);
                return;
            }
            if (leading && !isFirstCall) {
                const flush2 = ()=>{
                    if (debounceTimerRef.current !== 0) {
                        clearTimeoutAndLeadingRef();
                        handleCallback(...args);
                    }
                };
                const cancel2 = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                currentCallback.flush = flush2;
                currentCallback.cancel = cancel2;
                const resetLeadingState = ()=>{
                    clearTimeoutAndLeadingRef();
                };
                debounceTimerRef.current = window.setTimeout(resetLeadingState, delay);
                return;
            }
            const flush = ()=>{
                if (debounceTimerRef.current !== 0) {
                    clearTimeoutAndLeadingRef();
                    handleCallback(...args);
                }
            };
            const cancel = ()=>{
                clearTimeoutAndLeadingRef();
            };
            currentCallback.flush = flush;
            currentCallback.cancel = cancel;
            debounceTimerRef.current = window.setTimeout(flush, delay);
        }, {
            flush: ()=>{},
            cancel: ()=>{},
            _isFirstCall: true
        });
        return currentCallback;
    }, [
        handleCallback,
        delay,
        leading
    ]);
    (0, _react.useEffect)(()=>()=>{
            if (flushOnUnmount) lastCallback.flush();
            else lastCallback.cancel();
        }, [
        lastCallback,
        flushOnUnmount
    ]);
    return lastCallback;
}

},{"react":"erQJb","../utils/use-callback-ref/use-callback-ref.mjs":"1inGi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1okWM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClickOutside", ()=>useClickOutside);
var _react = require("react");
'use client';
const DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function useClickOutside(callback, events, nodes) {
    const ref = (0, _react.useRef)(null);
    const eventsList = events || DEFAULT_EVENTS;
    (0, _react.useEffect)(()=>{
        const listener = (event)=>{
            const { target } = event ?? {};
            if (Array.isArray(nodes)) {
                const shouldIgnore = !document.body.contains(target) && target?.tagName !== "HTML";
                const shouldTrigger = nodes.every((node)=>!!node && !event.composedPath().includes(node));
                shouldTrigger && !shouldIgnore && callback(event);
            } else if (ref.current && !ref.current.contains(target)) callback(event);
        };
        eventsList.forEach((fn)=>document.addEventListener(fn, listener));
        return ()=>{
            eventsList.forEach((fn)=>document.removeEventListener(fn, listener));
        };
    }, [
        ref,
        callback,
        nodes
    ]);
    return ref;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"33IuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClipboard", ()=>useClipboard);
var _react = require("react");
'use client';
function useClipboard(options = {
    timeout: 2e3
}) {
    const [error, setError] = (0, _react.useState)(null);
    const [copied, setCopied] = (0, _react.useState)(false);
    const [copyTimeout, setCopyTimeout] = (0, _react.useState)(null);
    const handleCopyResult = (value)=>{
        window.clearTimeout(copyTimeout);
        setCopyTimeout(window.setTimeout(()=>setCopied(false), options.timeout));
        setCopied(value);
    };
    const copy = (value)=>{
        if ("clipboard" in navigator) navigator.clipboard.writeText(value).then(()=>handleCopyResult(true)).catch((err)=>setError(err));
        else setError(new Error("useClipboard: navigator.clipboard is not supported"));
    };
    const reset = ()=>{
        setCopied(false);
        setError(null);
        window.clearTimeout(copyTimeout);
    };
    return {
        copy,
        reset,
        error,
        copied
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dounS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorScheme", ()=>useColorScheme);
var _useMediaQueryMjs = require("../use-media-query/use-media-query.mjs");
'use client';
function useColorScheme(initialValue, options) {
    return (0, _useMediaQueryMjs.useMediaQuery)("(prefers-color-scheme: dark)", initialValue === "dark", options) ? "dark" : "light";
}

},{"../use-media-query/use-media-query.mjs":"gNbAU","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gNbAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediaQuery", ()=>useMediaQuery);
var _react = require("react");
'use client';
function attachMediaListener(query, callback) {
    try {
        query.addEventListener("change", callback);
        return ()=>query.removeEventListener("change", callback);
    } catch (e) {
        query.addListener(callback);
        return ()=>query.removeListener(callback);
    }
}
function getInitialValue(query, initialValue) {
    if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
    return false;
}
function useMediaQuery(query, initialValue, { getInitialValueInEffect } = {
    getInitialValueInEffect: true
}) {
    const [matches, setMatches] = (0, _react.useState)(getInitialValueInEffect ? initialValue : getInitialValue(query));
    (0, _react.useEffect)(()=>{
        try {
            const mediaQuery = window.matchMedia(query);
            setMatches(mediaQuery.matches);
            return attachMediaListener(mediaQuery, (event)=>setMatches(event.matches));
        } catch (e) {
            return void 0;
        }
    }, [
        query
    ]);
    return matches || false;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lmsXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCounter", ()=>useCounter);
var _react = require("react");
var _clampMjs = require("../utils/clamp/clamp.mjs");
'use client';
const DEFAULT_OPTIONS = {
    min: -Infinity,
    max: Infinity
};
function useCounter(initialValue = 0, options) {
    const { min, max } = {
        ...DEFAULT_OPTIONS,
        ...options
    };
    const [count, setCount] = (0, _react.useState)((0, _clampMjs.clamp)(initialValue, min, max));
    const increment = (0, _react.useCallback)(()=>setCount((current)=>(0, _clampMjs.clamp)(current + 1, min, max)), [
        min,
        max
    ]);
    const decrement = (0, _react.useCallback)(()=>setCount((current)=>(0, _clampMjs.clamp)(current - 1, min, max)), [
        min,
        max
    ]);
    const set = (0, _react.useCallback)((value)=>setCount((0, _clampMjs.clamp)(value, min, max)), [
        min,
        max
    ]);
    const reset = (0, _react.useCallback)(()=>setCount((0, _clampMjs.clamp)(initialValue, min, max)), [
        initialValue,
        min,
        max
    ]);
    return [
        count,
        {
            increment,
            decrement,
            set,
            reset
        }
    ];
}

},{"react":"erQJb","../utils/clamp/clamp.mjs":"bNBKV","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3W9Dg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebouncedState", ()=>useDebouncedState);
var _react = require("react");
'use client';
function useDebouncedState(defaultValue, wait, options = {
    leading: false
}) {
    const [value, setValue] = (0, _react.useState)(defaultValue);
    const timeoutRef = (0, _react.useRef)(null);
    const leadingRef = (0, _react.useRef)(true);
    const clearTimeout = ()=>window.clearTimeout(timeoutRef.current);
    (0, _react.useEffect)(()=>clearTimeout, []);
    const debouncedSetValue = (0, _react.useCallback)((newValue)=>{
        clearTimeout();
        if (leadingRef.current && options.leading) setValue(newValue);
        else timeoutRef.current = window.setTimeout(()=>{
            leadingRef.current = true;
            setValue(newValue);
        }, wait);
        leadingRef.current = false;
    }, [
        options.leading
    ]);
    return [
        value,
        debouncedSetValue
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9g5zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebouncedValue", ()=>useDebouncedValue);
var _react = require("react");
'use client';
function useDebouncedValue(value, wait, options = {
    leading: false
}) {
    const [_value, setValue] = (0, _react.useState)(value);
    const mountedRef = (0, _react.useRef)(false);
    const timeoutRef = (0, _react.useRef)(null);
    const cooldownRef = (0, _react.useRef)(false);
    const cancel = (0, _react.useCallback)(()=>window.clearTimeout(timeoutRef.current), []);
    (0, _react.useEffect)(()=>{
        if (mountedRef.current) {
            if (!cooldownRef.current && options.leading) {
                cooldownRef.current = true;
                setValue(value);
            } else {
                cancel();
                timeoutRef.current = window.setTimeout(()=>{
                    cooldownRef.current = false;
                    setValue(value);
                }, wait);
            }
        }
    }, [
        value,
        options.leading,
        wait
    ]);
    (0, _react.useEffect)(()=>{
        mountedRef.current = true;
        return cancel;
    }, []);
    return [
        _value,
        cancel
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9WLNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentTitle", ()=>useDocumentTitle);
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
function useDocumentTitle(title) {
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        if (typeof title === "string" && title.trim().length > 0) document.title = title.trim();
    }, [
        title
    ]);
}

},{"../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6Cmng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicEffect", ()=>useIsomorphicEffect);
var _react = require("react");
'use client';
const useIsomorphicEffect = typeof document !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jXGng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDocumentVisibility", ()=>useDocumentVisibility);
var _react = require("react");
'use client';
function useDocumentVisibility() {
    const [documentVisibility, setDocumentVisibility] = (0, _react.useState)("visible");
    (0, _react.useEffect)(()=>{
        setDocumentVisibility(document.visibilityState);
        const listener = ()=>setDocumentVisibility(document.visibilityState);
        document.addEventListener("visibilitychange", listener);
        return ()=>document.removeEventListener("visibilitychange", listener);
    }, []);
    return documentVisibility;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lTHUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusReturn", ()=>useFocusReturn);
var _react = require("react");
var _useDidUpdateMjs = require("../use-did-update/use-did-update.mjs");
'use client';
function useFocusReturn({ opened, shouldReturnFocus = true }) {
    const lastActiveElement = (0, _react.useRef)(null);
    const returnFocus = ()=>{
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") lastActiveElement.current?.focus({
            preventScroll: true
        });
    };
    (0, _useDidUpdateMjs.useDidUpdate)(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === "Tab") window.clearTimeout(timeout);
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) lastActiveElement.current = document.activeElement;
        else if (shouldReturnFocus) timeout = window.setTimeout(returnFocus, 10);
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}

},{"react":"erQJb","../use-did-update/use-did-update.mjs":"bzSpx","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bzSpx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDidUpdate", ()=>useDidUpdate);
var _react = require("react");
'use client';
function useDidUpdate(fn, dependencies) {
    const mounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, _react.useEffect)(()=>{
        if (mounted.current) return fn();
        mounted.current = true;
        return void 0;
    }, dependencies);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hpsZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusTrap", ()=>useFocusTrap);
var _react = require("react");
var _scopeTabMjs = require("./scope-tab.mjs");
var _tabbableMjs = require("./tabbable.mjs");
'use client';
function useFocusTrap(active = true) {
    const ref = (0, _react.useRef)(null);
    const focusNode = (node)=>{
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            const children = Array.from(node.querySelectorAll((0, _tabbableMjs.FOCUS_SELECTOR)));
            focusElement = children.find((0, _tabbableMjs.tabbable)) || children.find((0, _tabbableMjs.focusable)) || null;
            if (!focusElement && (0, _tabbableMjs.focusable)(node)) focusElement = node;
        }
        if (focusElement) focusElement.focus({
            preventScroll: true
        });
    };
    const setRef = (0, _react.useCallback)((node)=>{
        if (!active) return;
        if (node === null) return;
        if (ref.current === node) return;
        if (node) {
            setTimeout(()=>{
                if (node.getRootNode()) focusNode(node);
            });
            ref.current = node;
        } else ref.current = null;
    }, [
        active
    ]);
    (0, _react.useEffect)(()=>{
        if (!active) return void 0;
        ref.current && setTimeout(()=>focusNode(ref.current));
        const handleKeyDown = (event)=>{
            if (event.key === "Tab" && ref.current) (0, _scopeTabMjs.scopeTab)(ref.current, event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        active
    ]);
    return setRef;
}

},{"react":"erQJb","./scope-tab.mjs":"fiEiF","./tabbable.mjs":"hQB1y","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fiEiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scopeTab", ()=>scopeTab);
var _tabbableMjs = require("./tabbable.mjs");
'use client';
function scopeTab(node, event) {
    const tabbable = (0, _tabbableMjs.findTabbableDescendants)(node);
    if (!tabbable.length) {
        event.preventDefault();
        return;
    }
    const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
    const root = node.getRootNode();
    let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    const activeElement = root.activeElement;
    const activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
    if (activeElementIsRadio) {
        const activeRadioGroup = tabbable.filter((element)=>element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name"));
        leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
    }
    if (!leavingFinalTabbable) return;
    event.preventDefault();
    const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
    if (target) target.focus();
}

},{"./tabbable.mjs":"hQB1y","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hQB1y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOCUS_SELECTOR", ()=>FOCUS_SELECTOR);
parcelHelpers.export(exports, "findTabbableDescendants", ()=>findTabbableDescendants);
parcelHelpers.export(exports, "focusable", ()=>focusable);
parcelHelpers.export(exports, "tabbable", ()=>tabbable);
'use client';
const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function hidden(element) {
    return element.style.display === "none";
}
function visible(element) {
    const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) break;
        if (hidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function getElementTabIndex(element) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    return parseInt(tabIndex, 10);
}
function focusable(element) {
    const nodeName = element.nodeName.toLowerCase();
    const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
    const res = // @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition
    TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    const tabIndex = getElementTabIndex(element);
    const isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
    return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3vpJH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useForceUpdate", ()=>useForceUpdate);
var _react = require("react");
'use client';
const reducer = (value)=>(value + 1) % 1e6;
function useForceUpdate() {
    const [, update] = (0, _react.useReducer)(reducer, 0);
    return update;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"H2nB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
var _randomIdMjs = require("../utils/random-id/random-id.mjs");
var _useReactIdMjs = require("./use-react-id.mjs");
'use client';
function useId(staticId) {
    const reactId = (0, _useReactIdMjs.useReactId)();
    const [uuid, setUuid] = (0, _react.useState)(reactId);
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        setUuid((0, _randomIdMjs.randomId)());
    }, []);
    if (typeof staticId === "string") return staticId;
    if (typeof window === "undefined") return reactId;
    return uuid;
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","../utils/random-id/random-id.mjs":"3bLBD","./use-react-id.mjs":"e0Qxb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"e0Qxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReactId", ()=>useReactId);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
const __useId = (0, _reactDefault.default)["useId".toString()] || (()=>void 0);
function useReactId() {
    const id = __useId();
    return id ? `mantine-${id.replace(/:/g, "")}` : "";
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3Ferq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIdle", ()=>useIdle);
var _react = require("react");
'use client';
const DEFAULT_OPTIONS = {
    events: [
        "keydown",
        "mousemove",
        "touchmove",
        "click",
        "scroll",
        "wheel"
    ],
    initialState: true
};
function useIdle(timeout, options) {
    const { events, initialState } = {
        ...DEFAULT_OPTIONS,
        ...options
    };
    const [idle, setIdle] = (0, _react.useState)(initialState);
    const timer = (0, _react.useRef)(-1);
    (0, _react.useEffect)(()=>{
        const handleEvents = ()=>{
            setIdle(false);
            if (timer.current) window.clearTimeout(timer.current);
            timer.current = window.setTimeout(()=>{
                setIdle(true);
            }, timeout);
        };
        events.forEach((event)=>document.addEventListener(event, handleEvents));
        timer.current = window.setTimeout(()=>{
            setIdle(true);
        }, timeout);
        return ()=>{
            events.forEach((event)=>document.removeEventListener(event, handleEvents));
            window.clearTimeout(timer.current);
            timer.current = -1;
        };
    }, [
        timeout
    ]);
    return idle;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8Kq6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
var _react = require("react");
'use client';
function useInterval(fn, interval, { autoInvoke = false } = {}) {
    const [active, setActive] = (0, _react.useState)(false);
    const intervalRef = (0, _react.useRef)(null);
    const fnRef = (0, _react.useRef)(null);
    const start = (0, _react.useCallback)(()=>{
        setActive((old)=>{
            if (!old && (!intervalRef.current || intervalRef.current === -1)) intervalRef.current = window.setInterval(fnRef.current, interval);
            return true;
        });
    }, []);
    const stop = (0, _react.useCallback)(()=>{
        setActive(false);
        window.clearInterval(intervalRef.current || -1);
        intervalRef.current = -1;
    }, []);
    const toggle = (0, _react.useCallback)(()=>{
        if (active) stop();
        else start();
    }, [
        active
    ]);
    (0, _react.useEffect)(()=>{
        fnRef.current = fn;
        active && start();
        return stop;
    }, [
        fn,
        active,
        interval
    ]);
    (0, _react.useEffect)(()=>{
        if (autoInvoke) start();
    }, []);
    return {
        start,
        stop,
        toggle,
        active
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"49dQQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useListState", ()=>useListState);
var _react = require("react");
'use client';
function useListState(initialValue = []) {
    const [state, setState] = (0, _react.useState)(initialValue);
    const append = (0, _react.useCallback)((...items)=>setState((current)=>[
                ...current,
                ...items
            ]), []);
    const prepend = (0, _react.useCallback)((...items)=>setState((current)=>[
                ...items,
                ...current
            ]), []);
    const insert = (0, _react.useCallback)((index, ...items)=>setState((current)=>[
                ...current.slice(0, index),
                ...items,
                ...current.slice(index)
            ]), []);
    const apply = (0, _react.useCallback)((fn)=>setState((current)=>current.map((item, index)=>fn(item, index))), []);
    const remove = (0, _react.useCallback)((...indices)=>setState((current)=>current.filter((_, index)=>!indices.includes(index))), []);
    const pop = (0, _react.useCallback)(()=>setState((current)=>{
            const cloned = [
                ...current
            ];
            cloned.pop();
            return cloned;
        }), []);
    const shift = (0, _react.useCallback)(()=>setState((current)=>{
            const cloned = [
                ...current
            ];
            cloned.shift();
            return cloned;
        }), []);
    const reorder = (0, _react.useCallback)(({ from, to })=>setState((current)=>{
            const cloned = [
                ...current
            ];
            const item = current[from];
            cloned.splice(from, 1);
            cloned.splice(to, 0, item);
            return cloned;
        }), []);
    const swap = (0, _react.useCallback)(({ from, to })=>setState((current)=>{
            const cloned = [
                ...current
            ];
            const fromItem = cloned[from];
            const toItem = cloned[to];
            cloned.splice(to, 1, fromItem);
            cloned.splice(from, 1, toItem);
            return cloned;
        }), []);
    const setItem = (0, _react.useCallback)((index, item)=>setState((current)=>{
            const cloned = [
                ...current
            ];
            cloned[index] = item;
            return cloned;
        }), []);
    const setItemProp = (0, _react.useCallback)((index, prop, value)=>setState((current)=>{
            const cloned = [
                ...current
            ];
            cloned[index] = {
                ...cloned[index],
                [prop]: value
            };
            return cloned;
        }), []);
    const applyWhere = (0, _react.useCallback)((condition, fn)=>setState((current)=>current.map((item, index)=>condition(item, index) ? fn(item, index) : item)), []);
    const filter = (0, _react.useCallback)((fn)=>{
        setState((current)=>current.filter(fn));
    }, []);
    const handlers = (0, _react.useMemo)(()=>({
            setState,
            append,
            prepend,
            insert,
            pop,
            shift,
            apply,
            applyWhere,
            remove,
            reorder,
            swap,
            setItem,
            setItemProp,
            filter
        }), []);
    return [
        state,
        handlers
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jBaZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readLocalStorageValue", ()=>readLocalStorageValue);
parcelHelpers.export(exports, "useLocalStorage", ()=>useLocalStorage);
var _createStorageMjs = require("./create-storage.mjs");
'use client';
function useLocalStorage(props) {
    return (0, _createStorageMjs.createStorage)("localStorage", "use-local-storage")(props);
}
const readLocalStorageValue = (0, _createStorageMjs.readValue)("localStorage");

},{"./create-storage.mjs":"1BIU6","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1BIU6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStorage", ()=>createStorage);
parcelHelpers.export(exports, "readValue", ()=>readValue);
var _react = require("react");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
function serializeJSON(value, hookName = "use-local-storage") {
    try {
        return JSON.stringify(value);
    } catch (error) {
        throw new Error(`@mantine/hooks ${hookName}: Failed to serialize the value`);
    }
}
function deserializeJSON(value) {
    try {
        return value && JSON.parse(value);
    } catch  {
        return value;
    }
}
function createStorageHandler(type) {
    const getItem = (key)=>{
        try {
            return window[type].getItem(key);
        } catch (error) {
            console.warn("use-local-storage: Failed to get value from storage, localStorage is blocked");
            return null;
        }
    };
    const setItem = (key, value)=>{
        try {
            window[type].setItem(key, value);
        } catch (error) {
            console.warn("use-local-storage: Failed to set value to storage, localStorage is blocked");
        }
    };
    const removeItem = (key)=>{
        try {
            window[type].removeItem(key);
        } catch (error) {
            console.warn("use-local-storage: Failed to remove value from storage, localStorage is blocked");
        }
    };
    return {
        getItem,
        setItem,
        removeItem
    };
}
function createStorage(type, hookName) {
    const eventName = type === "localStorage" ? "mantine-local-storage" : "mantine-session-storage";
    const { getItem, setItem, removeItem } = createStorageHandler(type);
    return function useStorage({ key, defaultValue, getInitialValueInEffect = true, sync = true, deserialize = deserializeJSON, serialize = (value)=>serializeJSON(value, hookName) }) {
        const readStorageValue = (0, _react.useCallback)((skipStorage)=>{
            let storageBlockedOrSkipped;
            try {
                storageBlockedOrSkipped = typeof window === "undefined" || !(type in window) || window[type] === null || !!skipStorage;
            } catch (_e) {
                storageBlockedOrSkipped = true;
            }
            if (storageBlockedOrSkipped) return defaultValue;
            const storageValue = getItem(key);
            return storageValue !== null ? deserialize(storageValue) : defaultValue;
        }, [
            key,
            defaultValue
        ]);
        const [value, setValue] = (0, _react.useState)(readStorageValue(getInitialValueInEffect));
        const setStorageValue = (0, _react.useCallback)((val)=>{
            if (val instanceof Function) setValue((current)=>{
                const result = val(current);
                setItem(key, serialize(result));
                queueMicrotask(()=>{
                    window.dispatchEvent(new CustomEvent(eventName, {
                        detail: {
                            key,
                            value: val(current)
                        }
                    }));
                });
                return result;
            });
            else {
                setItem(key, serialize(val));
                window.dispatchEvent(new CustomEvent(eventName, {
                    detail: {
                        key,
                        value: val
                    }
                }));
                setValue(val);
            }
        }, [
            key
        ]);
        const removeStorageValue = (0, _react.useCallback)(()=>{
            removeItem(key);
            setValue(defaultValue);
            window.dispatchEvent(new CustomEvent(eventName, {
                detail: {
                    key,
                    value: defaultValue
                }
            }));
        }, [
            key,
            defaultValue
        ]);
        (0, _useWindowEventMjs.useWindowEvent)("storage", (event)=>{
            if (sync) {
                if (event.storageArea === window[type] && event.key === key) setValue(deserialize(event.newValue ?? void 0));
            }
        });
        (0, _useWindowEventMjs.useWindowEvent)(eventName, (event)=>{
            if (sync) {
                if (event.detail.key === key) setValue(event.detail.value);
            }
        });
        (0, _react.useEffect)(()=>{
            if (defaultValue !== void 0 && value === void 0) setStorageValue(defaultValue);
        }, [
            defaultValue,
            value,
            setStorageValue
        ]);
        (0, _react.useEffect)(()=>{
            const val = readStorageValue();
            val !== void 0 && setStorageValue(val);
        }, [
            key
        ]);
        return [
            value === void 0 ? defaultValue : value,
            setStorageValue,
            removeStorageValue
        ];
    };
}
function readValue(type) {
    const { getItem } = createStorageHandler(type);
    return function read({ key, defaultValue, deserialize = deserializeJSON }) {
        let storageBlockedOrSkipped;
        try {
            storageBlockedOrSkipped = typeof window === "undefined" || !(type in window) || window[type] === null;
        } catch (_e) {
            storageBlockedOrSkipped = true;
        }
        if (storageBlockedOrSkipped) return defaultValue;
        const storageValue = getItem(key);
        return storageValue !== null ? deserialize(storageValue) : defaultValue;
    };
}

},{"react":"erQJb","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6GqGu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowEvent", ()=>useWindowEvent);
var _react = require("react");
'use client';
function useWindowEvent(type, listener, options) {
    (0, _react.useEffect)(()=>{
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener
    ]);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7ASi3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readSessionStorageValue", ()=>readSessionStorageValue);
parcelHelpers.export(exports, "useSessionStorage", ()=>useSessionStorage);
var _createStorageMjs = require("../use-local-storage/create-storage.mjs");
'use client';
function useSessionStorage(props) {
    return (0, _createStorageMjs.createStorage)("sessionStorage", "use-session-storage")(props);
}
const readSessionStorageValue = (0, _createStorageMjs.readValue)("sessionStorage");

},{"../use-local-storage/create-storage.mjs":"1BIU6","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3QtIc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>assignRef);
parcelHelpers.export(exports, "mergeRefs", ()=>mergeRefs);
parcelHelpers.export(exports, "useMergedRef", ()=>useMergedRef);
var _react = require("react");
'use client';
function assignRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (typeof ref === "object" && ref !== null && "current" in ref) ref.current = value;
}
function mergeRefs(...refs) {
    const cleanupMap = /* @__PURE__ */ new Map();
    return (node)=>{
        refs.forEach((ref)=>{
            const cleanup = assignRef(ref, node);
            if (cleanup) cleanupMap.set(ref, cleanup);
        });
        if (cleanupMap.size > 0) return ()=>{
            refs.forEach((ref)=>{
                const cleanup = cleanupMap.get(ref);
                if (cleanup && typeof cleanup === "function") cleanup();
                else assignRef(ref, null);
            });
            cleanupMap.clear();
        };
    };
}
function useMergedRef(...refs) {
    return (0, _react.useCallback)(mergeRefs(...refs), refs);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cXXGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMouse", ()=>useMouse);
var _react = require("react");
'use client';
function useMouse(options = {
    resetOnExit: false
}) {
    const [position, setPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const ref = (0, _react.useRef)(null);
    const setMousePosition = (event)=>{
        if (ref.current) {
            const rect = event.currentTarget.getBoundingClientRect();
            const x = Math.max(0, Math.round(event.pageX - rect.left - (window.scrollX || window.scrollX)));
            const y = Math.max(0, Math.round(event.pageY - rect.top - (window.scrollY || window.scrollY)));
            setPosition({
                x,
                y
            });
        } else setPosition({
            x: event.clientX,
            y: event.clientY
        });
    };
    const resetMousePosition = ()=>setPosition({
            x: 0,
            y: 0
        });
    (0, _react.useEffect)(()=>{
        const element = ref?.current ? ref.current : document;
        element.addEventListener("mousemove", setMousePosition);
        if (options.resetOnExit) element.addEventListener("mouseleave", resetMousePosition);
        return ()=>{
            element.removeEventListener("mousemove", setMousePosition);
            if (options.resetOnExit) element.removeEventListener("mouseleave", resetMousePosition);
        };
    }, [
        ref.current
    ]);
    return {
        ref,
        ...position
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"j02md":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clampUseMovePosition", ()=>clampUseMovePosition);
parcelHelpers.export(exports, "useMove", ()=>useMove);
var _react = require("react");
var _clampMjs = require("../utils/clamp/clamp.mjs");
'use client';
function clampUseMovePosition(position) {
    return {
        x: (0, _clampMjs.clamp)(position.x, 0, 1),
        y: (0, _clampMjs.clamp)(position.y, 0, 1)
    };
}
function useMove(onChange, handlers, dir = "ltr") {
    const mounted = (0, _react.useRef)(false);
    const isSliding = (0, _react.useRef)(false);
    const frame = (0, _react.useRef)(0);
    const [active, setActive] = (0, _react.useState)(false);
    const cleanupRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
    }, []);
    const refCallback = (0, _react.useCallback)((node)=>{
        if (cleanupRef.current) {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (!node) return;
        const onScrub = ({ x, y })=>{
            cancelAnimationFrame(frame.current);
            frame.current = requestAnimationFrame(()=>{
                if (mounted.current && node) {
                    node.style.userSelect = "none";
                    const rect = node.getBoundingClientRect();
                    if (rect.width && rect.height) {
                        const _x = (0, _clampMjs.clamp)((x - rect.left) / rect.width, 0, 1);
                        onChange({
                            x: dir === "ltr" ? _x : 1 - _x,
                            y: (0, _clampMjs.clamp)((y - rect.top) / rect.height, 0, 1)
                        });
                    }
                }
            });
        };
        const bindEvents = ()=>{
            document.addEventListener("mousemove", onMouseMove);
            document.addEventListener("mouseup", stopScrubbing);
            document.addEventListener("touchmove", onTouchMove, {
                passive: false
            });
            document.addEventListener("touchend", stopScrubbing);
        };
        const unbindEvents = ()=>{
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", stopScrubbing);
            document.removeEventListener("touchmove", onTouchMove);
            document.removeEventListener("touchend", stopScrubbing);
        };
        const startScrubbing = ()=>{
            if (!isSliding.current && mounted.current) {
                isSliding.current = true;
                typeof handlers?.onScrubStart === "function" && handlers.onScrubStart();
                setActive(true);
                bindEvents();
            }
        };
        const stopScrubbing = ()=>{
            if (isSliding.current && mounted.current) {
                isSliding.current = false;
                setActive(false);
                unbindEvents();
                setTimeout(()=>{
                    typeof handlers?.onScrubEnd === "function" && handlers.onScrubEnd();
                }, 0);
            }
        };
        const onMouseDown = (event)=>{
            startScrubbing();
            event.preventDefault();
            onMouseMove(event);
        };
        const onMouseMove = (event)=>onScrub({
                x: event.clientX,
                y: event.clientY
            });
        const onTouchStart = (event)=>{
            if (event.cancelable) event.preventDefault();
            startScrubbing();
            onTouchMove(event);
        };
        const onTouchMove = (event)=>{
            if (event.cancelable) event.preventDefault();
            onScrub({
                x: event.changedTouches[0].clientX,
                y: event.changedTouches[0].clientY
            });
        };
        node.addEventListener("mousedown", onMouseDown);
        node.addEventListener("touchstart", onTouchStart, {
            passive: false
        });
        cleanupRef.current = ()=>{
            node.removeEventListener("mousedown", onMouseDown);
            node.removeEventListener("touchstart", onTouchStart);
        };
    }, [
        dir,
        onChange
    ]);
    return {
        ref: refCallback,
        active
    };
}

},{"react":"erQJb","../utils/clamp/clamp.mjs":"bNBKV","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bMmGY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOTS", ()=>DOTS);
parcelHelpers.export(exports, "usePagination", ()=>usePagination);
var _react = require("react");
var _useUncontrolledMjs = require("../use-uncontrolled/use-uncontrolled.mjs");
'use client';
function range(start, end) {
    const length = end - start + 1;
    return Array.from({
        length
    }, (_, index)=>index + start);
}
const DOTS = "dots";
function usePagination({ total, siblings = 1, boundaries = 1, page, initialPage = 1, onChange }) {
    const _total = Math.max(Math.trunc(total), 0);
    const [activePage, setActivePage] = (0, _useUncontrolledMjs.useUncontrolled)({
        value: page,
        onChange,
        defaultValue: initialPage,
        finalValue: initialPage
    });
    const setPage = (pageNumber)=>{
        if (pageNumber <= 0) setActivePage(1);
        else if (pageNumber > _total) setActivePage(_total);
        else setActivePage(pageNumber);
    };
    const next = ()=>setPage(activePage + 1);
    const previous = ()=>setPage(activePage - 1);
    const first = ()=>setPage(1);
    const last = ()=>setPage(_total);
    const paginationRange = (0, _react.useMemo)(()=>{
        const totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
        if (totalPageNumbers >= _total) return range(1, _total);
        const leftSiblingIndex = Math.max(activePage - siblings, boundaries);
        const rightSiblingIndex = Math.min(activePage + siblings, _total - boundaries);
        const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
        const shouldShowRightDots = rightSiblingIndex < _total - (boundaries + 1);
        if (!shouldShowLeftDots && shouldShowRightDots) {
            const leftItemCount = siblings * 2 + boundaries + 2;
            return [
                ...range(1, leftItemCount),
                DOTS,
                ...range(_total - (boundaries - 1), _total)
            ];
        }
        if (shouldShowLeftDots && !shouldShowRightDots) {
            const rightItemCount = boundaries + 1 + 2 * siblings;
            return [
                ...range(1, boundaries),
                DOTS,
                ...range(_total - rightItemCount, _total)
            ];
        }
        return [
            ...range(1, boundaries),
            DOTS,
            ...range(leftSiblingIndex, rightSiblingIndex),
            DOTS,
            ...range(_total - boundaries + 1, _total)
        ];
    }, [
        _total,
        siblings,
        activePage
    ]);
    return {
        range: paginationRange,
        active: activePage,
        setPage,
        next,
        previous,
        first,
        last
    };
}

},{"react":"erQJb","../use-uncontrolled/use-uncontrolled.mjs":"bBNEa","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bBNEa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUncontrolled", ()=>useUncontrolled);
var _react = require("react");
'use client';
function useUncontrolled({ value, defaultValue, finalValue, onChange = ()=>{} }) {
    const [uncontrolledValue, setUncontrolledValue] = (0, _react.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
    const handleUncontrolledChange = (val, ...payload)=>{
        setUncontrolledValue(val);
        onChange?.(val, ...payload);
    };
    if (value !== void 0) return [
        value,
        onChange,
        true
    ];
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bSrOl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueue", ()=>useQueue);
var _react = require("react");
'use client';
function useQueue({ initialValues = [], limit }) {
    const [state, setState] = (0, _react.useState)({
        state: initialValues.slice(0, limit),
        queue: initialValues.slice(limit)
    });
    const add = (...items)=>setState((current)=>{
            const results = [
                ...current.state,
                ...current.queue,
                ...items
            ];
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit)
            };
        });
    const update = (fn)=>setState((current)=>{
            const results = fn([
                ...current.state,
                ...current.queue
            ]);
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit)
            };
        });
    const cleanQueue = ()=>setState((current)=>({
                state: current.state,
                queue: []
            }));
    return {
        state: state.state,
        queue: state.queue,
        add,
        update,
        cleanQueue
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kN6EH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePageLeave", ()=>usePageLeave);
var _react = require("react");
'use client';
function usePageLeave(onPageLeave) {
    (0, _react.useEffect)(()=>{
        document.documentElement.addEventListener("mouseleave", onPageLeave);
        return ()=>document.documentElement.removeEventListener("mouseleave", onPageLeave);
    }, []);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"F0OXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReducedMotion", ()=>useReducedMotion);
var _useMediaQueryMjs = require("../use-media-query/use-media-query.mjs");
'use client';
function useReducedMotion(initialValue, options) {
    return (0, _useMediaQueryMjs.useMediaQuery)("(prefers-reduced-motion: reduce)", initialValue, options);
}

},{"../use-media-query/use-media-query.mjs":"gNbAU","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7RRnA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollIntoView", ()=>useScrollIntoView);
var _react = require("react");
var _useReducedMotionMjs = require("../use-reduced-motion/use-reduced-motion.mjs");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
function useScrollIntoView({ duration = 1250, axis = "y", onScrollFinish, easing = easeInOutQuad, offset = 0, cancelable = true, isList = false } = {}) {
    const frameID = (0, _react.useRef)(0);
    const startTime = (0, _react.useRef)(0);
    const shouldStop = (0, _react.useRef)(false);
    const scrollableRef = (0, _react.useRef)(null);
    const targetRef = (0, _react.useRef)(null);
    const reducedMotion = (0, _useReducedMotionMjs.useReducedMotion)();
    const cancel = ()=>{
        if (frameID.current) cancelAnimationFrame(frameID.current);
    };
    const scrollIntoView = (0, _react.useCallback)(({ alignment = "start" } = {})=>{
        shouldStop.current = false;
        if (frameID.current) cancel();
        const start = getScrollStart({
            parent: scrollableRef.current,
            axis
        }) ?? 0;
        const change = getRelativePosition({
            parent: scrollableRef.current,
            target: targetRef.current,
            axis,
            alignment,
            offset,
            isList
        }) - (scrollableRef.current ? 0 : start);
        function animateScroll() {
            if (startTime.current === 0) startTime.current = performance.now();
            const now = performance.now();
            const elapsed = now - startTime.current;
            const t = reducedMotion || duration === 0 ? 1 : elapsed / duration;
            const distance = start + change * easing(t);
            setScrollParam({
                parent: scrollableRef.current,
                axis,
                distance
            });
            if (!shouldStop.current && t < 1) frameID.current = requestAnimationFrame(animateScroll);
            else {
                typeof onScrollFinish === "function" && onScrollFinish();
                startTime.current = 0;
                frameID.current = 0;
                cancel();
            }
        }
        animateScroll();
    }, [
        axis,
        duration,
        easing,
        isList,
        offset,
        onScrollFinish,
        reducedMotion
    ]);
    const handleStop = ()=>{
        if (cancelable) shouldStop.current = true;
    };
    (0, _useWindowEventMjs.useWindowEvent)("wheel", handleStop, {
        passive: true
    });
    (0, _useWindowEventMjs.useWindowEvent)("touchmove", handleStop, {
        passive: true
    });
    (0, _react.useEffect)(()=>cancel, []);
    return {
        scrollableRef,
        targetRef,
        scrollIntoView,
        cancel
    };
}
function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
function getRelativePosition({ axis, target, parent, alignment, offset, isList }) {
    if (!target || !parent && typeof document === "undefined") return 0;
    const isCustomParent = !!parent;
    const parentElement = parent || document.body;
    const parentPosition = parentElement.getBoundingClientRect();
    const targetPosition = target.getBoundingClientRect();
    const getDiff = (property)=>targetPosition[property] - parentPosition[property];
    if (axis === "y") {
        const diff = getDiff("top");
        if (diff === 0) return 0;
        if (alignment === "start") {
            const distance = diff - offset;
            const shouldScroll = distance <= targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll ? distance : 0;
        }
        const parentHeight = isCustomParent ? parentPosition.height : window.innerHeight;
        if (alignment === "end") {
            const distance = diff + offset - parentHeight + targetPosition.height;
            const shouldScroll = distance >= -targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll ? distance : 0;
        }
        if (alignment === "center") return diff - parentHeight / 2 + targetPosition.height / 2;
        return 0;
    }
    if (axis === "x") {
        const diff = getDiff("left");
        if (diff === 0) return 0;
        if (alignment === "start") {
            const distance = diff - offset;
            const shouldScroll = distance <= targetPosition.width || !isList;
            return shouldScroll ? distance : 0;
        }
        const parentWidth = isCustomParent ? parentPosition.width : window.innerWidth;
        if (alignment === "end") {
            const distance = diff + offset - parentWidth + targetPosition.width;
            const shouldScroll = distance >= -targetPosition.width || !isList;
            return shouldScroll ? distance : 0;
        }
        if (alignment === "center") return diff - parentWidth / 2 + targetPosition.width / 2;
        return 0;
    }
    return 0;
}
function getScrollStart({ axis, parent }) {
    if (!parent && typeof document === "undefined") return 0;
    const method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) return parent[method];
    const { body, documentElement } = document;
    return body[method] + documentElement[method];
}
function setScrollParam({ axis, parent, distance }) {
    if (!parent && typeof document === "undefined") return;
    const method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) parent[method] = distance;
    else {
        const { body, documentElement } = document;
        body[method] = distance;
        documentElement[method] = distance;
    }
}

},{"react":"erQJb","../use-reduced-motion/use-reduced-motion.mjs":"F0OXZ","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1qaJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useElementSize", ()=>useElementSize);
parcelHelpers.export(exports, "useResizeObserver", ()=>useResizeObserver);
var _react = require("react");
'use client';
const defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function useResizeObserver(options) {
    const frameID = (0, _react.useRef)(0);
    const ref = (0, _react.useRef)(null);
    const [rect, setRect] = (0, _react.useState)(defaultState);
    const observer = (0, _react.useMemo)(()=>typeof window !== "undefined" ? new ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry) {
                cancelAnimationFrame(frameID.current);
                frameID.current = requestAnimationFrame(()=>{
                    if (ref.current) {
                        const boxSize = entry.borderBoxSize?.[0] || entry.contentBoxSize?.[0];
                        if (boxSize) {
                            const width = boxSize.inlineSize;
                            const height = boxSize.blockSize;
                            setRect({
                                width,
                                height,
                                x: entry.contentRect.x,
                                y: entry.contentRect.y,
                                top: entry.contentRect.top,
                                left: entry.contentRect.left,
                                bottom: entry.contentRect.bottom,
                                right: entry.contentRect.right
                            });
                        } else setRect(entry.contentRect);
                    }
                });
            }
        }) : null, []);
    (0, _react.useEffect)(()=>{
        if (ref.current) observer?.observe(ref.current, options);
        return ()=>{
            observer?.disconnect();
            if (frameID.current) cancelAnimationFrame(frameID.current);
        };
    }, [
        ref.current
    ]);
    return [
        ref,
        rect
    ];
}
function useElementSize(options) {
    const [ref, { width, height }] = useResizeObserver(options);
    return {
        ref,
        width,
        height
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3I1EC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useShallowEffect", ()=>useShallowEffect);
var _react = require("react");
var _shallowEqualMjs = require("../utils/shallow-equal/shallow-equal.mjs");
'use client';
function shallowCompare(prevValue, currValue) {
    if (!prevValue || !currValue) return false;
    if (prevValue === currValue) return true;
    if (prevValue.length !== currValue.length) return false;
    for(let i = 0; i < prevValue.length; i += 1){
        if (!(0, _shallowEqualMjs.shallowEqual)(prevValue[i], currValue[i])) return false;
    }
    return true;
}
function useShallowCompare(dependencies) {
    const ref = (0, _react.useRef)([]);
    const updateRef = (0, _react.useRef)(0);
    if (!shallowCompare(ref.current, dependencies)) {
        ref.current = dependencies;
        updateRef.current += 1;
    }
    return [
        updateRef.current
    ];
}
function useShallowEffect(cb, dependencies) {
    (0, _react.useEffect)(cb, useShallowCompare(dependencies));
}

},{"react":"erQJb","../utils/shallow-equal/shallow-equal.mjs":"g7ba9","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3jxCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggle", ()=>useToggle);
var _react = require("react");
'use client';
function useToggle(options = [
    false,
    true
]) {
    const [[option], toggle] = (0, _react.useReducer)((state, action)=>{
        const value = action instanceof Function ? action(state[0]) : action;
        const index = Math.abs(state.indexOf(value));
        return state.slice(index).concat(state.slice(0, index));
    }, options);
    return [
        option,
        toggle
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dKpSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useViewportSize", ()=>useViewportSize);
var _react = require("react");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
const eventListerOptions = {
    passive: true
};
function useViewportSize() {
    const [windowSize, setWindowSize] = (0, _react.useState)({
        width: 0,
        height: 0
    });
    const setSize = (0, _react.useCallback)(()=>{
        setWindowSize({
            width: window.innerWidth || 0,
            height: window.innerHeight || 0
        });
    }, []);
    (0, _useWindowEventMjs.useWindowEvent)("resize", setSize, eventListerOptions);
    (0, _useWindowEventMjs.useWindowEvent)("orientationchange", setSize, eventListerOptions);
    (0, _react.useEffect)(setSize, []);
    return windowSize;
}

},{"react":"erQJb","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"iy20W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWindowScroll", ()=>useWindowScroll);
var _react = require("react");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
function getScrollPosition() {
    return typeof window !== "undefined" ? {
        x: window.scrollX,
        y: window.scrollY
    } : {
        x: 0,
        y: 0
    };
}
function scrollTo({ x, y }) {
    if (typeof window !== "undefined") {
        const scrollOptions = {
            behavior: "smooth"
        };
        if (typeof x === "number") scrollOptions.left = x;
        if (typeof y === "number") scrollOptions.top = y;
        window.scrollTo(scrollOptions);
    }
}
function useWindowScroll() {
    const [position, setPosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    (0, _useWindowEventMjs.useWindowEvent)("scroll", ()=>setPosition(getScrollPosition()));
    (0, _useWindowEventMjs.useWindowEvent)("resize", ()=>setPosition(getScrollPosition()));
    (0, _react.useEffect)(()=>{
        setPosition(getScrollPosition());
    }, []);
    return [
        position,
        scrollTo
    ];
}

},{"react":"erQJb","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"87Req":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIntersection", ()=>useIntersection);
var _react = require("react");
'use client';
function useIntersection(options) {
    const [entry, setEntry] = (0, _react.useState)(null);
    const observer = (0, _react.useRef)(null);
    const ref = (0, _react.useCallback)((element)=>{
        if (observer.current) {
            observer.current.disconnect();
            observer.current = null;
        }
        if (element === null) {
            setEntry(null);
            return;
        }
        observer.current = new IntersectionObserver(([_entry])=>{
            setEntry(_entry);
        }, options);
        observer.current.observe(element);
    }, [
        options?.rootMargin,
        options?.root,
        options?.threshold
    ]);
    return {
        ref,
        entry
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d9BOv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHash", ()=>useHash);
var _react = require("react");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
function useHash({ getInitialValueInEffect = true } = {}) {
    const [hash, setHash] = (0, _react.useState)(getInitialValueInEffect ? "" : window.location.hash || "");
    const setHashHandler = (value)=>{
        const valueWithHash = value.startsWith("#") ? value : `#${value}`;
        window.location.hash = valueWithHash;
        setHash(valueWithHash);
    };
    (0, _useWindowEventMjs.useWindowEvent)("hashchange", ()=>{
        const newHash = window.location.hash;
        if (hash !== newHash) setHash(newHash);
    });
    (0, _react.useEffect)(()=>{
        if (getInitialValueInEffect) setHash(window.location.hash);
    }, []);
    return [
        hash,
        setHashHandler
    ];
}

},{"react":"erQJb","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jkWab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHotkeyHandler", ()=>(0, _parseHotkeyMjs.getHotkeyHandler));
parcelHelpers.export(exports, "useHotkeys", ()=>useHotkeys);
var _react = require("react");
var _parseHotkeyMjs = require("./parse-hotkey.mjs");
'use client';
function shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable = false) {
    if (event.target instanceof HTMLElement) {
        if (triggerOnContentEditable) return !tagsToIgnore.includes(event.target.tagName);
        return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
    }
    return true;
}
function useHotkeys(hotkeys, tagsToIgnore = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
], triggerOnContentEditable = false) {
    (0, _react.useEffect)(()=>{
        const keydownListener = (event)=>{
            hotkeys.forEach(([hotkey, handler, options = {
                preventDefault: true,
                usePhysicalKeys: false
            }])=>{
                if ((0, _parseHotkeyMjs.getHotkeyMatcher)(hotkey, options.usePhysicalKeys)(event) && shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)) {
                    if (options.preventDefault) event.preventDefault();
                    handler(event);
                }
            });
        };
        document.documentElement.addEventListener("keydown", keydownListener);
        return ()=>document.documentElement.removeEventListener("keydown", keydownListener);
    }, [
        hotkeys
    ]);
}

},{"react":"erQJb","./parse-hotkey.mjs":"fzlL7","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fzlL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHotkeyHandler", ()=>getHotkeyHandler);
parcelHelpers.export(exports, "getHotkeyMatcher", ()=>getHotkeyMatcher);
parcelHelpers.export(exports, "parseHotkey", ()=>parseHotkey);
'use client';
const keyNameMap = {
    " ": "space",
    ArrowLeft: "arrowleft",
    ArrowRight: "arrowright",
    ArrowUp: "arrowup",
    ArrowDown: "arrowdown",
    Escape: "escape",
    Esc: "escape",
    esc: "escape",
    Enter: "enter",
    Tab: "tab",
    Backspace: "backspace",
    Delete: "delete",
    Insert: "insert",
    Home: "home",
    End: "end",
    PageUp: "pageup",
    PageDown: "pagedown",
    "+": "plus",
    "-": "minus",
    "*": "asterisk",
    "/": "slash"
};
function normalizeKey(key) {
    const lowerKey = key.replace("Key", "").toLowerCase();
    return keyNameMap[key] || lowerKey;
}
function parseHotkey(hotkey) {
    const keys = hotkey.toLowerCase().split("+").map((part)=>part.trim());
    const modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod"),
        shift: keys.includes("shift"),
        plus: keys.includes("[plus]")
    };
    const reservedKeys = [
        "alt",
        "ctrl",
        "meta",
        "shift",
        "mod"
    ];
    const freeKey = keys.find((key)=>!reservedKeys.includes(key));
    return {
        ...modifiers,
        key: freeKey === "[plus]" ? "+" : freeKey
    };
}
function isExactHotkey(hotkey, event, usePhysicalKeys) {
    const { alt, ctrl, meta, mod, shift, key } = hotkey;
    const { altKey, ctrlKey, metaKey, shiftKey, key: pressedKey, code: pressedCode } = event;
    if (alt !== altKey) return false;
    if (mod) {
        if (!ctrlKey && !metaKey) return false;
    } else {
        if (ctrl !== ctrlKey) return false;
        if (meta !== metaKey) return false;
    }
    if (shift !== shiftKey) return false;
    if (key && (usePhysicalKeys ? normalizeKey(pressedCode) === normalizeKey(key) : normalizeKey(pressedKey ?? pressedCode) === normalizeKey(key))) return true;
    return false;
}
function getHotkeyMatcher(hotkey, usePhysicalKeys) {
    return (event)=>isExactHotkey(parseHotkey(hotkey), event, usePhysicalKeys);
}
function getHotkeyHandler(hotkeys) {
    return (event)=>{
        const _event = "nativeEvent" in event ? event.nativeEvent : event;
        hotkeys.forEach(([hotkey, handler, options = {
            preventDefault: true,
            usePhysicalKeys: false
        }])=>{
            if (getHotkeyMatcher(hotkey, options.usePhysicalKeys)(_event)) {
                if (options.preventDefault) event.preventDefault();
                handler(_event);
            }
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"erxqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFullscreen", ()=>useFullscreen);
var _react = require("react");
'use client';
function getFullscreenElement() {
    const _document = window.document;
    const fullscreenElement = _document.fullscreenElement || _document.webkitFullscreenElement || _document.mozFullScreenElement || _document.msFullscreenElement;
    return fullscreenElement;
}
function exitFullscreen() {
    const _document = window.document;
    if (typeof _document.exitFullscreen === "function") return _document.exitFullscreen();
    if (typeof _document.msExitFullscreen === "function") return _document.msExitFullscreen();
    if (typeof _document.webkitExitFullscreen === "function") return _document.webkitExitFullscreen();
    if (typeof _document.mozCancelFullScreen === "function") return _document.mozCancelFullScreen();
    return null;
}
function enterFullScreen(element) {
    const _element = element;
    return _element.requestFullscreen?.() || _element.msRequestFullscreen?.() || _element.webkitEnterFullscreen?.() || _element.webkitRequestFullscreen?.() || _element.mozRequestFullscreen?.();
}
const prefixes = [
    "",
    "webkit",
    "moz",
    "ms"
];
function addEvents(element, { onFullScreen, onError }) {
    prefixes.forEach((prefix)=>{
        element.addEventListener(`${prefix}fullscreenchange`, onFullScreen);
        element.addEventListener(`${prefix}fullscreenerror`, onError);
    });
    return ()=>{
        prefixes.forEach((prefix)=>{
            element.removeEventListener(`${prefix}fullscreenchange`, onFullScreen);
            element.removeEventListener(`${prefix}fullscreenerror`, onError);
        });
    };
}
function useFullscreen() {
    const [fullscreen, setFullscreen] = (0, _react.useState)(false);
    const _ref = (0, _react.useRef)(null);
    const handleFullscreenChange = (0, _react.useCallback)((event)=>{
        setFullscreen(event.target === getFullscreenElement());
    }, [
        setFullscreen
    ]);
    const handleFullscreenError = (0, _react.useCallback)((event)=>{
        setFullscreen(false);
        console.error(`[@mantine/hooks] use-fullscreen: Error attempting full-screen mode method: ${event} (${event.target})`);
    }, [
        setFullscreen
    ]);
    const toggle = (0, _react.useCallback)(async ()=>{
        if (!getFullscreenElement()) await enterFullScreen(_ref.current);
        else await exitFullscreen();
    }, []);
    const ref = (0, _react.useCallback)((element)=>{
        if (element === null) _ref.current = window.document.documentElement;
        else _ref.current = element;
    }, []);
    (0, _react.useEffect)(()=>{
        if (!_ref.current && window.document) {
            _ref.current = window.document.documentElement;
            return addEvents(_ref.current, {
                onFullScreen: handleFullscreenChange,
                onError: handleFullscreenError
            });
        }
        if (_ref.current) return addEvents(_ref.current, {
            onFullScreen: handleFullscreenChange,
            onError: handleFullscreenError
        });
        return void 0;
    }, [
        _ref.current
    ]);
    return {
        ref,
        toggle,
        fullscreen
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"adklo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLogger", ()=>useLogger);
var _react = require("react");
var _useDidUpdateMjs = require("../use-did-update/use-did-update.mjs");
'use client';
function useLogger(componentName, props) {
    (0, _react.useEffect)(()=>{
        console.log(`${componentName} mounted`, ...props);
        return ()=>console.log(`${componentName} unmounted`);
    }, []);
    (0, _useDidUpdateMjs.useDidUpdate)(()=>{
        console.log(`${componentName} updated`, ...props);
    }, props);
    return null;
}

},{"react":"erQJb","../use-did-update/use-did-update.mjs":"bzSpx","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"iFgvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHover", ()=>useHover);
var _react = require("react");
'use client';
function useHover() {
    const [hovered, setHovered] = (0, _react.useState)(false);
    const previousNode = (0, _react.useRef)(null);
    const handleMouseEnter = (0, _react.useCallback)(()=>{
        setHovered(true);
    }, []);
    const handleMouseLeave = (0, _react.useCallback)(()=>{
        setHovered(false);
    }, []);
    const ref = (0, _react.useCallback)((node)=>{
        if (previousNode.current) {
            previousNode.current.removeEventListener("mouseenter", handleMouseEnter);
            previousNode.current.removeEventListener("mouseleave", handleMouseLeave);
        }
        if (node) {
            node.addEventListener("mouseenter", handleMouseEnter);
            node.addEventListener("mouseleave", handleMouseLeave);
        }
        previousNode.current = node;
    }, [
        handleMouseEnter,
        handleMouseLeave
    ]);
    return {
        ref,
        hovered
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"83dFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useValidatedState", ()=>useValidatedState);
var _react = require("react");
'use client';
function useValidatedState(initialValue, validate, initialValidationState) {
    const [value, setValue] = (0, _react.useState)(initialValue);
    const [lastValidValue, setLastValidValue] = (0, _react.useState)(validate(initialValue) ? initialValue : void 0);
    const [valid, setValid] = (0, _react.useState)(typeof initialValidationState === "boolean" ? initialValidationState : validate(initialValue));
    const onChange = (val)=>{
        if (validate(val)) {
            setLastValidValue(val);
            setValid(true);
        } else setValid(false);
        setValue(val);
    };
    return [
        {
            value,
            lastValidValue,
            valid
        },
        onChange
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kSudd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOs", ()=>useOs);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
function isMacOS(userAgent) {
    const macosPattern = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
    return macosPattern.test(userAgent);
}
function isIOS(userAgent) {
    const iosPattern = /(iPhone)|(iPad)|(iPod)/i;
    return iosPattern.test(userAgent);
}
function isWindows(userAgent) {
    const windowsPattern = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
    return windowsPattern.test(userAgent);
}
function isAndroid(userAgent) {
    const androidPattern = /Android/i;
    return androidPattern.test(userAgent);
}
function isLinux(userAgent) {
    const linuxPattern = /Linux/i;
    return linuxPattern.test(userAgent);
}
function isChromeOS(userAgent) {
    const chromePattern = /CrOS/i;
    return chromePattern.test(userAgent);
}
function getOS() {
    if (typeof window === "undefined") return "undetermined";
    const { userAgent } = window.navigator;
    if (isIOS(userAgent) || isMacOS(userAgent) && "ontouchend" in document) return "ios";
    if (isMacOS(userAgent)) return "macos";
    if (isWindows(userAgent)) return "windows";
    if (isAndroid(userAgent)) return "android";
    if (isLinux(userAgent)) return "linux";
    if (isChromeOS(userAgent)) return "chromeos";
    return "undetermined";
}
function useOs(options = {
    getValueInEffect: true
}) {
    const [value, setValue] = (0, _react.useState)(options.getValueInEffect ? "undetermined" : getOS());
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        if (options.getValueInEffect) setValue(getOS);
    }, []);
    return value;
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"QGAdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSetState", ()=>useSetState);
var _react = require("react");
'use client';
function useSetState(initialState) {
    const [state, setState] = (0, _react.useState)(initialState);
    const _setState = (0, _react.useCallback)((statePartial)=>setState((current)=>({
                ...current,
                ...typeof statePartial === "function" ? statePartial(current) : statePartial
            })), []);
    return [
        state,
        _setState
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d5ocs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputOnChange", ()=>getInputOnChange);
parcelHelpers.export(exports, "useInputState", ()=>useInputState);
var _react = require("react");
'use client';
function getInputOnChange(setValue) {
    return (val)=>{
        if (!val) setValue(val);
        else if (typeof val === "function") setValue(val);
        else if (typeof val === "object" && "nativeEvent" in val) {
            const { currentTarget } = val;
            if (currentTarget.type === "checkbox") setValue(currentTarget.checked);
            else setValue(currentTarget.value);
        } else setValue(val);
    };
}
function useInputState(initialState) {
    const [value, setValue] = (0, _react.useState)(initialState);
    return [
        value,
        getInputOnChange(setValue)
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2ATId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEventListener", ()=>useEventListener);
var _react = require("react");
'use client';
function useEventListener(type, listener, options) {
    const previousListener = (0, _react.useRef)(null);
    const previousNode = (0, _react.useRef)(null);
    const callbackRef = (0, _react.useCallback)((node)=>{
        if (!node) return;
        if (previousNode.current && previousListener.current) previousNode.current.removeEventListener(type, previousListener.current, options);
        node.addEventListener(type, listener, options);
        previousNode.current = node;
        previousListener.current = listener;
    }, [
        type,
        listener,
        options
    ]);
    (0, _react.useEffect)(()=>()=>{
            if (previousNode.current && previousListener.current) previousNode.current.removeEventListener(type, previousListener.current, options);
        }, [
        type,
        options
    ]);
    return callbackRef;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9UqII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDisclosure", ()=>useDisclosure);
var _react = require("react");
'use client';
function useDisclosure(initialState = false, options = {}) {
    const [opened, setOpened] = (0, _react.useState)(initialState);
    const open = (0, _react.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (!isOpened) {
                options.onOpen?.();
                return true;
            }
            return isOpened;
        });
    }, [
        options.onOpen
    ]);
    const close = (0, _react.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (isOpened) {
                options.onClose?.();
                return false;
            }
            return isOpened;
        });
    }, [
        options.onClose
    ]);
    const toggle = (0, _react.useCallback)(()=>{
        opened ? close() : open();
    }, [
        close,
        open,
        opened
    ]);
    return [
        opened,
        {
            open,
            close,
            toggle
        }
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2fZm7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFocusWithin", ()=>useFocusWithin);
var _react = require("react");
var _useCallbackRefMjs = require("../utils/use-callback-ref/use-callback-ref.mjs");
'use client';
function containsRelatedTarget(event) {
    if (event.currentTarget instanceof HTMLElement && event.relatedTarget instanceof HTMLElement) return event.currentTarget.contains(event.relatedTarget);
    return false;
}
function useFocusWithin({ onBlur, onFocus } = {}) {
    const [focused, setFocused] = (0, _react.useState)(false);
    const focusedRef = (0, _react.useRef)(false);
    const previousNode = (0, _react.useRef)(null);
    const onFocusRef = (0, _useCallbackRefMjs.useCallbackRef)(onFocus);
    const onBlurRef = (0, _useCallbackRefMjs.useCallbackRef)(onBlur);
    const _setFocused = (0, _react.useCallback)((value)=>{
        setFocused(value);
        focusedRef.current = value;
    }, []);
    const handleFocusIn = (0, _react.useCallback)((event)=>{
        if (!focusedRef.current) {
            _setFocused(true);
            onFocusRef(event);
        }
    }, []);
    const handleFocusOut = (0, _react.useCallback)((event)=>{
        if (focusedRef.current && !containsRelatedTarget(event)) {
            _setFocused(false);
            onBlurRef(event);
        }
    }, []);
    const callbackRef = (0, _react.useCallback)((node)=>{
        if (!node) return;
        if (previousNode.current) {
            previousNode.current.removeEventListener("focusin", handleFocusIn);
            previousNode.current.removeEventListener("focusout", handleFocusOut);
        }
        node.addEventListener("focusin", handleFocusIn);
        node.addEventListener("focusout", handleFocusOut);
        previousNode.current = node;
    }, [
        handleFocusIn,
        handleFocusOut
    ]);
    (0, _react.useEffect)(()=>()=>{
            if (previousNode.current) {
                previousNode.current.removeEventListener("focusin", handleFocusIn);
                previousNode.current.removeEventListener("focusout", handleFocusOut);
            }
        }, []);
    return {
        ref: callbackRef,
        focused
    };
}

},{"react":"erQJb","../utils/use-callback-ref/use-callback-ref.mjs":"1inGi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gcOC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNetwork", ()=>useNetwork);
var _react = require("react");
var _useWindowEventMjs = require("../use-window-event/use-window-event.mjs");
'use client';
function getConnection() {
    if (typeof navigator === "undefined") return {};
    const _navigator = navigator;
    const connection = _navigator.connection || _navigator.mozConnection || _navigator.webkitConnection;
    if (!connection) return {};
    return {
        downlink: connection?.downlink,
        downlinkMax: connection?.downlinkMax,
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt,
        saveData: connection?.saveData,
        type: connection?.type
    };
}
function useNetwork() {
    const [status, setStatus] = (0, _react.useState)({
        online: true
    });
    const handleConnectionChange = (0, _react.useCallback)(()=>setStatus((current)=>({
                ...current,
                ...getConnection()
            })), []);
    (0, _useWindowEventMjs.useWindowEvent)("online", ()=>setStatus({
            online: true,
            ...getConnection()
        }));
    (0, _useWindowEventMjs.useWindowEvent)("offline", ()=>setStatus({
            online: false,
            ...getConnection()
        }));
    (0, _react.useEffect)(()=>{
        const _navigator = navigator;
        if (_navigator.connection) {
            setStatus({
                online: _navigator.onLine,
                ...getConnection()
            });
            _navigator.connection.addEventListener("change", handleConnectionChange);
            return ()=>_navigator.connection.removeEventListener("change", handleConnectionChange);
        }
        if (typeof _navigator.onLine === "boolean") setStatus((current)=>({
                ...current,
                online: _navigator.onLine
            }));
        return void 0;
    }, []);
    return status;
}

},{"react":"erQJb","../use-window-event/use-window-event.mjs":"6GqGu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"irMHj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
var _react = require("react");
'use client';
function useTimeout(callback, delay, options = {
    autoInvoke: false
}) {
    const timeoutRef = (0, _react.useRef)(null);
    const start = (0, _react.useCallback)((...args)=>{
        if (!timeoutRef.current) timeoutRef.current = window.setTimeout(()=>{
            callback(args);
            timeoutRef.current = null;
        }, delay);
    }, [
        delay
    ]);
    const clear = (0, _react.useCallback)(()=>{
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (options.autoInvoke) start();
        return clear;
    }, [
        clear,
        start
    ]);
    return {
        start,
        clear
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5kClW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTextSelection", ()=>useTextSelection);
var _react = require("react");
var _useForceUpdateMjs = require("../use-force-update/use-force-update.mjs");
'use client';
function useTextSelection() {
    const forceUpdate = (0, _useForceUpdateMjs.useForceUpdate)();
    const [selection, setSelection] = (0, _react.useState)(null);
    const handleSelectionChange = ()=>{
        setSelection(document.getSelection());
        forceUpdate();
    };
    (0, _react.useEffect)(()=>{
        setSelection(document.getSelection());
        document.addEventListener("selectionchange", handleSelectionChange);
        return ()=>document.removeEventListener("selectionchange", handleSelectionChange);
    }, []);
    return selection;
}

},{"react":"erQJb","../use-force-update/use-force-update.mjs":"3vpJH","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"atULC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
var _react = require("react");
'use client';
function usePrevious(value) {
    const ref = (0, _react.useRef)(void 0);
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"j9Mzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFavicon", ()=>useFavicon);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
const MIME_TYPES = {
    ico: "image/x-icon",
    png: "image/png",
    svg: "image/svg+xml",
    gif: "image/gif"
};
function useFavicon(url) {
    const link = (0, _react.useRef)(null);
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        if (!url) return;
        if (!link.current) {
            const existingElements = document.querySelectorAll('link[rel*="icon"]');
            existingElements.forEach((element2)=>document.head.removeChild(element2));
            const element = document.createElement("link");
            element.rel = "shortcut icon";
            link.current = element;
            document.querySelector("head").appendChild(element);
        }
        const splittedUrl = url.split(".");
        link.current.setAttribute("type", MIME_TYPES[splittedUrl[splittedUrl.length - 1].toLowerCase()]);
        link.current.setAttribute("href", url);
    }, [
        url
    ]);
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lNCsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFixed", ()=>isFixed);
parcelHelpers.export(exports, "isPinnedOrReleased", ()=>isPinnedOrReleased);
parcelHelpers.export(exports, "useHeadroom", ()=>useHeadroom);
parcelHelpers.export(exports, "useScrollDirection", ()=>useScrollDirection);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
var _useWindowScrollMjs = require("../use-window-scroll/use-window-scroll.mjs");
'use client';
const isFixed = (current, fixedAt)=>current <= fixedAt;
const isPinnedOrReleased = (current, fixedAt, isCurrentlyPinnedRef, isScrollingUp, onPin, onRelease)=>{
    const isInFixedPosition = isFixed(current, fixedAt);
    if (isInFixedPosition && !isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = true;
        onPin?.();
    } else if (!isInFixedPosition && isScrollingUp && !isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = true;
        onPin?.();
    } else if (!isInFixedPosition && isCurrentlyPinnedRef.current) {
        isCurrentlyPinnedRef.current = false;
        onRelease?.();
    }
};
const useScrollDirection = ()=>{
    const [lastScrollTop, setLastScrollTop] = (0, _react.useState)(0);
    const [isScrollingUp, setIsScrollingUp] = (0, _react.useState)(false);
    const [isResizing, setIsResizing] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let resizeTimer;
        const onResize = ()=>{
            setIsResizing(true);
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(()=>{
                setIsResizing(false);
            }, 300);
        };
        const onScroll = ()=>{
            if (isResizing) return;
            const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
            setIsScrollingUp(currentScrollTop < lastScrollTop);
            setLastScrollTop(currentScrollTop);
        };
        window.addEventListener("scroll", onScroll);
        window.addEventListener("resize", onResize);
        return ()=>{
            window.removeEventListener("scroll", onScroll);
            window.removeEventListener("resize", onResize);
        };
    }, [
        lastScrollTop,
        isResizing
    ]);
    return isScrollingUp;
};
function useHeadroom({ fixedAt = 0, onPin, onFix, onRelease } = {}) {
    const isCurrentlyPinnedRef = (0, _react.useRef)(false);
    const isScrollingUp = useScrollDirection();
    const [{ y: scrollPosition }] = (0, _useWindowScrollMjs.useWindowScroll)();
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        isPinnedOrReleased(scrollPosition, fixedAt, isCurrentlyPinnedRef, isScrollingUp, onPin, onRelease);
    }, [
        scrollPosition
    ]);
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        if (isFixed(scrollPosition, fixedAt)) onFix?.();
    }, [
        scrollPosition,
        fixedAt,
        onFix
    ]);
    if (isFixed(scrollPosition, fixedAt) || isScrollingUp) return true;
    return false;
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","../use-window-scroll/use-window-scroll.mjs":"iy20W","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8TPz4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEyeDropper", ()=>useEyeDropper);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
function useEyeDropper() {
    const [supported, setSupported] = (0, _react.useState)(false);
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        setSupported(typeof window !== "undefined" && !isOpera() && "EyeDropper" in window);
    }, []);
    const open = (0, _react.useCallback)((options = {})=>{
        if (supported) {
            const eyeDropper = new window.EyeDropper();
            return eyeDropper.open(options);
        }
        return Promise.resolve(void 0);
    }, [
        supported
    ]);
    return {
        supported,
        open
    };
}
function isOpera() {
    return navigator.userAgent.includes("OPR");
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jWoOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInViewport", ()=>useInViewport);
var _react = require("react");
'use client';
function useInViewport() {
    const observer = (0, _react.useRef)(null);
    const [inViewport, setInViewport] = (0, _react.useState)(false);
    const ref = (0, _react.useCallback)((node)=>{
        if (typeof IntersectionObserver !== "undefined") {
            if (node && !observer.current) observer.current = new IntersectionObserver((entries)=>{
                const lastEntry = entries[entries.length - 1];
                setInViewport(lastEntry.isIntersecting);
            });
            else observer.current?.disconnect();
            if (node) observer.current?.observe(node);
            else setInViewport(false);
        }
    }, []);
    return {
        ref,
        inViewport
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9VXPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutationObserver", ()=>useMutationObserver);
var _react = require("react");
'use client';
function useMutationObserver(callback, options, target) {
    const observer = (0, _react.useRef)(null);
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const targetElement = typeof target === "function" ? target() : target;
        if (targetElement || ref.current) {
            observer.current = new MutationObserver(callback);
            observer.current.observe(targetElement || ref.current, options);
        }
        return ()=>{
            observer.current?.disconnect();
        };
    }, [
        callback,
        options
    ]);
    return ref;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9EYwU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMounted", ()=>useMounted);
var _react = require("react");
'use client';
function useMounted() {
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>setMounted(true), []);
    return mounted;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2Qtj3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateHistory", ()=>useStateHistory);
var _react = require("react");
'use client';
function useStateHistory(initialValue) {
    const [state, setState] = (0, _react.useState)({
        history: [
            initialValue
        ],
        current: 0
    });
    const set = (0, _react.useCallback)((val)=>setState((currentState)=>{
            const nextState = [
                ...currentState.history.slice(0, currentState.current + 1),
                val
            ];
            return {
                history: nextState,
                current: nextState.length - 1
            };
        }), []);
    const back = (0, _react.useCallback)((steps = 1)=>setState((currentState)=>({
                history: currentState.history,
                current: Math.max(0, currentState.current - steps)
            })), []);
    const forward = (0, _react.useCallback)((steps = 1)=>setState((currentState)=>({
                history: currentState.history,
                current: Math.min(currentState.history.length - 1, currentState.current + steps)
            })), []);
    const reset = (0, _react.useCallback)(()=>{
        setState({
            history: [
                initialValue
            ],
            current: 0
        });
    }, [
        initialValue
    ]);
    const handlers = (0, _react.useMemo)(()=>({
            back,
            forward,
            reset,
            set
        }), [
        back,
        forward,
        reset,
        set
    ]);
    return [
        state.history[state.current],
        handlers,
        state
    ];
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"99i0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMap", ()=>useMap);
var _react = require("react");
var _useForceUpdateMjs = require("../use-force-update/use-force-update.mjs");
'use client';
function useMap(initialState) {
    const mapRef = (0, _react.useRef)(new Map(initialState));
    const forceUpdate = (0, _useForceUpdateMjs.useForceUpdate)();
    mapRef.current.set = (...args)=>{
        Map.prototype.set.apply(mapRef.current, args);
        forceUpdate();
        return mapRef.current;
    };
    mapRef.current.clear = (...args)=>{
        Map.prototype.clear.apply(mapRef.current, args);
        forceUpdate();
    };
    mapRef.current.delete = (...args)=>{
        const res = Map.prototype.delete.apply(mapRef.current, args);
        forceUpdate();
        return res;
    };
    return mapRef.current;
}

},{"react":"erQJb","../use-force-update/use-force-update.mjs":"3vpJH","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4pmBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readonlySetLikeToSet", ()=>readonlySetLikeToSet);
parcelHelpers.export(exports, "useSet", ()=>useSet);
var _react = require("react");
var _useForceUpdateMjs = require("../use-force-update/use-force-update.mjs");
'use client';
function readonlySetLikeToSet(input) {
    if (input instanceof Set) return input;
    const result = /* @__PURE__ */ new Set();
    for (const item of input)result.add(item);
    return result;
}
function useSet(values) {
    const setRef = (0, _react.useRef)(new Set(values));
    const forceUpdate = (0, _useForceUpdateMjs.useForceUpdate)();
    setRef.current.add = (...args)=>{
        const res = Set.prototype.add.apply(setRef.current, args);
        forceUpdate();
        return res;
    };
    setRef.current.clear = (...args)=>{
        Set.prototype.clear.apply(setRef.current, args);
        forceUpdate();
    };
    setRef.current.delete = (...args)=>{
        const res = Set.prototype.delete.apply(setRef.current, args);
        forceUpdate();
        return res;
    };
    setRef.current.union = (other)=>{
        const result = new Set(setRef.current);
        readonlySetLikeToSet(other).forEach((item)=>result.add(item));
        return result;
    };
    setRef.current.intersection = (other)=>{
        const result = /* @__PURE__ */ new Set();
        const otherSet = readonlySetLikeToSet(other);
        setRef.current.forEach((item)=>{
            if (otherSet.has(item)) result.add(item);
        });
        return result;
    };
    setRef.current.difference = (other)=>{
        const result = /* @__PURE__ */ new Set();
        const otherSet = readonlySetLikeToSet(other);
        setRef.current.forEach((item)=>{
            if (!otherSet.has(item)) result.add(item);
        });
        return result;
    };
    setRef.current.symmetricDifference = (other)=>{
        const result = /* @__PURE__ */ new Set();
        const otherSet = readonlySetLikeToSet(other);
        setRef.current.forEach((item)=>{
            if (!otherSet.has(item)) result.add(item);
        });
        otherSet.forEach((item)=>{
            if (!setRef.current.has(item)) result.add(item);
        });
        return result;
    };
    return setRef.current;
}

},{"react":"erQJb","../use-force-update/use-force-update.mjs":"3vpJH","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1zIHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useThrottledCallback", ()=>useThrottledCallback);
parcelHelpers.export(exports, "useThrottledCallbackWithClearTimeout", ()=>useThrottledCallbackWithClearTimeout);
var _react = require("react");
var _useCallbackRefMjs = require("../utils/use-callback-ref/use-callback-ref.mjs");
'use client';
function useThrottledCallbackWithClearTimeout(callback, wait) {
    const handleCallback = (0, _useCallbackRefMjs.useCallbackRef)(callback);
    const latestInArgsRef = (0, _react.useRef)(null);
    const latestOutArgsRef = (0, _react.useRef)(null);
    const active = (0, _react.useRef)(true);
    const waitRef = (0, _react.useRef)(wait);
    const timeoutRef = (0, _react.useRef)(-1);
    const clearTimeout = ()=>window.clearTimeout(timeoutRef.current);
    const callThrottledCallback = (0, _react.useCallback)((...args)=>{
        handleCallback(...args);
        latestInArgsRef.current = args;
        latestOutArgsRef.current = args;
        active.current = false;
    }, [
        handleCallback
    ]);
    const timerCallback = (0, _react.useCallback)(()=>{
        if (latestInArgsRef.current && latestInArgsRef.current !== latestOutArgsRef.current) {
            callThrottledCallback(...latestInArgsRef.current);
            timeoutRef.current = window.setTimeout(timerCallback, waitRef.current);
        } else active.current = true;
    }, [
        callThrottledCallback
    ]);
    const throttled = (0, _react.useCallback)((...args)=>{
        if (active.current) {
            callThrottledCallback(...args);
            timeoutRef.current = window.setTimeout(timerCallback, waitRef.current);
        } else latestInArgsRef.current = args;
    }, [
        callThrottledCallback,
        timerCallback
    ]);
    (0, _react.useEffect)(()=>{
        waitRef.current = wait;
    }, [
        wait
    ]);
    return [
        throttled,
        clearTimeout
    ];
}
function useThrottledCallback(callback, wait) {
    return useThrottledCallbackWithClearTimeout(callback, wait)[0];
}

},{"react":"erQJb","../utils/use-callback-ref/use-callback-ref.mjs":"1inGi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2l1dL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useThrottledState", ()=>useThrottledState);
var _react = require("react");
var _useThrottledCallbackMjs = require("../use-throttled-callback/use-throttled-callback.mjs");
'use client';
function useThrottledState(defaultValue, wait) {
    const [value, setValue] = (0, _react.useState)(defaultValue);
    const [setThrottledValue, clearTimeout] = (0, _useThrottledCallbackMjs.useThrottledCallbackWithClearTimeout)(setValue, wait);
    (0, _react.useEffect)(()=>clearTimeout, []);
    return [
        value,
        setThrottledValue
    ];
}

},{"react":"erQJb","../use-throttled-callback/use-throttled-callback.mjs":"1zIHG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1BPvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useThrottledValue", ()=>useThrottledValue);
var _react = require("react");
var _useThrottledCallbackMjs = require("../use-throttled-callback/use-throttled-callback.mjs");
'use client';
function useThrottledValue(value, wait) {
    const [throttledValue, setThrottledValue] = (0, _react.useState)(value);
    const valueRef = (0, _react.useRef)(value);
    const [throttledSetValue, clearTimeout] = (0, _useThrottledCallbackMjs.useThrottledCallbackWithClearTimeout)(setThrottledValue, wait);
    (0, _react.useEffect)(()=>{
        if (value !== valueRef.current) {
            valueRef.current = value;
            throttledSetValue(value);
        }
    }, [
        throttledSetValue,
        value
    ]);
    (0, _react.useEffect)(()=>clearTimeout, []);
    return throttledValue;
}

},{"react":"erQJb","../use-throttled-callback/use-throttled-callback.mjs":"1zIHG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ND8KV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsFirstRender", ()=>useIsFirstRender);
var _react = require("react");
'use client';
function useIsFirstRender() {
    const renderRef = (0, _react.useRef)(true);
    if (renderRef.current === true) {
        renderRef.current = false;
        return true;
    }
    return renderRef.current;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d2qsB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOrientation", ()=>useOrientation);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
function getInitialValue(initialValue, getInitialValueInEffect) {
    if (getInitialValueInEffect) return initialValue;
    if (typeof window !== "undefined" && "screen" in window) return {
        angle: window.screen.orientation?.angle ?? initialValue.angle,
        type: window.screen.orientation?.type ?? initialValue.type
    };
    return initialValue;
}
function useOrientation({ defaultAngle = 0, defaultType = "landscape-primary", getInitialValueInEffect = true } = {}) {
    const [orientation, setOrientation] = (0, _react.useState)(getInitialValue({
        angle: defaultAngle,
        type: defaultType
    }, getInitialValueInEffect));
    const handleOrientationChange = (event)=>{
        const target = event.currentTarget;
        setOrientation({
            angle: target?.angle || 0,
            type: target?.type || "landscape-primary"
        });
    };
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        window.screen.orientation?.addEventListener("change", handleOrientationChange);
        return ()=>window.screen.orientation?.removeEventListener("change", handleOrientationChange);
    }, []);
    return orientation;
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3sZf1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetch", ()=>useFetch);
var _react = require("react");
'use client';
function useFetch(url, { autoInvoke = true, ...options } = {}) {
    const [data, setData] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)(null);
    const controller = (0, _react.useRef)(null);
    const refetch = (0, _react.useCallback)(()=>{
        if (controller.current) controller.current.abort();
        controller.current = new AbortController();
        setLoading(true);
        return fetch(url, {
            signal: controller.current.signal,
            ...options
        }).then((res)=>res.json()).then((res)=>{
            setData(res);
            setLoading(false);
            return res;
        }).catch((err)=>{
            setLoading(false);
            if (err.name !== "AbortError") setError(err);
            return err;
        });
    }, [
        url
    ]);
    const abort = (0, _react.useCallback)(()=>{
        if (controller.current) controller.current?.abort("");
    }, []);
    (0, _react.useEffect)(()=>{
        if (autoInvoke) refetch();
        return ()=>{
            if (controller.current) controller.current.abort("");
        };
    }, [
        refetch,
        autoInvoke
    ]);
    return {
        data,
        loading,
        error,
        refetch,
        abort
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dc1My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeRadialValue", ()=>normalizeRadialValue);
parcelHelpers.export(exports, "useRadialMove", ()=>useRadialMove);
var _react = require("react");
var _clampMjs = require("../utils/clamp/clamp.mjs");
'use client';
function radiansToDegrees(radians) {
    return radians * (180 / Math.PI);
}
function getElementCenter(element) {
    const rect = element.getBoundingClientRect();
    return [
        rect.left + rect.width / 2,
        rect.top + rect.height / 2
    ];
}
function getAngle(coordinates, element) {
    const center = getElementCenter(element);
    const x = coordinates[0] - center[0];
    const y = coordinates[1] - center[1];
    const deg = radiansToDegrees(Math.atan2(x, y)) + 180;
    return 360 - deg;
}
function toFixed(value, digits) {
    return parseFloat(value.toFixed(digits));
}
function getDigitsAfterDot(value) {
    return value.toString().split(".")[1]?.length || 0;
}
function normalizeRadialValue(degree, step) {
    const clamped = (0, _clampMjs.clamp)(degree, 0, 360);
    const high = Math.ceil(clamped / step);
    const low = Math.round(clamped / step);
    return toFixed(high >= clamped / step ? high * step === 360 ? 0 : high * step : low * step, getDigitsAfterDot(step));
}
function useRadialMove(onChange, { step = 0.01, onChangeEnd, onScrubStart, onScrubEnd } = {}) {
    const mounted = (0, _react.useRef)(false);
    const [active, setActive] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        mounted.current = true;
    }, []);
    const refCallback = (0, _react.useCallback)((node)=>{
        const update = (event, done = false)=>{
            if (node) {
                node.style.userSelect = "none";
                const deg = getAngle([
                    event.clientX,
                    event.clientY
                ], node);
                const newValue = normalizeRadialValue(deg, step || 1);
                onChange(newValue);
                done && onChangeEnd?.(newValue);
            }
        };
        const beginTracking = ()=>{
            onScrubStart?.();
            setActive(true);
            document.addEventListener("mousemove", handleMouseMove, false);
            document.addEventListener("mouseup", handleMouseUp, false);
            document.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
            document.addEventListener("touchend", handleTouchEnd, false);
        };
        const endTracking = ()=>{
            onScrubEnd?.();
            setActive(false);
            document.removeEventListener("mousemove", handleMouseMove, false);
            document.removeEventListener("mouseup", handleMouseUp, false);
            document.removeEventListener("touchmove", handleTouchMove, false);
            document.removeEventListener("touchend", handleTouchEnd, false);
        };
        const onMouseDown = (event)=>{
            beginTracking();
            update(event);
        };
        const handleMouseMove = (event)=>{
            update(event);
        };
        const handleMouseUp = (event)=>{
            update(event, true);
            endTracking();
        };
        const handleTouchMove = (event)=>{
            event.preventDefault();
            update(event.touches[0]);
        };
        const handleTouchEnd = (event)=>{
            update(event.changedTouches[0], true);
            endTracking();
        };
        const handleTouchStart = (event)=>{
            event.preventDefault();
            beginTracking();
            update(event.touches[0]);
        };
        node?.addEventListener("mousedown", onMouseDown);
        node?.addEventListener("touchstart", handleTouchStart, {
            passive: false
        });
        return ()=>{
            if (node) {
                node.removeEventListener("mousedown", onMouseDown);
                node.removeEventListener("touchstart", handleTouchStart);
            }
        };
    }, [
        onChange
    ]);
    return {
        ref: refCallback,
        active
    };
}

},{"react":"erQJb","../utils/clamp/clamp.mjs":"bNBKV","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1RYNc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollSpy", ()=>useScrollSpy);
var _react = require("react");
var _randomIdMjs = require("../utils/random-id/random-id.mjs");
'use client';
function getHeadingsData(headings, getDepth, getValue) {
    const result = [];
    for(let i = 0; i < headings.length; i += 1){
        const heading = headings[i];
        result.push({
            depth: getDepth(heading),
            value: getValue(heading),
            id: heading.id || (0, _randomIdMjs.randomId)(),
            getNode: ()=>heading.id ? document.getElementById(heading.id) : heading
        });
    }
    return result;
}
function getActiveElement(rects, offset = 0) {
    if (rects.length === 0) return -1;
    const closest = rects.reduce((acc, item, index)=>{
        if (Math.abs(acc.position - offset) < Math.abs(item.y - offset)) return acc;
        return {
            index,
            position: item.y
        };
    }, {
        index: 0,
        position: rects[0].y
    });
    return closest.index;
}
function getDefaultDepth(element) {
    return Number(element.tagName[1]);
}
function getDefaultValue(element) {
    return element.textContent || "";
}
function useScrollSpy({ selector = "h1, h2, h3, h4, h5, h6", getDepth = getDefaultDepth, getValue = getDefaultValue, offset = 0, scrollHost } = {}) {
    const [active, setActive] = (0, _react.useState)(-1);
    const [initialized, setInitialized] = (0, _react.useState)(false);
    const [data, setData] = (0, _react.useState)([]);
    const headingsRef = (0, _react.useRef)([]);
    const handleScroll = ()=>{
        setActive(getActiveElement(headingsRef.current.map((d)=>d.getNode().getBoundingClientRect()), offset));
    };
    const initialize = ()=>{
        const headings = getHeadingsData(Array.from(document.querySelectorAll(selector)), getDepth, getValue);
        headingsRef.current = headings;
        setInitialized(true);
        setData(headings);
        setActive(getActiveElement(headings.map((d)=>d.getNode().getBoundingClientRect()), offset));
    };
    (0, _react.useEffect)(()=>{
        initialize();
        const _scrollHost = scrollHost || window;
        _scrollHost.addEventListener("scroll", handleScroll);
        return ()=>_scrollHost.removeEventListener("scroll", handleScroll);
    }, [
        scrollHost
    ]);
    return {
        reinitialize: initialize,
        active,
        initialized,
        data
    };
}

},{"react":"erQJb","../utils/random-id/random-id.mjs":"3bLBD","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hnL8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFileDialog", ()=>useFileDialog);
var _react = require("react");
var _useIsomorphicEffectMjs = require("../use-isomorphic-effect/use-isomorphic-effect.mjs");
'use client';
const defaultOptions = {
    multiple: true,
    accept: "*"
};
function getInitialFilesList(files) {
    if (!files) return null;
    if (files instanceof FileList) return files;
    const result = new DataTransfer();
    for (const file of files)result.items.add(file);
    return result.files;
}
function createInput(options) {
    if (typeof document === "undefined") return null;
    const input = document.createElement("input");
    input.type = "file";
    if (options.accept) input.accept = options.accept;
    if (options.multiple) input.multiple = options.multiple;
    if (options.capture) input.capture = options.capture;
    if (options.directory) input.webkitdirectory = options.directory;
    input.style.display = "none";
    return input;
}
function useFileDialog(input = {}) {
    const options = {
        ...defaultOptions,
        ...input
    };
    const [files, setFiles] = (0, _react.useState)(getInitialFilesList(options.initialFiles));
    const inputRef = (0, _react.useRef)(null);
    const handleChange = (0, _react.useCallback)((event)=>{
        const target = event.target;
        if (target?.files) {
            setFiles(target.files);
            options.onChange?.(target.files);
        }
    }, [
        options.onChange
    ]);
    const createAndSetupInput = (0, _react.useCallback)(()=>{
        inputRef.current?.remove();
        inputRef.current = createInput(options);
        if (inputRef.current) {
            inputRef.current.addEventListener("change", handleChange, {
                once: true
            });
            document.body.appendChild(inputRef.current);
        }
    }, [
        options,
        handleChange
    ]);
    (0, _useIsomorphicEffectMjs.useIsomorphicEffect)(()=>{
        createAndSetupInput();
        return ()=>inputRef.current?.remove();
    }, []);
    const reset = (0, _react.useCallback)(()=>{
        setFiles(null);
        options.onChange?.(null);
    }, [
        options.onChange
    ]);
    const open = (0, _react.useCallback)(()=>{
        if (options.resetOnOpen) reset();
        createAndSetupInput();
        inputRef.current?.click();
    }, [
        options.resetOnOpen,
        reset,
        createAndSetupInput
    ]);
    return {
        files,
        open,
        reset
    };
}

},{"react":"erQJb","../use-isomorphic-effect/use-isomorphic-effect.mjs":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2QBuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLongPress", ()=>useLongPress);
var _react = require("react");
'use client';
function useLongPress(onLongPress, options = {}) {
    const { threshold = 400, onStart, onFinish, onCancel } = options;
    const isLongPressActive = (0, _react.useRef)(false);
    const isPressed = (0, _react.useRef)(false);
    const timeout = (0, _react.useRef)(-1);
    (0, _react.useEffect)(()=>()=>window.clearTimeout(timeout.current), []);
    return (0, _react.useMemo)(()=>{
        if (typeof onLongPress !== "function") return {};
        const start = (event)=>{
            if (!isMouseEvent(event) && !isTouchEvent(event)) return;
            if (onStart) onStart(event);
            isPressed.current = true;
            timeout.current = window.setTimeout(()=>{
                onLongPress(event);
                isLongPressActive.current = true;
            }, threshold);
        };
        const cancel = (event)=>{
            if (!isMouseEvent(event) && !isTouchEvent(event)) return;
            if (isLongPressActive.current) {
                if (onFinish) onFinish(event);
            } else if (isPressed.current) {
                if (onCancel) onCancel(event);
            }
            isLongPressActive.current = false;
            isPressed.current = false;
            if (timeout.current) window.clearTimeout(timeout.current);
        };
        return {
            onMouseDown: start,
            onMouseUp: cancel,
            onMouseLeave: cancel,
            onTouchStart: start,
            onTouchEnd: cancel
        };
    }, [
        onLongPress,
        threshold,
        onCancel,
        onFinish,
        onStart
    ]);
}
function isTouchEvent(event) {
    return window.TouchEvent ? event.nativeEvent instanceof TouchEvent : "touches" in event.nativeEvent;
}
function isMouseEvent(event) {
    return event.nativeEvent instanceof MouseEvent;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7wT8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSelection", ()=>useSelection);
var _react = require("react");
var _useDidUpdateMjs = require("../use-did-update/use-did-update.mjs");
'use client';
function useSelection(input) {
    const [selectionSet, setSelectionSet] = (0, _react.useState)(new Set(input.defaultSelection || []));
    (0, _useDidUpdateMjs.useDidUpdate)(()=>{
        if (input.resetSelectionOnDataChange) setSelectionSet(/* @__PURE__ */ new Set());
    }, [
        input.data,
        input.resetSelectionOnDataChange
    ]);
    const select = (0, _react.useCallback)((selected)=>{
        setSelectionSet((state)=>{
            if (!state.has(selected)) {
                const newSet = new Set(state);
                newSet.add(selected);
                return newSet;
            }
            return state;
        });
    }, []);
    const deselect = (0, _react.useCallback)((deselected)=>{
        setSelectionSet((state)=>{
            if (state.has(deselected)) {
                const newSet = new Set(state);
                newSet.delete(deselected);
                return newSet;
            }
            return state;
        });
    }, []);
    const toggle = (0, _react.useCallback)((toggled)=>{
        setSelectionSet((state)=>{
            const newSet = new Set(state);
            if (state.has(toggled)) newSet.delete(toggled);
            else newSet.add(toggled);
            return newSet;
        });
    }, []);
    const resetSelection = (0, _react.useCallback)(()=>{
        setSelectionSet(/* @__PURE__ */ new Set());
    }, []);
    const setSelection = (0, _react.useCallback)((selection)=>{
        setSelectionSet(new Set(selection));
    }, []);
    const isAllSelected = (0, _react.useCallback)(()=>{
        if (input.data.length === 0) return false;
        return input.data.every((item)=>selectionSet.has(item));
    }, [
        selectionSet,
        input.data
    ]);
    const isSomeSelected = (0, _react.useCallback)(()=>{
        return input.data.some((item)=>selectionSet.has(item));
    }, [
        selectionSet,
        input.data
    ]);
    return [
        Array.from(selectionSet),
        {
            select,
            deselect,
            toggle,
            isAllSelected,
            isSomeSelected,
            setSelection,
            resetSelection
        }
    ];
}

},{"react":"erQJb","../use-did-update/use-did-update.mjs":"bzSpx","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9idv4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7oXOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MantineContext", ()=>MantineContext);
parcelHelpers.export(exports, "useMantineClassNamesPrefix", ()=>useMantineClassNamesPrefix);
parcelHelpers.export(exports, "useMantineContext", ()=>useMantineContext);
parcelHelpers.export(exports, "useMantineCssVariablesResolver", ()=>useMantineCssVariablesResolver);
parcelHelpers.export(exports, "useMantineEnv", ()=>useMantineEnv);
parcelHelpers.export(exports, "useMantineIsHeadless", ()=>useMantineIsHeadless);
parcelHelpers.export(exports, "useMantineStyleNonce", ()=>useMantineStyleNonce);
parcelHelpers.export(exports, "useMantineStylesTransform", ()=>useMantineStylesTransform);
parcelHelpers.export(exports, "useMantineSxTransform", ()=>useMantineSxTransform);
parcelHelpers.export(exports, "useMantineWithStaticClasses", ()=>useMantineWithStaticClasses);
var _react = require("react");
'use client';
const MantineContext = (0, _react.createContext)(null);
function useMantineContext() {
    const ctx = (0, _react.useContext)(MantineContext);
    if (!ctx) throw new Error("[@mantine/core] MantineProvider was not found in tree");
    return ctx;
}
function useMantineCssVariablesResolver() {
    return useMantineContext().cssVariablesResolver;
}
function useMantineClassNamesPrefix() {
    return useMantineContext().classNamesPrefix;
}
function useMantineStyleNonce() {
    return useMantineContext().getStyleNonce;
}
function useMantineWithStaticClasses() {
    return useMantineContext().withStaticClasses;
}
function useMantineIsHeadless() {
    return useMantineContext().headless;
}
function useMantineSxTransform() {
    return useMantineContext().stylesTransform?.sx;
}
function useMantineStylesTransform() {
    return useMantineContext().stylesTransform?.styles;
}
function useMantineEnv() {
    return useMantineContext().env || "default";
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ixgDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_THEME", ()=>DEFAULT_THEME);
var _remMjs = require("../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _defaultVariantColorsResolverMjs = require("./color-functions/default-variant-colors-resolver/default-variant-colors-resolver.mjs");
var _defaultColorsMjs = require("./default-colors.mjs");
const DEFAULT_FONT_FAMILY = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji";
const DEFAULT_THEME = {
    scale: 1,
    fontSmoothing: true,
    focusRing: "auto",
    white: "#fff",
    black: "#000",
    colors: (0, _defaultColorsMjs.DEFAULT_COLORS),
    primaryShade: {
        light: 6,
        dark: 8
    },
    primaryColor: "blue",
    variantColorResolver: (0, _defaultVariantColorsResolverMjs.defaultVariantColorsResolver),
    autoContrast: false,
    luminanceThreshold: 0.3,
    fontFamily: DEFAULT_FONT_FAMILY,
    fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
    respectReducedMotion: false,
    cursorType: "default",
    defaultGradient: {
        from: "blue",
        to: "cyan",
        deg: 45
    },
    defaultRadius: "sm",
    activeClassName: "mantine-active",
    focusClassName: "",
    headings: {
        fontFamily: DEFAULT_FONT_FAMILY,
        fontWeight: "700",
        textWrap: "wrap",
        sizes: {
            h1: {
                fontSize: (0, _remMjs.rem)(34),
                lineHeight: "1.3"
            },
            h2: {
                fontSize: (0, _remMjs.rem)(26),
                lineHeight: "1.35"
            },
            h3: {
                fontSize: (0, _remMjs.rem)(22),
                lineHeight: "1.4"
            },
            h4: {
                fontSize: (0, _remMjs.rem)(18),
                lineHeight: "1.45"
            },
            h5: {
                fontSize: (0, _remMjs.rem)(16),
                lineHeight: "1.5"
            },
            h6: {
                fontSize: (0, _remMjs.rem)(14),
                lineHeight: "1.5"
            }
        }
    },
    fontSizes: {
        xs: (0, _remMjs.rem)(12),
        sm: (0, _remMjs.rem)(14),
        md: (0, _remMjs.rem)(16),
        lg: (0, _remMjs.rem)(18),
        xl: (0, _remMjs.rem)(20)
    },
    lineHeights: {
        xs: "1.4",
        sm: "1.45",
        md: "1.55",
        lg: "1.6",
        xl: "1.65"
    },
    radius: {
        xs: (0, _remMjs.rem)(2),
        sm: (0, _remMjs.rem)(4),
        md: (0, _remMjs.rem)(8),
        lg: (0, _remMjs.rem)(16),
        xl: (0, _remMjs.rem)(32)
    },
    spacing: {
        xs: (0, _remMjs.rem)(10),
        sm: (0, _remMjs.rem)(12),
        md: (0, _remMjs.rem)(16),
        lg: (0, _remMjs.rem)(20),
        xl: (0, _remMjs.rem)(32)
    },
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    shadows: {
        xs: `0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(3)} rgba(0, 0, 0, 0.05), 0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(2)} rgba(0, 0, 0, 0.1)`,
        sm: `0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, _remMjs.rem)(10)} ${(0, _remMjs.rem)(15)} ${(0, _remMjs.rem)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, _remMjs.rem)(7)} ${(0, _remMjs.rem)(7)} ${(0, _remMjs.rem)(-5)}`,
        md: `0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, _remMjs.rem)(20)} ${(0, _remMjs.rem)(25)} ${(0, _remMjs.rem)(-5)}, rgba(0, 0, 0, 0.04) 0 ${(0, _remMjs.rem)(10)} ${(0, _remMjs.rem)(10)} ${(0, _remMjs.rem)(-5)}`,
        lg: `0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, _remMjs.rem)(28)} ${(0, _remMjs.rem)(23)} ${(0, _remMjs.rem)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, _remMjs.rem)(12)} ${(0, _remMjs.rem)(12)} ${(0, _remMjs.rem)(-7)}`,
        xl: `0 ${(0, _remMjs.rem)(1)} ${(0, _remMjs.rem)(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${(0, _remMjs.rem)(36)} ${(0, _remMjs.rem)(28)} ${(0, _remMjs.rem)(-7)}, rgba(0, 0, 0, 0.04) 0 ${(0, _remMjs.rem)(17)} ${(0, _remMjs.rem)(17)} ${(0, _remMjs.rem)(-7)}`
    },
    other: {},
    components: {}
};

},{"../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","./color-functions/default-variant-colors-resolver/default-variant-colors-resolver.mjs":"dLkZZ","./default-colors.mjs":"fHXgM","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dLkZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultVariantColorsResolver", ()=>defaultVariantColorsResolver);
var _remMjs = require("../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _darkenMjs = require("../darken/darken.mjs");
var _getGradientMjs = require("../get-gradient/get-gradient.mjs");
var _parseThemeColorMjs = require("../parse-theme-color/parse-theme-color.mjs");
var _rgbaMjs = require("../rgba/rgba.mjs");
'use client';
const defaultVariantColorsResolver = ({ color, theme, variant, gradient, autoContrast })=>{
    const parsed = (0, _parseThemeColorMjs.parseThemeColor)({
        color,
        theme
    });
    const _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
    if (variant === "none") return {
        background: "transparent",
        hover: "transparent",
        color: "inherit",
        border: "none"
    };
    if (variant === "filled") {
        const textColor = _autoContrast ? parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)" : "var(--mantine-color-white)";
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-filled)`,
                hover: `var(--mantine-color-${color}-filled-hover)`,
                color: textColor,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
            return {
                background: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                hover: `var(--mantine-color-${parsed.color}-${parsed.shade === 9 ? 8 : parsed.shade + 1})`,
                color: textColor,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
        }
        return {
            background: color,
            hover: (0, _darkenMjs.darken)(color, 0.1),
            color: textColor,
            border: `${(0, _remMjs.rem)(1)} solid transparent`
        };
    }
    if (variant === "light") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: `var(--mantine-color-${color}-light)`,
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: (0, _rgbaMjs.rgba)(parsedColor, 0.1),
                hover: (0, _rgbaMjs.rgba)(parsedColor, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
        }
        return {
            background: (0, _rgbaMjs.rgba)(color, 0.1),
            hover: (0, _rgbaMjs.rgba)(color, 0.12),
            color,
            border: `${(0, _remMjs.rem)(1)} solid transparent`
        };
    }
    if (variant === "outline") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-outline-hover)`,
                color: `var(--mantine-color-${color}-outline)`,
                border: `${(0, _remMjs.rem)(1)} solid var(--mantine-color-${color}-outline)`
            };
            return {
                background: "transparent",
                hover: (0, _rgbaMjs.rgba)(theme.colors[parsed.color][parsed.shade], 0.05),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, _remMjs.rem)(1)} solid var(--mantine-color-${parsed.color}-${parsed.shade})`
            };
        }
        return {
            background: "transparent",
            hover: (0, _rgbaMjs.rgba)(color, 0.05),
            color,
            border: `${(0, _remMjs.rem)(1)} solid ${color}`
        };
    }
    if (variant === "subtle") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: `var(--mantine-color-${color}-light-hover)`,
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
            const parsedColor = theme.colors[parsed.color][parsed.shade];
            return {
                background: "transparent",
                hover: (0, _rgbaMjs.rgba)(parsedColor, 0.12),
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: (0, _rgbaMjs.rgba)(color, 0.12),
            color,
            border: `${(0, _remMjs.rem)(1)} solid transparent`
        };
    }
    if (variant === "transparent") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${color}-light-color)`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
            return {
                background: "transparent",
                hover: "transparent",
                color: `var(--mantine-color-${parsed.color}-${Math.min(parsed.shade, 6)})`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
        }
        return {
            background: "transparent",
            hover: "transparent",
            color,
            border: `${(0, _remMjs.rem)(1)} solid transparent`
        };
    }
    if (variant === "white") {
        if (parsed.isThemeColor) {
            if (parsed.shade === void 0) return {
                background: "var(--mantine-color-white)",
                hover: (0, _darkenMjs.darken)(theme.white, 0.01),
                color: `var(--mantine-color-${color}-filled)`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
            return {
                background: "var(--mantine-color-white)",
                hover: (0, _darkenMjs.darken)(theme.white, 0.01),
                color: `var(--mantine-color-${parsed.color}-${parsed.shade})`,
                border: `${(0, _remMjs.rem)(1)} solid transparent`
            };
        }
        return {
            background: "var(--mantine-color-white)",
            hover: (0, _darkenMjs.darken)(theme.white, 0.01),
            color,
            border: `${(0, _remMjs.rem)(1)} solid transparent`
        };
    }
    if (variant === "gradient") return {
        background: (0, _getGradientMjs.getGradient)(gradient, theme),
        hover: (0, _getGradientMjs.getGradient)(gradient, theme),
        color: "var(--mantine-color-white)",
        border: "none"
    };
    if (variant === "default") return {
        background: "var(--mantine-color-default)",
        hover: "var(--mantine-color-default-hover)",
        color: "var(--mantine-color-default-color)",
        border: `${(0, _remMjs.rem)(1)} solid var(--mantine-color-default-border)`
    };
    return {};
};

},{"../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../darken/darken.mjs":"2cVMH","../get-gradient/get-gradient.mjs":"haIj3","../parse-theme-color/parse-theme-color.mjs":"4t4fh","../rgba/rgba.mjs":"bqV23","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2cVMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "darken", ()=>darken);
var _toRgbaMjs = require("../to-rgba/to-rgba.mjs");
function darken(color, alpha) {
    if (color.startsWith("var(")) return `color-mix(in srgb, ${color}, black ${alpha * 100}%)`;
    const { r, g, b, a } = (0, _toRgbaMjs.toRgba)(color);
    const f = 1 - alpha;
    const dark = (input)=>Math.round(input * f);
    return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}

},{"../to-rgba/to-rgba.mjs":"bfIaz","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bfIaz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toRgba", ()=>toRgba);
function isHexColor(hex) {
    const HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i;
    return HEX_REGEXP.test(hex);
}
function hexToRgba(color) {
    let hexString = color.replace("#", "");
    if (hexString.length === 3) {
        const shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    if (hexString.length === 8) {
        const alpha = parseInt(hexString.slice(6, 8), 16) / 255;
        return {
            r: parseInt(hexString.slice(0, 2), 16),
            g: parseInt(hexString.slice(2, 4), 16),
            b: parseInt(hexString.slice(4, 6), 16),
            a: alpha
        };
    }
    const parsed = parseInt(hexString, 16);
    const r = parsed >> 16 & 255;
    const g = parsed >> 8 & 255;
    const b = parsed & 255;
    return {
        r,
        g,
        b,
        a: 1
    };
}
function rgbStringToRgba(color) {
    const [r, g, b, a] = color.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
    return {
        r,
        g,
        b,
        a: a === void 0 ? 1 : a
    };
}
function hslStringToRgba(hslaString) {
    const hslaRegex = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i;
    const matches = hslaString.match(hslaRegex);
    if (!matches) return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
    const h = parseInt(matches[1], 10);
    const s = parseInt(matches[2], 10) / 100;
    const l = parseInt(matches[3], 10) / 100;
    const a = matches[5] ? parseFloat(matches[5]) : void 0;
    const chroma = (1 - Math.abs(2 * l - 1)) * s;
    const huePrime = h / 60;
    const x = chroma * (1 - Math.abs(huePrime % 2 - 1));
    const m = l - chroma / 2;
    let r;
    let g;
    let b;
    if (huePrime >= 0 && huePrime < 1) {
        r = chroma;
        g = x;
        b = 0;
    } else if (huePrime >= 1 && huePrime < 2) {
        r = x;
        g = chroma;
        b = 0;
    } else if (huePrime >= 2 && huePrime < 3) {
        r = 0;
        g = chroma;
        b = x;
    } else if (huePrime >= 3 && huePrime < 4) {
        r = 0;
        g = x;
        b = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        r = x;
        g = 0;
        b = chroma;
    } else {
        r = chroma;
        g = 0;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255),
        a: a || 1
    };
}
function toRgba(color) {
    if (isHexColor(color)) return hexToRgba(color);
    if (color.startsWith("rgb")) return rgbStringToRgba(color);
    if (color.startsWith("hsl")) return hslStringToRgba(color);
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"haIj3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGradient", ()=>getGradient);
var _getThemeColorMjs = require("../get-theme-color/get-theme-color.mjs");
'use client';
function getGradient(gradient, theme) {
    const merged = {
        from: gradient?.from || theme.defaultGradient.from,
        to: gradient?.to || theme.defaultGradient.to,
        deg: gradient?.deg ?? theme.defaultGradient.deg ?? 0
    };
    const fromColor = (0, _getThemeColorMjs.getThemeColor)(merged.from, theme);
    const toColor = (0, _getThemeColorMjs.getThemeColor)(merged.to, theme);
    return `linear-gradient(${merged.deg}deg, ${fromColor} 0%, ${toColor} 100%)`;
}

},{"../get-theme-color/get-theme-color.mjs":"1o8C6","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1o8C6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeColor", ()=>getThemeColor);
var _parseThemeColorMjs = require("../parse-theme-color/parse-theme-color.mjs");
'use client';
function getThemeColor(color, theme) {
    const parsed = (0, _parseThemeColorMjs.parseThemeColor)({
        color: color || theme.primaryColor,
        theme
    });
    return parsed.variable ? `var(${parsed.variable})` : color;
}

},{"../parse-theme-color/parse-theme-color.mjs":"4t4fh","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4t4fh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseThemeColor", ()=>parseThemeColor);
var _getPrimaryShadeMjs = require("../get-primary-shade/get-primary-shade.mjs");
var _luminanceMjs = require("../luminance/luminance.mjs");
'use client';
function parseThemeColor({ color, theme, colorScheme }) {
    if (typeof color !== "string") throw new Error(`[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof color}`);
    if (color === "bright") return {
        color,
        value: colorScheme === "dark" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: (0, _luminanceMjs.isLightColor)(colorScheme === "dark" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: "--mantine-color-bright"
    };
    if (color === "dimmed") return {
        color,
        value: colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
        shade: void 0,
        isThemeColor: false,
        isLight: (0, _luminanceMjs.isLightColor)(colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6], theme.luminanceThreshold),
        variable: "--mantine-color-dimmed"
    };
    if (color === "white" || color === "black") return {
        color,
        value: color === "white" ? theme.white : theme.black,
        shade: void 0,
        isThemeColor: false,
        isLight: (0, _luminanceMjs.isLightColor)(color === "white" ? theme.white : theme.black, theme.luminanceThreshold),
        variable: `--mantine-color-${color}`
    };
    const [_color, shade] = color.split(".");
    const colorShade = shade ? Number(shade) : void 0;
    const isThemeColor = _color in theme.colors;
    if (isThemeColor) {
        const colorValue = colorShade !== void 0 ? theme.colors[_color][colorShade] : theme.colors[_color][(0, _getPrimaryShadeMjs.getPrimaryShade)(theme, colorScheme || "light")];
        return {
            color: _color,
            value: colorValue,
            shade: colorShade,
            isThemeColor,
            isLight: (0, _luminanceMjs.isLightColor)(colorValue, theme.luminanceThreshold),
            variable: shade ? `--mantine-color-${_color}-${colorShade}` : `--mantine-color-${_color}-filled`
        };
    }
    return {
        color,
        value: color,
        isThemeColor,
        isLight: (0, _luminanceMjs.isLightColor)(color, theme.luminanceThreshold),
        shade: colorShade,
        variable: void 0
    };
}

},{"../get-primary-shade/get-primary-shade.mjs":"6W4V1","../luminance/luminance.mjs":"flfn1","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6W4V1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPrimaryShade", ()=>getPrimaryShade);
'use client';
function getPrimaryShade(theme, colorScheme) {
    if (typeof theme.primaryShade === "number") return theme.primaryShade;
    if (colorScheme === "dark") return theme.primaryShade.dark;
    return theme.primaryShade.light;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"flfn1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLightColor", ()=>isLightColor);
parcelHelpers.export(exports, "luminance", ()=>luminance);
var _toRgbaMjs = require("../to-rgba/to-rgba.mjs");
function gammaCorrect(c) {
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
}
function getLightnessFromOklch(oklchColor) {
    const match = oklchColor.match(/oklch\((.*?)%\s/);
    return match ? parseFloat(match[1]) : null;
}
function luminance(color) {
    if (color.startsWith("oklch(")) return (getLightnessFromOklch(color) || 0) / 100;
    const { r, g, b } = (0, _toRgbaMjs.toRgba)(color);
    const sR = r / 255;
    const sG = g / 255;
    const sB = b / 255;
    const rLinear = gammaCorrect(sR);
    const gLinear = gammaCorrect(sG);
    const bLinear = gammaCorrect(sB);
    return 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;
}
function isLightColor(color, luminanceThreshold = 0.179) {
    if (color.startsWith("var(")) return false;
    return luminance(color) > luminanceThreshold;
}

},{"../to-rgba/to-rgba.mjs":"bfIaz","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bqV23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "rgba", ()=>rgba);
var _toRgbaMjs = require("../to-rgba/to-rgba.mjs");
function rgba(color, alpha2) {
    if (typeof color !== "string" || alpha2 > 1 || alpha2 < 0) return "rgba(0, 0, 0, 1)";
    if (color.startsWith("var(")) {
        const mixPercentage = (1 - alpha2) * 100;
        return `color-mix(in srgb, ${color}, transparent ${mixPercentage}%)`;
    }
    if (color.startsWith("oklch")) {
        if (color.includes("/")) return color.replace(/\/\s*[\d.]+\s*\)/, `/ ${alpha2})`);
        return color.replace(")", ` / ${alpha2})`);
    }
    const { r, g, b } = (0, _toRgbaMjs.toRgba)(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha2})`;
}
const alpha = rgba;

},{"../to-rgba/to-rgba.mjs":"bfIaz","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fHXgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_COLORS", ()=>DEFAULT_COLORS);
const DEFAULT_COLORS = {
    dark: [
        "#C9C9C9",
        "#b8b8b8",
        "#828282",
        "#696969",
        "#424242",
        "#3b3b3b",
        "#2e2e2e",
        "#242424",
        "#1f1f1f",
        "#141414"
    ],
    gray: [
        "#f8f9fa",
        "#f1f3f5",
        "#e9ecef",
        "#dee2e6",
        "#ced4da",
        "#adb5bd",
        "#868e96",
        "#495057",
        "#343a40",
        "#212529"
    ],
    red: [
        "#fff5f5",
        "#ffe3e3",
        "#ffc9c9",
        "#ffa8a8",
        "#ff8787",
        "#ff6b6b",
        "#fa5252",
        "#f03e3e",
        "#e03131",
        "#c92a2a"
    ],
    pink: [
        "#fff0f6",
        "#ffdeeb",
        "#fcc2d7",
        "#faa2c1",
        "#f783ac",
        "#f06595",
        "#e64980",
        "#d6336c",
        "#c2255c",
        "#a61e4d"
    ],
    grape: [
        "#f8f0fc",
        "#f3d9fa",
        "#eebefa",
        "#e599f7",
        "#da77f2",
        "#cc5de8",
        "#be4bdb",
        "#ae3ec9",
        "#9c36b5",
        "#862e9c"
    ],
    violet: [
        "#f3f0ff",
        "#e5dbff",
        "#d0bfff",
        "#b197fc",
        "#9775fa",
        "#845ef7",
        "#7950f2",
        "#7048e8",
        "#6741d9",
        "#5f3dc4"
    ],
    indigo: [
        "#edf2ff",
        "#dbe4ff",
        "#bac8ff",
        "#91a7ff",
        "#748ffc",
        "#5c7cfa",
        "#4c6ef5",
        "#4263eb",
        "#3b5bdb",
        "#364fc7"
    ],
    blue: [
        "#e7f5ff",
        "#d0ebff",
        "#a5d8ff",
        "#74c0fc",
        "#4dabf7",
        "#339af0",
        "#228be6",
        "#1c7ed6",
        "#1971c2",
        "#1864ab"
    ],
    cyan: [
        "#e3fafc",
        "#c5f6fa",
        "#99e9f2",
        "#66d9e8",
        "#3bc9db",
        "#22b8cf",
        "#15aabf",
        "#1098ad",
        "#0c8599",
        "#0b7285"
    ],
    teal: [
        "#e6fcf5",
        "#c3fae8",
        "#96f2d7",
        "#63e6be",
        "#38d9a9",
        "#20c997",
        "#12b886",
        "#0ca678",
        "#099268",
        "#087f5b"
    ],
    green: [
        "#ebfbee",
        "#d3f9d8",
        "#b2f2bb",
        "#8ce99a",
        "#69db7c",
        "#51cf66",
        "#40c057",
        "#37b24d",
        "#2f9e44",
        "#2b8a3e"
    ],
    lime: [
        "#f4fce3",
        "#e9fac8",
        "#d8f5a2",
        "#c0eb75",
        "#a9e34b",
        "#94d82d",
        "#82c91e",
        "#74b816",
        "#66a80f",
        "#5c940d"
    ],
    yellow: [
        "#fff9db",
        "#fff3bf",
        "#ffec99",
        "#ffe066",
        "#ffd43b",
        "#fcc419",
        "#fab005",
        "#f59f00",
        "#f08c00",
        "#e67700"
    ],
    orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f"
    ]
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2TSc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadlessMantineProvider", ()=>HeadlessMantineProvider);
parcelHelpers.export(exports, "MantineProvider", ()=>MantineProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _localStorageManagerMjs = require("./color-scheme-managers/local-storage-manager.mjs");
var _mantineContextMjs = require("./Mantine.context.mjs");
var _mantineClassesMjs = require("./MantineClasses/MantineClasses.mjs");
var _mantineCssVariablesMjs = require("./MantineCssVariables/MantineCssVariables.mjs");
var _remMjs = require("../utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineThemeProviderMjs = require("./MantineThemeProvider/MantineThemeProvider.mjs");
var _useProviderColorSchemeMjs = require("./use-mantine-color-scheme/use-provider-color-scheme.mjs");
var _useRespectReduceMotionMjs = require("./use-respect-reduce-motion/use-respect-reduce-motion.mjs");
'use client';
function MantineProvider({ theme, children, getStyleNonce, withStaticClasses = true, withGlobalClasses = true, deduplicateCssVariables = true, withCssVariables = true, cssVariablesSelector, classNamesPrefix = "mantine", colorSchemeManager = (0, _localStorageManagerMjs.localStorageColorSchemeManager)(), defaultColorScheme = "light", getRootElement = ()=>document.documentElement, cssVariablesResolver, forceColorScheme, stylesTransform, env }) {
    const { colorScheme, setColorScheme, clearColorScheme } = (0, _useProviderColorSchemeMjs.useProviderColorScheme)({
        defaultColorScheme,
        forceColorScheme,
        manager: colorSchemeManager,
        getRootElement
    });
    (0, _useRespectReduceMotionMjs.useRespectReduceMotion)({
        respectReducedMotion: theme?.respectReducedMotion || false,
        getRootElement
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _mantineContextMjs.MantineContext).Provider, {
        value: {
            colorScheme,
            setColorScheme,
            clearColorScheme,
            getRootElement,
            classNamesPrefix,
            getStyleNonce,
            cssVariablesResolver,
            cssVariablesSelector: cssVariablesSelector ?? ":root",
            withStaticClasses,
            stylesTransform,
            env
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _mantineThemeProviderMjs.MantineThemeProvider), {
            theme,
            children: [
                withCssVariables && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _mantineCssVariablesMjs.MantineCssVariables), {
                    cssVariablesSelector,
                    deduplicateCssVariables
                }),
                withGlobalClasses && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _mantineClassesMjs.MantineClasses), {}),
                children
            ]
        })
    });
}
MantineProvider.displayName = "@mantine/core/MantineProvider";
function HeadlessMantineProvider({ children, theme, env }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _mantineContextMjs.MantineContext).Provider, {
        value: {
            colorScheme: "auto",
            setColorScheme: ()=>{},
            clearColorScheme: ()=>{},
            getRootElement: ()=>document.documentElement,
            classNamesPrefix: "mantine",
            cssVariablesSelector: ":root",
            withStaticClasses: false,
            headless: true,
            env
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _mantineThemeProviderMjs.MantineThemeProvider), {
            theme,
            children
        })
    });
}
HeadlessMantineProvider.displayName = "@mantine/core/HeadlessMantineProvider";

},{"react/jsx-runtime":"1xKTF","./color-scheme-managers/local-storage-manager.mjs":"5NLp4","./Mantine.context.mjs":"7oXOX","./MantineClasses/MantineClasses.mjs":"6W0kF","./MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","./MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","./use-mantine-color-scheme/use-provider-color-scheme.mjs":"56ZQ1","./use-respect-reduce-motion/use-respect-reduce-motion.mjs":"arnqG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5NLp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localStorageColorSchemeManager", ()=>localStorageColorSchemeManager);
var _isMantineColorSchemeMjs = require("./is-mantine-color-scheme.mjs");
'use client';
function localStorageColorSchemeManager({ key = "mantine-color-scheme-value" } = {}) {
    let handleStorageEvent;
    return {
        get: (defaultValue)=>{
            if (typeof window === "undefined") return defaultValue;
            try {
                const storedColorScheme = window.localStorage.getItem(key);
                return (0, _isMantineColorSchemeMjs.isMantineColorScheme)(storedColorScheme) ? storedColorScheme : defaultValue;
            } catch  {
                return defaultValue;
            }
        },
        set: (value)=>{
            try {
                window.localStorage.setItem(key, value);
            } catch (error) {
                console.warn("[@mantine/core] Local storage color scheme manager was unable to save color scheme.", error);
            }
        },
        subscribe: (onUpdate)=>{
            handleStorageEvent = (event)=>{
                if (event.storageArea === window.localStorage && event.key === key) (0, _isMantineColorSchemeMjs.isMantineColorScheme)(event.newValue) && onUpdate(event.newValue);
            };
            window.addEventListener("storage", handleStorageEvent);
        },
        unsubscribe: ()=>{
            window.removeEventListener("storage", handleStorageEvent);
        },
        clear: ()=>{
            window.localStorage.removeItem(key);
        }
    };
}

},{"./is-mantine-color-scheme.mjs":"8GkeA","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8GkeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMantineColorScheme", ()=>isMantineColorScheme);
'use client';
function isMantineColorScheme(value) {
    return value === "auto" || value === "dark" || value === "light";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6W0kF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MantineClasses", ()=>MantineClasses);
var _jsxRuntime = require("react/jsx-runtime");
var _keysMjs = require("../../utils/keys/keys.mjs");
var _pxMjs = require("../../utils/units-converters/px.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../Mantine.context.mjs");
var _mantineThemeProviderMjs = require("../MantineThemeProvider/MantineThemeProvider.mjs");
'use client';
function MantineClasses() {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const nonce = (0, _mantineContextMjs.useMantineStyleNonce)();
    const classes = (0, _keysMjs.keys)(theme.breakpoints).reduce((acc, breakpoint)=>{
        const isPxBreakpoint = theme.breakpoints[breakpoint].includes("px");
        const pxValue = (0, _pxMjs.px)(theme.breakpoints[breakpoint]);
        const maxWidthBreakpoint = isPxBreakpoint ? `${pxValue - 0.1}px` : (0, _remMjs.em)(pxValue - 0.1);
        const minWidthBreakpoint = isPxBreakpoint ? `${pxValue}px` : (0, _remMjs.em)(pxValue);
        return `${acc}@media (max-width: ${maxWidthBreakpoint}) {.mantine-visible-from-${breakpoint} {display: none !important;}}@media (min-width: ${minWidthBreakpoint}) {.mantine-hidden-from-${breakpoint} {display: none !important;}}`;
    }, "");
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("style", {
        "data-mantine-styles": "classes",
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: classes
        }
    });
}

},{"react/jsx-runtime":"1xKTF","../../utils/keys/keys.mjs":"7biZA","../../utils/units-converters/px.mjs":"kdby7","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../Mantine.context.mjs":"7oXOX","../MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7biZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keys", ()=>keys);
'use client';
function keys(object) {
    return Object.keys(object);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kdby7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "px", ()=>px);
function getTransformedScaledValue(value) {
    if (typeof value !== "string" || !value.includes("var(--mantine-scale)")) return value;
    return value.match(/^calc\((.*?)\)$/)?.[1].split("*")[0].trim();
}
function px(value) {
    const transformedValue = getTransformedScaledValue(value);
    if (typeof transformedValue === "number") return transformedValue;
    if (typeof transformedValue === "string") {
        if (transformedValue.includes("calc") || transformedValue.includes("var")) return transformedValue;
        if (transformedValue.includes("px")) return Number(transformedValue.replace("px", ""));
        if (transformedValue.includes("rem")) return Number(transformedValue.replace("rem", "")) * 16;
        if (transformedValue.includes("em")) return Number(transformedValue.replace("em", "")) * 16;
        return Number(transformedValue);
    }
    return NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bajsd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MantineThemeContext", ()=>MantineThemeContext);
parcelHelpers.export(exports, "MantineThemeProvider", ()=>MantineThemeProvider);
parcelHelpers.export(exports, "useMantineTheme", ()=>useMantineTheme);
parcelHelpers.export(exports, "useSafeMantineTheme", ()=>useSafeMantineTheme);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _defaultThemeMjs = require("../default-theme.mjs");
var _mergeMantineThemeMjs = require("../merge-mantine-theme/merge-mantine-theme.mjs");
'use client';
const MantineThemeContext = (0, _react.createContext)(null);
const useSafeMantineTheme = ()=>(0, _react.useContext)(MantineThemeContext) || (0, _defaultThemeMjs.DEFAULT_THEME);
function useMantineTheme() {
    const ctx = (0, _react.useContext)(MantineThemeContext);
    if (!ctx) throw new Error("@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app");
    return ctx;
}
function MantineThemeProvider({ theme, children, inherit = true }) {
    const parentTheme = useSafeMantineTheme();
    const mergedTheme = (0, _react.useMemo)(()=>(0, _mergeMantineThemeMjs.mergeMantineTheme)(inherit ? parentTheme : (0, _defaultThemeMjs.DEFAULT_THEME), theme), [
        theme,
        parentTheme,
        inherit
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(MantineThemeContext.Provider, {
        value: mergedTheme,
        children
    });
}
MantineThemeProvider.displayName = "@mantine/core/MantineThemeProvider";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../default-theme.mjs":"ixgDZ","../merge-mantine-theme/merge-mantine-theme.mjs":"aSlIr","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aSlIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INVALID_PRIMARY_COLOR_ERROR", ()=>INVALID_PRIMARY_COLOR_ERROR);
parcelHelpers.export(exports, "INVALID_PRIMARY_SHADE_ERROR", ()=>INVALID_PRIMARY_SHADE_ERROR);
parcelHelpers.export(exports, "mergeMantineTheme", ()=>mergeMantineTheme);
parcelHelpers.export(exports, "validateMantineTheme", ()=>validateMantineTheme);
var _deepMergeMjs = require("../../utils/deep-merge/deep-merge.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
const INVALID_PRIMARY_COLOR_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color";
const INVALID_PRIMARY_SHADE_ERROR = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function isValidPrimaryShade(shade) {
    if (shade < 0 || shade > 9) return false;
    return parseInt(shade.toString(), 10) === shade;
}
function validateMantineTheme(theme) {
    if (!(theme.primaryColor in theme.colors)) throw new Error(INVALID_PRIMARY_COLOR_ERROR);
    if (typeof theme.primaryShade === "object") {
        if (!isValidPrimaryShade(theme.primaryShade.dark) || !isValidPrimaryShade(theme.primaryShade.light)) throw new Error(INVALID_PRIMARY_SHADE_ERROR);
    }
    if (typeof theme.primaryShade === "number" && !isValidPrimaryShade(theme.primaryShade)) throw new Error(INVALID_PRIMARY_SHADE_ERROR);
}
function mergeMantineTheme(currentTheme, themeOverride) {
    if (!themeOverride) {
        validateMantineTheme(currentTheme);
        return currentTheme;
    }
    const result = (0, _deepMergeMjs.deepMerge)(currentTheme, themeOverride);
    if (themeOverride.fontFamily && !themeOverride.headings?.fontFamily) result.headings.fontFamily = themeOverride.fontFamily;
    validateMantineTheme(result);
    return result;
}

},{"../../utils/deep-merge/deep-merge.mjs":"e8avY","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"e8avY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepMerge", ()=>deepMerge);
function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
function deepMerge(target, source) {
    const result = {
        ...target
    };
    const _source = source;
    if (isObject(target) && isObject(source)) Object.keys(source).forEach((key)=>{
        if (isObject(_source[key])) {
            if (!(key in target)) result[key] = _source[key];
            else result[key] = deepMerge(result[key], _source[key]);
        } else result[key] = _source[key];
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"iF9wl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MantineCssVariables", ()=>MantineCssVariables);
var _jsxRuntime = require("react/jsx-runtime");
var _convertCssVariablesMjs = require("../convert-css-variables/convert-css-variables.mjs");
var _mantineContextMjs = require("../Mantine.context.mjs");
var _mantineThemeProviderMjs = require("../MantineThemeProvider/MantineThemeProvider.mjs");
var _getMergedVariablesMjs = require("./get-merged-variables.mjs");
var _removeDefaultVariablesMjs = require("./remove-default-variables.mjs");
'use client';
function getColorSchemeCssVariables(selectorOverride) {
    return (0, _convertCssVariablesMjs.convertCssVariables)({
        variables: {},
        dark: {
            "--mantine-color-scheme": "dark"
        },
        light: {
            "--mantine-color-scheme": "light"
        }
    }, selectorOverride);
}
function MantineCssVariables({ cssVariablesSelector, deduplicateCssVariables }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const nonce = (0, _mantineContextMjs.useMantineStyleNonce)();
    const generator = (0, _mantineContextMjs.useMantineCssVariablesResolver)();
    const mergedVariables = (0, _getMergedVariablesMjs.getMergedVariables)({
        theme,
        generator
    });
    const shouldCleanVariables = (cssVariablesSelector === void 0 || cssVariablesSelector === ":root" || cssVariablesSelector === ":host") && deduplicateCssVariables;
    const cleanedVariables = shouldCleanVariables ? (0, _removeDefaultVariablesMjs.removeDefaultVariables)(mergedVariables) : mergedVariables;
    const css = (0, _convertCssVariablesMjs.convertCssVariables)(cleanedVariables, cssVariablesSelector);
    if (css) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("style", {
        "data-mantine-styles": true,
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: `${css}${shouldCleanVariables ? "" : getColorSchemeCssVariables(cssVariablesSelector)}`
        }
    });
    return null;
}
MantineCssVariables.displayName = "@mantine/CssVariables";

},{"react/jsx-runtime":"1xKTF","../convert-css-variables/convert-css-variables.mjs":"7Vl8A","../Mantine.context.mjs":"7oXOX","../MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","./get-merged-variables.mjs":"cFH92","./remove-default-variables.mjs":"62SNU","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7Vl8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertCssVariables", ()=>convertCssVariables);
var _cssVariablesObjectToStringMjs = require("./css-variables-object-to-string.mjs");
'use client';
function convertCssVariables(input, selectorOverride) {
    const selectors = selectorOverride ? [
        selectorOverride
    ] : [
        ":root",
        ":host"
    ];
    const sharedVariables = (0, _cssVariablesObjectToStringMjs.cssVariablesObjectToString)(input.variables);
    const shared = sharedVariables ? `${selectors.join(", ")}{${sharedVariables}}` : "";
    const dark = (0, _cssVariablesObjectToStringMjs.cssVariablesObjectToString)(input.dark);
    const light = (0, _cssVariablesObjectToStringMjs.cssVariablesObjectToString)(input.light);
    const selectorsWithScheme = (scheme)=>selectors.map((selector)=>selector === ":host" ? `${selector}([data-mantine-color-scheme="${scheme}"])` : `${selector}[data-mantine-color-scheme="${scheme}"]`).join(", ");
    const darkForced = dark ? `${selectorsWithScheme("dark")}{${dark}}` : "";
    const lightForced = light ? `${selectorsWithScheme("light")}{${light}}` : "";
    return `${shared}

${darkForced}

${lightForced}`;
}

},{"./css-variables-object-to-string.mjs":"c6hi1","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c6hi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cssVariablesObjectToString", ()=>cssVariablesObjectToString);
'use client';
function cssVariablesObjectToString(variables) {
    return Object.entries(variables).map(([name, value])=>`${name}: ${value};`).join("");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cFH92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMergedVariables", ()=>getMergedVariables);
var _deepMergeMjs = require("../../utils/deep-merge/deep-merge.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _defaultCssVariablesResolverMjs = require("./default-css-variables-resolver.mjs");
'use client';
function getMergedVariables({ theme, generator }) {
    const defaultResolver = (0, _defaultCssVariablesResolverMjs.defaultCssVariablesResolver)(theme);
    const providerGenerator = generator?.(theme);
    return providerGenerator ? (0, _deepMergeMjs.deepMerge)(defaultResolver, providerGenerator) : defaultResolver;
}

},{"../../utils/deep-merge/deep-merge.mjs":"e8avY","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","./default-css-variables-resolver.mjs":"312Xb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"312Xb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultCssVariablesResolver", ()=>defaultCssVariablesResolver);
var _keysMjs = require("../../utils/keys/keys.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _getPrimaryShadeMjs = require("../color-functions/get-primary-shade/get-primary-shade.mjs");
var _getContrastColorMjs = require("../color-functions/get-contrast-color/get-contrast-color.mjs");
var _getCssColorVariablesMjs = require("./get-css-color-variables.mjs");
var _virtualColorMjs = require("./virtual-color/virtual-color.mjs");
'use client';
function assignSizeVariables(variables, sizes, name) {
    (0, _keysMjs.keys)(sizes).forEach((size)=>Object.assign(variables, {
            [`--mantine-${name}-${size}`]: sizes[size]
        }));
}
const defaultCssVariablesResolver = (theme)=>{
    const lightPrimaryShade = (0, _getPrimaryShadeMjs.getPrimaryShade)(theme, "light");
    const defaultRadius = theme.defaultRadius in theme.radius ? theme.radius[theme.defaultRadius] : (0, _remMjs.rem)(theme.defaultRadius);
    const result = {
        variables: {
            "--mantine-z-index-app": "100",
            "--mantine-z-index-modal": "200",
            "--mantine-z-index-popover": "300",
            "--mantine-z-index-overlay": "400",
            "--mantine-z-index-max": "9999",
            "--mantine-scale": theme.scale.toString(),
            "--mantine-cursor-type": theme.cursorType,
            "--mantine-webkit-font-smoothing": theme.fontSmoothing ? "antialiased" : "unset",
            "--mantine-moz-font-smoothing": theme.fontSmoothing ? "grayscale" : "unset",
            "--mantine-color-white": theme.white,
            "--mantine-color-black": theme.black,
            "--mantine-line-height": theme.lineHeights.md,
            "--mantine-font-family": theme.fontFamily,
            "--mantine-font-family-monospace": theme.fontFamilyMonospace,
            "--mantine-font-family-headings": theme.headings.fontFamily,
            "--mantine-heading-font-weight": theme.headings.fontWeight,
            "--mantine-heading-text-wrap": theme.headings.textWrap,
            "--mantine-radius-default": defaultRadius,
            // Primary colors
            "--mantine-primary-color-filled": `var(--mantine-color-${theme.primaryColor}-filled)`,
            "--mantine-primary-color-filled-hover": `var(--mantine-color-${theme.primaryColor}-filled-hover)`,
            "--mantine-primary-color-light": `var(--mantine-color-${theme.primaryColor}-light)`,
            "--mantine-primary-color-light-hover": `var(--mantine-color-${theme.primaryColor}-light-hover)`,
            "--mantine-primary-color-light-color": `var(--mantine-color-${theme.primaryColor}-light-color)`
        },
        light: {
            "--mantine-color-scheme": "light",
            "--mantine-primary-color-contrast": (0, _getContrastColorMjs.getPrimaryContrastColor)(theme, "light"),
            "--mantine-color-bright": "var(--mantine-color-black)",
            "--mantine-color-text": theme.black,
            "--mantine-color-body": theme.white,
            "--mantine-color-error": "var(--mantine-color-red-6)",
            "--mantine-color-placeholder": "var(--mantine-color-gray-5)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-${lightPrimaryShade})`,
            "--mantine-color-default": "var(--mantine-color-white)",
            "--mantine-color-default-hover": "var(--mantine-color-gray-0)",
            "--mantine-color-default-color": "var(--mantine-color-black)",
            "--mantine-color-default-border": "var(--mantine-color-gray-4)",
            "--mantine-color-dimmed": "var(--mantine-color-gray-6)",
            "--mantine-color-disabled": "var(--mantine-color-gray-2)",
            "--mantine-color-disabled-color": "var(--mantine-color-gray-5)",
            "--mantine-color-disabled-border": "var(--mantine-color-gray-3)"
        },
        dark: {
            "--mantine-color-scheme": "dark",
            "--mantine-primary-color-contrast": (0, _getContrastColorMjs.getPrimaryContrastColor)(theme, "dark"),
            "--mantine-color-bright": "var(--mantine-color-white)",
            "--mantine-color-text": "var(--mantine-color-dark-0)",
            "--mantine-color-body": "var(--mantine-color-dark-7)",
            "--mantine-color-error": "var(--mantine-color-red-8)",
            "--mantine-color-placeholder": "var(--mantine-color-dark-3)",
            "--mantine-color-anchor": `var(--mantine-color-${theme.primaryColor}-4)`,
            "--mantine-color-default": "var(--mantine-color-dark-6)",
            "--mantine-color-default-hover": "var(--mantine-color-dark-5)",
            "--mantine-color-default-color": "var(--mantine-color-white)",
            "--mantine-color-default-border": "var(--mantine-color-dark-4)",
            "--mantine-color-dimmed": "var(--mantine-color-dark-2)",
            "--mantine-color-disabled": "var(--mantine-color-dark-6)",
            "--mantine-color-disabled-color": "var(--mantine-color-dark-3)",
            "--mantine-color-disabled-border": "var(--mantine-color-dark-4)"
        }
    };
    assignSizeVariables(result.variables, theme.breakpoints, "breakpoint");
    assignSizeVariables(result.variables, theme.spacing, "spacing");
    assignSizeVariables(result.variables, theme.fontSizes, "font-size");
    assignSizeVariables(result.variables, theme.lineHeights, "line-height");
    assignSizeVariables(result.variables, theme.shadows, "shadow");
    assignSizeVariables(result.variables, theme.radius, "radius");
    theme.colors[theme.primaryColor].forEach((_, index)=>{
        result.variables[`--mantine-primary-color-${index}`] = `var(--mantine-color-${theme.primaryColor}-${index})`;
    });
    (0, _keysMjs.keys)(theme.colors).forEach((color)=>{
        const value = theme.colors[color];
        if ((0, _virtualColorMjs.isVirtualColor)(value)) {
            Object.assign(result.light, (0, _getCssColorVariablesMjs.getCSSColorVariables)({
                theme,
                name: value.name,
                color: value.light,
                colorScheme: "light",
                withColorValues: true
            }));
            Object.assign(result.dark, (0, _getCssColorVariablesMjs.getCSSColorVariables)({
                theme,
                name: value.name,
                color: value.dark,
                colorScheme: "dark",
                withColorValues: true
            }));
            return;
        }
        value.forEach((shade, index)=>{
            result.variables[`--mantine-color-${color}-${index}`] = shade;
        });
        Object.assign(result.light, (0, _getCssColorVariablesMjs.getCSSColorVariables)({
            theme,
            color,
            colorScheme: "light",
            withColorValues: false
        }));
        Object.assign(result.dark, (0, _getCssColorVariablesMjs.getCSSColorVariables)({
            theme,
            color,
            colorScheme: "dark",
            withColorValues: false
        }));
    });
    const headings = theme.headings.sizes;
    (0, _keysMjs.keys)(headings).forEach((heading)=>{
        result.variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
        result.variables[`--mantine-${heading}-line-height`] = headings[heading].lineHeight;
        result.variables[`--mantine-${heading}-font-weight`] = headings[heading].fontWeight || theme.headings.fontWeight;
    });
    return result;
};

},{"../../utils/keys/keys.mjs":"7biZA","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../color-functions/get-primary-shade/get-primary-shade.mjs":"6W4V1","../color-functions/get-contrast-color/get-contrast-color.mjs":"3hO4e","./get-css-color-variables.mjs":"OD699","./virtual-color/virtual-color.mjs":"2otji","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3hO4e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContrastColor", ()=>getContrastColor);
parcelHelpers.export(exports, "getPrimaryContrastColor", ()=>getPrimaryContrastColor);
var _getPrimaryShadeMjs = require("../get-primary-shade/get-primary-shade.mjs");
var _parseThemeColorMjs = require("../parse-theme-color/parse-theme-color.mjs");
'use client';
function getContrastColor({ color, theme, autoContrast }) {
    const _autoContrast = typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
    if (!_autoContrast) return "var(--mantine-color-white)";
    const parsed = (0, _parseThemeColorMjs.parseThemeColor)({
        color: color || theme.primaryColor,
        theme
    });
    return parsed.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
}
function getPrimaryContrastColor(theme, colorScheme) {
    return getContrastColor({
        color: theme.colors[theme.primaryColor][(0, _getPrimaryShadeMjs.getPrimaryShade)(theme, colorScheme)],
        theme,
        autoContrast: null
    });
}

},{"../get-primary-shade/get-primary-shade.mjs":"6W4V1","../parse-theme-color/parse-theme-color.mjs":"4t4fh","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"OD699":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCSSColorVariables", ()=>getCSSColorVariables);
var _getPrimaryShadeMjs = require("../color-functions/get-primary-shade/get-primary-shade.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _rgbaMjs = require("../color-functions/rgba/rgba.mjs");
'use client';
function getCSSColorVariables({ theme, color, colorScheme, name = color, withColorValues = true }) {
    if (!theme.colors[color]) return {};
    if (colorScheme === "light") {
        const primaryShade2 = (0, _getPrimaryShadeMjs.getPrimaryShade)(theme, "light");
        const dynamicVariables2 = {
            [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-filled)`,
            [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade2 === 9 ? 8 : primaryShade2 + 1})`,
            [`--mantine-color-${name}-light`]: (0, _rgbaMjs.alpha)(theme.colors[color][primaryShade2], 0.1),
            [`--mantine-color-${name}-light-hover`]: (0, _rgbaMjs.alpha)(theme.colors[color][primaryShade2], 0.12),
            [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${primaryShade2})`,
            [`--mantine-color-${name}-outline-hover`]: (0, _rgbaMjs.alpha)(theme.colors[color][primaryShade2], 0.05)
        };
        if (!withColorValues) return dynamicVariables2;
        return {
            [`--mantine-color-${name}-0`]: theme.colors[color][0],
            [`--mantine-color-${name}-1`]: theme.colors[color][1],
            [`--mantine-color-${name}-2`]: theme.colors[color][2],
            [`--mantine-color-${name}-3`]: theme.colors[color][3],
            [`--mantine-color-${name}-4`]: theme.colors[color][4],
            [`--mantine-color-${name}-5`]: theme.colors[color][5],
            [`--mantine-color-${name}-6`]: theme.colors[color][6],
            [`--mantine-color-${name}-7`]: theme.colors[color][7],
            [`--mantine-color-${name}-8`]: theme.colors[color][8],
            [`--mantine-color-${name}-9`]: theme.colors[color][9],
            ...dynamicVariables2
        };
    }
    const primaryShade = (0, _getPrimaryShadeMjs.getPrimaryShade)(theme, "dark");
    const dynamicVariables = {
        [`--mantine-color-${name}-text`]: `var(--mantine-color-${name}-4)`,
        [`--mantine-color-${name}-filled`]: `var(--mantine-color-${name}-${primaryShade})`,
        [`--mantine-color-${name}-filled-hover`]: `var(--mantine-color-${name}-${primaryShade === 9 ? 8 : primaryShade + 1})`,
        [`--mantine-color-${name}-light`]: (0, _rgbaMjs.alpha)(theme.colors[color][Math.max(0, primaryShade - 2)], 0.15),
        [`--mantine-color-${name}-light-hover`]: (0, _rgbaMjs.alpha)(theme.colors[color][Math.max(0, primaryShade - 2)], 0.2),
        [`--mantine-color-${name}-light-color`]: `var(--mantine-color-${name}-${Math.max(primaryShade - 5, 0)})`,
        [`--mantine-color-${name}-outline`]: `var(--mantine-color-${name}-${Math.max(primaryShade - 4, 0)})`,
        [`--mantine-color-${name}-outline-hover`]: (0, _rgbaMjs.alpha)(theme.colors[color][Math.max(primaryShade - 4, 0)], 0.05)
    };
    if (!withColorValues) return dynamicVariables;
    return {
        [`--mantine-color-${name}-0`]: theme.colors[color][0],
        [`--mantine-color-${name}-1`]: theme.colors[color][1],
        [`--mantine-color-${name}-2`]: theme.colors[color][2],
        [`--mantine-color-${name}-3`]: theme.colors[color][3],
        [`--mantine-color-${name}-4`]: theme.colors[color][4],
        [`--mantine-color-${name}-5`]: theme.colors[color][5],
        [`--mantine-color-${name}-6`]: theme.colors[color][6],
        [`--mantine-color-${name}-7`]: theme.colors[color][7],
        [`--mantine-color-${name}-8`]: theme.colors[color][8],
        [`--mantine-color-${name}-9`]: theme.colors[color][9],
        ...dynamicVariables
    };
}

},{"../color-functions/get-primary-shade/get-primary-shade.mjs":"6W4V1","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../color-functions/rgba/rgba.mjs":"bqV23","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2otji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVirtualColor", ()=>isVirtualColor);
parcelHelpers.export(exports, "virtualColor", ()=>virtualColor);
var _remMjs = require("../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _colorsTupleMjs = require("../../color-functions/colors-tuple/colors-tuple.mjs");
function virtualColor(input) {
    const result = (0, _colorsTupleMjs.colorsTuple)(Array.from({
        length: 10
    }).map((_, i)=>`var(--mantine-color-${input.name}-${i})`));
    Object.defineProperty(result, "mantine-virtual-color", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: true
    });
    Object.defineProperty(result, "dark", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.dark
    });
    Object.defineProperty(result, "light", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.light
    });
    Object.defineProperty(result, "name", {
        enumerable: false,
        writable: false,
        configurable: false,
        value: input.name
    });
    return result;
}
function isVirtualColor(value) {
    return !!value && typeof value === "object" && "mantine-virtual-color" in value;
}

},{"../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../../color-functions/colors-tuple/colors-tuple.mjs":"cPLTX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cPLTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorsTuple", ()=>colorsTuple);
function colorsTuple(input) {
    if (Array.isArray(input)) return input;
    return Array(10).fill(input);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"62SNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeDefaultVariables", ()=>removeDefaultVariables);
var _keysMjs = require("../../utils/keys/keys.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _defaultThemeMjs = require("../default-theme.mjs");
var _defaultCssVariablesResolverMjs = require("./default-css-variables-resolver.mjs");
'use client';
const defaultCssVariables = (0, _defaultCssVariablesResolverMjs.defaultCssVariablesResolver)((0, _defaultThemeMjs.DEFAULT_THEME));
function removeDefaultVariables(input) {
    const cleaned = {
        variables: {},
        light: {},
        dark: {}
    };
    (0, _keysMjs.keys)(input.variables).forEach((key)=>{
        if (defaultCssVariables.variables[key] !== input.variables[key]) cleaned.variables[key] = input.variables[key];
    });
    (0, _keysMjs.keys)(input.light).forEach((key)=>{
        if (defaultCssVariables.light[key] !== input.light[key]) cleaned.light[key] = input.light[key];
    });
    (0, _keysMjs.keys)(input.dark).forEach((key)=>{
        if (defaultCssVariables.dark[key] !== input.dark[key]) cleaned.dark[key] = input.dark[key];
    });
    return cleaned;
}

},{"../../utils/keys/keys.mjs":"7biZA","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../default-theme.mjs":"ixgDZ","./default-css-variables-resolver.mjs":"312Xb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"56ZQ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProviderColorScheme", ()=>useProviderColorScheme);
var _react = require("react");
var _hooks = require("@mantine/hooks");
'use client';
function setColorSchemeAttribute(colorScheme, getRootElement) {
    const hasDarkColorScheme = typeof window !== "undefined" && "matchMedia" in window && window.matchMedia("(prefers-color-scheme: dark)")?.matches;
    const computedColorScheme = colorScheme !== "auto" ? colorScheme : hasDarkColorScheme ? "dark" : "light";
    getRootElement()?.setAttribute("data-mantine-color-scheme", computedColorScheme);
}
function useProviderColorScheme({ manager, defaultColorScheme, getRootElement, forceColorScheme }) {
    const media = (0, _react.useRef)(null);
    const [value, setValue] = (0, _react.useState)(()=>manager.get(defaultColorScheme));
    const colorSchemeValue = forceColorScheme || value;
    const setColorScheme = (0, _react.useCallback)((colorScheme)=>{
        if (!forceColorScheme) {
            setColorSchemeAttribute(colorScheme, getRootElement);
            setValue(colorScheme);
            manager.set(colorScheme);
        }
    }, [
        manager.set,
        colorSchemeValue,
        forceColorScheme
    ]);
    const clearColorScheme = (0, _react.useCallback)(()=>{
        setValue(defaultColorScheme);
        setColorSchemeAttribute(defaultColorScheme, getRootElement);
        manager.clear();
    }, [
        manager.clear,
        defaultColorScheme
    ]);
    (0, _react.useEffect)(()=>{
        manager.subscribe(setColorScheme);
        return manager.unsubscribe;
    }, [
        manager.subscribe,
        manager.unsubscribe
    ]);
    (0, _hooks.useIsomorphicEffect)(()=>{
        setColorSchemeAttribute(manager.get(defaultColorScheme), getRootElement);
    }, []);
    (0, _react.useEffect)(()=>{
        if (forceColorScheme) {
            setColorSchemeAttribute(forceColorScheme, getRootElement);
            return ()=>{};
        }
        if (forceColorScheme === void 0) setColorSchemeAttribute(value, getRootElement);
        if (typeof window !== "undefined" && "matchMedia" in window) media.current = window.matchMedia("(prefers-color-scheme: dark)");
        const listener = (event)=>{
            if (value === "auto") setColorSchemeAttribute(event.matches ? "dark" : "light", getRootElement);
        };
        media.current?.addEventListener("change", listener);
        return ()=>media.current?.removeEventListener("change", listener);
    }, [
        value,
        forceColorScheme
    ]);
    return {
        colorScheme: colorSchemeValue,
        setColorScheme,
        clearColorScheme
    };
}

},{"react":"erQJb","@mantine/hooks":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"arnqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRespectReduceMotion", ()=>useRespectReduceMotion);
var _hooks = require("@mantine/hooks");
'use client';
function useRespectReduceMotion({ respectReducedMotion, getRootElement }) {
    (0, _hooks.useIsomorphicEffect)(()=>{
        if (respectReducedMotion) getRootElement()?.setAttribute("data-respect-reduced-motion", "true");
    }, [
        respectReducedMotion
    ]);
}

},{"@mantine/hooks":"6Cmng","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kSa6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProps", ()=>useProps);
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _filterPropsMjs = require("../../utils/filter-props/filter-props.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _mantineThemeProviderMjs = require("../MantineThemeProvider/MantineThemeProvider.mjs");
'use client';
function useProps(component, defaultProps, props) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const contextPropsPayload = theme.components[component]?.defaultProps;
    const contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
    return {
        ...defaultProps,
        ...contextProps,
        ...(0, _filterPropsMjs.filterProps)(props)
    };
}

},{"../../utils/units-converters/rem.mjs":"c70Xm","../../utils/filter-props/filter-props.mjs":"ZNjvb","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ZNjvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
'use client';
function filterProps(props) {
    return Object.keys(props).reduce((acc, key)=>{
        if (props[key] !== void 0) acc[key] = props[key];
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8urVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStyles", ()=>useStyles);
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _getClassNameMjs = require("./get-class-name/get-class-name.mjs");
var _getStyleMjs = require("./get-style/get-style.mjs");
var _useTransformedStylesMjs = require("./use-transformed-styles.mjs");
'use client';
function useStyles({ name, classes, props, stylesCtx, className, style, rootSelector = "root", unstyled, classNames, styles, vars, varsResolver, attributes }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const classNamesPrefix = (0, _mantineContextMjs.useMantineClassNamesPrefix)();
    const withStaticClasses = (0, _mantineContextMjs.useMantineWithStaticClasses)();
    const headless = (0, _mantineContextMjs.useMantineIsHeadless)();
    const themeName = (Array.isArray(name) ? name : [
        name
    ]).filter((n)=>n);
    const { withStylesTransform, getTransformedStyles } = (0, _useTransformedStylesMjs.useStylesTransform)({
        props,
        stylesCtx,
        themeName
    });
    return (selector, options)=>({
            className: (0, _getClassNameMjs.getClassName)({
                theme,
                options,
                themeName,
                selector,
                classNamesPrefix,
                classNames,
                classes,
                unstyled,
                className,
                rootSelector,
                props,
                stylesCtx,
                withStaticClasses,
                headless,
                transformedStyles: getTransformedStyles([
                    options?.styles,
                    styles
                ])
            }),
            style: (0, _getStyleMjs.getStyle)({
                theme,
                themeName,
                selector,
                options,
                props,
                stylesCtx,
                rootSelector,
                styles,
                style,
                vars,
                varsResolver,
                headless,
                withStylesTransform
            }),
            ...attributes?.[selector]
        });
}

},{"../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../../MantineProvider/Mantine.context.mjs":"7oXOX","../../MantineProvider/default-theme.mjs":"ixgDZ","../../MantineProvider/MantineProvider.mjs":"2TSc8","../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","./get-class-name/get-class-name.mjs":"3ULC2","./get-style/get-style.mjs":"kJgG0","./use-transformed-styles.mjs":"9GFq7","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3ULC2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClassName", ()=>getClassName);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _getGlobalClassNamesMjs = require("./get-global-class-names/get-global-class-names.mjs");
var _getOptionsClassNamesMjs = require("./get-options-class-names/get-options-class-names.mjs");
var _getResolvedClassNamesMjs = require("./get-resolved-class-names/get-resolved-class-names.mjs");
var _getRootClassNameMjs = require("./get-root-class-name/get-root-class-name.mjs");
var _getSelectorClassNameMjs = require("./get-selector-class-name/get-selector-class-name.mjs");
var _getStaticClassNamesMjs = require("./get-static-class-names/get-static-class-names.mjs");
var _getThemeClassNamesMjs = require("./get-theme-class-names/get-theme-class-names.mjs");
var _getVariantClassNameMjs = require("./get-variant-class-name/get-variant-class-name.mjs");
'use client';
function getClassName({ theme, options, themeName, selector, classNamesPrefix, classNames, classes, unstyled, className, rootSelector, props, stylesCtx, withStaticClasses, headless, transformedStyles }) {
    return (0, _clsxDefault.default)((0, _getGlobalClassNamesMjs.getGlobalClassNames)({
        theme,
        options,
        unstyled: unstyled || headless
    }), (0, _getThemeClassNamesMjs.getThemeClassNames)({
        theme,
        themeName,
        selector,
        props,
        stylesCtx
    }), (0, _getVariantClassNameMjs.getVariantClassName)({
        options,
        classes,
        selector,
        unstyled
    }), (0, _getResolvedClassNamesMjs.getResolvedClassNames)({
        selector,
        stylesCtx,
        theme,
        classNames,
        props
    }), (0, _getResolvedClassNamesMjs.getResolvedClassNames)({
        selector,
        stylesCtx,
        theme,
        classNames: transformedStyles,
        props
    }), (0, _getOptionsClassNamesMjs.getOptionsClassNames)({
        selector,
        stylesCtx,
        options,
        props,
        theme
    }), (0, _getRootClassNameMjs.getRootClassName)({
        rootSelector,
        selector,
        className
    }), (0, _getSelectorClassNameMjs.getSelectorClassName)({
        selector,
        classes,
        unstyled: unstyled || headless
    }), withStaticClasses && !headless && (0, _getStaticClassNamesMjs.getStaticClassNames)({
        themeName,
        classNamesPrefix,
        selector,
        withStaticClass: options?.withStaticClass
    }), options?.className);
}

},{"clsx":"9idv4","./get-global-class-names/get-global-class-names.mjs":"9Xl41","./get-options-class-names/get-options-class-names.mjs":"lgRI5","./get-resolved-class-names/get-resolved-class-names.mjs":"18PgS","./get-root-class-name/get-root-class-name.mjs":"dE4a9","./get-selector-class-name/get-selector-class-name.mjs":"2kw8I","./get-static-class-names/get-static-class-names.mjs":"2UATJ","./get-theme-class-names/get-theme-class-names.mjs":"ebWoH","./get-variant-class-name/get-variant-class-name.mjs":"6sxtc","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9Xl41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FOCUS_CLASS_NAMES", ()=>FOCUS_CLASS_NAMES);
parcelHelpers.export(exports, "getGlobalClassNames", ()=>getGlobalClassNames);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
'use client';
const FOCUS_CLASS_NAMES = {
    always: "mantine-focus-always",
    auto: "mantine-focus-auto",
    never: "mantine-focus-never"
};
function getGlobalClassNames({ theme, options, unstyled }) {
    return (0, _clsxDefault.default)(options?.focusable && !unstyled && (theme.focusClassName || FOCUS_CLASS_NAMES[theme.focusRing]), options?.active && !unstyled && theme.activeClassName);
}

},{"clsx":"9idv4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lgRI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptionsClassNames", ()=>getOptionsClassNames);
var _resolveClassNamesMjs = require("../resolve-class-names/resolve-class-names.mjs");
'use client';
function getOptionsClassNames({ selector, stylesCtx, options, props, theme }) {
    return (0, _resolveClassNamesMjs.resolveClassNames)({
        theme,
        classNames: options?.classNames,
        props: options?.props || props,
        stylesCtx
    })[selector];
}

},{"../resolve-class-names/resolve-class-names.mjs":"7nwQC","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7nwQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveClassNames", ()=>resolveClassNames);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
'use client';
const EMPTY_CLASS_NAMES = {};
function mergeClassNames(objects) {
    const merged = {};
    objects.forEach((obj)=>{
        Object.entries(obj).forEach(([key, value])=>{
            if (merged[key]) merged[key] = (0, _clsxDefault.default)(merged[key], value);
            else merged[key] = value;
        });
    });
    return merged;
}
function resolveClassNames({ theme, classNames, props, stylesCtx }) {
    const arrayClassNames = Array.isArray(classNames) ? classNames : [
        classNames
    ];
    const resolvedClassNames = arrayClassNames.map((item)=>typeof item === "function" ? item(theme, props, stylesCtx) : item || EMPTY_CLASS_NAMES);
    return mergeClassNames(resolvedClassNames);
}

},{"clsx":"9idv4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"18PgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResolvedClassNames", ()=>getResolvedClassNames);
var _resolveClassNamesMjs = require("../resolve-class-names/resolve-class-names.mjs");
'use client';
function getResolvedClassNames({ selector, stylesCtx, theme, classNames, props }) {
    return (0, _resolveClassNamesMjs.resolveClassNames)({
        theme,
        classNames,
        props,
        stylesCtx
    })[selector];
}

},{"../resolve-class-names/resolve-class-names.mjs":"7nwQC","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dE4a9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRootClassName", ()=>getRootClassName);
'use client';
function getRootClassName({ rootSelector, selector, className }) {
    return rootSelector === selector ? className : void 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2kw8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectorClassName", ()=>getSelectorClassName);
'use client';
function getSelectorClassName({ selector, classes, unstyled }) {
    return unstyled ? void 0 : classes[selector];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2UATJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStaticClassNames", ()=>getStaticClassNames);
'use client';
function getStaticClassNames({ themeName, classNamesPrefix, selector, withStaticClass }) {
    if (withStaticClass === false) return [];
    return themeName.map((n)=>`${classNamesPrefix}-${n}-${selector}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ebWoH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeClassNames", ()=>getThemeClassNames);
var _resolveClassNamesMjs = require("../resolve-class-names/resolve-class-names.mjs");
'use client';
function getThemeClassNames({ themeName, theme, selector, props, stylesCtx }) {
    return themeName.map((n)=>(0, _resolveClassNamesMjs.resolveClassNames)({
            theme,
            classNames: theme.components[n]?.classNames,
            props,
            stylesCtx
        })?.[selector]);
}

},{"../resolve-class-names/resolve-class-names.mjs":"7nwQC","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6sxtc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariantClassName", ()=>getVariantClassName);
'use client';
function getVariantClassName({ options, classes, selector, unstyled }) {
    return options?.variant && !unstyled ? classes[`${selector}--${options.variant}`] : void 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kJgG0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyle", ()=>getStyle);
var _getThemeStylesMjs = require("./get-theme-styles/get-theme-styles.mjs");
var _resolveStyleMjs = require("./resolve-style/resolve-style.mjs");
var _resolveStylesMjs = require("./resolve-styles/resolve-styles.mjs");
var _resolveVarsMjs = require("./resolve-vars/resolve-vars.mjs");
'use client';
function getStyle({ theme, themeName, selector, options, props, stylesCtx, rootSelector, styles, style, vars, varsResolver, headless, withStylesTransform }) {
    return {
        ...!withStylesTransform && (0, _getThemeStylesMjs.getThemeStyles)({
            theme,
            themeName,
            props,
            stylesCtx,
            selector
        }),
        ...!withStylesTransform && (0, _resolveStylesMjs.resolveStyles)({
            theme,
            styles,
            props,
            stylesCtx
        })[selector],
        ...!withStylesTransform && (0, _resolveStylesMjs.resolveStyles)({
            theme,
            styles: options?.styles,
            props: options?.props || props,
            stylesCtx
        })[selector],
        ...(0, _resolveVarsMjs.resolveVars)({
            theme,
            props,
            stylesCtx,
            vars,
            varsResolver,
            selector,
            themeName,
            headless
        }),
        ...rootSelector === selector ? (0, _resolveStyleMjs.resolveStyle)({
            style,
            theme
        }) : null,
        ...(0, _resolveStyleMjs.resolveStyle)({
            style: options?.style,
            theme
        })
    };
}

},{"./get-theme-styles/get-theme-styles.mjs":"4egtv","./resolve-style/resolve-style.mjs":"hdvoA","./resolve-styles/resolve-styles.mjs":"kuqsT","./resolve-vars/resolve-vars.mjs":"7vG3w","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4egtv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThemeStyles", ()=>getThemeStyles);
var _resolveStylesMjs = require("../resolve-styles/resolve-styles.mjs");
'use client';
function getThemeStyles({ theme, themeName, props, stylesCtx, selector }) {
    return themeName.map((n)=>(0, _resolveStylesMjs.resolveStyles)({
            theme,
            styles: theme.components[n]?.styles,
            props,
            stylesCtx
        })[selector]).reduce((acc, val)=>({
            ...acc,
            ...val
        }), {});
}

},{"../resolve-styles/resolve-styles.mjs":"kuqsT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kuqsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveStyles", ()=>resolveStyles);
'use client';
function resolveStyles({ theme, styles, props, stylesCtx }) {
    const arrayStyles = Array.isArray(styles) ? styles : [
        styles
    ];
    return arrayStyles.reduce((acc, style)=>{
        if (typeof style === "function") return {
            ...acc,
            ...style(theme, props, stylesCtx)
        };
        return {
            ...acc,
            ...style
        };
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hdvoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveStyle", ()=>resolveStyle);
'use client';
function resolveStyle({ style, theme }) {
    if (Array.isArray(style)) return [
        ...style
    ].reduce((acc, item)=>({
            ...acc,
            ...resolveStyle({
                style: item,
                theme
            })
        }), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7vG3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVars", ()=>resolveVars);
var _mergeVarsMjs = require("./merge-vars.mjs");
'use client';
function resolveVars({ vars, varsResolver, theme, props, stylesCtx, selector, themeName, headless }) {
    return (0, _mergeVarsMjs.mergeVars)([
        headless ? {} : varsResolver?.(theme, props, stylesCtx),
        ...themeName.map((name)=>theme.components?.[name]?.vars?.(theme, props, stylesCtx)),
        vars?.(theme, props, stylesCtx)
    ])?.[selector];
}

},{"./merge-vars.mjs":"h8NqJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"h8NqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeVars", ()=>mergeVars);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _filterPropsMjs = require("../../../../utils/filter-props/filter-props.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function mergeVars(vars) {
    return vars.reduce((acc, current)=>{
        if (current) Object.keys(current).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...(0, _filterPropsMjs.filterProps)(current[key])
            };
        });
        return acc;
    }, {});
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","../../../../utils/filter-props/filter-props.mjs":"ZNjvb","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9GFq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStylesTransform", ()=>useStylesTransform);
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
'use client';
function useStylesTransform({ props, stylesCtx, themeName }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const stylesTransform = (0, _mantineContextMjs.useMantineStylesTransform)()?.();
    const getTransformedStyles = (styles)=>{
        if (!stylesTransform) return [];
        const transformedStyles = styles.map((style)=>stylesTransform(style, {
                props,
                theme,
                ctx: stylesCtx
            }));
        return [
            ...transformedStyles,
            ...themeName.map((n)=>stylesTransform(theme.components[n]?.styles, {
                    props,
                    theme,
                    ctx: stylesCtx
                }))
        ].filter(Boolean);
    };
    return {
        getTransformedStyles,
        withStylesTransform: !!stylesTransform
    };
}

},{"../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../../MantineProvider/Mantine.context.mjs":"7oXOX","../../MantineProvider/default-theme.mjs":"ixgDZ","../../MantineProvider/MantineProvider.mjs":"2TSc8","../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eq62v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>Box);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _createPolymorphicComponentMjs = require("../factory/create-polymorphic-component.mjs");
var _inlineStylesMjs = require("../InlineStyles/InlineStyles.mjs");
var _remMjs = require("../utils/units-converters/rem.mjs");
var _isNumberLikeMjs = require("../utils/is-number-like/is-number-like.mjs");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _getBoxModMjs = require("./get-box-mod/get-box-mod.mjs");
var _getBoxStyleMjs = require("./get-box-style/get-box-style.mjs");
var _extractStylePropsMjs = require("./style-props/extract-style-props/extract-style-props.mjs");
var _stylePropsDataMjs = require("./style-props/style-props-data.mjs");
var _parseStylePropsMjs = require("./style-props/parse-style-props/parse-style-props.mjs");
var _useRandomClassnameMjs = require("./use-random-classname/use-random-classname.mjs");
'use client';
const _Box = (0, _react.forwardRef)(({ component, style, __vars, className, variant, mod, size, hiddenFrom, visibleFrom, lightHidden, darkHidden, renderRoot, __size, ...others }, ref)=>{
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const Element = component || "div";
    const { styleProps, rest } = (0, _extractStylePropsMjs.extractStyleProps)(others);
    const useSxTransform = (0, _mantineContextMjs.useMantineSxTransform)();
    const transformedSx = useSxTransform?.()?.(styleProps.sx);
    const responsiveClassName = (0, _useRandomClassnameMjs.useRandomClassName)();
    const parsedStyleProps = (0, _parseStylePropsMjs.parseStyleProps)({
        styleProps,
        theme,
        data: (0, _stylePropsDataMjs.STYlE_PROPS_DATA)
    });
    const props = {
        ref,
        style: (0, _getBoxStyleMjs.getBoxStyle)({
            theme,
            style,
            vars: __vars,
            styleProps: parsedStyleProps.inlineStyles
        }),
        className: (0, _clsxDefault.default)(className, transformedSx, {
            [responsiveClassName]: parsedStyleProps.hasResponsiveStyles,
            "mantine-light-hidden": lightHidden,
            "mantine-dark-hidden": darkHidden,
            [`mantine-hidden-from-${hiddenFrom}`]: hiddenFrom,
            [`mantine-visible-from-${visibleFrom}`]: visibleFrom
        }),
        "data-variant": variant,
        "data-size": (0, _isNumberLikeMjs.isNumberLike)(size) ? void 0 : size || void 0,
        size: __size,
        ...(0, _getBoxModMjs.getBoxMod)(mod),
        ...rest
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inlineStylesMjs.InlineStyles), {
                selector: `.${responsiveClassName}`,
                styles: parsedStyleProps.styles,
                media: parsedStyleProps.media
            }),
            typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ (0, _jsxRuntime.jsx)(Element, {
                ...props
            })
        ]
    });
});
_Box.displayName = "@mantine/core/Box";
const Box = (0, _createPolymorphicComponentMjs.createPolymorphicComponent)(_Box);

},{"react/jsx-runtime":"1xKTF","react":"erQJb","clsx":"9idv4","../factory/create-polymorphic-component.mjs":"97nwk","../InlineStyles/InlineStyles.mjs":"j6wgm","../utils/units-converters/rem.mjs":"c70Xm","../utils/is-number-like/is-number-like.mjs":"evg4z","@mantine/hooks":"cPWeR","../MantineProvider/Mantine.context.mjs":"7oXOX","../MantineProvider/default-theme.mjs":"ixgDZ","../MantineProvider/MantineProvider.mjs":"2TSc8","../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","./get-box-mod/get-box-mod.mjs":"gNBXy","./get-box-style/get-box-style.mjs":"j1fei","./style-props/extract-style-props/extract-style-props.mjs":"h5n1i","./style-props/style-props-data.mjs":"f6xay","./style-props/parse-style-props/parse-style-props.mjs":"94ePE","./use-random-classname/use-random-classname.mjs":"kYw1r","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"97nwk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPolymorphicComponent", ()=>createPolymorphicComponent);
function createPolymorphicComponent(component) {
    return component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"j6wgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineStyles", ()=>InlineStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _stylesToStringMjs = require("./styles-to-string/styles-to-string.mjs");
'use client';
function InlineStyles(props) {
    const nonce = (0, _mantineContextMjs.useMantineStyleNonce)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("style", {
        "data-mantine-styles": "inline",
        nonce: nonce?.(),
        dangerouslySetInnerHTML: {
            __html: (0, _stylesToStringMjs.stylesToString)(props)
        }
    });
}

},{"react/jsx-runtime":"1xKTF","../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../MantineProvider/Mantine.context.mjs":"7oXOX","../MantineProvider/default-theme.mjs":"ixgDZ","../MantineProvider/MantineProvider.mjs":"2TSc8","../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","./styles-to-string/styles-to-string.mjs":"htJxt","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"htJxt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stylesToString", ()=>stylesToString);
var _cssObjectToStringMjs = require("../css-object-to-string/css-object-to-string.mjs");
'use client';
function stylesToString({ selector, styles, media, container }) {
    const baseStyles = styles ? (0, _cssObjectToStringMjs.cssObjectToString)(styles) : "";
    const mediaQueryStyles = !Array.isArray(media) ? [] : media.map((item)=>`@media${item.query}{${selector}{${(0, _cssObjectToStringMjs.cssObjectToString)(item.styles)}}}`);
    const containerStyles = !Array.isArray(container) ? [] : container.map((item)=>`@container ${item.query}{${selector}{${(0, _cssObjectToStringMjs.cssObjectToString)(item.styles)}}}`);
    return `${baseStyles ? `${selector}{${baseStyles}}` : ""}${mediaQueryStyles.join("")}${containerStyles.join("")}`.trim();
}

},{"../css-object-to-string/css-object-to-string.mjs":"gJdmj","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gJdmj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cssObjectToString", ()=>cssObjectToString);
var _keysMjs = require("../../utils/keys/keys.mjs");
var _camelToKebabCaseMjs = require("../../utils/camel-to-kebab-case/camel-to-kebab-case.mjs");
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function cssObjectToString(css) {
    return (0, _keysMjs.keys)(css).reduce((acc, rule)=>css[rule] !== void 0 ? `${acc}${(0, _camelToKebabCaseMjs.camelToKebabCase)(rule)}:${css[rule]};` : acc, "").trim();
}

},{"../../utils/keys/keys.mjs":"7biZA","../../utils/camel-to-kebab-case/camel-to-kebab-case.mjs":"9bxXs","../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9bxXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelToKebabCase", ()=>camelToKebabCase);
'use client';
function camelToKebabCase(value) {
    return value.replace(/[A-Z]/g, (letter)=>`-${letter.toLowerCase()}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"evg4z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumberLike", ()=>isNumberLike);
'use client';
function isNumberLike(value) {
    if (typeof value === "number") return true;
    if (typeof value === "string") {
        if (value.startsWith("calc(") || value.startsWith("var(") || value.includes(" ") && value.trim() !== "") return true;
        const cssUnitsRegex = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
        const values = value.trim().split(/\s+/);
        return values.every((val)=>cssUnitsRegex.test(val));
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gNBXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBoxMod", ()=>getBoxMod);
parcelHelpers.export(exports, "getMod", ()=>getMod);
'use client';
function transformModKey(key) {
    return key.startsWith("data-") ? key : `data-${key}`;
}
function getMod(props) {
    return Object.keys(props).reduce((acc, key)=>{
        const value = props[key];
        if (value === void 0 || value === "" || value === false || value === null) return acc;
        acc[transformModKey(key)] = props[key];
        return acc;
    }, {});
}
function getBoxMod(mod) {
    if (!mod) return null;
    if (typeof mod === "string") return {
        [transformModKey(mod)]: true
    };
    if (Array.isArray(mod)) return [
        ...mod
    ].reduce((acc, value)=>({
            ...acc,
            ...getBoxMod(value)
        }), {});
    return getMod(mod);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"j1fei":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBoxStyle", ()=>getBoxStyle);
'use client';
function mergeStyles(styles, theme) {
    if (Array.isArray(styles)) return [
        ...styles
    ].reduce((acc, item)=>({
            ...acc,
            ...mergeStyles(item, theme)
        }), {});
    if (typeof styles === "function") return styles(theme);
    if (styles == null) return {};
    return styles;
}
function getBoxStyle({ theme, style, vars, styleProps }) {
    const _style = mergeStyles(style, theme);
    const _vars = mergeStyles(vars, theme);
    return {
        ..._style,
        ..._vars,
        ...styleProps
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"h5n1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extractStyleProps", ()=>extractStyleProps);
var _remMjs = require("../../../utils/units-converters/rem.mjs");
var _filterPropsMjs = require("../../../utils/filter-props/filter-props.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function extractStyleProps(others) {
    const { m, mx, my, mt, mb, ml, mr, me, ms, p, px, py, pt, pb, pl, pr, pe, ps, bd, bdrs, bg, c, opacity, ff, fz, fw, lts, ta, lh, fs, tt, td, w, miw, maw, h, mih, mah, bgsz, bgp, bgr, bga, pos, top, left, bottom, right, inset, display, flex, hiddenFrom, visibleFrom, lightHidden, darkHidden, sx, ...rest } = others;
    const styleProps = (0, _filterPropsMjs.filterProps)({
        m,
        mx,
        my,
        mt,
        mb,
        ml,
        mr,
        me,
        ms,
        p,
        px,
        py,
        pt,
        pb,
        pl,
        pr,
        pe,
        ps,
        bd,
        bg,
        c,
        opacity,
        ff,
        fz,
        fw,
        lts,
        ta,
        lh,
        fs,
        tt,
        td,
        w,
        miw,
        maw,
        h,
        mih,
        mah,
        bgsz,
        bgp,
        bgr,
        bga,
        pos,
        top,
        left,
        bottom,
        right,
        inset,
        display,
        flex,
        bdrs,
        hiddenFrom,
        visibleFrom,
        lightHidden,
        darkHidden,
        sx
    });
    return {
        styleProps,
        rest
    };
}

},{"../../../utils/units-converters/rem.mjs":"c70Xm","../../../utils/filter-props/filter-props.mjs":"ZNjvb","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"f6xay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STYlE_PROPS_DATA", ()=>STYlE_PROPS_DATA);
'use client';
const STYlE_PROPS_DATA = {
    m: {
        type: "spacing",
        property: "margin"
    },
    mt: {
        type: "spacing",
        property: "marginTop"
    },
    mb: {
        type: "spacing",
        property: "marginBottom"
    },
    ml: {
        type: "spacing",
        property: "marginLeft"
    },
    mr: {
        type: "spacing",
        property: "marginRight"
    },
    ms: {
        type: "spacing",
        property: "marginInlineStart"
    },
    me: {
        type: "spacing",
        property: "marginInlineEnd"
    },
    mx: {
        type: "spacing",
        property: "marginInline"
    },
    my: {
        type: "spacing",
        property: "marginBlock"
    },
    p: {
        type: "spacing",
        property: "padding"
    },
    pt: {
        type: "spacing",
        property: "paddingTop"
    },
    pb: {
        type: "spacing",
        property: "paddingBottom"
    },
    pl: {
        type: "spacing",
        property: "paddingLeft"
    },
    pr: {
        type: "spacing",
        property: "paddingRight"
    },
    ps: {
        type: "spacing",
        property: "paddingInlineStart"
    },
    pe: {
        type: "spacing",
        property: "paddingInlineEnd"
    },
    px: {
        type: "spacing",
        property: "paddingInline"
    },
    py: {
        type: "spacing",
        property: "paddingBlock"
    },
    bd: {
        type: "border",
        property: "border"
    },
    bdrs: {
        type: "radius",
        property: "borderRadius"
    },
    bg: {
        type: "color",
        property: "background"
    },
    c: {
        type: "textColor",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    ff: {
        type: "fontFamily",
        property: "fontFamily"
    },
    fz: {
        type: "fontSize",
        property: "fontSize"
    },
    fw: {
        type: "identity",
        property: "fontWeight"
    },
    lts: {
        type: "size",
        property: "letterSpacing"
    },
    ta: {
        type: "identity",
        property: "textAlign"
    },
    lh: {
        type: "lineHeight",
        property: "lineHeight"
    },
    fs: {
        type: "identity",
        property: "fontStyle"
    },
    tt: {
        type: "identity",
        property: "textTransform"
    },
    td: {
        type: "identity",
        property: "textDecoration"
    },
    w: {
        type: "spacing",
        property: "width"
    },
    miw: {
        type: "spacing",
        property: "minWidth"
    },
    maw: {
        type: "spacing",
        property: "maxWidth"
    },
    h: {
        type: "spacing",
        property: "height"
    },
    mih: {
        type: "spacing",
        property: "minHeight"
    },
    mah: {
        type: "spacing",
        property: "maxHeight"
    },
    bgsz: {
        type: "size",
        property: "backgroundSize"
    },
    bgp: {
        type: "identity",
        property: "backgroundPosition"
    },
    bgr: {
        type: "identity",
        property: "backgroundRepeat"
    },
    bga: {
        type: "identity",
        property: "backgroundAttachment"
    },
    pos: {
        type: "identity",
        property: "position"
    },
    top: {
        type: "size",
        property: "top"
    },
    left: {
        type: "size",
        property: "left"
    },
    bottom: {
        type: "size",
        property: "bottom"
    },
    right: {
        type: "size",
        property: "right"
    },
    inset: {
        type: "size",
        property: "inset"
    },
    display: {
        type: "identity",
        property: "display"
    },
    flex: {
        type: "identity",
        property: "flex"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"94ePE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseStyleProps", ()=>parseStyleProps);
var _keysMjs = require("../../../utils/keys/keys.mjs");
var _remMjs = require("../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _indexMjs = require("../resolvers/index.mjs");
var _sortMediaQueriesMjs = require("./sort-media-queries.mjs");
'use client';
function hasResponsiveStyles(styleProp) {
    if (typeof styleProp !== "object" || styleProp === null) return false;
    const breakpoints = Object.keys(styleProp);
    if (breakpoints.length === 1 && breakpoints[0] === "base") return false;
    return true;
}
function getBaseValue(value) {
    if (typeof value === "object" && value !== null) {
        if ("base" in value) return value.base;
        return void 0;
    }
    return value;
}
function getBreakpointKeys(value) {
    if (typeof value === "object" && value !== null) return (0, _keysMjs.keys)(value).filter((key)=>key !== "base");
    return [];
}
function getBreakpointValue(value, breakpoint) {
    if (typeof value === "object" && value !== null && breakpoint in value) return value[breakpoint];
    return value;
}
function parseStyleProps({ styleProps, data, theme }) {
    return (0, _sortMediaQueriesMjs.sortMediaQueries)((0, _keysMjs.keys)(styleProps).reduce((acc, styleProp)=>{
        if (styleProp === "hiddenFrom" || styleProp === "visibleFrom" || styleProp === "sx") return acc;
        const propertyData = data[styleProp];
        const properties = Array.isArray(propertyData.property) ? propertyData.property : [
            propertyData.property
        ];
        const baseValue = getBaseValue(styleProps[styleProp]);
        if (!hasResponsiveStyles(styleProps[styleProp])) {
            properties.forEach((property)=>{
                acc.inlineStyles[property] = (0, _indexMjs.resolvers)[propertyData.type](baseValue, theme);
            });
            return acc;
        }
        acc.hasResponsiveStyles = true;
        const breakpoints = getBreakpointKeys(styleProps[styleProp]);
        properties.forEach((property)=>{
            if (baseValue != null) acc.styles[property] = (0, _indexMjs.resolvers)[propertyData.type](baseValue, theme);
            breakpoints.forEach((breakpoint)=>{
                const bp = `(min-width: ${theme.breakpoints[breakpoint]})`;
                acc.media[bp] = {
                    ...acc.media[bp],
                    [property]: (0, _indexMjs.resolvers)[propertyData.type](getBreakpointValue(styleProps[styleProp], breakpoint), theme)
                };
            });
        });
        return acc;
    }, {
        hasResponsiveStyles: false,
        styles: {},
        inlineStyles: {},
        media: {}
    }));
}

},{"../../../utils/keys/keys.mjs":"7biZA","../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../resolvers/index.mjs":"i2YbQ","./sort-media-queries.mjs":"1nMEs","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"i2YbQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolvers", ()=>resolvers);
var _borderResolverMjs = require("./border-resolver/border-resolver.mjs");
var _colorResolverMjs = require("./color-resolver/color-resolver.mjs");
var _fontFamilyResolverMjs = require("./font-family-resolver/font-family-resolver.mjs");
var _fontSizeResolverMjs = require("./font-size-resolver/font-size-resolver.mjs");
var _identityResolverMjs = require("./identity-resolver/identity-resolver.mjs");
var _lineHeightResolverMjs = require("./line-height-resolver/line-height-resolver.mjs");
var _radiusResolverMjs = require("./radius-resolver/radius-resolver.mjs");
var _sizeResolverMjs = require("./size-resolver/size-resolver.mjs");
var _spacingResolverMjs = require("./spacing-resolver/spacing-resolver.mjs");
'use client';
const resolvers = {
    color: (0, _colorResolverMjs.colorResolver),
    textColor: (0, _colorResolverMjs.textColorResolver),
    fontSize: (0, _fontSizeResolverMjs.fontSizeResolver),
    spacing: (0, _spacingResolverMjs.spacingResolver),
    radius: (0, _radiusResolverMjs.radiusResolver),
    identity: (0, _identityResolverMjs.identityResolver),
    size: (0, _sizeResolverMjs.sizeResolver),
    lineHeight: (0, _lineHeightResolverMjs.lineHeightResolver),
    fontFamily: (0, _fontFamilyResolverMjs.fontFamilyResolver),
    border: (0, _borderResolverMjs.borderResolver)
};

},{"./border-resolver/border-resolver.mjs":"8uOfI","./color-resolver/color-resolver.mjs":"3RDJ0","./font-family-resolver/font-family-resolver.mjs":"dFtoU","./font-size-resolver/font-size-resolver.mjs":"1ivT2","./identity-resolver/identity-resolver.mjs":"1RA5Q","./line-height-resolver/line-height-resolver.mjs":"991Zi","./radius-resolver/radius-resolver.mjs":"jV1sr","./size-resolver/size-resolver.mjs":"dCz58","./spacing-resolver/spacing-resolver.mjs":"ehsCo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8uOfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderResolver", ()=>borderResolver);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _colorResolverMjs = require("../color-resolver/color-resolver.mjs");
'use client';
function borderResolver(value, theme) {
    if (typeof value === "number") return (0, _remMjs.rem)(value);
    if (typeof value === "string") {
        const [size, style, ...colorTuple] = value.split(" ").filter((val)=>val.trim() !== "");
        let result = `${(0, _remMjs.rem)(size)}`;
        style && (result += ` ${style}`);
        colorTuple.length > 0 && (result += ` ${(0, _colorResolverMjs.colorResolver)(colorTuple.join(" "), theme)}`);
        return result.trim();
    }
    return value;
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../color-resolver/color-resolver.mjs":"3RDJ0","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3RDJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorResolver", ()=>colorResolver);
parcelHelpers.export(exports, "textColorResolver", ()=>textColorResolver);
var _parseThemeColorMjs = require("../../../../MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs");
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
'use client';
function colorResolver(color, theme) {
    const parsedColor = (0, _parseThemeColorMjs.parseThemeColor)({
        color,
        theme
    });
    if (parsedColor.color === "dimmed") return "var(--mantine-color-dimmed)";
    if (parsedColor.color === "bright") return "var(--mantine-color-bright)";
    return parsedColor.variable ? `var(${parsedColor.variable})` : parsedColor.color;
}
function textColorResolver(color, theme) {
    const parsedColor = (0, _parseThemeColorMjs.parseThemeColor)({
        color,
        theme
    });
    if (parsedColor.isThemeColor && parsedColor.shade === void 0) return `var(--mantine-color-${parsedColor.color}-text)`;
    return colorResolver(color, theme);
}

},{"../../../../MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs":"4t4fh","../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../../../../MantineProvider/Mantine.context.mjs":"7oXOX","../../../../MantineProvider/default-theme.mjs":"ixgDZ","../../../../MantineProvider/MantineProvider.mjs":"2TSc8","../../../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dFtoU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontFamilyResolver", ()=>fontFamilyResolver);
'use client';
const values = {
    text: "var(--mantine-font-family)",
    mono: "var(--mantine-font-family-monospace)",
    monospace: "var(--mantine-font-family-monospace)",
    heading: "var(--mantine-font-family-headings)",
    headings: "var(--mantine-font-family-headings)"
};
function fontFamilyResolver(fontFamily) {
    if (typeof fontFamily === "string" && fontFamily in values) return values[fontFamily];
    return fontFamily;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1ivT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontSizeResolver", ()=>fontSizeResolver);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
const headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function fontSizeResolver(value, theme) {
    if (typeof value === "string" && value in theme.fontSizes) return `var(--mantine-font-size-${value})`;
    if (typeof value === "string" && headings.includes(value)) return `var(--mantine-${value}-font-size)`;
    if (typeof value === "number") return (0, _remMjs.rem)(value);
    if (typeof value === "string") return (0, _remMjs.rem)(value);
    return value;
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1RA5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identityResolver", ()=>identityResolver);
'use client';
function identityResolver(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"991Zi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineHeightResolver", ()=>lineHeightResolver);
'use client';
const headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
function lineHeightResolver(value, theme) {
    if (typeof value === "string" && value in theme.lineHeights) return `var(--mantine-line-height-${value})`;
    if (typeof value === "string" && headings.includes(value)) return `var(--mantine-${value}-line-height)`;
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jV1sr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radiusResolver", ()=>radiusResolver);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function radiusResolver(value, theme) {
    if (typeof value === "string" && value in theme.radius) return `var(--mantine-radius-${value})`;
    if (typeof value === "number") return (0, _remMjs.rem)(value);
    if (typeof value === "string") return (0, _remMjs.rem)(value);
    return value;
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dCz58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizeResolver", ()=>sizeResolver);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function sizeResolver(value) {
    if (typeof value === "number") return (0, _remMjs.rem)(value);
    return value;
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ehsCo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spacingResolver", ()=>spacingResolver);
var _remMjs = require("../../../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
'use client';
function spacingResolver(value, theme) {
    if (typeof value === "number") return (0, _remMjs.rem)(value);
    if (typeof value === "string") {
        const mod = value.replace("-", "");
        if (!(mod in theme.spacing)) return (0, _remMjs.rem)(value);
        const variable = `--mantine-spacing-${mod}`;
        return value.startsWith("-") ? `calc(var(${variable}) * -1)` : `var(${variable})`;
    }
    return value;
}

},{"../../../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1nMEs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortMediaQueries", ()=>sortMediaQueries);
'use client';
function replaceMediaQuery(query) {
    return query.replace("(min-width: ", "").replace("em)", "");
}
function sortMediaQueries({ media, ...props }) {
    const breakpoints = Object.keys(media);
    const sortedMedia = breakpoints.sort((a, b)=>Number(replaceMediaQuery(a)) - Number(replaceMediaQuery(b))).map((query)=>({
            query,
            styles: media[query]
        }));
    return {
        ...props,
        media: sortedMedia
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kYw1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRandomClassName", ()=>useRandomClassName);
var _react = require("react");
'use client';
function useRandomClassName() {
    const id = (0, _react.useId)().replace(/[:«»]/g, "");
    return `__m__-${id}`;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"etaNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polymorphicFactory", ()=>polymorphicFactory);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _factoryMjs = require("./factory.mjs");
'use client';
function polymorphicFactory(ui) {
    const Component = (0, _react.forwardRef)(ui);
    Component.withProps = (fixedProps)=>{
        const Extended = (0, _react.forwardRef)((props, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Component, {
                ...fixedProps,
                ...props,
                ref
            }));
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    Component.extend = (0, _factoryMjs.identity);
    return Component;
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","./factory.mjs":"lBP7N","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lBP7N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "factory", ()=>factory);
parcelHelpers.export(exports, "getWithProps", ()=>getWithProps);
parcelHelpers.export(exports, "identity", ()=>identity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
function identity(value) {
    return value;
}
function getWithProps(Component) {
    const _Component = Component;
    return (fixedProps)=>{
        const Extended = (0, _react.forwardRef)((props, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(_Component, {
                ...fixedProps,
                ...props,
                ref
            }));
        Extended.extend = _Component.extend;
        Extended.displayName = `WithProps(${_Component.displayName})`;
        return Extended;
    };
}
function factory(ui) {
    const Component = (0, _react.forwardRef)(ui);
    Component.extend = identity;
    Component.withProps = (fixedProps)=>{
        const Extended = (0, _react.forwardRef)((props, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Component, {
                ...fixedProps,
                ...props,
                ref
            }));
        Extended.extend = Component.extend;
        Extended.displayName = `WithProps(${Component.displayName})`;
        return Extended;
    };
    return Component;
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dNrdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DirectionContext", ()=>DirectionContext);
parcelHelpers.export(exports, "DirectionProvider", ()=>DirectionProvider);
parcelHelpers.export(exports, "useDirection", ()=>useDirection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
'use client';
const DirectionContext = (0, _react.createContext)({
    dir: "ltr",
    toggleDirection: ()=>{},
    setDirection: ()=>{}
});
function useDirection() {
    return (0, _react.useContext)(DirectionContext);
}
function DirectionProvider({ children, initialDirection = "ltr", detectDirection = true }) {
    const [dir, setDir] = (0, _react.useState)(initialDirection);
    const setDirection = (0, _react.useCallback)((direction)=>{
        setDir(direction);
        if (document.documentElement.getAttribute("dir") !== direction) document.documentElement.setAttribute("dir", direction);
    }, []);
    const toggleDirection = ()=>setDirection(dir === "ltr" ? "rtl" : "ltr");
    (0, _hooks.useIsomorphicEffect)(()=>{
        if (detectDirection) {
            const direction = document.documentElement.getAttribute("dir");
            if (direction === "rtl" || direction === "ltr") setDir(direction);
        }
    }, []);
    const mutationCallback = (0, _react.useCallback)(()=>{
        if (typeof document === "undefined") return;
        const direction = document.documentElement.getAttribute("dir");
        if (direction === "rtl" || direction === "ltr") setDir((prev)=>prev !== direction ? direction : prev);
    }, []);
    (0, _hooks.useMutationObserver)(mutationCallback, detectDirection ? {
        attributes: true,
        attributeFilter: [
            "dir"
        ]
    } : {}, typeof document !== "undefined" && detectDirection ? document.documentElement : null);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(DirectionContext.Provider, {
        value: {
            dir,
            toggleDirection,
            setDirection
        },
        children
    });
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useIsomorphicEffect","6Cmng"],["useMutationObserver","9VXPX"]],"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fLjoL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_4451eb3a"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7aA6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loader", ()=>Loader);
parcelHelpers.export(exports, "defaultLoaders", ()=>defaultLoaders);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _getThemeColorMjs = require("../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderModuleCssMjs = require("./Loader.module.css.mjs");
var _loaderModuleCssMjsDefault = parcelHelpers.interopDefault(_loaderModuleCssMjs);
var _barsMjs = require("./loaders/Bars.mjs");
var _dotsMjs = require("./loaders/Dots.mjs");
var _ovalMjs = require("./loaders/Oval.mjs");
'use client';
const defaultLoaders = {
    bars: (0, _barsMjs.Bars),
    oval: (0, _ovalMjs.Oval),
    dots: (0, _dotsMjs.Dots)
};
const defaultProps = {
    loaders: defaultLoaders,
    type: "oval"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { size, color })=>({
        root: {
            "--loader-size": (0, _getSizeMjs.getSize)(size, "loader-size"),
            "--loader-color": color ? (0, _getThemeColorMjs.getThemeColor)(color, theme) : void 0
        }
    }));
const Loader = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Loader", defaultProps, _props);
    const { size, color, type, vars, className, style, classNames, styles, unstyled, loaders, variant, children, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Loader",
        props,
        classes: (0, _loaderModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    if (children) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root"),
        ref,
        ...others,
        children
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root"),
        ref,
        component: loaders[type],
        variant,
        size,
        ...others
    });
});
Loader.defaultLoaders = defaultLoaders;
Loader.classes = (0, _loaderModuleCssMjsDefault.default);
Loader.displayName = "@mantine/core/Loader";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Loader.module.css.mjs":"8WSd5","./loaders/Bars.mjs":"01ld6","./loaders/Dots.mjs":"3DD61","./loaders/Oval.mjs":"aHc8b","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"giXTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFontSize", ()=>getFontSize);
parcelHelpers.export(exports, "getLineHeight", ()=>getLineHeight);
parcelHelpers.export(exports, "getRadius", ()=>getRadius);
parcelHelpers.export(exports, "getShadow", ()=>getShadow);
parcelHelpers.export(exports, "getSize", ()=>getSize);
parcelHelpers.export(exports, "getSpacing", ()=>getSpacing);
var _isNumberLikeMjs = require("../is-number-like/is-number-like.mjs");
var _remMjs = require("../units-converters/rem.mjs");
'use client';
function getSize(size, prefix = "size", convertToRem = true) {
    if (size === void 0) return void 0;
    return (0, _isNumberLikeMjs.isNumberLike)(size) ? convertToRem ? (0, _remMjs.rem)(size) : size : `var(--${prefix}-${size})`;
}
function getSpacing(size) {
    return getSize(size, "mantine-spacing");
}
function getRadius(size) {
    if (size === void 0) return "var(--mantine-radius-default)";
    return getSize(size, "mantine-radius");
}
function getFontSize(size) {
    return getSize(size, "mantine-font-size");
}
function getLineHeight(size) {
    return getSize(size, "mantine-line-height", false);
}
function getShadow(size) {
    if (!size) return void 0;
    return getSize(size, "mantine-shadow", false);
}

},{"../is-number-like/is-number-like.mjs":"evg4z","../units-converters/rem.mjs":"c70Xm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"b5eiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createVarsResolver", ()=>createVarsResolver);
'use client';
function createVarsResolver(resolver) {
    return resolver;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8WSd5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_5ae2e3c",
    "barsLoader": "m_7a2bd4cd",
    "bar": "m_870bb79",
    "bars-loader-animation": "m_5d2b3b9d",
    "dotsLoader": "m_4e3f22d7",
    "dot": "m_870c4af",
    "loader-dots-animation": "m_aac34a1",
    "ovalLoader": "m_b34414df",
    "oval-loader-animation": "m_f8e89c4b"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"01ld6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Bars", ()=>Bars);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderModuleCssMjs = require("../Loader.module.css.mjs");
var _loaderModuleCssMjsDefault = parcelHelpers.interopDefault(_loaderModuleCssMjs);
'use client';
const Bars = (0, _react.forwardRef)(({ className, ...others }, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
        component: "span",
        className: (0, _clsxDefault.default)((0, _loaderModuleCssMjsDefault.default).barsLoader, className),
        ...others,
        ref,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).bar
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).bar
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).bar
            })
        ]
    }));
Bars.displayName = "@mantine/core/Bars";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","clsx":"9idv4","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Loader.module.css.mjs":"8WSd5","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3DD61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dots", ()=>Dots);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderModuleCssMjs = require("../Loader.module.css.mjs");
var _loaderModuleCssMjsDefault = parcelHelpers.interopDefault(_loaderModuleCssMjs);
'use client';
const Dots = (0, _react.forwardRef)(({ className, ...others }, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
        component: "span",
        className: (0, _clsxDefault.default)((0, _loaderModuleCssMjsDefault.default).dotsLoader, className),
        ...others,
        ref,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).dot
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).dot
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                className: (0, _loaderModuleCssMjsDefault.default).dot
            })
        ]
    }));
Dots.displayName = "@mantine/core/Dots";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","clsx":"9idv4","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Loader.module.css.mjs":"8WSd5","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aHc8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Oval", ()=>Oval);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderModuleCssMjs = require("../Loader.module.css.mjs");
var _loaderModuleCssMjsDefault = parcelHelpers.interopDefault(_loaderModuleCssMjs);
'use client';
const Oval = (0, _react.forwardRef)(({ className, ...others }, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "span",
        className: (0, _clsxDefault.default)((0, _loaderModuleCssMjsDefault.default).ovalLoader, className),
        ...others,
        ref
    }));
Oval.displayName = "@mantine/core/Oval";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","clsx":"9idv4","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Loader.module.css.mjs":"8WSd5","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9NmbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
parcelHelpers.export(exports, "ErrorBoundaryContext", ()=>ErrorBoundaryContext);
parcelHelpers.export(exports, "useErrorBoundary", ()=>useErrorBoundary);
parcelHelpers.export(exports, "withErrorBoundary", ()=>withErrorBoundary);
var _react = require("react");
'use client';
const ErrorBoundaryContext = (0, _react.createContext)(null);
const initialState = {
    didCatch: false,
    error: null
};
class ErrorBoundary extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error
        };
    }
    resetErrorBoundary() {
        const { error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args,
                reason: "imperative-api"
            });
            this.setState(initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch } = this.state;
        const { resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState(initialState);
        }
    }
    render() {
        const { children, fallbackRender, FallbackComponent, fallback } = this.props;
        const { didCatch, error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, _react.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, _react.createElement)(ErrorBoundaryContext.Provider, {
            value: {
                didCatch,
                error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function useErrorBoundary() {
    const context = (0, _react.useContext)(ErrorBoundaryContext);
    assertErrorBoundaryContext(context);
    const [state, setState] = (0, _react.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, _react.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function withErrorBoundary(component, errorBoundaryProps) {
    const Wrapped = (0, _react.forwardRef)((props, ref)=>(0, _react.createElement)(ErrorBoundary, errorBoundaryProps, (0, _react.createElement)(component, {
            ...props,
            ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8HxbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "theme", ()=>theme);
parcelHelpers.export(exports, "baseTheme", ()=>baseTheme);
parcelHelpers.export(exports, "tabletTheme", ()=>tabletTheme);
parcelHelpers.export(exports, "laptopTheme", ()=>laptopTheme);
var _core = require("@mantine/core");
// Shade 0 = card background, shade 9 = screen background / heading
const navyBlue = [
    "#d6e8f5",
    "#bdd8ee",
    "#96c0e3",
    "#6da6d8",
    "#488ccc",
    "#2c72bf",
    "#1a5aa8",
    "#134590",
    "#0e3070",
    "#0d1b3e"
];
const theme = (0, _core.createTheme)({
    primaryColor: "navyBlue",
    primaryShade: 7,
    fontFamily: "Arial, sans-serif",
    colors: {
        navyBlue
    }
});
const baseTheme = theme;
const tabletTheme = theme;
const laptopTheme = theme;

},{"@mantine/core":"44B1X","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"44B1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTheme", ()=>createTheme);
function createTheme(theme) {
    return theme;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3pGYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorFallback", ()=>ErrorFallback);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _friendlyError = require("@/shared/utils/FriendlyError");
var _friendlyErrorDefault = parcelHelpers.interopDefault(_friendlyError);
const ErrorFallback = (t0)=>{
    const $ = (0, _compilerRuntime.c)(10);
    const { error, resetErrorBoundary } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
            children: "Something went wrong"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== error) {
        t2 = error instanceof (0, _friendlyErrorDefault.default) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: error.message
        }) : null;
        $[1] = error;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                t1,
                t2
            ]
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== resetErrorBoundary) {
        t4 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            onClick: resetErrorBoundary,
            children: "Try again"
        });
        $[5] = resetErrorBoundary;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "welcome",
            children: [
                t3,
                t4
            ]
        });
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@/shared/utils/FriendlyError":"lp93b","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lp93b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class FriendlyError extends Error {
    // This is a custom error class that can be used to display friendly error messages to the user.
    // It extends the built-in Error class and adds a `friendlyMessage` property.
    // The `friendlyMessage` property is intended to be used for displaying user-friendly error messages.
    constructor(message){
        super(message);
        this.name = "FriendlyError";
    }
}
exports.default = FriendlyError;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7rU0V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotFoundPage);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _wouter = require("wouter");
function NotFoundPage() {
    const $ = (0, _compilerRuntime.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Title), {
            order: 1,
            size: 120,
            fw: 900,
            c: "dimmed",
            children: "404"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Container), {
            size: "sm",
            py: "xl",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Stack), {
                gap: "xl",
                align: "center",
                mt: 100,
                children: [
                    t0,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Stack), {
                        gap: "md",
                        ta: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Title), {
                                order: 2,
                                children: "Page Not Found"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
                                size: "lg",
                                c: "dimmed",
                                maw: 400,
                                children: "The page you're looking for doesn't exist or has been moved."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Button), {
                        component: (0, _wouter.Link),
                        href: "/",
                        size: "lg",
                        variant: "filled",
                        children: "Go Home"
                    })
                ]
            })
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["Button","ipjnW"],["Container","hHiOd"],["Stack","29e8E"],["Text","1QStM"],["Title","8dCI1"]],"wouter":"3dLPT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ipjnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderMjs = require("../Loader/Loader.mjs");
var _transitionMjs = require("../Transition/Transition.mjs");
var _unstyledButtonMjs = require("../UnstyledButton/UnstyledButton.mjs");
var _buttonModuleCssMjs = require("./Button.module.css.mjs");
var _buttonModuleCssMjsDefault = parcelHelpers.interopDefault(_buttonModuleCssMjs);
var _buttonGroupMjs = require("./ButtonGroup/ButtonGroup.mjs");
var _buttonGroupSectionMjs = require("./ButtonGroupSection/ButtonGroupSection.mjs");
'use client';
const loaderTransition = {
    in: {
        opacity: 1,
        transform: `translate(-50%, calc(-50% + ${(0, _remMjs.rem)(1)}))`
    },
    out: {
        opacity: 0,
        transform: "translate(-50%, -200%)"
    },
    common: {
        transformOrigin: "center"
    },
    transitionProperty: "transform, opacity"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color, gradient, variant, size, justify, autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--button-justify": justify,
            "--button-height": (0, _getSizeMjs.getSize)(size, "button-height"),
            "--button-padding-x": (0, _getSizeMjs.getSize)(size, "button-padding-x"),
            "--button-fz": size?.includes("compact") ? (0, _getSizeMjs.getFontSize)(size.replace("compact-", "")) : (0, _getSizeMjs.getFontSize)(size),
            "--button-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--button-bg": color || variant ? colors.background : void 0,
            "--button-hover": color || variant ? colors.hover : void 0,
            "--button-color": colors.color,
            "--button-bd": color || variant ? colors.border : void 0,
            "--button-hover-color": color || variant ? colors.hoverColor : void 0
        }
    };
});
const Button = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Button", null, _props);
    const { style, vars, className, color, disabled, children, leftSection, rightSection, fullWidth, variant, radius, loading, loaderProps, gradient, classNames, styles, unstyled, "data-disabled": dataDisabled, autoContrast, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Button",
        props,
        classes: (0, _buttonModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const hasLeftSection = !!leftSection;
    const hasRightSection = !!rightSection;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        ref,
        ...getStyles("root", {
            active: !disabled && !loading && !dataDisabled
        }),
        unstyled,
        variant,
        disabled: disabled || loading,
        mod: [
            {
                disabled: disabled || dataDisabled,
                loading,
                block: fullWidth,
                "with-left-section": hasLeftSection,
                "with-right-section": hasRightSection
            },
            mod
        ],
        ...others,
        children: [
            typeof loading === "boolean" && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _transitionMjs.Transition), {
                mounted: loading,
                transition: loaderTransition,
                duration: 150,
                children: (transitionStyles)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        ...getStyles("loader", {
                            style: transitionStyles
                        }),
                        "aria-hidden": true,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _loaderMjs.Loader), {
                            color: "var(--button-color)",
                            size: "calc(var(--button-height) / 1.8)",
                            ...loaderProps
                        })
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("span", {
                ...getStyles("inner"),
                children: [
                    leftSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        ...getStyles("section"),
                        mod: {
                            position: "left"
                        },
                        children: leftSection
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        mod: {
                            loading
                        },
                        ...getStyles("label"),
                        children
                    }),
                    rightSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        ...getStyles("section"),
                        mod: {
                            position: "right"
                        },
                        children: rightSection
                    })
                ]
            })
        ]
    });
});
Button.classes = (0, _buttonModuleCssMjsDefault.default);
Button.displayName = "@mantine/core/Button";
Button.Group = (0, _buttonGroupMjs.ButtonGroup);
Button.GroupSection = (0, _buttonGroupSectionMjs.ButtonGroupSection);

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Loader/Loader.mjs":"7aA6l","../Transition/Transition.mjs":"3eGlY","../UnstyledButton/UnstyledButton.mjs":"55gpk","./Button.module.css.mjs":"jqJRo","./ButtonGroup/ButtonGroup.mjs":"kSYHc","./ButtonGroupSection/ButtonGroupSection.mjs":"pAjVs","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3eGlY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _getTransitionStylesMjs = require("./get-transition-styles/get-transition-styles.mjs");
var _useTransitionMjs = require("./use-transition.mjs");
'use client';
function Transition({ keepMounted, transition = "fade", duration = 250, exitDuration = duration, mounted, children, timingFunction = "ease", onExit, onEntered, onEnter, onExited, enterDelay, exitDelay }) {
    const env = (0, _mantineContextMjs.useMantineEnv)();
    const { transitionDuration, transitionStatus, transitionTimingFunction } = (0, _useTransitionMjs.useTransition)({
        mounted,
        exitDuration,
        duration,
        timingFunction,
        onExit,
        onEntered,
        onEnter,
        onExited,
        enterDelay,
        exitDelay
    });
    if (transitionDuration === 0 || env === "test") return mounted ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children({})
    }) : keepMounted ? children({
        display: "none"
    }) : null;
    return transitionStatus === "exited" ? keepMounted ? children({
        display: "none"
    }) : null : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children((0, _getTransitionStylesMjs.getTransitionStyles)({
            transition,
            duration: transitionDuration,
            state: transitionStatus,
            timingFunction: transitionTimingFunction
        }))
    });
}
Transition.displayName = "@mantine/core/Transition";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./get-transition-styles/get-transition-styles.mjs":"8UCdo","./use-transition.mjs":"37jyh","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8UCdo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTransitionStyles", ()=>getTransitionStyles);
var _transitionsMjs = require("../transitions.mjs");
'use client';
const transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function getTransitionStyles({ transition, state, duration, timingFunction }) {
    const shared = {
        WebkitBackfaceVisibility: "hidden",
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in (0, _transitionsMjs.transitions))) return {};
        return {
            transitionProperty: (0, _transitionsMjs.transitions)[transition].transitionProperty,
            ...shared,
            ...(0, _transitionsMjs.transitions)[transition].common,
            ...(0, _transitionsMjs.transitions)[transition][transitionStatuses[state]]
        };
    }
    return {
        transitionProperty: transition.transitionProperty,
        ...shared,
        ...transition.common,
        ...transition[transitionStatuses[state]]
    };
}

},{"../transitions.mjs":"2ftqp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2ftqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transitions", ()=>transitions);
'use client';
const popIn = (from)=>({
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: `scale(.9) translateY(${from === "bottom" ? 10 : -10}px)`
        },
        transitionProperty: "transform, opacity"
    });
const transitions = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: "opacity"
    },
    "fade-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(30px)"
        },
        transitionProperty: "opacity, transform"
    },
    "fade-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-30px)"
        },
        transitionProperty: "opacity, transform"
    },
    scale: {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: "scale(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-y": {
        in: {
            opacity: 1,
            transform: "scaleY(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleY(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-x": {
        in: {
            opacity: 1,
            transform: "scaleX(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleX(0)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-up": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-down": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) skew(-10deg, -5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-left": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(-5deg)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-right": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: "translateY(20px) rotate(5deg)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-100%)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(100%)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-100%)"
        },
        common: {
            transformOrigin: "right"
        },
        transitionProperty: "transform, opacity"
    },
    pop: {
        ...popIn("bottom"),
        common: {
            transformOrigin: "center center"
        }
    },
    "pop-bottom-left": {
        ...popIn("bottom"),
        common: {
            transformOrigin: "bottom left"
        }
    },
    "pop-bottom-right": {
        ...popIn("bottom"),
        common: {
            transformOrigin: "bottom right"
        }
    },
    "pop-top-left": {
        ...popIn("top"),
        common: {
            transformOrigin: "top left"
        }
    },
    "pop-top-right": {
        ...popIn("top"),
        common: {
            transformOrigin: "top right"
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"37jyh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTransition", ()=>useTransition);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function useTransition({ duration, exitDuration, timingFunction, mounted, onEnter, onExit, onEntered, onExited, enterDelay, exitDelay }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const shouldReduceMotion = (0, _hooks.useReducedMotion)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const [transitionDuration, setTransitionDuration] = (0, _react.useState)(reduceMotion ? 0 : duration);
    const [transitionStatus, setStatus] = (0, _react.useState)(mounted ? "entered" : "exited");
    const transitionTimeoutRef = (0, _react.useRef)(-1);
    const delayTimeoutRef = (0, _react.useRef)(-1);
    const rafRef = (0, _react.useRef)(-1);
    function clearAllTimeouts() {
        window.clearTimeout(transitionTimeoutRef.current);
        window.clearTimeout(delayTimeoutRef.current);
        cancelAnimationFrame(rafRef.current);
    }
    const handleStateChange = (shouldMount)=>{
        clearAllTimeouts();
        const preHandler = shouldMount ? onEnter : onExit;
        const handler = shouldMount ? onEntered : onExited;
        const newTransitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
        setTransitionDuration(newTransitionDuration);
        if (newTransitionDuration === 0) {
            typeof preHandler === "function" && preHandler();
            typeof handler === "function" && handler();
            setStatus(shouldMount ? "entered" : "exited");
        } else rafRef.current = requestAnimationFrame(()=>{
            (0, _reactDomDefault.default).flushSync(()=>{
                setStatus(shouldMount ? "pre-entering" : "pre-exiting");
            });
            rafRef.current = requestAnimationFrame(()=>{
                typeof preHandler === "function" && preHandler();
                setStatus(shouldMount ? "entering" : "exiting");
                transitionTimeoutRef.current = window.setTimeout(()=>{
                    typeof handler === "function" && handler();
                    setStatus(shouldMount ? "entered" : "exited");
                }, newTransitionDuration);
            });
        });
    };
    const handleTransitionWithDelay = (shouldMount)=>{
        clearAllTimeouts();
        const delay = shouldMount ? enterDelay : exitDelay;
        if (typeof delay !== "number") {
            handleStateChange(shouldMount);
            return;
        }
        delayTimeoutRef.current = window.setTimeout(()=>{
            handleStateChange(shouldMount);
        }, shouldMount ? enterDelay : exitDelay);
    };
    (0, _hooks.useDidUpdate)(()=>{
        handleTransitionWithDelay(mounted);
    }, [
        mounted
    ]);
    (0, _react.useEffect)(()=>()=>{
            clearAllTimeouts();
        }, []);
    return {
        transitionDuration,
        transitionStatus,
        transitionTimingFunction: timingFunction || "ease"
    };
}

},{"react":"erQJb","react-dom":"kVyn3","@mantine/hooks":[["useDidUpdate","bzSpx"],["useReducedMotion","F0OXZ"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","react/jsx-runtime":"1xKTF","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"55gpk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnstyledButton", ()=>UnstyledButton);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonModuleCssMjs = require("./UnstyledButton.module.css.mjs");
var _unstyledButtonModuleCssMjsDefault = parcelHelpers.interopDefault(_unstyledButtonModuleCssMjs);
'use client';
const defaultProps = {
    __staticSelector: "UnstyledButton"
};
const UnstyledButton = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("UnstyledButton", defaultProps, _props);
    const { className, component = "button", __staticSelector, unstyled, classNames, styles, style, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: __staticSelector,
        props,
        classes: (0, _unstyledButtonModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root", {
            focusable: true
        }),
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        ...others
    });
});
UnstyledButton.classes = (0, _unstyledButtonModuleCssMjsDefault.default);
UnstyledButton.displayName = "@mantine/core/UnstyledButton";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./UnstyledButton.module.css.mjs":"jmK0L","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jmK0L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_87cf2631"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jqJRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_77c9d27d",
    "inner": "m_80f1301b",
    "label": "m_811560b9",
    "section": "m_a74036a",
    "loader": "m_a25b86ee",
    "group": "m_80d6d844",
    "groupSection": "m_70be2a01"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kSYHc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroup", ()=>ButtonGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _buttonModuleCssMjs = require("../Button.module.css.mjs");
var _buttonModuleCssMjsDefault = parcelHelpers.interopDefault(_buttonModuleCssMjs);
'use client';
const defaultProps = {
    orientation: "horizontal"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { borderWidth })=>({
        group: {
            "--button-border-width": (0, _remMjs.rem)(borderWidth)
        }
    }));
const ButtonGroup = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ButtonGroup", defaultProps, _props);
    const { className, style, classNames, styles, unstyled, orientation, vars, borderWidth, variant, mod, attributes, ...others } = (0, _usePropsMjs.useProps)("ButtonGroup", defaultProps, _props);
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ButtonGroup",
        props,
        classes: (0, _buttonModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("group"),
        ref,
        variant,
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group",
        ...others
    });
});
ButtonGroup.classes = (0, _buttonModuleCssMjsDefault.default);
ButtonGroup.displayName = "@mantine/core/ButtonGroup";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Button.module.css.mjs":"jqJRo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"pAjVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonGroupSection", ()=>ButtonGroupSection);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _buttonModuleCssMjs = require("../Button.module.css.mjs");
var _buttonModuleCssMjsDefault = parcelHelpers.interopDefault(_buttonModuleCssMjs);
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color, gradient, variant, autoContrast, size })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        groupSection: {
            "--section-height": (0, _getSizeMjs.getSize)(size, "section-height"),
            "--section-padding-x": (0, _getSizeMjs.getSize)(size, "section-padding-x"),
            "--section-fz": size?.includes("compact") ? (0, _getSizeMjs.getFontSize)(size.replace("compact-", "")) : (0, _getSizeMjs.getFontSize)(size),
            "--section-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
const ButtonGroupSection = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ButtonGroupSection", null, _props);
    const { className, style, classNames, styles, unstyled, vars, variant, gradient, radius, autoContrast, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ButtonGroupSection",
        props,
        classes: (0, _buttonModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "groupSection"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("groupSection"),
        ref,
        variant,
        ...others
    });
});
ButtonGroupSection.classes = (0, _buttonModuleCssMjsDefault.default);
ButtonGroupSection.displayName = "@mantine/core/ButtonGroupSection";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Button.module.css.mjs":"jqJRo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hHiOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Container", ()=>Container);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _containerModuleCssMjs = require("./Container.module.css.mjs");
var _containerModuleCssMjsDefault = parcelHelpers.interopDefault(_containerModuleCssMjs);
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size, fluid })=>({
        root: {
            "--container-size": fluid ? void 0 : (0, _getSizeMjs.getSize)(size, "container-size")
        }
    }));
const Container = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Container", null, _props);
    const { classNames, className, style, styles, unstyled, vars, fluid, mod, attributes, strategy, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Container",
        classes: (0, _containerModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        mod: [
            {
                fluid,
                strategy: strategy || "block"
            },
            mod
        ],
        ...getStyles("root"),
        ...others
    });
});
Container.classes = (0, _containerModuleCssMjsDefault.default);
Container.displayName = "@mantine/core/Container";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Container.module.css.mjs":"0CiOZ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"0CiOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_7485cace"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"29e8E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stack", ()=>Stack);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _stackModuleCssMjs = require("./Stack.module.css.mjs");
var _stackModuleCssMjsDefault = parcelHelpers.interopDefault(_stackModuleCssMjs);
'use client';
const defaultProps = {
    gap: "md",
    align: "stretch",
    justify: "flex-start"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { gap, align, justify })=>({
        root: {
            "--stack-gap": (0, _getSizeMjs.getSpacing)(gap),
            "--stack-align": align,
            "--stack-justify": justify
        }
    }));
const Stack = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Stack", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, align, justify, gap, variant, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Stack",
        props,
        classes: (0, _stackModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...getStyles("root"),
        variant,
        ...others
    });
});
Stack.classes = (0, _stackModuleCssMjsDefault.default);
Stack.displayName = "@mantine/core/Stack";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Stack.module.css.mjs":"9ozjN","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9ozjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_6d731127"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1QStM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _getThemeColorMjs = require("../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _getGradientMjs = require("../../core/MantineProvider/color-functions/get-gradient/get-gradient.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _textModuleCssMjs = require("./Text.module.css.mjs");
var _textModuleCssMjsDefault = parcelHelpers.interopDefault(_textModuleCssMjs);
'use client';
function getTextTruncate(truncate) {
    if (truncate === "start") return "start";
    if (truncate === "end" || truncate) return "end";
    return void 0;
}
const defaultProps = {
    inherit: false
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)(// Will be removed in 9.0
// eslint-disable-next-line @typescript-eslint/no-deprecated
(theme, { variant, lineClamp, gradient, size, color })=>({
        root: {
            "--text-fz": (0, _getSizeMjs.getFontSize)(size),
            "--text-lh": (0, _getSizeMjs.getLineHeight)(size),
            "--text-gradient": variant === "gradient" ? (0, _getGradientMjs.getGradient)(gradient, theme) : void 0,
            "--text-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--text-color": color ? (0, _getThemeColorMjs.getThemeColor)(color, theme) : void 0
        }
    }));
const Text = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Text", defaultProps, _props);
    const { lineClamp, truncate, inline, inherit, gradient, span, __staticSelector, vars, className, style, classNames, styles, unstyled, variant, mod, size, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "Text",
            __staticSelector
        ],
        props,
        classes: (0, _textModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root", {
            focusable: true
        }),
        ref,
        component: span ? "span" : "p",
        variant,
        mod: [
            {
                "data-truncate": getTextTruncate(truncate),
                "data-line-clamp": typeof lineClamp === "number",
                "data-inline": inline,
                "data-inherit": inherit
            },
            mod
        ],
        size,
        ...others
    });
});
Text.classes = (0, _textModuleCssMjsDefault.default);
Text.displayName = "@mantine/core/Text";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../core/MantineProvider/color-functions/get-gradient/get-gradient.mjs":"haIj3","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Text.module.css.mjs":"8yxKV","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8yxKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_b6d8b162"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8dCI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Title", ()=>Title);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _getTitleSizeMjs = require("./get-title-size.mjs");
var _titleModuleCssMjs = require("./Title.module.css.mjs");
var _titleModuleCssMjsDefault = parcelHelpers.interopDefault(_titleModuleCssMjs);
'use client';
const defaultProps = {
    order: 1
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { order, size, lineClamp, textWrap })=>{
    const sizeVariables = (0, _getTitleSizeMjs.getTitleSize)(order || 1, size);
    return {
        root: {
            "--title-fw": sizeVariables.fontWeight,
            "--title-lh": sizeVariables.lineHeight,
            "--title-fz": sizeVariables.fontSize,
            "--title-line-clamp": typeof lineClamp === "number" ? lineClamp.toString() : void 0,
            "--title-text-wrap": textWrap
        }
    };
});
const Title = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Title", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, order, vars, size, variant, lineClamp, textWrap, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Title",
        props,
        classes: (0, _titleModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    if (![
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(order)) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root"),
        component: `h${order}`,
        variant,
        ref,
        mod: [
            {
                order,
                "data-line-clamp": typeof lineClamp === "number"
            },
            mod
        ],
        size,
        ...others
    });
});
Title.classes = (0, _titleModuleCssMjsDefault.default);
Title.displayName = "@mantine/core/Title";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./get-title-size.mjs":"exZ4x","./Title.module.css.mjs":"1ubSy","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"exZ4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTitleSize", ()=>getTitleSize);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const headings = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
];
const sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
function getTitleSize(order, size) {
    const titleSize = size !== void 0 ? size : `h${order}`;
    if (headings.includes(titleSize)) return {
        fontSize: `var(--mantine-${titleSize}-font-size)`,
        fontWeight: `var(--mantine-${titleSize}-font-weight)`,
        lineHeight: `var(--mantine-${titleSize}-line-height)`
    };
    else if (sizes.includes(titleSize)) return {
        fontSize: `var(--mantine-font-size-${titleSize})`,
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
    return {
        fontSize: (0, _remMjs.rem)(titleSize),
        fontWeight: `var(--mantine-h${order}-font-weight)`,
        lineHeight: `var(--mantine-h${order}-line-height)`
    };
}

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1ubSy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_8a5d1357"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hMmjB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdminAuthGuard);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _react = require("react");
var _wouter = require("wouter");
var _useAdminAuthStore = require("../stores/useAdminAuthStore");
function AdminAuthGuard(t0) {
    const $ = (0, _compilerRuntime.c)(11);
    const { children } = t0;
    const [, setLocation] = (0, _wouter.useLocation)();
    const { isAuthenticated, isInitialized, initialize } = (0, _useAdminAuthStore.useAdminAuthStore)();
    let t1;
    let t2;
    if ($[0] !== initialize) {
        t1 = ()=>{
            initialize();
        };
        t2 = [
            initialize
        ];
        $[0] = initialize;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, _react.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[3] !== isAuthenticated || $[4] !== isInitialized || $[5] !== setLocation) {
        t3 = ()=>{
            if (isInitialized && !isAuthenticated) setLocation("/login");
        };
        t4 = [
            isInitialized,
            isAuthenticated,
            setLocation
        ];
        $[3] = isAuthenticated;
        $[4] = isInitialized;
        $[5] = setLocation;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, _react.useEffect)(t3, t4);
    if (!isInitialized) {
        let t5;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Center), {
                style: {
                    minHeight: "100vh"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Loader), {
                    size: "xl"
                })
            });
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    if (!isAuthenticated) return null;
    let t5;
    if ($[9] !== children) {
        t5 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: children
        });
        $[9] = children;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["Center","haski"],["Loader","7aA6l"]],"react":"erQJb","wouter":"3dLPT","../stores/useAdminAuthStore":"33UXj","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"33UXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAdminAuthStore", ()=>useAdminAuthStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _adminApi = require("@/shared/api/AdminApi");
const useAdminAuthStore = (0, _zustand.create)()((0, _middleware.persist)((set, get)=>({
        // Initial state
        user: null,
        isAuthenticated: false,
        isInitialized: false,
        isLoading: false,
        error: null,
        // Initialize auth state on app load
        initialize: async ()=>{
            if (get().isInitialized) return;
            set({
                isLoading: true
            });
            try {
                const response = await (0, _adminApi.checkAuth)();
                set({
                    user: response.user,
                    isAuthenticated: response.authenticated,
                    isInitialized: true,
                    isLoading: false,
                    error: null
                });
            } catch (error) {
                console.error('Failed to check auth:', error);
                set({
                    user: null,
                    isAuthenticated: false,
                    isInitialized: true,
                    isLoading: false,
                    error: null
                });
            }
        },
        // Login
        loginUser: async (username, password, rememberMe = false)=>{
            set({
                isLoading: true,
                error: null
            });
            try {
                const response = await (0, _adminApi.login)({
                    username,
                    password,
                    rememberMe
                });
                if (response.success && response.user) {
                    set({
                        user: response.user,
                        isAuthenticated: true,
                        isLoading: false,
                        error: null
                    });
                    return true;
                } else {
                    set({
                        user: null,
                        isAuthenticated: false,
                        isLoading: false,
                        error: response.error || 'Login failed'
                    });
                    return false;
                }
            } catch (error) {
                console.error('Login error:', error);
                set({
                    user: null,
                    isAuthenticated: false,
                    isLoading: false,
                    error: 'Network error. Please try again.'
                });
                return false;
            }
        },
        // Logout
        logoutUser: async ()=>{
            set({
                isLoading: true
            });
            try {
                await (0, _adminApi.logout)();
                set({
                    user: null,
                    isAuthenticated: false,
                    isLoading: false,
                    error: null
                });
            } catch (error) {
                console.error('Logout error:', error);
                // Force logout client-side even if server fails
                set({
                    user: null,
                    isAuthenticated: false,
                    isLoading: false,
                    error: null
                });
            }
        },
        // Clear error
        clearError: ()=>{
            set({
                error: null
            });
        }
    }), {
    name: 'admin-auth-storage',
    partialize: (state)=>({
            // Only persist minimal data
            isAuthenticated: state.isAuthenticated
        })
}));

},{"zustand":"fnNkQ","zustand/middleware":"jbOcO","@/shared/api/AdminApi":"10FIo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fnNkQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _vanilla = require("zustand/vanilla");
const identity = (arg)=>arg;
function useStore(api, selector = identity) {
    const slice = (0, _reactDefault.default).useSyncExternalStore(api.subscribe, (0, _reactDefault.default).useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), (0, _reactDefault.default).useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    (0, _reactDefault.default).useDebugValue(slice);
    return slice;
}
const createImpl = (createState)=>{
    const api = (0, _vanilla.createStore)(createState);
    const useBoundStore = (selector)=>useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const create = (createState)=>createState ? createImpl(createState) : createImpl;

},{"react":"erQJb","zustand/vanilla":"ijadY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ijadY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>createStore);
const createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState,
        getState,
        getInitialState,
        subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const createStore = (createState)=>createState ? createStoreImpl(createState) : createStoreImpl;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jbOcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combine", ()=>combine);
parcelHelpers.export(exports, "createJSONStorage", ()=>createJSONStorage);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "persist", ()=>persist);
parcelHelpers.export(exports, "redux", ()=>redux);
parcelHelpers.export(exports, "subscribeWithSelector", ()=>subscribeWithSelector);
parcelHelpers.export(exports, "unstable_ssrSafe", ()=>ssrSafe);
var $ec6ee7080513c488$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/zustand@5.0.12_@types+react@19.2.14_react@19.2.4_use-sync-external-store@1.6.0_react@19.2.4_/node_modules/zustand/esm/middleware.mjs"
});
const reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const redux = reduxImpl;
const shouldDispatchFromDevtools = (api)=>!!api.dispatchFromDevtools && typeof api.dispatch === "function";
const trackedConnections = /* @__PURE__ */ new Map();
const getTrackedConnectionState = (name)=>{
    const api = trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store,
        ...newConnection
    };
};
const removeStoreFromTrackedConnections = (name, store)=>{
    if (store === void 0) return;
    const connectionInfo = trackedConnections.get(name);
    if (!connectionInfo) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) trackedConnections.delete(name);
};
const findCallerName = (stack)=>{
    var _a, _b;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return (_b = /.+ (.+) .+/.exec(callerLine)) == null ? void 0 : _b[1];
};
const devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled, anonymousActionType, store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($ec6ee7080513c488$import_meta.env ? $ec6ee7080513c488$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection, ...connectionInformation } = extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        api.devtools = {
            cleanup: ()=>{
                if (connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
                removeStoreFromTrackedConnections(options.name, store);
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (shouldDispatchFromDevtools(api)) {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                if (($ec6ee7080513c488$import_meta.env ? $ec6ee7080513c488$import_meta.env.MODE : void 0) !== "production" && args[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...args);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (shouldDispatchFromDevtools(api)) api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init(getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const devtools = devtoolsImpl;
const parseJsonThen = (stringified, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const subscribeWithSelector = subscribeWithSelectorImpl;
function combine(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
const persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: createJSONStorage(()=>window.localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        let hydrationVersion = 0;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            return setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            return setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            const currentVersion = ++hydrationVersion;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                if (currentVersion !== hydrationVersion) return;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                if (currentVersion !== hydrationVersion) return;
                postRehydrationCallback == null || postRehydrationCallback(get(), void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                if (currentVersion !== hydrationVersion) return;
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const persist = persistImpl;
function ssrSafe(config, isSSR = typeof window === "undefined") {
    return (set, get, api)=>{
        if (!isSSR) return config(set, get, api);
        const ssrSet = ()=>{
            throw new Error("Cannot set state of Zustand store in SSR");
        };
        api.setState = ssrSet;
        return config(ssrSet, get, api);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"10FIo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Auth API Functions
parcelHelpers.export(exports, "login", ()=>login);
parcelHelpers.export(exports, "logout", ()=>logout);
parcelHelpers.export(exports, "checkAuth", ()=>checkAuth);
parcelHelpers.export(exports, "fetchEvents", ()=>fetchEvents);
parcelHelpers.export(exports, "createEvent", ()=>createEvent);
parcelHelpers.export(exports, "fetchAdminEventData", ()=>fetchAdminEventData);
// Generate Composite
parcelHelpers.export(exports, "generateComposite", ()=>generateComposite);
parcelHelpers.export(exports, "regenerateDriverProfile", ()=>regenerateDriverProfile);
parcelHelpers.export(exports, "fetchFollowUpPreviewHtml", ()=>fetchFollowUpPreviewHtml);
// Upload User Image
parcelHelpers.export(exports, "uploadUserImage", ()=>uploadUserImage);
// Manual Update Photo
parcelHelpers.export(exports, "manualUpdatePhoto", ()=>manualUpdatePhoto);
parcelHelpers.export(exports, "fetchQueueJobs", ()=>fetchQueueJobs);
// Retry Queue Job
parcelHelpers.export(exports, "retryQueueJob", ()=>retryQueueJob);
// Bulk Retry Queue Jobs
parcelHelpers.export(exports, "bulkRetryQueueJobs", ()=>bulkRetryQueueJobs);
parcelHelpers.export(exports, "testGemini", ()=>testGemini);
parcelHelpers.export(exports, "fetchConfigs", ()=>fetchConfigs);
parcelHelpers.export(exports, "fetchConfig", ()=>fetchConfig);
parcelHelpers.export(exports, "updateConfig", ()=>updateConfig);
parcelHelpers.export(exports, "fetchStatsMetrics", ()=>fetchStatsMetrics);
parcelHelpers.export(exports, "fetchStatsReport", ()=>fetchStatsReport);
parcelHelpers.export(exports, "downloadStatsReportCsv", ()=>downloadStatsReportCsv);
// Data Archives (event data dump)
parcelHelpers.export(exports, "queueDataArchive", ()=>queueDataArchive);
parcelHelpers.export(exports, "getDataArchiveDownloadUrl", ()=>getDataArchiveDownloadUrl);
parcelHelpers.export(exports, "deleteDataArchive", ()=>deleteDataArchive);
var _zod = require("zod");
var _useAdminAuthStore = require("@/features/admin/stores/useAdminAuthStore");
// Global fetch wrapper for 401 handling
async function adminFetch(url, options) {
    const response = await fetch(url, options);
    if (response.status === 401) {
        (0, _useAdminAuthStore.useAdminAuthStore).getState().logoutUser();
        throw new Error("Authentication required");
    }
    return response;
}
// Auth Schemas
const AuthUserSchema = _zod.object({
    id: _zod.string(),
    username: _zod.string()
});
const LoginResponseSchema = _zod.object({
    success: _zod.boolean(),
    user: AuthUserSchema.optional(),
    error: _zod.string().optional()
});
const AuthCheckResponseSchema = _zod.object({
    authenticated: _zod.boolean(),
    user: AuthUserSchema.nullable()
});
const LogoutResponseSchema = _zod.object({
    success: _zod.boolean()
});
async function login(data) {
    const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error("Login request failed");
    return LoginResponseSchema.parse(await response.json());
}
async function logout() {
    const response = await fetch("/api/admin-logout", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({})
    });
    if (!response.ok) throw new Error("Logout request failed");
    return LogoutResponseSchema.parse(await response.json());
}
async function checkAuth() {
    const response = await fetch("/api/admin-auth-check");
    if (!response.ok) throw new Error("Auth check request failed");
    return AuthCheckResponseSchema.parse(await response.json());
}
// Event Management
const EventSchema = _zod.object({
    event_id: _zod.number(),
    name: _zod.string(),
    submission_count: _zod.number(),
    created_at: _zod.number(),
    updated_at: _zod.number()
});
const EventsResponseSchema = _zod.object({
    events: _zod.array(EventSchema)
});
const CreateEventResponseSchema = _zod.object({
    success: _zod.boolean(),
    event: EventSchema.optional(),
    archived_count: _zod.number().optional(),
    message: _zod.string()
});
async function fetchEvents() {
    const response = await adminFetch("/api/admin-events");
    if (!response.ok) throw new Error("Failed to fetch events");
    return EventsResponseSchema.parse(await response.json());
}
async function createEvent(name) {
    const response = await adminFetch("/api/admin-create-event", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            name
        })
    });
    if (!response.ok) throw new Error("Failed to create event");
    return CreateEventResponseSchema.parse(await response.json());
}
// Admin Event Data Schemas (empower-specific)
const EventSubmissionDataSchema = _zod.object({
    submission_id: _zod.number(),
    email_address: _zod.string().nullable(),
    full_name: _zod.string(),
    phone_number: _zod.string().nullable(),
    driver_number: _zod.string(),
    color_selection: _zod.string(),
    pattern_selection: _zod.string(),
    driver_profile: _zod.string().nullable(),
    delivery_method: _zod.string(),
    submitted_photo_path: _zod.string(),
    submitted_photo_url: _zod.string().nullable(),
    created_at: _zod.number(),
    updated_at: _zod.number()
});
const EventCompositeDataSchema = _zod.object({
    composite_id: _zod.number(),
    uuid: _zod.string().nullable(),
    queue_job_id: _zod.string().nullable(),
    submission_id: _zod.number(),
    composite_path: _zod.string().nullable(),
    composite_url: _zod.string().nullable(),
    created_at: _zod.number(),
    updated_at: _zod.number()
});
const EventQueueJobDataSchema = _zod.object({
    queue_job_id: _zod.string(),
    queue_id: _zod.number().nullable(),
    submission_id: _zod.number().nullable(),
    className: _zod.string(),
    status: _zod.string(),
    input: _zod.any(),
    output: _zod.any().nullable(),
    error: _zod.string().nullable(),
    created_at: _zod.number(),
    updated_at: _zod.number()
});
const DataArchiveSchema = _zod.object({
    data_archive_id: _zod.number(),
    event_id: _zod.number().nullable(),
    include_photos: _zod.boolean(),
    status: _zod.enum([
        "queued",
        "processing",
        "completed",
        "failed"
    ]),
    file_size: _zod.number().nullable(),
    download_url: _zod.string().nullable(),
    error: _zod.string().nullable(),
    queue_job_id: _zod.string().nullable(),
    requested_by_user_id: _zod.number().nullable(),
    created_at: _zod.number(),
    updated_at: _zod.number(),
    completed_at: _zod.number().nullable()
});
const AdminEventDataResponseSchema = _zod.object({
    submissions: _zod.array(EventSubmissionDataSchema),
    composites: _zod.array(EventCompositeDataSchema),
    queue_jobs: _zod.array(EventQueueJobDataSchema),
    data_archives: _zod.array(DataArchiveSchema),
    metadata: _zod.object({
        event_id: _zod.number().nullable(),
        is_current_event: _zod.boolean(),
        timestamp: _zod.number()
    })
});
async function fetchAdminEventData(changesSince, eventId) {
    const searchParams = new URLSearchParams();
    if (changesSince !== undefined) searchParams.append("changes_since", changesSince.toString());
    if (eventId !== undefined && eventId !== null) searchParams.append("event_id", eventId.toString());
    const url = `/api/admin-event-data?${searchParams}`;
    const response = await adminFetch(url);
    if (!response.ok) throw new Error("Failed to fetch admin event data");
    return AdminEventDataResponseSchema.parse(await response.json());
}
async function generateComposite(data) {
    const response = await adminFetch("/api/admin-generate-composite", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error("Failed to generate composite");
    return _zod.object({
        success: _zod.boolean(),
        composite_id: _zod.number(),
        compose_job_id: _zod.string(),
        message: _zod.string()
    }).parse(await response.json());
}
async function regenerateDriverProfile(userId) {
    const response = await adminFetch("/api/admin-regenerate-driver-profile", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            submission_id: userId
        })
    });
    if (!response.ok) throw new Error("Failed to regenerate driver profile");
    return _zod.object({
        success: _zod.boolean(),
        queue_job_id: _zod.string(),
        submission_id: _zod.number(),
        message: _zod.string()
    }).parse(await response.json());
}
async function fetchFollowUpPreviewHtml(uuid) {
    const response = await adminFetch(`/api/admin-follow-up-preview?uuid=${encodeURIComponent(uuid)}`);
    if (!response.ok) throw new Error("Failed to load follow-up preview");
    return response.text();
}
async function uploadUserImage(data) {
    const formData = new FormData();
    formData.append("submission_id", data.submission_id.toString());
    formData.append("photo", data.file);
    const response = await adminFetch("/api/admin-upload-user-image", {
        method: "POST",
        body: formData
    });
    if (!response.ok) throw new Error("Failed to upload user image");
    return _zod.object({
        success: _zod.boolean(),
        photo_url: _zod.string(),
        message: _zod.string()
    }).parse(await response.json());
}
async function manualUpdatePhoto(data) {
    const formData = new FormData();
    formData.append("submission_id", data.submission_id.toString());
    formData.append("composite_id", data.composite_id.toString());
    formData.append("photo", data.photo);
    const response = await adminFetch("/api/admin-manual-update-photo", {
        method: "POST",
        body: formData
    });
    if (!response.ok) throw new Error("Failed to manually update photo");
    return _zod.object({
        success: _zod.boolean(),
        path: _zod.string().optional()
    }).parse(await response.json());
}
// Queue Jobs
const QueueJobSchema = _zod.object({
    queue_job_id: _zod.string(),
    queue_id: _zod.number().nullable(),
    className: _zod.string().nullable(),
    status: _zod.string(),
    input: _zod.any(),
    output: _zod.any().nullable(),
    error: _zod.string().nullable()
});
async function fetchQueueJobs() {
    const response = await adminFetch("/api/admin-queue-jobs");
    if (!response.ok) throw new Error("Failed to fetch queue jobs");
    return _zod.object({
        success: _zod.boolean(),
        jobs: _zod.array(QueueJobSchema),
        total: _zod.number()
    }).parse(await response.json());
}
async function retryQueueJob(queueJobId) {
    const response = await adminFetch("/api/admin-retry-queue-job", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            queue_job_id: queueJobId
        })
    });
    if (!response.ok) throw new Error("Failed to retry queue job");
    return _zod.object({
        success: _zod.boolean(),
        old_queue_job_id: _zod.string(),
        new_queue_job_id: _zod.string(),
        message: _zod.string()
    }).parse(await response.json());
}
async function bulkRetryQueueJobs(queueJobIds) {
    const response = await adminFetch("/api/admin-bulk-retry-queue-jobs", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            queue_job_ids: queueJobIds
        })
    });
    if (!response.ok) throw new Error("Failed to bulk retry queue jobs");
    return _zod.object({
        success: _zod.boolean(),
        retried_count: _zod.number(),
        failed_count: _zod.number(),
        results: _zod.array(_zod.object({
            old_queue_job_id: _zod.string(),
            new_queue_job_id: _zod.string(),
            success: _zod.boolean()
        })),
        failures: _zod.array(_zod.object({
            queue_job_id: _zod.string(),
            error: _zod.string()
        })),
        message: _zod.string()
    }).parse(await response.json());
}
async function testGemini(data) {
    const formData = new FormData();
    formData.append("image", data.image);
    formData.append("prompt", data.prompt);
    if (data.model) formData.append("model", data.model);
    const response = await adminFetch("/api/admin-test-gemini", {
        method: "POST",
        body: formData
    });
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to test AI model: ${errorText}`);
    }
    return _zod.object({
        success: _zod.boolean(),
        output_image: _zod.string(),
        message: _zod.string(),
        model: _zod.string().optional()
    }).parse(await response.json());
}
// Config Schemas
const ConfigSchema = _zod.object({
    key: _zod.string(),
    value: _zod.string().nullable(),
    schema: _zod.string().nullable()
});
const ConfigListResponseSchema = _zod.object({
    success: _zod.boolean(),
    configs: _zod.array(ConfigSchema)
});
const ConfigGetResponseSchema = _zod.object({
    success: _zod.boolean(),
    config: ConfigSchema.optional(),
    error: _zod.string().optional()
});
const ConfigUpdateResponseSchema = _zod.object({
    success: _zod.boolean(),
    config: ConfigSchema.optional(),
    error: _zod.string().optional()
});
async function fetchConfigs() {
    const response = await adminFetch("/api/admin-config");
    if (!response.ok) throw new Error("Failed to fetch configs");
    return ConfigListResponseSchema.parse(await response.json());
}
async function fetchConfig(key) {
    const response = await adminFetch(`/api/admin-config?key=${encodeURIComponent(key)}`);
    if (!response.ok) throw new Error("Failed to fetch config");
    return ConfigGetResponseSchema.parse(await response.json());
}
async function updateConfig(key, updates) {
    const response = await adminFetch("/api/admin-config", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            key,
            ...updates
        })
    });
    if (!response.ok) throw new Error("Failed to update config");
    return ConfigUpdateResponseSchema.parse(await response.json());
}
// Stats Reports
const StatsMetricSchema = _zod.object({
    key: _zod.string(),
    name: _zod.string(),
    description: _zod.string()
});
const StatsMetricsResponseSchema = _zod.object({
    metrics: _zod.array(StatsMetricSchema)
});
const StatsReportMetricDataSchema = _zod.object({
    name: _zod.string(),
    description: _zod.string(),
    data: _zod.array(_zod.record(_zod.string(), _zod.any()))
});
const StatsReportResponseSchema = _zod.object({
    generated_at: _zod.string(),
    metrics: _zod.record(_zod.string(), StatsReportMetricDataSchema)
});
async function fetchStatsMetrics() {
    const response = await adminFetch("/api/admin-stats-metrics");
    if (!response.ok) throw new Error("Failed to fetch stats metrics");
    return StatsMetricsResponseSchema.parse(await response.json());
}
async function fetchStatsReport(metricKeys) {
    const params = new URLSearchParams({
        format: "json"
    });
    if (metricKeys && metricKeys.length > 0) params.append("metrics", metricKeys.join(","));
    const response = await adminFetch(`/api/admin-stats-report?${params}`);
    if (!response.ok) throw new Error("Failed to fetch stats report");
    return StatsReportResponseSchema.parse(await response.json());
}
async function downloadStatsReportCsv(metricKeys, filename) {
    const params = new URLSearchParams({
        format: "csv"
    });
    if (metricKeys && metricKeys.length > 0) params.append("metrics", metricKeys.join(","));
    if (filename) params.append("filename", filename);
    // Fetch the CSV data
    const response = await adminFetch(`/api/admin-stats-report?${params}`);
    if (!response.ok) throw new Error("Failed to download CSV");
    // Get the blob data
    const blob = await response.blob();
    // Create a temporary anchor element to trigger download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "stats-report.csv";
    document.body.appendChild(a);
    a.click();
    // Cleanup
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}
async function queueDataArchive(data) {
    const response = await adminFetch("/api/admin-data-dump", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            event_id: data.event_id ?? null,
            include_photos: data.include_photos
        })
    });
    if (!response.ok) throw new Error("Failed to queue data archive");
    return _zod.object({
        success: _zod.boolean(),
        data_archive_id: _zod.number(),
        queue_job_id: _zod.string()
    }).parse(await response.json());
}
function getDataArchiveDownloadUrl(archive) {
    return archive.download_url ?? "";
}
async function deleteDataArchive(dataArchiveId) {
    const response = await adminFetch("/api/admin-delete-data-archive", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            data_archive_id: dataArchiveId
        })
    });
    if (!response.ok) throw new Error("Failed to delete data archive");
    return _zod.object({
        success: _zod.boolean(),
        data_archive_id: _zod.number()
    }).parse(await response.json());
}

},{"zod":"7oEJh","@/features/admin/stores/useAdminAuthStore":"33UXj","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7oEJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "z", ()=>_externalJs);
var _externalJs = require("./v3/external.js");
parcelHelpers.exportAll(_externalJs, exports);
exports.default = _externalJs;

},{"./v3/external.js":"jsPXs","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jsPXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errorsJs = require("./errors.js");
parcelHelpers.exportAll(_errorsJs, exports);
var _parseUtilJs = require("./helpers/parseUtil.js");
parcelHelpers.exportAll(_parseUtilJs, exports);
var _typeAliasesJs = require("./helpers/typeAliases.js");
parcelHelpers.exportAll(_typeAliasesJs, exports);
var _utilJs = require("./helpers/util.js");
parcelHelpers.exportAll(_utilJs, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _zodErrorJs = require("./ZodError.js");
parcelHelpers.exportAll(_zodErrorJs, exports);

},{"./errors.js":"gpElb","./helpers/parseUtil.js":"8pqRE","./helpers/typeAliases.js":"jj7oy","./helpers/util.js":"3o0Sn","./types.js":"kH8K6","./ZodError.js":"hghDK","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gpElb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultErrorMap", ()=>(0, _enJsDefault.default));
parcelHelpers.export(exports, "setErrorMap", ()=>setErrorMap);
parcelHelpers.export(exports, "getErrorMap", ()=>getErrorMap);
var _enJs = require("./locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
let overrideErrorMap = (0, _enJsDefault.default);
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

},{"./locales/en.js":"aE2V2","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aE2V2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zodErrorJs = require("../ZodError.js");
var _utilJs = require("../helpers/util.js");
const errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case (0, _zodErrorJs.ZodIssueCode).invalid_type:
            if (issue.received === (0, _utilJs.ZodParsedType).undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, (0, _utilJs.util).jsonStringifyReplacer)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).unrecognized_keys:
            message = `Unrecognized key(s) in object: ${(0, _utilJs.util).joinValues(issue.keys, ", ")}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${(0, _utilJs.util).joinValues(issue.options)}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_enum_value:
            message = `Invalid enum value. Expected ${(0, _utilJs.util).joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_return_type:
            message = `Invalid function return type`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_date:
            message = `Invalid date`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else (0, _utilJs.util).assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "bigint") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case (0, _zodErrorJs.ZodIssueCode).custom:
            message = `Invalid input`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case (0, _zodErrorJs.ZodIssueCode).not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            (0, _utilJs.util).assertNever(issue);
    }
    return {
        message
    };
};
exports.default = errorMap;

},{"../ZodError.js":"hghDK","../helpers/util.js":"3o0Sn","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hghDK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodIssueCode", ()=>ZodIssueCode);
parcelHelpers.export(exports, "quotelessJson", ()=>quotelessJson);
parcelHelpers.export(exports, "ZodError", ()=>ZodError);
var _utilJs = require("./helpers/util.js");
const ZodIssueCode = (0, _utilJs.util).arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof ZodError)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, (0, _utilJs.util).jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            const firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors,
            fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues)=>{
    const error = new ZodError(issues);
    return error;
};

},{"./helpers/util.js":"3o0Sn","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3o0Sn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "util", ()=>util);
parcelHelpers.export(exports, "objectUtil", ()=>objectUtil);
parcelHelpers.export(exports, "ZodParsedType", ()=>ZodParsedType);
parcelHelpers.export(exports, "getParsedType", ()=>getParsedType);
var util;
(function(util) {
    util.assertEqual = (_)=>{};
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return ZodParsedType.array;
            if (data === null) return ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return ZodParsedType.date;
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8pqRE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeIssue", ()=>makeIssue);
parcelHelpers.export(exports, "EMPTY_PATH", ()=>EMPTY_PATH);
parcelHelpers.export(exports, "addIssueToContext", ()=>addIssueToContext);
parcelHelpers.export(exports, "ParseStatus", ()=>ParseStatus);
parcelHelpers.export(exports, "INVALID", ()=>INVALID);
parcelHelpers.export(exports, "DIRTY", ()=>DIRTY);
parcelHelpers.export(exports, "OK", ()=>OK);
parcelHelpers.export(exports, "isAborted", ()=>isAborted);
parcelHelpers.export(exports, "isDirty", ()=>isDirty);
parcelHelpers.export(exports, "isValid", ()=>isValid);
parcelHelpers.export(exports, "isAsync", ()=>isAsync);
var _errorsJs = require("../errors.js");
var _enJs = require("../locales/en.js");
var _enJsDefault = parcelHelpers.interopDefault(_enJs);
const makeIssue = (params)=>{
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const overrideMap = (0, _errorsJs.getErrorMap)();
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === (0, _enJsDefault.default) ? undefined : (0, _enJsDefault.default)
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key,
                value
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key, value } = pair;
            if (key.status === "aborted") return INVALID;
            if (value.status === "aborted") return INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const INVALID = Object.freeze({
    status: "aborted"
});
const DIRTY = (value)=>({
        status: "dirty",
        value
    });
const OK = (value)=>({
        status: "valid",
        value
    });
const isAborted = (x)=>x.status === "aborted";
const isDirty = (x)=>x.status === "dirty";
const isValid = (x)=>x.status === "valid";
const isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;

},{"../errors.js":"gpElb","../locales/en.js":"aE2V2","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jj7oy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kH8K6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ZodType", ()=>ZodType);
// Adapted from https://stackoverflow.com/a/3143231
parcelHelpers.export(exports, "datetimeRegex", ()=>datetimeRegex);
parcelHelpers.export(exports, "ZodString", ()=>ZodString);
parcelHelpers.export(exports, "ZodNumber", ()=>ZodNumber);
parcelHelpers.export(exports, "ZodBigInt", ()=>ZodBigInt);
parcelHelpers.export(exports, "ZodBoolean", ()=>ZodBoolean);
parcelHelpers.export(exports, "ZodDate", ()=>ZodDate);
parcelHelpers.export(exports, "ZodSymbol", ()=>ZodSymbol);
parcelHelpers.export(exports, "ZodUndefined", ()=>ZodUndefined);
parcelHelpers.export(exports, "ZodNull", ()=>ZodNull);
parcelHelpers.export(exports, "ZodAny", ()=>ZodAny);
parcelHelpers.export(exports, "ZodUnknown", ()=>ZodUnknown);
parcelHelpers.export(exports, "ZodNever", ()=>ZodNever);
parcelHelpers.export(exports, "ZodVoid", ()=>ZodVoid);
parcelHelpers.export(exports, "ZodArray", ()=>ZodArray);
parcelHelpers.export(exports, "ZodObject", ()=>ZodObject);
parcelHelpers.export(exports, "ZodUnion", ()=>ZodUnion);
parcelHelpers.export(exports, "ZodDiscriminatedUnion", ()=>ZodDiscriminatedUnion);
parcelHelpers.export(exports, "ZodIntersection", ()=>ZodIntersection);
// type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];
parcelHelpers.export(exports, "ZodTuple", ()=>ZodTuple);
parcelHelpers.export(exports, "ZodRecord", ()=>ZodRecord);
parcelHelpers.export(exports, "ZodMap", ()=>ZodMap);
parcelHelpers.export(exports, "ZodSet", ()=>ZodSet);
parcelHelpers.export(exports, "ZodFunction", ()=>ZodFunction);
parcelHelpers.export(exports, "ZodLazy", ()=>ZodLazy);
parcelHelpers.export(exports, "ZodLiteral", ()=>ZodLiteral);
parcelHelpers.export(exports, "ZodEnum", ()=>ZodEnum);
parcelHelpers.export(exports, "ZodNativeEnum", ()=>ZodNativeEnum);
parcelHelpers.export(exports, "ZodPromise", ()=>ZodPromise);
parcelHelpers.export(exports, "ZodEffects", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodTransformer", ()=>ZodEffects);
parcelHelpers.export(exports, "ZodOptional", ()=>ZodOptional);
parcelHelpers.export(exports, "ZodNullable", ()=>ZodNullable);
parcelHelpers.export(exports, "ZodDefault", ()=>ZodDefault);
parcelHelpers.export(exports, "ZodCatch", ()=>ZodCatch);
parcelHelpers.export(exports, "ZodNaN", ()=>ZodNaN);
parcelHelpers.export(exports, "BRAND", ()=>BRAND);
parcelHelpers.export(exports, "ZodBranded", ()=>ZodBranded);
parcelHelpers.export(exports, "ZodPipeline", ()=>ZodPipeline);
parcelHelpers.export(exports, "ZodReadonly", ()=>ZodReadonly);
parcelHelpers.export(exports, "custom", ()=>custom);
parcelHelpers.export(exports, "Schema", ()=>ZodType);
parcelHelpers.export(exports, "ZodSchema", ()=>ZodType);
parcelHelpers.export(exports, "late", ()=>late);
parcelHelpers.export(exports, "ZodFirstPartyTypeKind", ()=>ZodFirstPartyTypeKind);
parcelHelpers.export(exports, "coerce", ()=>coerce);
parcelHelpers.export(exports, "any", ()=>anyType);
parcelHelpers.export(exports, "array", ()=>arrayType);
parcelHelpers.export(exports, "bigint", ()=>bigIntType);
parcelHelpers.export(exports, "boolean", ()=>booleanType);
parcelHelpers.export(exports, "date", ()=>dateType);
parcelHelpers.export(exports, "discriminatedUnion", ()=>discriminatedUnionType);
parcelHelpers.export(exports, "effect", ()=>effectsType);
parcelHelpers.export(exports, "enum", ()=>enumType);
parcelHelpers.export(exports, "function", ()=>functionType);
parcelHelpers.export(exports, "instanceof", ()=>instanceOfType);
parcelHelpers.export(exports, "intersection", ()=>intersectionType);
parcelHelpers.export(exports, "lazy", ()=>lazyType);
parcelHelpers.export(exports, "literal", ()=>literalType);
parcelHelpers.export(exports, "map", ()=>mapType);
parcelHelpers.export(exports, "nan", ()=>nanType);
parcelHelpers.export(exports, "nativeEnum", ()=>nativeEnumType);
parcelHelpers.export(exports, "never", ()=>neverType);
parcelHelpers.export(exports, "null", ()=>nullType);
parcelHelpers.export(exports, "nullable", ()=>nullableType);
parcelHelpers.export(exports, "number", ()=>numberType);
parcelHelpers.export(exports, "object", ()=>objectType);
parcelHelpers.export(exports, "oboolean", ()=>oboolean);
parcelHelpers.export(exports, "onumber", ()=>onumber);
parcelHelpers.export(exports, "optional", ()=>optionalType);
parcelHelpers.export(exports, "ostring", ()=>ostring);
parcelHelpers.export(exports, "pipeline", ()=>pipelineType);
parcelHelpers.export(exports, "preprocess", ()=>preprocessType);
parcelHelpers.export(exports, "promise", ()=>promiseType);
parcelHelpers.export(exports, "record", ()=>recordType);
parcelHelpers.export(exports, "set", ()=>setType);
parcelHelpers.export(exports, "strictObject", ()=>strictObjectType);
parcelHelpers.export(exports, "string", ()=>stringType);
parcelHelpers.export(exports, "symbol", ()=>symbolType);
parcelHelpers.export(exports, "transformer", ()=>effectsType);
parcelHelpers.export(exports, "tuple", ()=>tupleType);
parcelHelpers.export(exports, "undefined", ()=>undefinedType);
parcelHelpers.export(exports, "union", ()=>unionType);
parcelHelpers.export(exports, "unknown", ()=>unknownType);
parcelHelpers.export(exports, "void", ()=>voidType);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
var _zodErrorJs = require("./ZodError.js");
var _errorsJs = require("./errors.js");
var _errorUtilJs = require("./helpers/errorUtil.js");
var _parseUtilJs = require("./helpers/parseUtil.js");
var _utilJs = require("./helpers/util.js");
class ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (Array.isArray(this._key)) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result)=>{
    if ((0, _parseUtilJs.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new (0, _zodErrorJs.ZodError)(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function processCreateParams(params) {
    if (!params) return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description
    };
    const customMap = (iss, ctx)=>{
        const { message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message ?? ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: message ?? required_error ?? ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: message ?? invalid_type_error ?? ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description
    };
}
class ZodType {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, _utilJs.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, _utilJs.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new (0, _parseUtilJs.ParseStatus)(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, _utilJs.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, _parseUtilJs.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        const ctx = {
            common: {
                issues: [],
                async: params?.async ?? false,
                contextualErrorMap: params?.errorMap
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const result = this._parseSync({
            data,
            path: ctx.path,
            parent: ctx
        });
        return handleResult(ctx, result);
    }
    "~validate"(data) {
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data,
                path: [],
                parent: ctx
            });
            return (0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if (err?.message?.toLowerCase()?.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data,
            path: [],
            parent: ctx
        }).then((result)=>(0, _parseUtilJs.isValid)(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params?.errorMap,
                async: true
            },
            path: params?.path || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: (0, _utilJs.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, _parseUtilJs.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: (0, _zodErrorJs.ZodIssueCode).custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[0-9a-z]+$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const nanoidRegex = /^[a-z0-9_-]{21}$/i;
const jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
// faster, simpler, safer
const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
    let secondsRegexSource = `[0-5]\\d`;
    if (args.precision) secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
    else if (args.precision == null) secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
    const secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero
    return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
    return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
    let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) return true;
    return false;
}
function isValidJWT(jwt, alg) {
    if (!jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        if (!header) return false;
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if ("typ" in decoded && decoded?.typ !== "JWT") return false;
        if (!decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch  {
        return false;
    }
}
function isValidCidr(ip, version) {
    if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) return true;
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).string) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).string,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "email",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!emojiRegex) emojiRegex = new RegExp(_emojiRegex, "u");
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "nanoid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch  {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    validation: "url",
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "duration",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "jwt",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "cidr",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        validation: "base64url",
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation,
            code: (0, _zodErrorJs.ZodIssueCode).invalid_string,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...(0, _errorUtilJs.errorUtil).errToObj(options)
        });
    }
    datetime(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            offset: options?.offset ?? false,
            local: options?.local ?? false,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof options?.precision === "undefined" ? null : options?.precision,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options?.position,
            ...(0, _errorUtilJs.errorUtil).errToObj(options?.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...(0, _errorUtilJs.errorUtil).errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, (0, _errorUtilJs.errorUtil).errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params)=>{
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
class ZodNumber extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).number) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).number,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!(0, _utilJs.util).isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && (0, _utilJs.util).isInteger(ch.value));
    }
    get isFinite() {
        let max = null;
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params)=>{
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodBigInt extends ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch  {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new (0, _parseUtilJs.ParseStatus)();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).bigint,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, (0, _errorUtilJs.errorUtil).toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, (0, _errorUtilJs.errorUtil).toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: (0, _errorUtilJs.errorUtil).toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params)=>{
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: params?.coerce ?? false,
        ...processCreateParams(params)
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).boolean,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodBoolean.create = (params)=>{
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: params?.coerce || false,
        ...processCreateParams(params)
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).date) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).date,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_date
            });
            return 0, _parseUtilJs.INVALID;
        }
        const status = new (0, _parseUtilJs.ParseStatus)();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else (0, _utilJs.util).assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: (0, _errorUtilJs.errorUtil).toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params)=>{
    return new ZodDate({
        checks: [],
        coerce: params?.coerce || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).symbol,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodSymbol.create = (params)=>{
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).undefined,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUndefined.create = (params)=>{
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).null) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).null,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodNull.create = (params)=>{
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
    });
};
class ZodAny extends ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodAny.create = (params)=>{
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
    });
};
class ZodUnknown extends ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodUnknown.create = (params)=>{
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, _parseUtilJs.addIssueToContext)(ctx, {
            code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
            expected: (0, _utilJs.ZodParsedType).never,
            received: ctx.parsedType
        });
        return 0, _parseUtilJs.INVALID;
    }
}
ZodNever.create = (params)=>{
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).void,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
}
ZodVoid.create = (params)=>{
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: tooBig ? (0, _zodErrorJs.ZodIssueCode).too_big : (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return (0, _parseUtilJs.ParseStatus).mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params)=>{
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof ZodArray) return new ZodArray({
        ...schema._def,
        type: deepPartialify(schema.element)
    });
    else if (schema instanceof ZodOptional) return ZodOptional.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodNullable) return ZodNullable.create(deepPartialify(schema.unwrap()));
    else if (schema instanceof ZodTuple) return ZodTuple.create(schema.items.map((item)=>deepPartialify(item)));
    else return schema;
}
class ZodObject extends ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = (0, _utilJs.util).objectKeys(shape);
        this._cached = {
            shape,
            keys
        };
        return this._cached;
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).object) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, _parseUtilJs.addIssueToContext)(ctx, {
                        code: (0, _zodErrorJs.ZodIssueCode).unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key,
                    value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, syncPairs);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        (0, _errorUtilJs.errorUtil).errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (0, _errorUtilJs.errorUtil).errToObj(message).message ?? defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(mask))if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (!mask[key]) shape[key] = this.shape[key];
        return new ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape)){
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        for (const key of (0, _utilJs.util).objectKeys(this.shape))if (mask && !mask[key]) newShape[key] = this.shape[key];
        else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while(newField instanceof ZodOptional)newField = newField._def.innerType;
            newShape[key] = newField;
        }
        return new ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return createZodEnum((0, _utilJs.util).objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.strictCreate = (shape, params)=>{
    return new ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
ZodObject.lazycreate = (shape, params)=>{
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new (0, _zodErrorJs.ZodError)(result.ctx.common.issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new (0, _zodErrorJs.ZodError)(issues));
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union,
                unionErrors
            });
            return 0, _parseUtilJs.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params)=>{
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type)=>{
    if (type instanceof ZodLazy) return getDiscriminator(type.schema);
    else if (type instanceof ZodEffects) return getDiscriminator(type.innerType());
    else if (type instanceof ZodLiteral) return [
        type.value
    ];
    else if (type instanceof ZodEnum) return type.options;
    else if (type instanceof ZodNativeEnum) // eslint-disable-next-line ban/ban
    return (0, _utilJs.util).objectValues(type.enum);
    else if (type instanceof ZodDefault) return getDiscriminator(type._def.innerType);
    else if (type instanceof ZodUndefined) return [
        undefined
    ];
    else if (type instanceof ZodNull) return [
        null
    ];
    else if (type instanceof ZodOptional) return [
        undefined,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodNullable) return [
        null,
        ...getDiscriminator(type.unwrap())
    ];
    else if (type instanceof ZodBranded) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodReadonly) return getDiscriminator(type.unwrap());
    else if (type instanceof ZodCatch) return getDiscriminator(type._def.innerType);
    else return [];
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params)
        });
    }
}
function mergeValues(a, b) {
    const aType = (0, _utilJs.getParsedType)(a);
    const bType = (0, _utilJs.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === (0, _utilJs.ZodParsedType).object && bType === (0, _utilJs.ZodParsedType).object) {
        const bKeys = (0, _utilJs.util).objectKeys(b);
        const sharedKeys = (0, _utilJs.util).objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === (0, _utilJs.ZodParsedType).array && bType === (0, _utilJs.ZodParsedType).array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === (0, _utilJs.ZodParsedType).date && bType === (0, _utilJs.ZodParsedType).date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, _parseUtilJs.isAborted)(parsedLeft) || (0, _parseUtilJs.isAborted)(parsedRight)) return 0, _parseUtilJs.INVALID;
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_intersection_types
                });
                return 0, _parseUtilJs.INVALID;
            }
            if ((0, _parseUtilJs.isDirty)(parsedLeft) || (0, _parseUtilJs.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
ZodIntersection.create = (left, right, params)=>{
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).array) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).array,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return 0, _parseUtilJs.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return (0, _parseUtilJs.ParseStatus).mergeArray(status, results);
        });
        else return (0, _parseUtilJs.ParseStatus).mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest
        });
    }
}
ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).object) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).object,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return (0, _parseUtilJs.ParseStatus).mergeObjectAsync(status, pairs);
        else return (0, _parseUtilJs.ParseStatus).mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) return new ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
        });
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second)
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).map) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).map,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
ZodMap.create = (keyType, valueType, params)=>{
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).set) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).set,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, _parseUtilJs.addIssueToContext)(ctx, {
                    code: (0, _zodErrorJs.ZodIssueCode).too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: (0, _errorUtilJs.errorUtil).toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params)=>{
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
    });
};
class ZodFunction extends ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).function) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).function,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, _parseUtilJs.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, _errorsJs.getErrorMap)(),
                    (0, _errorsJs.defaultErrorMap)
                ].filter((x)=>!!x),
                issueData: {
                    code: (0, _zodErrorJs.ZodIssueCode).invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(async function(...args) {
                const error = new (0, _zodErrorJs.ZodError)([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, _parseUtilJs.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new (0, _zodErrorJs.ZodError)([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new (0, _zodErrorJs.ZodError)([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params)
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
ZodLazy.create = (getter, params)=>{
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_literal,
                expected: this._def.value
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params)=>{
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set(this._def.values);
        if (!this._cache.has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return ZodEnum.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = (0, _utilJs.util).getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).string && ctx.parsedType !== (0, _utilJs.ZodParsedType).number) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                expected: (0, _utilJs.util).joinValues(expectedValues),
                received: ctx.parsedType,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type
            });
            return 0, _parseUtilJs.INVALID;
        }
        if (!this._cache) this._cache = new Set((0, _utilJs.util).getValidEnumValues(this._def.values));
        if (!this._cache.has(input.data)) {
            const expectedValues = (0, _utilJs.util).objectValues(nativeEnumValues);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                received: ctx.data,
                code: (0, _zodErrorJs.ZodIssueCode).invalid_enum_value,
                options: expectedValues
            });
            return 0, _parseUtilJs.INVALID;
        }
        return (0, _parseUtilJs.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params)=>{
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== (0, _utilJs.ZodParsedType).promise && ctx.common.async === false) {
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).promise,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        const promisified = ctx.parsedType === (0, _utilJs.ZodParsedType).promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, _parseUtilJs.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
ZodPromise.create = (schema, params)=>{
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, _parseUtilJs.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return 0, _parseUtilJs.INVALID;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (result.status === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                if (status.value === "dirty") return (0, _parseUtilJs.DIRTY)(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, _parseUtilJs.isValid)(base)) return 0, _parseUtilJs.INVALID;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        (0, _utilJs.util).assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params)=>{
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new ZodEffects({
        schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).undefined) return (0, _parseUtilJs.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params)=>{
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === (0, _utilJs.ZodParsedType).null) return (0, _parseUtilJs.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params)=>{
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === (0, _utilJs.ZodParsedType).undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params)=>{
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...processCreateParams(params)
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, _parseUtilJs.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new (0, _zodErrorJs.ZodError)(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params)=>{
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...processCreateParams(params)
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== (0, _utilJs.ZodParsedType).nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, _parseUtilJs.addIssueToContext)(ctx, {
                code: (0, _zodErrorJs.ZodIssueCode).invalid_type,
                expected: (0, _utilJs.ZodParsedType).nan,
                received: ctx.parsedType
            });
            return 0, _parseUtilJs.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
ZodNaN.create = (params)=>{
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, _parseUtilJs.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return 0, _parseUtilJs.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ((0, _parseUtilJs.isValid)(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return (0, _parseUtilJs.isAsync)(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodReadonly.create = (type, params)=>{
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function custom(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return ZodAny.create().superRefine((data, ctx)=>{
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            if (!r) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return ZodAny.create();
}
const late = {
    object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class Class {
    constructor(..._){}
}
const instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>custom((data)=>data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = ()=>stringType().optional();
const onumber = ()=>numberType().optional();
const oboolean = ()=>booleanType().optional();
const coerce = {
    string: (arg)=>ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>ZodDate.create({
            ...arg,
            coerce: true
        })
};
const NEVER = (0, _parseUtilJs.INVALID);

},{"./ZodError.js":"hghDK","./errors.js":"gpElb","./helpers/errorUtil.js":"hlND0","./helpers/parseUtil.js":"8pqRE","./helpers/util.js":"3o0Sn","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hlND0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorUtil", ()=>errorUtil);
var errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message
        } : message || {};
    // biome-ignore lint:
    errorUtil.toString = (message)=>typeof message === "string" ? message : message?.message;
})(errorUtil || (errorUtil = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6yJTw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdminLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _hooks = require("@mantine/hooks");
var _notifications = require("@mantine/notifications");
var _iconsReact = require("@tabler/icons-react");
var _react = require("react");
var _reactErrorBoundary = require("react-error-boundary");
var _wouter = require("wouter");
var _adminSidebar = require("./AdminSidebar");
var _adminSidebarDefault = parcelHelpers.interopDefault(_adminSidebar);
var _errorFallback = require("@/shared/components/ErrorFallback");
var _fillAndCenter = require("@/shared/components/FillAndCenter");
var _fillAndCenterDefault = parcelHelpers.interopDefault(_fillAndCenter);
var _adminNavContext = require("@/features/admin/contexts/AdminNavContext");
var _useAdminAuthStore = require("@/features/admin/stores/useAdminAuthStore");
var _useAdminEventDataStore = require("@/features/admin/stores/useAdminEventDataStore");
function PageLoader() {
    const $ = (0, _compilerRuntime.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            position: "relative",
            width: "var(--app-shell-content-width)",
            height: "var(--app-shell-content-height)"
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: t0,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fillAndCenterDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Loader), {
                    size: "lg"
                })
            })
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
function AdminLayoutContent(t0) {
    const $ = (0, _compilerRuntime.c)(65);
    const { children } = t0;
    const theme = (0, _core.useMantineTheme)();
    const [, setLocation] = (0, _wouter.useLocation)();
    const { user, logoutUser } = (0, _useAdminAuthStore.useAdminAuthStore)();
    const selectedEventId = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp);
    const events = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp2);
    const setSelectedEventId = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp3);
    const fetchEventList = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp4);
    const startPolling = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp5);
    const stopPolling = (0, _useAdminEventDataStore.useAdminEventDataStore)(_temp6);
    const [mobileOpened, t1] = (0, _hooks.useDisclosure)();
    const { toggle: toggleMobile, close: closeMobile } = t1;
    const [desktopOpened, t2] = (0, _hooks.useDisclosure)(true);
    const { toggle: toggleDesktop } = t2;
    const isMobile = (0, _hooks.useMediaQuery)(`(max-width: ${theme.breakpoints.sm})`);
    let t3;
    if ($[0] !== closeMobile || $[1] !== isMobile) {
        t3 = {
            closeMobileNav: ()=>{
                if (!isMobile) return;
                closeMobile();
            }
        };
        $[0] = closeMobile;
        $[1] = isMobile;
        $[2] = t3;
    } else t3 = $[2];
    const navContextValue = t3;
    let t4;
    if ($[3] !== logoutUser || $[4] !== setLocation) {
        t4 = async ()=>{
            await logoutUser();
            setLocation("/login");
        };
        $[3] = logoutUser;
        $[4] = setLocation;
        $[5] = t4;
    } else t4 = $[5];
    const handleLogout = t4;
    let t5;
    let t6;
    if ($[6] !== fetchEventList || $[7] !== startPolling || $[8] !== stopPolling) {
        t5 = ()=>{
            fetchEventList();
            startPolling();
            return ()=>{
                stopPolling();
            };
        };
        t6 = [
            fetchEventList,
            startPolling,
            stopPolling
        ];
        $[6] = fetchEventList;
        $[7] = startPolling;
        $[8] = stopPolling;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, _react.useEffect)(t5, t6);
    let t7;
    if ($[11] !== setSelectedEventId) {
        t7 = (value)=>{
            const eventId = value === "current" ? null : value ? parseInt(value) : null;
            setSelectedEventId(eventId);
        };
        $[11] = setSelectedEventId;
        $[12] = t7;
    } else t7 = $[12];
    const handleEventChange = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [];
        $[13] = t8;
    } else t8 = $[13];
    (0, _react.useEffect)(_temp8, t8);
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            height: 60
        };
        $[14] = t9;
    } else t9 = $[14];
    const t10 = !mobileOpened;
    const t11 = !desktopOpened;
    let t12;
    if ($[15] !== t10 || $[16] !== t11) {
        t12 = {
            width: 200,
            breakpoint: "sm",
            collapsed: {
                mobile: t10,
                desktop: t11
            }
        };
        $[15] = t10;
        $[16] = t11;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
            "--app-shell-content-width": "calc(100vw - var(--app-shell-navbar-offset) - var(--app-shell-padding) * 2)",
            "--app-shell-content-height": "calc(100dvh - var(--app-shell-header-offset) - var(--app-shell-padding) * 2)"
        };
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== mobileOpened || $[20] !== toggleMobile) {
        t14 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Burger), {
            opened: mobileOpened,
            onClick: toggleMobile,
            hiddenFrom: "sm",
            size: "sm"
        });
        $[19] = mobileOpened;
        $[20] = toggleMobile;
        $[21] = t14;
    } else t14 = $[21];
    let t15;
    if ($[22] !== desktopOpened || $[23] !== toggleDesktop) {
        t15 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Burger), {
            opened: desktopOpened,
            onClick: toggleDesktop,
            visibleFrom: "sm",
            size: "sm"
        });
        $[22] = desktopOpened;
        $[23] = toggleDesktop;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Title), {
            order: 3,
            children: "Empower Driver Admin"
        });
        $[25] = t16;
    } else t16 = $[25];
    let t17;
    if ($[26] !== t14 || $[27] !== t15) {
        t17 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Group), {
            children: [
                t14,
                t15,
                t16
            ]
        });
        $[26] = t14;
        $[27] = t15;
        $[28] = t17;
    } else t17 = $[28];
    let t18;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconCalendarEvent), {
            size: 16
        });
        $[29] = t18;
    } else t18 = $[29];
    const t19 = selectedEventId === null ? "current" : String(selectedEventId);
    let t20;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = {
            value: "current",
            label: "\uD83D\uDCCD Current Event"
        };
        $[30] = t20;
    } else t20 = $[30];
    let t21;
    if ($[31] !== events) {
        t21 = [
            t20,
            ...events.map(_temp9)
        ];
        $[31] = events;
        $[32] = t21;
    } else t21 = $[32];
    let t22;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = {
            withinPortal: true
        };
        $[33] = t22;
    } else t22 = $[33];
    let t23;
    if ($[34] !== handleEventChange || $[35] !== t19 || $[36] !== t21) {
        t23 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Select), {
            leftSection: t18,
            placeholder: "Select Event",
            value: t19,
            onChange: handleEventChange,
            data: t21,
            w: 250,
            size: "sm",
            comboboxProps: t22
        });
        $[34] = handleEventChange;
        $[35] = t19;
        $[36] = t21;
        $[37] = t23;
    } else t23 = $[37];
    let t24;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Menu).Target, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.ActionIcon), {
                variant: "subtle",
                size: "lg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconUser), {
                    size: 20
                })
            })
        });
        $[38] = t24;
    } else t24 = $[38];
    const t25 = user?.username || "Admin";
    let t26;
    if ($[39] !== t25) {
        t26 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Menu).Label, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
                size: "sm",
                fw: 500,
                children: t25
            })
        });
        $[39] = t25;
        $[40] = t26;
    } else t26 = $[40];
    let t27;
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Menu).Divider, {});
        $[41] = t27;
    } else t27 = $[41];
    let t28;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconLogout), {
            size: 16
        });
        $[42] = t28;
    } else t28 = $[42];
    let t29;
    if ($[43] !== handleLogout) {
        t29 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Menu).Item, {
            leftSection: t28,
            onClick: handleLogout,
            color: "red",
            children: "Logout"
        });
        $[43] = handleLogout;
        $[44] = t29;
    } else t29 = $[44];
    let t30;
    if ($[45] !== t26 || $[46] !== t29) {
        t30 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Menu), {
            shadow: "md",
            width: 200,
            children: [
                t24,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Menu).Dropdown, {
                    children: [
                        t26,
                        t27,
                        t29
                    ]
                })
            ]
        });
        $[45] = t26;
        $[46] = t29;
        $[47] = t30;
    } else t30 = $[47];
    let t31;
    if ($[48] !== t23 || $[49] !== t30) {
        t31 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Group), {
            children: [
                t23,
                t30
            ]
        });
        $[48] = t23;
        $[49] = t30;
        $[50] = t31;
    } else t31 = $[50];
    let t32;
    if ($[51] !== t17 || $[52] !== t31) {
        t32 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.AppShell).Header, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Group), {
                h: "100%",
                px: "md",
                justify: "space-between",
                children: [
                    t17,
                    t31
                ]
            })
        });
        $[51] = t17;
        $[52] = t31;
        $[53] = t32;
    } else t32 = $[53];
    let t33;
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.AppShell).Navbar, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminSidebarDefault.default), {})
        });
        $[54] = t33;
    } else t33 = $[54];
    let t34;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ (0, _jsxRuntime.jsx)(PageLoader, {});
        $[55] = t34;
    } else t34 = $[55];
    let t35;
    if ($[56] !== children) {
        t35 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.AppShell).Main, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                fallback: t34,
                children: children
            })
        });
        $[56] = children;
        $[57] = t35;
    } else t35 = $[57];
    let t36;
    if ($[58] !== t12 || $[59] !== t32 || $[60] !== t35) {
        t36 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.AppShell), {
            header: t9,
            navbar: t12,
            padding: "md",
            style: t13,
            children: [
                t32,
                t33,
                t35
            ]
        });
        $[58] = t12;
        $[59] = t32;
        $[60] = t35;
        $[61] = t36;
    } else t36 = $[61];
    let t37;
    if ($[62] !== navContextValue || $[63] !== t36) {
        t37 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adminNavContext.AdminNavProvider), {
            value: navContextValue,
            children: t36
        });
        $[62] = navContextValue;
        $[63] = t36;
        $[64] = t37;
    } else t37 = $[64];
    return t37;
}
function _temp9(event) {
    return {
        value: String(event.event_id),
        label: `\u{1F4C1} ${event.name} (${event.submission_count} submissions)`
    };
}
function _temp8() {
    document.body.classList.add("adminLayout");
    return _temp7;
}
function _temp7() {
    document.body.classList.remove("adminLayout");
}
function _temp6(state_4) {
    return state_4.stopPolling;
}
function _temp5(state_3) {
    return state_3.startPolling;
}
function _temp4(state_2) {
    return state_2.fetchEventList;
}
function _temp3(state_1) {
    return state_1.setSelectedEventId;
}
function _temp2(state_0) {
    return state_0.events;
}
function _temp(state) {
    return state.selectedEventId;
}
function AdminLayout(t0) {
    const $ = (0, _compilerRuntime.c)(3);
    const { children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notifications.Notifications), {});
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.MantineProvider), {
            children: [
                t1,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactErrorBoundary.ErrorBoundary), {
                    FallbackComponent: (0, _errorFallback.ErrorFallback),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AdminLayoutContent, {
                        children: children
                    })
                })
            ]
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["ActionIcon","7iZCX"],["AppShell","7QHq9"],["Burger","erlWx"],["Group","cxrP6"],["Loader","7aA6l"],["MantineProvider","2TSc8"],["Menu","cPRhZ"],["Select","3nDTo"],["Text","1QStM"],["Title","8dCI1"],["useMantineTheme","bajsd"]],"@mantine/hooks":[["useDisclosure","9UqII"],["useMediaQuery","gNbAU"]],"@mantine/notifications":"a2Nak","@tabler/icons-react":[["IconCalendarEvent","i1TZS","default"],["IconLogout","04DKa","default"],["IconUser","8SbdW","default"]],"react":"erQJb","react-error-boundary":"9NmbP","wouter":"3dLPT","./AdminSidebar":"b7jEm","@/shared/components/ErrorFallback":"3pGYY","@/shared/components/FillAndCenter":"ffS8N","@/features/admin/contexts/AdminNavContext":"dAN6f","@/features/admin/stores/useAdminAuthStore":"33UXj","@/features/admin/stores/useAdminEventDataStore":"7J6Ue","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7iZCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionIcon", ()=>ActionIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _loaderMjs = require("../Loader/Loader.mjs");
var _transitionMjs = require("../Transition/Transition.mjs");
var _unstyledButtonMjs = require("../UnstyledButton/UnstyledButton.mjs");
var _actionIconModuleCssMjs = require("./ActionIcon.module.css.mjs");
var _actionIconModuleCssMjsDefault = parcelHelpers.interopDefault(_actionIconModuleCssMjs);
var _actionIconGroupMjs = require("./ActionIconGroup/ActionIconGroup.mjs");
var _actionIconGroupSectionMjs = require("./ActionIconGroupSection/ActionIconGroupSection.mjs");
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { size, radius, variant, gradient, color, autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        root: {
            "--ai-size": (0, _getSizeMjs.getSize)(size, "ai-size"),
            "--ai-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--ai-bg": color || variant ? colors.background : void 0,
            "--ai-hover": color || variant ? colors.hover : void 0,
            "--ai-hover-color": color || variant ? colors.hoverColor : void 0,
            "--ai-color": colors.color,
            "--ai-bd": color || variant ? colors.border : void 0
        }
    };
});
const ActionIcon = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ActionIcon", null, _props);
    const { className, unstyled, variant, classNames, styles, style, loading, loaderProps, size, color, radius, __staticSelector, gradient, vars, children, disabled, "data-disabled": dataDisabled, autoContrast, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "ActionIcon",
            __staticSelector
        ],
        props,
        className,
        style,
        classes: (0, _actionIconModuleCssMjsDefault.default),
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        ...getStyles("root", {
            active: !disabled && !loading && !dataDisabled
        }),
        ...others,
        unstyled,
        variant,
        size,
        disabled: disabled || loading,
        ref,
        mod: [
            {
                loading,
                disabled: disabled || dataDisabled
            },
            mod
        ],
        children: [
            typeof loading === "boolean" && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _transitionMjs.Transition), {
                mounted: loading,
                transition: "slide-down",
                duration: 150,
                children: (transitionStyles)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        ...getStyles("loader", {
                            style: transitionStyles
                        }),
                        "aria-hidden": true,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _loaderMjs.Loader), {
                            color: "var(--ai-color)",
                            size: "calc(var(--ai-size) * 0.55)",
                            ...loaderProps
                        })
                    })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                component: "span",
                mod: {
                    loading
                },
                ...getStyles("icon"),
                children
            })
        ]
    });
});
ActionIcon.classes = (0, _actionIconModuleCssMjsDefault.default);
ActionIcon.displayName = "@mantine/core/ActionIcon";
ActionIcon.Group = (0, _actionIconGroupMjs.ActionIconGroup);
ActionIcon.GroupSection = (0, _actionIconGroupSectionMjs.ActionIconGroupSection);

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Loader/Loader.mjs":"7aA6l","../Transition/Transition.mjs":"3eGlY","../UnstyledButton/UnstyledButton.mjs":"55gpk","./ActionIcon.module.css.mjs":"c6qxY","./ActionIconGroup/ActionIconGroup.mjs":"jcASj","./ActionIconGroupSection/ActionIconGroupSection.mjs":"ZhFbw","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c6qxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_8d3f4000",
    "icon": "m_8d3afb97",
    "loader": "m_302b9fb1",
    "group": "m_1a0f1b21",
    "groupSection": "m_437b6484"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jcASj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionIconGroup", ()=>ActionIconGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _actionIconModuleCssMjs = require("../ActionIcon.module.css.mjs");
var _actionIconModuleCssMjsDefault = parcelHelpers.interopDefault(_actionIconModuleCssMjs);
'use client';
const defaultProps = {
    orientation: "horizontal"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { borderWidth })=>({
        group: {
            "--ai-border-width": (0, _remMjs.rem)(borderWidth)
        }
    }));
const ActionIconGroup = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ActionIconGroup", defaultProps, _props);
    const { className, style, classNames, styles, unstyled, orientation, vars, borderWidth, variant, mod, attributes, ...others } = (0, _usePropsMjs.useProps)("ActionIconGroup", defaultProps, _props);
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ActionIconGroup",
        props,
        classes: (0, _actionIconModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "group"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("group"),
        ref,
        variant,
        mod: [
            {
                "data-orientation": orientation
            },
            mod
        ],
        role: "group",
        ...others
    });
});
ActionIconGroup.classes = (0, _actionIconModuleCssMjsDefault.default);
ActionIconGroup.displayName = "@mantine/core/ActionIconGroup";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../ActionIcon.module.css.mjs":"c6qxY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ZhFbw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionIconGroupSection", ()=>ActionIconGroupSection);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _actionIconModuleCssMjs = require("../ActionIcon.module.css.mjs");
var _actionIconModuleCssMjsDefault = parcelHelpers.interopDefault(_actionIconModuleCssMjs);
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color, gradient, variant, autoContrast, size })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        gradient,
        variant: variant || "filled",
        autoContrast
    });
    return {
        groupSection: {
            "--section-height": (0, _getSizeMjs.getSize)(size, "section-height"),
            "--section-padding-x": (0, _getSizeMjs.getSize)(size, "section-padding-x"),
            "--section-fz": (0, _getSizeMjs.getFontSize)(size),
            "--section-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--section-bg": color || variant ? colors.background : void 0,
            "--section-color": colors.color,
            "--section-bd": color || variant ? colors.border : void 0
        }
    };
});
const ActionIconGroupSection = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ActionIconGroupSection", null, _props);
    const { className, style, classNames, styles, unstyled, vars, variant, gradient, radius, autoContrast, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ActionIconGroupSection",
        props,
        classes: (0, _actionIconModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "groupSection"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("groupSection"),
        ref,
        variant,
        ...others
    });
});
ActionIconGroupSection.classes = (0, _actionIconModuleCssMjsDefault.default);
ActionIconGroupSection.displayName = "@mantine/core/ActionIconGroupSection";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../ActionIcon.module.css.mjs":"c6qxY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7QHq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShell", ()=>AppShell);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getDefaultZIndexMjs = require("../../core/utils/get-default-z-index/get-default-z-index.mjs");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("./AppShell.context.mjs");
var _appShellModuleCssMjs = require("./AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
var _appShellAsideMjs = require("./AppShellAside/AppShellAside.mjs");
var _appShellFooterMjs = require("./AppShellFooter/AppShellFooter.mjs");
var _appShellHeaderMjs = require("./AppShellHeader/AppShellHeader.mjs");
var _appShellMainMjs = require("./AppShellMain/AppShellMain.mjs");
var _appShellMediaStylesMjs = require("./AppShellMediaStyles/AppShellMediaStyles.mjs");
var _appShellNavbarMjs = require("./AppShellNavbar/AppShellNavbar.mjs");
var _appShellSectionMjs = require("./AppShellSection/AppShellSection.mjs");
var _useResizingMjs = require("./use-resizing/use-resizing.mjs");
'use client';
const defaultProps = {
    withBorder: true,
    padding: 0,
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    zIndex: (0, _getDefaultZIndexMjs.getDefaultZIndex)("app"),
    mode: "fixed"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { transitionDuration, transitionTimingFunction })=>({
        root: {
            "--app-shell-transition-duration": `${transitionDuration}ms`,
            "--app-shell-transition-timing-function": transitionTimingFunction
        }
    }));
const AppShell = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("AppShell", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, navbar, withBorder, padding, transitionDuration, transitionTimingFunction, header, zIndex, layout, disabled, aside, footer, offsetScrollbars = true, mode, mod, attributes, id, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "AppShell",
        classes: (0, _appShellModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const resizing = (0, _useResizingMjs.useResizing)({
        disabled,
        transitionDuration
    });
    const _id = (0, _hooks.useId)(id);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _appShellContextMjs.AppShellProvider), {
        value: {
            getStyles,
            withBorder,
            zIndex,
            disabled,
            offsetScrollbars,
            mode
        },
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _appShellMediaStylesMjs.AppShellMediaStyles), {
                navbar,
                header,
                aside,
                footer,
                padding,
                mode,
                selector: mode === "static" ? `#${_id}` : void 0
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                ref,
                ...getStyles("root"),
                mod: [
                    {
                        resizing,
                        layout,
                        disabled,
                        mode
                    },
                    mod
                ],
                id: _id,
                ...others
            })
        ]
    });
});
AppShell.classes = (0, _appShellModuleCssMjsDefault.default);
AppShell.displayName = "@mantine/core/AppShell";
AppShell.Navbar = (0, _appShellNavbarMjs.AppShellNavbar);
AppShell.Header = (0, _appShellHeaderMjs.AppShellHeader);
AppShell.Main = (0, _appShellMainMjs.AppShellMain);
AppShell.Aside = (0, _appShellAsideMjs.AppShellAside);
AppShell.Footer = (0, _appShellFooterMjs.AppShellFooter);
AppShell.Section = (0, _appShellSectionMjs.AppShellSection);

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"H2nB9","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-default-z-index/get-default-z-index.mjs":"4YtNJ","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./AppShell.context.mjs":"8baFu","./AppShell.module.css.mjs":"1K92e","./AppShellAside/AppShellAside.mjs":"dIkxY","./AppShellFooter/AppShellFooter.mjs":"cmBHo","./AppShellHeader/AppShellHeader.mjs":"lFP1Y","./AppShellMain/AppShellMain.mjs":"6rHJe","./AppShellMediaStyles/AppShellMediaStyles.mjs":"2HsWJ","./AppShellNavbar/AppShellNavbar.mjs":"dh1RA","./AppShellSection/AppShellSection.mjs":"hNEk3","./use-resizing/use-resizing.mjs":"h0aV8","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4YtNJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultZIndex", ()=>getDefaultZIndex);
'use client';
const elevations = {
    app: 100,
    modal: 200,
    popover: 300,
    overlay: 400,
    max: 9999
};
function getDefaultZIndex(level) {
    return elevations[level];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8baFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellProvider", ()=>AppShellProvider);
parcelHelpers.export(exports, "useAppShellContext", ()=>useAppShellContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [AppShellProvider, useAppShellContext] = (0, _createSafeContextMjs.createSafeContext)("AppShell was not found in tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lbm6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSafeContext", ()=>createSafeContext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
function createSafeContext(errorMessage) {
    const Context = (0, _react.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0, _react.useContext)(Context);
        if (ctx === null) throw new Error(errorMessage);
        return ctx;
    };
    const Provider = ({ children, value })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    return [
        Provider,
        useSafeContext
    ];
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1K92e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_89ab340",
    "navbar": "m_45252eee",
    "aside": "m_9cdde9a",
    "header": "m_3b16f56b",
    "main": "m_8983817",
    "footer": "m_3840c879",
    "section": "m_6dcfc7c7"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dIkxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellAside", ()=>AppShellAside);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactRemoveScroll = require("react-remove-scroll");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellAside = (0, _factoryMjs.factory)((_props, ref)=>{
    const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = (0, _usePropsMjs.useProps)("AppShellAside", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "aside",
        ref,
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("aside", {
            className: (0, _clsxDefault.default)({
                [(0, _reactRemoveScroll.RemoveScroll).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames,
            styles,
            style
        }),
        ...others,
        __vars: {
            "--app-shell-aside-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)`
        }
    });
});
AppShellAside.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellAside.displayName = "@mantine/core/AppShellAside";

},{"react/jsx-runtime":"1xKTF","clsx":"9idv4","react-remove-scroll":[["RemoveScroll","dBeBD","default"]],"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dBeBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var _ui = require("./UI");
var _sidecar = require("./sidecar");
var _sidecarDefault = parcelHelpers.interopDefault(_sidecar);
var ReactRemoveScroll = _react.forwardRef(function(props, ref) {
    return _react.createElement((0, _ui.RemoveScroll), (0, _tslib.__assign)({}, props, {
        ref: ref,
        sideCar: (0, _sidecarDefault.default)
    }));
});
ReactRemoveScroll.classNames = (0, _ui.RemoveScroll).classNames;
exports.default = ReactRemoveScroll;

},{"tslib":"5508s","react":"erQJb","./UI":"diwDS","./sidecar":"5WqKF","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5508s":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"diwDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScroll", ()=>RemoveScroll);
var _tslib = require("tslib");
var _react = require("react");
var _constants = require("react-remove-scroll-bar/constants");
var _useCallbackRef = require("use-callback-ref");
var _medium = require("./medium");
var nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var RemoveScroll = _react.forwardRef(function(props, parentRef) {
    var ref = _react.useRef(null);
    var _a = _react.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, _tslib.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, _useCallbackRef.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, _tslib.__assign)((0, _tslib.__assign)({}, rest), callbacks);
    return _react.createElement(_react.Fragment, null, enabled && _react.createElement(SideCar, {
        sideCar: (0, _medium.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? _react.cloneElement(_react.Children.only(children), (0, _tslib.__assign)((0, _tslib.__assign)({}, containerProps), {
        ref: containerRef
    })) : _react.createElement(Container, (0, _tslib.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
RemoveScroll.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
RemoveScroll.classNames = {
    fullWidth: (0, _constants.fullWidthClassName),
    zeroRight: (0, _constants.zeroRightClassName)
};

},{"tslib":"5508s","react":"erQJb","react-remove-scroll-bar/constants":"8Do4y","use-callback-ref":"589C4","./medium":"atJ39","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8Do4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroRightClassName", ()=>zeroRightClassName);
parcelHelpers.export(exports, "fullWidthClassName", ()=>fullWidthClassName);
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>noScrollbarsClassName);
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>removedBarSizeVariable);
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
var removedBarSizeVariable = '--removed-body-scroll-bar-size';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"589C4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */ parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
var _react = require("react");
var _assignRef = require("./assignRef");
var _useRef = require("./useRef");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
var currentValues = new WeakMap();
function useMergeRefs(refs, defaultValue) {
    var callbackRef = (0, _useRef.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, _assignRef.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect(function() {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, _assignRef.assignRef)(ref, current_1);
            });
        }
        currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

},{"react":"erQJb","./assignRef":"1QqJO","./useRef":"4sSf4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1QqJO":[function(require,module,exports,__globalThis) {
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignRef", ()=>assignRef);
function assignRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4sSf4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */ parcelHelpers.export(exports, "useCallbackRef", ()=>useCallbackRef);
var _react = require("react");
function useCallbackRef(initialValue, callback) {
    var ref = (0, _react.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"atJ39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "effectCar", ()=>effectCar);
var _useSidecar = require("use-sidecar");
var effectCar = (0, _useSidecar.createSidecarMedium)();

},{"use-sidecar":"277h3","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"277h3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMedium", ()=>createMedium);
// eslint-disable-next-line @typescript-eslint/ban-types
parcelHelpers.export(exports, "createSidecarMedium", ()=>createSidecarMedium);
var _tslib = require("tslib");
function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) middleware = ItoI;
    return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
    if (options === void 0) options = {};
    var medium = innerCreateMedium(null);
    medium.options = (0, _tslib.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

},{"tslib":"5508s","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5WqKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useSidecar = require("use-sidecar");
var _sideEffect = require("./SideEffect");
var _medium = require("./medium");
exports.default = (0, _useSidecar.exportSidecar)((0, _medium.effectCar), (0, _sideEffect.RemoveScrollSideCar));

},{"use-sidecar":"5ObH6","./SideEffect":"3q3rA","./medium":"atJ39","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5ObH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportSidecar", ()=>exportSidecar);
var _tslib = require("tslib");
var _react = require("react");
var SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, _tslib.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return _react.createElement(Target, (0, _tslib.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
    medium.useMedium(exported);
    return SideCar;
}

},{"tslib":"5508s","react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3q3rA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchXY", ()=>getTouchXY);
parcelHelpers.export(exports, "getDeltaXY", ()=>getDeltaXY);
parcelHelpers.export(exports, "RemoveScrollSideCar", ()=>RemoveScrollSideCar);
var _tslib = require("tslib");
var _react = require("react");
var _reactRemoveScrollBar = require("react-remove-scroll-bar");
var _reactStyleSingleton = require("react-style-singleton");
var _aggresiveCapture = require("./aggresiveCapture");
var _handleScroll = require("./handleScroll");
var getTouchXY = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var getDeltaXY = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
    var shouldPreventQueue = _react.useRef([]);
    var touchStartRef = _react.useRef([
        0,
        0
    ]);
    var activeAxis = _react.useRef();
    var id = _react.useState(idCounter++)[0];
    var Style = _react.useState((0, _reactStyleSingleton.styleSingleton))[0];
    var lastProps = _react.useRef(props);
    _react.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    _react.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, _tslib.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map(extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = _react.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = getTouchXY(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, _handleScroll.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, _handleScroll.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = _react.useCallback(function(_event) {
        var event = _event;
        if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = _react.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = _react.useCallback(function(event) {
        touchStartRef.current = getTouchXY(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = _react.useCallback(function(event) {
        shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = _react.useCallback(function(event) {
        shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    _react.useEffect(function() {
        lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        return function() {
            lockStack = lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, _aggresiveCapture.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, _aggresiveCapture.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return _react.createElement(_react.Fragment, null, inert ? _react.createElement(Style, {
        styles: generateStyle(id)
    }) : null, removeScrollBar ? _react.createElement((0, _reactRemoveScrollBar.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

},{"tslib":"5508s","react":"erQJb","react-remove-scroll-bar":"hDj40","react-style-singleton":"dxte1","./aggresiveCapture":"2bOW8","./handleScroll":"dUi7w","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hDj40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>(0, _component.RemoveScrollBar));
parcelHelpers.export(exports, "zeroRightClassName", ()=>(0, _constants.zeroRightClassName));
parcelHelpers.export(exports, "fullWidthClassName", ()=>(0, _constants.fullWidthClassName));
parcelHelpers.export(exports, "noScrollbarsClassName", ()=>(0, _constants.noScrollbarsClassName));
parcelHelpers.export(exports, "removedBarSizeVariable", ()=>(0, _constants.removedBarSizeVariable));
parcelHelpers.export(exports, "getGapWidth", ()=>(0, _utils.getGapWidth));
var _component = require("./component");
var _constants = require("./constants");
var _utils = require("./utils");

},{"./component":"kF7lA","./constants":"8Do4y","./utils":"5HCRY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kF7lA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lockAttribute", ()=>lockAttribute);
parcelHelpers.export(exports, "useLockAttribute", ()=>useLockAttribute);
parcelHelpers.export(exports, "RemoveScrollBar", ()=>RemoveScrollBar);
var _react = require("react");
var _reactStyleSingleton = require("react-style-singleton");
var _constants = require("./constants");
var _utils = require("./utils");
var Style = (0, _reactStyleSingleton.styleSingleton)();
var lockAttribute = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, _constants.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.zeroRightClassName), " .").concat((0, _constants.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, _constants.fullWidthClassName), " .").concat((0, _constants.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat((0, _constants.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
    _react.useEffect(function() {
        document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute(lockAttribute);
            else document.body.setAttribute(lockAttribute, newCounter.toString());
        };
    }, []);
};
var RemoveScrollBar = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    useLockAttribute();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = _react.useMemo(function() {
        return (0, _utils.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return _react.createElement(Style, {
        styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

},{"react":"erQJb","react-style-singleton":"dxte1","./constants":"8Do4y","./utils":"5HCRY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dxte1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>(0, _component.styleSingleton));
parcelHelpers.export(exports, "stylesheetSingleton", ()=>(0, _singleton.stylesheetSingleton));
parcelHelpers.export(exports, "styleHookSingleton", ()=>(0, _hook.styleHookSingleton));
var _component = require("./component");
var _singleton = require("./singleton");
var _hook = require("./hook");

},{"./component":"aMh4I","./singleton":"6Muwh","./hook":"OeOTD","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aMh4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleSingleton", ()=>styleSingleton);
var _hook = require("./hook");
var styleSingleton = function() {
    var useStyle = (0, _hook.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

},{"./hook":"OeOTD","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"OeOTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styleHookSingleton", ()=>styleHookSingleton);
var _react = require("react");
var _singleton = require("./singleton");
var styleHookSingleton = function() {
    var sheet = (0, _singleton.stylesheetSingleton)();
    return function(styles, isDynamic) {
        _react.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

},{"react":"erQJb","./singleton":"6Muwh","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6Muwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stylesheetSingleton", ()=>stylesheetSingleton);
var _getNonce = require("get-nonce");
function makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, _getNonce.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var stylesheetSingleton = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = makeStyleTag()) {
                    injectStyles(stylesheet, style);
                    insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

},{"get-nonce":"kGZAI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kGZAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setNonce", ()=>setNonce);
parcelHelpers.export(exports, "getNonce", ()=>getNonce);
var currentNonce;
var setNonce = function(nonce) {
    currentNonce = nonce;
};
var getNonce = function() {
    if (currentNonce) return currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5HCRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zeroGap", ()=>zeroGap);
parcelHelpers.export(exports, "getGapWidth", ()=>getGapWidth);
var zeroGap = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        parse(left),
        parse(top),
        parse(right)
    ];
};
var getGapWidth = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return zeroGap;
    var offsets = getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2bOW8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonPassive", ()=>nonPassive);
var passiveSupported = false;
if (typeof window !== 'undefined') try {
    var options = Object.defineProperty({}, 'passive', {
        get: function() {
            passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', options, options);
    // @ts-ignore
    window.removeEventListener('test', options, options);
} catch (err) {
    passiveSupported = false;
}
var nonPassive = passiveSupported ? {
    passive: false
} : false;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dUi7w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "locationCouldBeScrolled", ()=>locationCouldBeScrolled);
parcelHelpers.export(exports, "handleScroll", ()=>handleScroll);
var alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var elementCouldBeVScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function(node) {
    return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
    return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if (elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cmBHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellFooter", ()=>AppShellFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactRemoveScroll = require("react-remove-scroll");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellFooter = (0, _factoryMjs.factory)((_props, ref)=>{
    const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = (0, _usePropsMjs.useProps)("AppShellFooter", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "footer",
        ref,
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("footer", {
            className: (0, _clsxDefault.default)({
                [(0, _reactRemoveScroll.RemoveScroll).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames,
            styles,
            style
        }),
        ...others,
        __vars: {
            "--app-shell-footer-z-index": (zIndex ?? ctx.zIndex)?.toString()
        }
    });
});
AppShellFooter.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellFooter.displayName = "@mantine/core/AppShellFooter";

},{"react/jsx-runtime":"1xKTF","clsx":"9idv4","react-remove-scroll":[["RemoveScroll","dBeBD","default"]],"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lFP1Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellHeader", ()=>AppShellHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactRemoveScroll = require("react-remove-scroll");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellHeader = (0, _factoryMjs.factory)((_props, ref)=>{
    const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = (0, _usePropsMjs.useProps)("AppShellHeader", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "header",
        ref,
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("header", {
            className: (0, _clsxDefault.default)({
                [(0, _reactRemoveScroll.RemoveScroll).classNames.zeroRight]: ctx.offsetScrollbars
            }, className),
            classNames,
            styles,
            style
        }),
        ...others,
        __vars: {
            "--app-shell-header-z-index": (zIndex ?? ctx.zIndex)?.toString()
        }
    });
});
AppShellHeader.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellHeader.displayName = "@mantine/core/AppShellHeader";

},{"react/jsx-runtime":"1xKTF","clsx":"9idv4","react-remove-scroll":[["RemoveScroll","dBeBD","default"]],"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6rHJe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellMain", ()=>AppShellMain);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellMain = (0, _factoryMjs.factory)((_props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("AppShellMain", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "main",
        ref,
        ...ctx.getStyles("main", {
            className,
            style,
            classNames,
            styles
        }),
        ...others
    });
});
AppShellMain.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellMain.displayName = "@mantine/core/AppShellMain";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2HsWJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellMediaStyles", ()=>AppShellMediaStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _inlineStylesMjs = require("../../../core/InlineStyles/InlineStyles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _getVariablesMjs = require("./get-variables/get-variables.mjs");
'use client';
function AppShellMediaStyles({ navbar, header, aside, footer, padding, mode, selector }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const ctx = (0, _mantineContextMjs.useMantineContext)();
    const { media, baseStyles } = (0, _getVariablesMjs.getVariables)({
        navbar,
        header,
        footer,
        aside,
        padding,
        theme,
        mode
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inlineStylesMjs.InlineStyles), {
        media,
        styles: baseStyles,
        selector: selector || ctx.cssVariablesSelector
    });
}

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/InlineStyles/InlineStyles.mjs":"j6wgm","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./get-variables/get-variables.mjs":"m8oc4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"m8oc4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariables", ()=>getVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _getSortedBreakpointsMjs = require("../../../../core/utils/get-sorted-breakpoints/get-sorted-breakpoints.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _assignAsideVariablesMjs = require("../assign-aside-variables/assign-aside-variables.mjs");
var _assignFooterVariablesMjs = require("../assign-footer-variables/assign-footer-variables.mjs");
var _assignHeaderVariablesMjs = require("../assign-header-variables/assign-header-variables.mjs");
var _assignNavbarVariablesMjs = require("../assign-navbar-variables/assign-navbar-variables.mjs");
var _assignPaddingVariablesMjs = require("../assign-padding-variables/assign-padding-variables.mjs");
'use client';
function getVariables({ navbar, header, footer, aside, padding, theme, mode }) {
    const minMediaStyles = {};
    const maxMediaStyles = {};
    const baseStyles = {};
    if (mode === "static") {
        baseStyles["--app-shell-main-grid-column"] = "1 / -1";
        baseStyles["--app-shell-main-grid-row"] = "2";
    }
    (0, _assignNavbarVariablesMjs.assignNavbarVariables)({
        baseStyles,
        minMediaStyles,
        maxMediaStyles,
        navbar,
        theme,
        mode
    });
    (0, _assignAsideVariablesMjs.assignAsideVariables)({
        baseStyles,
        minMediaStyles,
        maxMediaStyles,
        aside,
        theme,
        mode
    });
    (0, _assignHeaderVariablesMjs.assignHeaderVariables)({
        baseStyles,
        minMediaStyles,
        header,
        mode
    });
    (0, _assignFooterVariablesMjs.assignFooterVariables)({
        baseStyles,
        minMediaStyles,
        footer,
        mode
    });
    (0, _assignPaddingVariablesMjs.assignPaddingVariables)({
        baseStyles,
        minMediaStyles,
        padding
    });
    const minMedia = (0, _getSortedBreakpointsMjs.getSortedBreakpoints)((0, _keysMjs.keys)(minMediaStyles), theme.breakpoints).map((breakpoint)=>({
            query: `(min-width: ${(0, _remMjs.em)(breakpoint.px)})`,
            styles: minMediaStyles[breakpoint.value]
        }));
    const maxMedia = (0, _getSortedBreakpointsMjs.getSortedBreakpoints)((0, _keysMjs.keys)(maxMediaStyles), theme.breakpoints).map((breakpoint)=>({
            query: `(max-width: ${(0, _remMjs.em)(breakpoint.px)})`,
            styles: maxMediaStyles[breakpoint.value]
        }));
    const media = [
        ...minMedia,
        ...maxMedia
    ];
    return {
        baseStyles,
        media
    };
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../../core/utils/get-sorted-breakpoints/get-sorted-breakpoints.mjs":"5Vjuf","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../assign-aside-variables/assign-aside-variables.mjs":"5ZiyX","../assign-footer-variables/assign-footer-variables.mjs":"7UhVX","../assign-header-variables/assign-header-variables.mjs":"fJJUZ","../assign-navbar-variables/assign-navbar-variables.mjs":"c5ieJ","../assign-padding-variables/assign-padding-variables.mjs":"eWLd9","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5Vjuf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSortedBreakpoints", ()=>getSortedBreakpoints);
var _getBreakpointValueMjs = require("../get-breakpoint-value/get-breakpoint-value.mjs");
'use client';
function getSortedBreakpoints(values, breakpoints) {
    const convertedBreakpoints = values.map((breakpoint)=>({
            value: breakpoint,
            px: (0, _getBreakpointValueMjs.getBreakpointValue)(breakpoint, breakpoints)
        }));
    convertedBreakpoints.sort((a, b)=>a.px - b.px);
    return convertedBreakpoints;
}

},{"../get-breakpoint-value/get-breakpoint-value.mjs":"g64io","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"g64io":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreakpointValue", ()=>getBreakpointValue);
var _pxMjs = require("../units-converters/px.mjs");
var _remMjs = require("../units-converters/rem.mjs");
'use client';
function getBreakpointValue(breakpoint, breakpoints) {
    if (breakpoint in breakpoints) return (0, _pxMjs.px)(breakpoints[breakpoint]);
    return (0, _pxMjs.px)(breakpoint);
}

},{"../units-converters/px.mjs":"kdby7","../units-converters/rem.mjs":"c70Xm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5ZiyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignAsideVariables", ()=>assignAsideVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _getBreakpointValueMjs = require("../../../../core/utils/get-breakpoint-value/get-breakpoint-value.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _getBaseSizeMjs = require("../get-base-size/get-base-size.mjs");
var _isPrimitiveSizeMjs = require("../is-primitive-size/is-primitive-size.mjs");
var _isResponsiveSizeMjs = require("../is-responsive-size/is-responsive-size.mjs");
'use client';
function assignAsideVariables({ baseStyles, minMediaStyles, maxMediaStyles, aside, theme, mode }) {
    const asideWidth = aside?.width;
    const collapsedAsideTransform = "translateX(var(--app-shell-aside-width))";
    const collapsedAsideTransformRtl = "translateX(calc(var(--app-shell-aside-width) * -1))";
    if (aside?.breakpoint && !aside?.collapsed?.mobile) {
        maxMediaStyles[aside?.breakpoint] = maxMediaStyles[aside?.breakpoint] || {};
        if (mode === "fixed") {
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-width"] = "100%";
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-offset"] = "0px";
        } else {
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-width"] = "0px";
            maxMediaStyles[aside?.breakpoint]["--app-shell-aside-offset"] = "0px";
        }
    }
    if ((0, _isPrimitiveSizeMjs.isPrimitiveSize)(asideWidth)) {
        const baseSize = (0, _remMjs.rem)((0, _getBaseSizeMjs.getBaseSize)(asideWidth));
        baseStyles["--app-shell-aside-width"] = baseSize;
        baseStyles["--app-shell-aside-offset"] = baseSize;
    }
    if ((0, _isResponsiveSizeMjs.isResponsiveSize)(asideWidth)) {
        if (typeof asideWidth.base !== "undefined") {
            baseStyles["--app-shell-aside-width"] = (0, _remMjs.rem)(asideWidth.base);
            baseStyles["--app-shell-aside-offset"] = (0, _remMjs.rem)(asideWidth.base);
        }
        (0, _keysMjs.keys)(asideWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-aside-width"] = (0, _remMjs.rem)(asideWidth[key]);
                minMediaStyles[key]["--app-shell-aside-offset"] = (0, _remMjs.rem)(asideWidth[key]);
            }
        });
    }
    if (aside?.breakpoint && mode === "static") {
        minMediaStyles[aside.breakpoint] = minMediaStyles[aside.breakpoint] || {};
        minMediaStyles[aside.breakpoint]["--app-shell-aside-position"] = "sticky";
        minMediaStyles[aside.breakpoint]["--app-shell-aside-grid-row"] = "2";
        minMediaStyles[aside.breakpoint]["--app-shell-aside-grid-column"] = "3";
        minMediaStyles[aside.breakpoint]["--app-shell-main-column-end"] = "3";
    }
    if (aside?.collapsed?.desktop) {
        const breakpointValue = aside.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        minMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        if (mode === "fixed") minMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px !important";
        else {
            minMediaStyles[breakpointValue]["--app-shell-aside-width"] = "0px";
            minMediaStyles[breakpointValue]["--app-shell-aside-display"] = "none";
            minMediaStyles[breakpointValue]["--app-shell-main-column-end"] = "-1";
        }
        minMediaStyles[breakpointValue]["--app-shell-aside-scroll-locked-visibility"] = "hidden";
    }
    if (aside?.collapsed?.mobile) {
        const breakpointValue = (0, _getBreakpointValueMjs.getBreakpointValue)(aside.breakpoint, theme.breakpoints) - 0.1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        if (mode === "fixed") {
            maxMediaStyles[breakpointValue]["--app-shell-aside-width"] = "100%";
            maxMediaStyles[breakpointValue]["--app-shell-aside-offset"] = "0px";
        } else maxMediaStyles[breakpointValue]["--app-shell-aside-width"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform"] = collapsedAsideTransform;
        maxMediaStyles[breakpointValue]["--app-shell-aside-transform-rtl"] = collapsedAsideTransformRtl;
        maxMediaStyles[breakpointValue]["--app-shell-aside-scroll-locked-visibility"] = "hidden";
    }
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../../core/utils/get-breakpoint-value/get-breakpoint-value.mjs":"g64io","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../get-base-size/get-base-size.mjs":"h3qwK","../is-primitive-size/is-primitive-size.mjs":"4Sb0x","../is-responsive-size/is-responsive-size.mjs":"hGbqX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"h3qwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBaseSize", ()=>getBaseSize);
'use client';
function getBaseSize(size) {
    if (typeof size === "object") return size.base;
    return size;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4Sb0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPrimitiveSize", ()=>isPrimitiveSize);
'use client';
function isPrimitiveSize(size) {
    const isBaseSize = typeof size === "object" && size !== null && typeof size.base !== "undefined" && Object.keys(size).length === 1;
    return typeof size === "number" || typeof size === "string" || isBaseSize;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hGbqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isResponsiveSize", ()=>isResponsiveSize);
'use client';
function isResponsiveSize(size) {
    if (typeof size !== "object" || size === null) return false;
    if (Object.keys(size).length === 1 && "base" in size) return false;
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7UhVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignFooterVariables", ()=>assignFooterVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _getBaseSizeMjs = require("../get-base-size/get-base-size.mjs");
var _isPrimitiveSizeMjs = require("../is-primitive-size/is-primitive-size.mjs");
var _isResponsiveSizeMjs = require("../is-responsive-size/is-responsive-size.mjs");
'use client';
function assignFooterVariables({ baseStyles, minMediaStyles, footer, mode }) {
    const footerHeight = footer?.height;
    const collapsedFooterTransform = "translateY(var(--app-shell-footer-height))";
    const shouldOffset = mode === "static" ? true : footer?.offset ?? true;
    if (mode === "static" && footer) {
        baseStyles["--app-shell-footer-position"] = "sticky";
        baseStyles["--app-shell-footer-grid-column"] = "1 / -1";
        baseStyles["--app-shell-footer-grid-row"] = "3";
    }
    if ((0, _isPrimitiveSizeMjs.isPrimitiveSize)(footerHeight)) {
        const baseSize = (0, _remMjs.rem)((0, _getBaseSizeMjs.getBaseSize)(footerHeight));
        baseStyles["--app-shell-footer-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-footer-offset"] = baseSize;
    }
    if ((0, _isResponsiveSizeMjs.isResponsiveSize)(footerHeight)) {
        if (typeof footerHeight.base !== "undefined") {
            baseStyles["--app-shell-footer-height"] = (0, _remMjs.rem)(footerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-footer-offset"] = (0, _remMjs.rem)(footerHeight.base);
        }
        (0, _keysMjs.keys)(footerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-footer-height"] = (0, _remMjs.rem)(footerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-footer-offset"] = (0, _remMjs.rem)(footerHeight[key]);
            }
        });
    }
    if (footer?.collapsed) {
        baseStyles["--app-shell-footer-transform"] = collapsedFooterTransform;
        if (mode === "fixed") baseStyles["--app-shell-footer-offset"] = "0px !important";
    }
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../get-base-size/get-base-size.mjs":"h3qwK","../is-primitive-size/is-primitive-size.mjs":"4Sb0x","../is-responsive-size/is-responsive-size.mjs":"hGbqX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fJJUZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignHeaderVariables", ()=>assignHeaderVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _getBaseSizeMjs = require("../get-base-size/get-base-size.mjs");
var _isPrimitiveSizeMjs = require("../is-primitive-size/is-primitive-size.mjs");
var _isResponsiveSizeMjs = require("../is-responsive-size/is-responsive-size.mjs");
'use client';
function assignHeaderVariables({ baseStyles, minMediaStyles, header, mode }) {
    const headerHeight = header?.height;
    const collapsedHeaderTransform = "translateY(calc(var(--app-shell-header-height) * -1))";
    const shouldOffset = mode === "static" ? true : header?.offset ?? true;
    if (mode === "static" && header) {
        baseStyles["--app-shell-header-position"] = "sticky";
        baseStyles["--app-shell-header-grid-column"] = "1 / -1";
        baseStyles["--app-shell-header-grid-row"] = "1";
    }
    if ((0, _isPrimitiveSizeMjs.isPrimitiveSize)(headerHeight)) {
        const baseSize = (0, _remMjs.rem)((0, _getBaseSizeMjs.getBaseSize)(headerHeight));
        baseStyles["--app-shell-header-height"] = baseSize;
        if (shouldOffset) baseStyles["--app-shell-header-offset"] = baseSize;
    }
    if ((0, _isResponsiveSizeMjs.isResponsiveSize)(headerHeight)) {
        if (typeof headerHeight.base !== "undefined") {
            baseStyles["--app-shell-header-height"] = (0, _remMjs.rem)(headerHeight.base);
            if (shouldOffset) baseStyles["--app-shell-header-offset"] = (0, _remMjs.rem)(headerHeight.base);
        }
        (0, _keysMjs.keys)(headerHeight).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-header-height"] = (0, _remMjs.rem)(headerHeight[key]);
                if (shouldOffset) minMediaStyles[key]["--app-shell-header-offset"] = (0, _remMjs.rem)(headerHeight[key]);
            }
        });
    }
    if (header?.collapsed) {
        baseStyles["--app-shell-header-transform"] = collapsedHeaderTransform;
        if (mode === "fixed") baseStyles["--app-shell-header-offset"] = "0px !important";
    }
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../get-base-size/get-base-size.mjs":"h3qwK","../is-primitive-size/is-primitive-size.mjs":"4Sb0x","../is-responsive-size/is-responsive-size.mjs":"hGbqX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c5ieJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignNavbarVariables", ()=>assignNavbarVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _getBreakpointValueMjs = require("../../../../core/utils/get-breakpoint-value/get-breakpoint-value.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _getBaseSizeMjs = require("../get-base-size/get-base-size.mjs");
var _isPrimitiveSizeMjs = require("../is-primitive-size/is-primitive-size.mjs");
var _isResponsiveSizeMjs = require("../is-responsive-size/is-responsive-size.mjs");
'use client';
function assignNavbarVariables({ baseStyles, minMediaStyles, maxMediaStyles, navbar, theme, mode }) {
    const navbarWidth = navbar?.width;
    const collapsedNavbarTransform = "translateX(calc(var(--app-shell-navbar-width) * -1))";
    const collapsedNavbarTransformRtl = "translateX(var(--app-shell-navbar-width))";
    if (navbar?.breakpoint && !navbar?.collapsed?.mobile) {
        maxMediaStyles[navbar?.breakpoint] = maxMediaStyles[navbar?.breakpoint] || {};
        maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-offset"] = "0px";
        maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-width"] = "100%";
        if (mode === "static") maxMediaStyles[navbar?.breakpoint]["--app-shell-navbar-grid-width"] = "0px";
    }
    if ((0, _isPrimitiveSizeMjs.isPrimitiveSize)(navbarWidth)) {
        const baseSize = (0, _remMjs.rem)((0, _getBaseSizeMjs.getBaseSize)(navbarWidth));
        baseStyles["--app-shell-navbar-width"] = baseSize;
        baseStyles["--app-shell-navbar-offset"] = baseSize;
        if (mode === "static") baseStyles["--app-shell-navbar-grid-width"] = baseSize;
    }
    if ((0, _isResponsiveSizeMjs.isResponsiveSize)(navbarWidth)) {
        if (typeof navbarWidth.base !== "undefined") {
            baseStyles["--app-shell-navbar-width"] = (0, _remMjs.rem)(navbarWidth.base);
            baseStyles["--app-shell-navbar-offset"] = (0, _remMjs.rem)(navbarWidth.base);
            if (mode === "static") baseStyles["--app-shell-navbar-grid-width"] = (0, _remMjs.rem)(navbarWidth.base);
        }
        (0, _keysMjs.keys)(navbarWidth).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-navbar-width"] = (0, _remMjs.rem)(navbarWidth[key]);
                minMediaStyles[key]["--app-shell-navbar-offset"] = (0, _remMjs.rem)(navbarWidth[key]);
                if (mode === "static") minMediaStyles[key]["--app-shell-navbar-grid-width"] = (0, _remMjs.rem)(navbarWidth[key]);
            }
        });
    }
    if (navbar?.breakpoint && mode === "static") {
        minMediaStyles[navbar.breakpoint] = minMediaStyles[navbar.breakpoint] || {};
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-position"] = "sticky";
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-grid-row"] = "2";
        minMediaStyles[navbar.breakpoint]["--app-shell-navbar-grid-column"] = "1";
        minMediaStyles[navbar.breakpoint]["--app-shell-main-column-start"] = "2";
    }
    if (navbar?.collapsed?.desktop) {
        const breakpointValue = navbar.breakpoint;
        minMediaStyles[breakpointValue] = minMediaStyles[breakpointValue] || {};
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        minMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
        if (mode === "fixed") minMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px !important";
        else {
            minMediaStyles[breakpointValue]["--app-shell-navbar-width"] = "0px";
            minMediaStyles[breakpointValue]["--app-shell-navbar-display"] = "none";
            minMediaStyles[breakpointValue]["--app-shell-main-column-start"] = "1";
        }
    }
    if (navbar?.collapsed?.mobile) {
        const breakpointValue = (0, _getBreakpointValueMjs.getBreakpointValue)(navbar.breakpoint, theme.breakpoints) - 0.1;
        maxMediaStyles[breakpointValue] = maxMediaStyles[breakpointValue] || {};
        maxMediaStyles[breakpointValue]["--app-shell-navbar-width"] = "100%";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-offset"] = "0px";
        if (mode === "static") maxMediaStyles[breakpointValue]["--app-shell-navbar-grid-width"] = "0px";
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform"] = collapsedNavbarTransform;
        maxMediaStyles[breakpointValue]["--app-shell-navbar-transform-rtl"] = collapsedNavbarTransformRtl;
    }
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../../core/utils/get-breakpoint-value/get-breakpoint-value.mjs":"g64io","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../get-base-size/get-base-size.mjs":"h3qwK","../is-primitive-size/is-primitive-size.mjs":"4Sb0x","../is-responsive-size/is-responsive-size.mjs":"hGbqX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eWLd9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignPaddingVariables", ()=>assignPaddingVariables);
var _keysMjs = require("../../../../core/utils/keys/keys.mjs");
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
var _getBaseSizeMjs = require("../get-base-size/get-base-size.mjs");
var _getPaddingValueMjs = require("../get-padding-value/get-padding-value.mjs");
var _isPrimitiveSizeMjs = require("../is-primitive-size/is-primitive-size.mjs");
var _isResponsiveSizeMjs = require("../is-responsive-size/is-responsive-size.mjs");
'use client';
function assignPaddingVariables({ padding, baseStyles, minMediaStyles }) {
    if ((0, _isPrimitiveSizeMjs.isPrimitiveSize)(padding)) baseStyles["--app-shell-padding"] = (0, _getPaddingValueMjs.getPaddingValue)((0, _getBaseSizeMjs.getBaseSize)(padding));
    if ((0, _isResponsiveSizeMjs.isResponsiveSize)(padding)) {
        if (padding.base) baseStyles["--app-shell-padding"] = (0, _getPaddingValueMjs.getPaddingValue)(padding.base);
        (0, _keysMjs.keys)(padding).forEach((key)=>{
            if (key !== "base") {
                minMediaStyles[key] = minMediaStyles[key] || {};
                minMediaStyles[key]["--app-shell-padding"] = (0, _getPaddingValueMjs.getPaddingValue)(padding[key]);
            }
        });
    }
}

},{"../../../../core/utils/keys/keys.mjs":"7biZA","../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../get-base-size/get-base-size.mjs":"h3qwK","../get-padding-value/get-padding-value.mjs":"fMWJP","../is-primitive-size/is-primitive-size.mjs":"4Sb0x","../is-responsive-size/is-responsive-size.mjs":"hGbqX","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fMWJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaddingValue", ()=>getPaddingValue);
var _remMjs = require("../../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _getSizeMjs = require("../../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function getPaddingValue(padding) {
    return Number(padding) === 0 ? "0px" : (0, _getSizeMjs.getSpacing)(padding);
}

},{"../../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../../core/Box/Box.mjs":"eq62v","../../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dh1RA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellNavbar", ()=>AppShellNavbar);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellNavbar = (0, _factoryMjs.factory)((_props, ref)=>{
    const { classNames, className, style, styles, unstyled, vars, withBorder, zIndex, mod, ...others } = (0, _usePropsMjs.useProps)("AppShellNavbar", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "nav",
        ref,
        mod: [
            {
                "with-border": withBorder ?? ctx.withBorder
            },
            mod
        ],
        ...ctx.getStyles("navbar", {
            className,
            classNames,
            styles,
            style
        }),
        ...others,
        __vars: {
            "--app-shell-navbar-z-index": `calc(${zIndex ?? ctx.zIndex} + 1)`
        }
    });
});
AppShellNavbar.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellNavbar.displayName = "@mantine/core/AppShellNavbar";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hNEk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppShellSection", ()=>AppShellSection);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _appShellContextMjs = require("../AppShell.context.mjs");
var _appShellModuleCssMjs = require("../AppShell.module.css.mjs");
var _appShellModuleCssMjsDefault = parcelHelpers.interopDefault(_appShellModuleCssMjs);
'use client';
const AppShellSection = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const { classNames, className, style, styles, vars, grow, mod, ...others } = (0, _usePropsMjs.useProps)("AppShellSection", null, _props);
    const ctx = (0, _appShellContextMjs.useAppShellContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        mod: [
            {
                grow
            },
            mod
        ],
        ...ctx.getStyles("section", {
            className,
            style,
            classNames,
            styles
        }),
        ...others
    });
});
AppShellSection.classes = (0, _appShellModuleCssMjsDefault.default);
AppShellSection.displayName = "@mantine/core/AppShellSection";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/polymorphic-factory.mjs":"etaNf","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../AppShell.context.mjs":"8baFu","../AppShell.module.css.mjs":"1K92e","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"h0aV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizing", ()=>useResizing);
var _react = require("react");
var _hooks = require("@mantine/hooks");
'use client';
function useResizing({ transitionDuration, disabled }) {
    const [resizing, setResizing] = (0, _react.useState)(true);
    const resizingTimeout = (0, _react.useRef)(-1);
    const disabledTimeout = (0, _react.useRef)(-1);
    (0, _hooks.useWindowEvent)("resize", ()=>{
        setResizing(true);
        clearTimeout(resizingTimeout.current);
        resizingTimeout.current = window.setTimeout(()=>(0, _react.startTransition)(()=>{
                setResizing(false);
            }), 200);
    });
    (0, _hooks.useIsomorphicEffect)(()=>{
        setResizing(true);
        clearTimeout(disabledTimeout.current);
        disabledTimeout.current = window.setTimeout(()=>(0, _react.startTransition)(()=>{
                setResizing(false);
            }), transitionDuration || 0);
    }, [
        disabled,
        transitionDuration
    ]);
    return resizing;
}

},{"react":"erQJb","@mantine/hooks":[["useIsomorphicEffect","6Cmng"],["useWindowEvent","6GqGu"]],"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"erlWx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Burger", ()=>Burger);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _getThemeColorMjs = require("../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonMjs = require("../UnstyledButton/UnstyledButton.mjs");
var _burgerModuleCssMjs = require("./Burger.module.css.mjs");
var _burgerModuleCssMjsDefault = parcelHelpers.interopDefault(_burgerModuleCssMjs);
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { color, size, lineSize, transitionDuration, transitionTimingFunction })=>({
        root: {
            "--burger-color": color ? (0, _getThemeColorMjs.getThemeColor)(color, theme) : void 0,
            "--burger-size": (0, _getSizeMjs.getSize)(size, "burger-size"),
            "--burger-line-size": lineSize ? (0, _remMjs.rem)(lineSize) : void 0,
            "--burger-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--burger-transition-timing-function": transitionTimingFunction
        }
    }));
const Burger = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Burger", null, _props);
    const { classNames, className, style, styles, unstyled, vars, opened, children, transitionDuration, transitionTimingFunction, lineSize, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Burger",
        classes: (0, _burgerModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        ...getStyles("root"),
        ref,
        ...others,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                mod: [
                    "reduce-motion",
                    {
                        opened
                    }
                ],
                ...getStyles("burger")
            }),
            children
        ]
    });
});
Burger.classes = (0, _burgerModuleCssMjsDefault.default);
Burger.displayName = "@mantine/core/Burger";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../UnstyledButton/UnstyledButton.mjs":"55gpk","./Burger.module.css.mjs":"4KHOI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4KHOI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_fea6bf1a",
    "burger": "m_d4fb9cad"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cxrP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Group", ()=>Group);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _filterFalsyChildrenMjs = require("./filter-falsy-children/filter-falsy-children.mjs");
var _groupModuleCssMjs = require("./Group.module.css.mjs");
var _groupModuleCssMjsDefault = parcelHelpers.interopDefault(_groupModuleCssMjs);
'use client';
const defaultProps = {
    preventGrowOverflow: true,
    gap: "md",
    align: "center",
    justify: "flex-start",
    wrap: "wrap"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { grow, preventGrowOverflow, gap, align, justify, wrap }, { childWidth })=>({
        root: {
            "--group-child-width": grow && preventGrowOverflow ? childWidth : void 0,
            "--group-gap": (0, _getSizeMjs.getSpacing)(gap),
            "--group-align": align,
            "--group-justify": justify,
            "--group-wrap": wrap
        }
    }));
const Group = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Group", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, children, gap, align, justify, wrap, grow, preventGrowOverflow, vars, variant, __size, mod, attributes, ...others } = props;
    const filteredChildren = (0, _filterFalsyChildrenMjs.filterFalsyChildren)(children);
    const childrenCount = filteredChildren.length;
    const resolvedGap = (0, _getSizeMjs.getSpacing)(gap ?? "md");
    const childWidth = `calc(${100 / childrenCount}% - (${resolvedGap} - ${resolvedGap} / ${childrenCount}))`;
    const stylesCtx = {
        childWidth
    };
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Group",
        props,
        stylesCtx,
        className,
        style,
        classes: (0, _groupModuleCssMjsDefault.default),
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root"),
        ref,
        variant,
        mod: [
            {
                grow
            },
            mod
        ],
        size: __size,
        ...others,
        children: filteredChildren
    });
});
Group.classes = (0, _groupModuleCssMjsDefault.default);
Group.displayName = "@mantine/core/Group";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./filter-falsy-children/filter-falsy-children.mjs":"c40W9","./Group.module.css.mjs":"fqpQo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c40W9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterFalsyChildren", ()=>filterFalsyChildren);
var _react = require("react");
'use client';
function filterFalsyChildren(children) {
    return (0, _react.Children).toArray(children).filter(Boolean);
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fqpQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_4081bf90"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cPRhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _getContextItemIndexMjs = require("../../core/utils/get-context-item-index/get-context-item-index.mjs");
var _clsx = require("clsx");
var _useResolvedStylesApiMjs = require("../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _floatingArrowMjs = require("../../utils/Floating/FloatingArrow/FloatingArrow.mjs");
var _useDelayedHoverMjs = require("../../utils/Floating/use-delayed-hover.mjs");
var _popoverMjs = require("../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuContextMjs = require("./Menu.context.mjs");
var _menuModuleCssMjs = require("./Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
var _menuDividerMjs = require("./MenuDivider/MenuDivider.mjs");
var _menuDropdownMjs = require("./MenuDropdown/MenuDropdown.mjs");
var _menuItemMjs = require("./MenuItem/MenuItem.mjs");
var _menuLabelMjs = require("./MenuLabel/MenuLabel.mjs");
var _menuSubMjs = require("./MenuSub/MenuSub.mjs");
var _menuTargetMjs = require("./MenuTarget/MenuTarget.mjs");
'use client';
const defaultProps = {
    trapFocus: true,
    closeOnItemClick: true,
    withInitialFocusPlaceholder: true,
    clickOutsideEvents: [
        "mousedown",
        "touchstart",
        "keydown"
    ],
    loop: true,
    trigger: "click",
    openDelay: 0,
    closeDelay: 100,
    menuItemTabIndex: -1
};
function Menu(_props) {
    const props = (0, _usePropsMjs.useProps)("Menu", defaultProps, _props);
    const { children, onOpen, onClose, opened, defaultOpened, trapFocus, onChange, closeOnItemClick, loop, closeOnEscape, trigger, openDelay, closeDelay, classNames, styles, unstyled, variant, vars, menuItemTabIndex, keepMounted, withInitialFocusPlaceholder, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Menu",
        classes: (0, _menuModuleCssMjsDefault.default),
        props,
        classNames,
        styles,
        unstyled,
        attributes
    });
    const [_opened, setOpened] = (0, _hooks.useUncontrolled)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange
    });
    const [openedViaClick, setOpenedViaClick] = (0, _react.useState)(false);
    const close = ()=>{
        setOpened(false);
        setOpenedViaClick(false);
        _opened && onClose?.();
    };
    const open = ()=>{
        setOpened(true);
        !_opened && onOpen?.();
    };
    const toggleDropdown = ()=>{
        _opened ? close() : open();
    };
    const { openDropdown, closeDropdown } = (0, _useDelayedHoverMjs.useDelayedHover)({
        open,
        close,
        closeDelay,
        openDelay
    });
    const getItemIndex = (node)=>(0, _getContextItemIndexMjs.getContextItemIndex)("[data-menu-item]", "[data-menu-dropdown]", node);
    const { resolvedClassNames, resolvedStyles } = (0, _useResolvedStylesApiMjs.useResolvedStylesApi)({
        classNames,
        styles,
        props
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _menuContextMjs.MenuContextProvider), {
        value: {
            getStyles,
            opened: _opened,
            toggleDropdown,
            getItemIndex,
            openedViaClick,
            setOpenedViaClick,
            closeOnItemClick,
            closeDropdown: trigger === "click" ? close : closeDropdown,
            openDropdown: trigger === "click" ? open : openDropdown,
            closeDropdownImmediately: close,
            loop,
            trigger,
            unstyled,
            menuItemTabIndex,
            withInitialFocusPlaceholder
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover), {
            returnFocus: true,
            ...others,
            opened: _opened,
            onChange: toggleDropdown,
            defaultOpened,
            trapFocus: keepMounted ? false : trapFocus,
            closeOnEscape,
            __staticSelector: "Menu",
            classNames: resolvedClassNames,
            styles: resolvedStyles,
            unstyled,
            variant,
            keepMounted,
            children
        })
    });
}
Menu.extend = (input)=>input;
Menu.withProps = (0, _factoryMjs.getWithProps)(Menu);
Menu.classes = (0, _menuModuleCssMjsDefault.default);
Menu.displayName = "@mantine/core/Menu";
Menu.Item = (0, _menuItemMjs.MenuItem);
Menu.Label = (0, _menuLabelMjs.MenuLabel);
Menu.Dropdown = (0, _menuDropdownMjs.MenuDropdown);
Menu.Target = (0, _menuTargetMjs.MenuTarget);
Menu.Divider = (0, _menuDividerMjs.MenuDivider);
Menu.Sub = (0, _menuSubMjs.MenuSub);

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"bBNEa","../../core/utils/units-converters/rem.mjs":"c70Xm","../../core/utils/get-context-item-index/get-context-item-index.mjs":"71mkJ","clsx":"9idv4","../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs":"jZX9i","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../utils/Floating/FloatingArrow/FloatingArrow.mjs":"kyZ0h","../../utils/Floating/use-delayed-hover.mjs":"3MZAL","../Popover/Popover.mjs":"7fOmz","../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","./Menu.context.mjs":"2hVYT","./Menu.module.css.mjs":"6PtVu","./MenuDivider/MenuDivider.mjs":"2cpgP","./MenuDropdown/MenuDropdown.mjs":"5afhz","./MenuItem/MenuItem.mjs":"Y1e44","./MenuLabel/MenuLabel.mjs":"brO70","./MenuSub/MenuSub.mjs":"2j3WP","./MenuTarget/MenuTarget.mjs":"k2hse","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"71mkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContextItemIndex", ()=>getContextItemIndex);
var _findElementAncestorMjs = require("../find-element-ancestor/find-element-ancestor.mjs");
'use client';
function getContextItemIndex(elementSelector, parentSelector, node) {
    if (!node) return null;
    return Array.from((0, _findElementAncestorMjs.findElementAncestor)(node, parentSelector)?.querySelectorAll(elementSelector) || []).findIndex((element)=>element === node);
}

},{"../find-element-ancestor/find-element-ancestor.mjs":"kNkgL","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kNkgL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findElementAncestor", ()=>findElementAncestor);
'use client';
function findElementAncestor(element, selector) {
    let _element = element;
    while((_element = _element.parentElement) && !_element.matches(selector));
    return _element;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jZX9i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResolvedStylesApi", ()=>useResolvedStylesApi);
var _remMjs = require("../../utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _mantineContextMjs = require("../../MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _resolveClassNamesMjs = require("../use-styles/get-class-name/resolve-class-names/resolve-class-names.mjs");
var _resolveStylesMjs = require("../use-styles/get-style/resolve-styles/resolve-styles.mjs");
'use client';
function useResolvedStylesApi({ classNames, styles, props, stylesCtx }) {
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    return {
        resolvedClassNames: (0, _resolveClassNamesMjs.resolveClassNames)({
            theme,
            classNames,
            props,
            stylesCtx: stylesCtx || void 0
        }),
        resolvedStyles: (0, _resolveStylesMjs.resolveStyles)({
            theme,
            styles,
            props,
            stylesCtx: stylesCtx || void 0
        })
    };
}

},{"../../utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","../../MantineProvider/Mantine.context.mjs":"7oXOX","../../MantineProvider/default-theme.mjs":"ixgDZ","../../MantineProvider/MantineProvider.mjs":"2TSc8","../../MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../use-styles/get-class-name/resolve-class-names/resolve-class-names.mjs":"7nwQC","../use-styles/get-style/resolve-styles/resolve-styles.mjs":"kuqsT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kyZ0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FloatingArrow", ()=>FloatingArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _getArrowPositionStylesMjs = require("./get-arrow-position-styles.mjs");
'use client';
const FloatingArrow = (0, _react.forwardRef)(({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, visible, arrowX, arrowY, style, ...others }, ref)=>{
    const { dir } = (0, _directionProviderMjs.useDirection)();
    if (!visible) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ...others,
        ref,
        style: {
            ...style,
            ...(0, _getArrowPositionStylesMjs.getArrowPositionStyles)({
                position,
                arrowSize,
                arrowOffset,
                arrowRadius,
                arrowPosition,
                dir,
                arrowX,
                arrowY
            })
        }
    });
});
FloatingArrow.displayName = "@mantine/core/FloatingArrow";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./get-arrow-position-styles.mjs":"3HItI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3HItI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrowPositionStyles", ()=>getArrowPositionStyles);
'use client';
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") return {
        top: arrowY
    };
    if (placement === "end") return {
        bottom: arrowOffset
    };
    if (placement === "start") return {
        top: arrowOffset
    };
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") return {
        left: arrowX
    };
    if (placement === "end") return {
        [dir === "ltr" ? "right" : "left"]: arrowOffset
    };
    if (placement === "start") return {
        [dir === "ltr" ? "left" : "right"]: arrowOffset
    };
    return {};
}
const radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function getArrowPositionStyles({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, arrowX, arrowY, dir }) {
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: arrowSize,
        height: arrowSize,
        transform: "rotate(45deg)",
        position: "absolute",
        [radiusByFloatingSide[side]]: arrowRadius
    };
    const arrowPlacement = -arrowSize / 2;
    if (side === "left") return {
        ...baseStyles,
        ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
        right: arrowPlacement,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent",
        clipPath: "polygon(100% 0, 0 0, 100% 100%)"
    };
    if (side === "right") return {
        ...baseStyles,
        ...horizontalSide(placement, arrowY, arrowOffset, arrowPosition),
        left: arrowPlacement,
        borderRightColor: "transparent",
        borderTopColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 100%)"
    };
    if (side === "top") return {
        ...baseStyles,
        ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
        bottom: arrowPlacement,
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        clipPath: "polygon(0 100%, 100% 100%, 100% 0)"
    };
    if (side === "bottom") return {
        ...baseStyles,
        ...verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir),
        top: arrowPlacement,
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
        clipPath: "polygon(0 100%, 0 0, 100% 0)"
    };
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3MZAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDelayedHover", ()=>useDelayedHover);
var _react = require("react");
'use client';
function useDelayedHover({ open, close, openDelay, closeDelay }) {
    const openTimeout = (0, _react.useRef)(-1);
    const closeTimeout = (0, _react.useRef)(-1);
    const clearTimeouts = ()=>{
        window.clearTimeout(openTimeout.current);
        window.clearTimeout(closeTimeout.current);
    };
    const openDropdown = ()=>{
        clearTimeouts();
        if (openDelay === 0 || openDelay === void 0) open();
        else openTimeout.current = window.setTimeout(open, openDelay);
    };
    const closeDropdown = ()=>{
        clearTimeouts();
        if (closeDelay === 0 || closeDelay === void 0) close();
        else closeTimeout.current = window.setTimeout(close, closeDelay);
    };
    (0, _react.useEffect)(()=>clearTimeouts, []);
    return {
        openDropdown,
        closeDropdown
    };
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7fOmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _getDefaultZIndexMjs = require("../../core/utils/get-default-z-index/get-default-z-index.mjs");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _useResolvedStylesApiMjs = require("../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _floatingArrowMjs = require("../../utils/Floating/FloatingArrow/FloatingArrow.mjs");
var _getFloatingPositionMjs = require("../../utils/Floating/get-floating-position/get-floating-position.mjs");
var _overlayMjs = require("../Overlay/Overlay.mjs");
var _portalMjs = require("../Portal/Portal.mjs");
var _optionalPortalMjs = require("../Portal/OptionalPortal.mjs");
var _transitionMjs = require("../Transition/Transition.mjs");
var _popoverContextMjs = require("./Popover.context.mjs");
var _popoverModuleCssMjs = require("./Popover.module.css.mjs");
var _popoverModuleCssMjsDefault = parcelHelpers.interopDefault(_popoverModuleCssMjs);
var _popoverDropdownMjs = require("./PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("./PopoverTarget/PopoverTarget.mjs");
var _usePopoverMjs = require("./use-popover.mjs");
'use client';
const defaultProps = {
    position: "bottom",
    offset: 8,
    positionDependencies: [],
    transitionProps: {
        transition: "fade",
        duration: 150
    },
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    },
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: true,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    withOverlay: false,
    hideDetached: true,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: (0, _getDefaultZIndexMjs.getDefaultZIndex)("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { radius, shadow })=>({
        dropdown: {
            "--popover-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--popover-shadow": (0, _getSizeMjs.getShadow)(shadow)
        }
    }));
function Popover(_props) {
    const props = (0, _usePropsMjs.useProps)("Popover", defaultProps, _props);
    const { children, position, offset, onPositionChange, // Scheduled for removal in 9.0
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    positionDependencies, opened, transitionProps, onExitTransitionEnd, onEnterTransitionEnd, width, middlewares, withArrow, arrowSize, arrowOffset, arrowRadius, arrowPosition, unstyled, classNames, styles, closeOnClickOutside, withinPortal, portalProps, closeOnEscape, clickOutsideEvents, trapFocus, onClose, onDismiss, onOpen, onChange, zIndex, radius, shadow, id, defaultOpened, __staticSelector, withRoles, disabled, returnFocus, variant, keepMounted, vars, floatingStrategy, withOverlay, overlayProps, hideDetached, attributes, preventPositionChangeWhenVisible, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: __staticSelector,
        props,
        classes: (0, _popoverModuleCssMjsDefault.default),
        classNames,
        styles,
        unstyled,
        attributes,
        rootSelector: "dropdown",
        vars,
        varsResolver
    });
    const { resolvedStyles } = (0, _useResolvedStylesApiMjs.useResolvedStylesApi)({
        classNames,
        styles,
        props
    });
    const [dropdownVisible, setDropdownVisible] = (0, _react.useState)(opened ?? defaultOpened ?? false);
    const positionRef = (0, _react.useRef)(position);
    const arrowRef = (0, _react.useRef)(null);
    const [targetNode, setTargetNode] = (0, _react.useState)(null);
    const [dropdownNode, setDropdownNode] = (0, _react.useState)(null);
    const { dir } = (0, _directionProviderMjs.useDirection)();
    const env = (0, _mantineContextMjs.useMantineEnv)();
    const uid = (0, _hooks.useId)(id);
    const popover = (0, _usePopoverMjs.usePopover)({
        middlewares,
        width,
        position: (0, _getFloatingPositionMjs.getFloatingPosition)(dir, position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef,
        arrowOffset,
        onPositionChange,
        positionDependencies,
        opened,
        defaultOpened,
        onChange,
        onOpen,
        onClose,
        onDismiss,
        strategy: floatingStrategy,
        dropdownVisible,
        setDropdownVisible,
        positionRef,
        disabled,
        preventPositionChangeWhenVisible,
        keepMounted
    });
    (0, _hooks.useClickOutside)(()=>{
        if (closeOnClickOutside) {
            popover.onClose();
            onDismiss?.();
        }
    }, clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    const reference = (0, _react.useCallback)((node)=>{
        setTargetNode(node);
        popover.floating.refs.setReference(node);
    }, [
        popover.floating.refs.setReference
    ]);
    const floating = (0, _react.useCallback)((node)=>{
        setDropdownNode(node);
        popover.floating.refs.setFloating(node);
    }, [
        popover.floating.refs.setFloating
    ]);
    const onExited = (0, _react.useCallback)(()=>{
        transitionProps?.onExited?.();
        onExitTransitionEnd?.();
        setDropdownVisible(false);
        if (!preventPositionChangeWhenVisible) positionRef.current = position;
    }, [
        transitionProps?.onExited,
        onExitTransitionEnd,
        preventPositionChangeWhenVisible,
        position
    ]);
    const onEntered = (0, _react.useCallback)(()=>{
        transitionProps?.onEntered?.();
        onEnterTransitionEnd?.();
    }, [
        transitionProps?.onEntered,
        onEnterTransitionEnd
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _popoverContextMjs.PopoverContextProvider), {
        value: {
            returnFocus,
            disabled,
            controlled: popover.controlled,
            reference,
            floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: popover.floating?.middlewareData?.arrow?.x,
            arrowY: popover.floating?.middlewareData?.arrow?.y,
            opened: popover.opened,
            arrowRef,
            transitionProps: {
                ...transitionProps,
                onExited,
                onEntered
            },
            width,
            withArrow,
            arrowSize,
            arrowOffset,
            arrowRadius,
            arrowPosition,
            placement: popover.floating.placement,
            trapFocus,
            withinPortal,
            portalProps,
            zIndex,
            radius,
            shadow,
            closeOnEscape,
            onDismiss,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: ()=>`${uid}-target`,
            getDropdownId: ()=>`${uid}-dropdown`,
            withRoles,
            targetProps: others,
            __staticSelector,
            classNames,
            styles,
            unstyled,
            variant,
            keepMounted,
            getStyles,
            resolvedStyles,
            floatingStrategy,
            referenceHidden: hideDetached && env !== "test" ? popover.floating.middlewareData.hide?.referenceHidden : false
        },
        children: [
            children,
            withOverlay && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _transitionMjs.Transition), {
                transition: "fade",
                mounted: popover.opened,
                duration: transitionProps?.duration || 250,
                exitDuration: transitionProps?.exitDuration || 250,
                children: (transitionStyles)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _optionalPortalMjs.OptionalPortal), {
                        withinPortal,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _overlayMjs.Overlay), {
                            ...overlayProps,
                            ...getStyles("overlay", {
                                className: overlayProps?.className,
                                style: [
                                    transitionStyles,
                                    overlayProps?.style
                                ]
                            })
                        })
                    })
            })
        ]
    });
}
Popover.Target = (0, _popoverTargetMjs.PopoverTarget);
Popover.Dropdown = (0, _popoverDropdownMjs.PopoverDropdown);
Popover.displayName = "@mantine/core/Popover";
Popover.extend = (input)=>input;

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useClickOutside","1okWM"],["useId","H2nB9"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","../../core/utils/get-default-z-index/get-default-z-index.mjs":"4YtNJ","../../core/utils/get-size/get-size.mjs":"giXTO","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs":"jZX9i","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../utils/Floating/FloatingArrow/FloatingArrow.mjs":"kyZ0h","../../utils/Floating/get-floating-position/get-floating-position.mjs":"7Uu1l","../Overlay/Overlay.mjs":"eJQ57","../Portal/Portal.mjs":"70ZGD","../Portal/OptionalPortal.mjs":"dQaeU","../Transition/Transition.mjs":"3eGlY","./Popover.context.mjs":"7r95O","./Popover.module.css.mjs":"gpVKc","./PopoverDropdown/PopoverDropdown.mjs":"4plSF","./PopoverTarget/PopoverTarget.mjs":"duafB","./use-popover.mjs":"bkpdM","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7Uu1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFloatingPosition", ()=>getFloatingPosition);
'use client';
function getFloatingPosition(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        const [side, placement] = position.split("-");
        const flippedPosition = side === "right" ? "left" : "right";
        return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eJQ57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay", ()=>Overlay);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getDefaultZIndexMjs = require("../../core/utils/get-default-z-index/get-default-z-index.mjs");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _rgbaMjs = require("../../core/MantineProvider/color-functions/rgba/rgba.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _overlayModuleCssMjs = require("./Overlay.module.css.mjs");
var _overlayModuleCssMjsDefault = parcelHelpers.interopDefault(_overlayModuleCssMjs);
'use client';
const defaultProps = {
    zIndex: (0, _getDefaultZIndexMjs.getDefaultZIndex)("modal")
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { gradient, color, backgroundOpacity, blur, radius, zIndex })=>({
        root: {
            "--overlay-bg": gradient || (color !== void 0 || backgroundOpacity !== void 0) && (0, _rgbaMjs.rgba)(color || "#000", backgroundOpacity ?? 0.6) || void 0,
            "--overlay-filter": blur ? `blur(${(0, _remMjs.rem)(blur)})` : void 0,
            "--overlay-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--overlay-z-index": zIndex?.toString()
        }
    }));
const Overlay = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Overlay", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, fixed, center, children, radius, zIndex, gradient, blur, color, backgroundOpacity, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Overlay",
        props,
        classes: (0, _overlayModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...getStyles("root"),
        mod: [
            {
                center,
                fixed
            },
            mod
        ],
        ...others,
        children
    });
});
Overlay.classes = (0, _overlayModuleCssMjsDefault.default);
Overlay.displayName = "@mantine/core/Overlay";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-default-z-index/get-default-z-index.mjs":"4YtNJ","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/rgba/rgba.mjs":"bqV23","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Overlay.module.css.mjs":"137Ub","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"137Ub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_9814e45f"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"70ZGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function createPortalNode(props) {
    const node = document.createElement("div");
    node.setAttribute("data-portal", "true");
    typeof props.className === "string" && node.classList.add(...props.className.split(" ").filter(Boolean));
    typeof props.style === "object" && Object.assign(node.style, props.style);
    typeof props.id === "string" && node.setAttribute("id", props.id);
    return node;
}
function getTargetNode({ target, reuseTargetNode, ...others }) {
    if (target) {
        if (typeof target === "string") return document.querySelector(target) || createPortalNode(others);
        return target;
    }
    if (reuseTargetNode) {
        const existingNode = document.querySelector("[data-mantine-shared-portal-node]");
        if (existingNode) return existingNode;
        const node = createPortalNode(others);
        node.setAttribute("data-mantine-shared-portal-node", "true");
        document.body.appendChild(node);
        return node;
    }
    return createPortalNode(others);
}
const defaultProps = {
    reuseTargetNode: true
};
const Portal = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, target, reuseTargetNode, ...others } = (0, _usePropsMjs.useProps)("Portal", defaultProps, props);
    const [mounted, setMounted] = (0, _react.useState)(false);
    const nodeRef = (0, _react.useRef)(null);
    (0, _hooks.useIsomorphicEffect)(()=>{
        setMounted(true);
        nodeRef.current = getTargetNode({
            target,
            reuseTargetNode,
            ...others
        });
        (0, _hooks.assignRef)(ref, nodeRef.current);
        if (!target && !reuseTargetNode && nodeRef.current) document.body.appendChild(nodeRef.current);
        return ()=>{
            if (!target && !reuseTargetNode && nodeRef.current) document.body.removeChild(nodeRef.current);
        };
    }, [
        target
    ]);
    if (!mounted || !nodeRef.current) return null;
    return (0, _reactDom.createPortal)(/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children
    }), nodeRef.current);
});
Portal.displayName = "@mantine/core/Portal";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","react-dom":"kVyn3","@mantine/hooks":[["assignRef","3QtIc"],["useIsomorphicEffect","6Cmng"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dQaeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionalPortal", ()=>OptionalPortal);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _portalMjs = require("./Portal.mjs");
'use client';
const OptionalPortal = (0, _factoryMjs.factory)(({ withinPortal = true, children, ...others }, ref)=>{
    const env = (0, _mantineContextMjs.useMantineEnv)();
    if (env === "test" || !withinPortal) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _portalMjs.Portal), {
        ref,
        ...others,
        children
    });
});
OptionalPortal.displayName = "@mantine/core/OptionalPortal";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Portal.mjs":"70ZGD","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7r95O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverContextProvider", ()=>PopoverContextProvider);
parcelHelpers.export(exports, "usePopoverContext", ()=>usePopoverContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [PopoverContextProvider, usePopoverContext] = (0, _createSafeContextMjs.createSafeContext)("Popover component was not found in the tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gpVKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "dropdown": "m_38a85659",
    "arrow": "m_a31dc6c1",
    "overlay": "m_3d7bc908"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4plSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverDropdown", ()=>PopoverDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _closeOnEscapeMjs = require("../../../core/utils/close-on-escape/close-on-escape.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _floatingArrowMjs = require("../../../utils/Floating/FloatingArrow/FloatingArrow.mjs");
var _focusTrapMjs = require("../../FocusTrap/FocusTrap.mjs");
var _portalMjs = require("../../Portal/Portal.mjs");
var _optionalPortalMjs = require("../../Portal/OptionalPortal.mjs");
var _transitionMjs = require("../../Transition/Transition.mjs");
var _popoverContextMjs = require("../Popover.context.mjs");
var _popoverModuleCssMjs = require("../Popover.module.css.mjs");
var _popoverModuleCssMjsDefault = parcelHelpers.interopDefault(_popoverModuleCssMjs);
'use client';
const PopoverDropdown = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("PopoverDropdown", null, _props);
    const { className, style, vars, children, onKeyDownCapture, variant, classNames, styles, ...others } = props;
    const ctx = (0, _popoverContextMjs.usePopoverContext)();
    const returnFocus = (0, _hooks.useFocusReturn)({
        opened: ctx.opened,
        shouldReturnFocus: ctx.returnFocus
    });
    const accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog",
        tabIndex: -1
    } : {};
    const mergedRef = (0, _hooks.useMergedRef)(ref, ctx.floating);
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _optionalPortalMjs.OptionalPortal), {
        ...ctx.portalProps,
        withinPortal: ctx.withinPortal,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _transitionMjs.Transition), {
            mounted: ctx.opened,
            ...ctx.transitionProps,
            transition: ctx.transitionProps?.transition || "fade",
            duration: ctx.transitionProps?.duration ?? 150,
            keepMounted: ctx.keepMounted,
            exitDuration: typeof ctx.transitionProps?.exitDuration === "number" ? ctx.transitionProps.exitDuration : ctx.transitionProps?.duration,
            children: (transitionStyles)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _focusTrapMjs.FocusTrap), {
                    active: ctx.trapFocus && ctx.opened,
                    innerRef: mergedRef,
                    children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
                        ...accessibleProps,
                        ...others,
                        variant,
                        onKeyDownCapture: (0, _closeOnEscapeMjs.closeOnEscape)(()=>{
                            ctx.onClose?.();
                            ctx.onDismiss?.();
                        }, {
                            active: ctx.closeOnEscape,
                            onTrigger: returnFocus,
                            onKeyDown: onKeyDownCapture
                        }),
                        "data-position": ctx.placement,
                        "data-fixed": ctx.floatingStrategy === "fixed" || void 0,
                        ...ctx.getStyles("dropdown", {
                            className,
                            props,
                            classNames,
                            styles,
                            style: [
                                {
                                    ...transitionStyles,
                                    zIndex: ctx.zIndex,
                                    top: ctx.y ?? 0,
                                    left: ctx.x ?? 0,
                                    width: ctx.width === "target" ? void 0 : (0, _remMjs.rem)(ctx.width),
                                    ...ctx.referenceHidden ? {
                                        display: "none"
                                    } : null
                                },
                                ctx.resolvedStyles.dropdown,
                                styles?.dropdown,
                                style
                            ]
                        }),
                        children: [
                            children,
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _floatingArrowMjs.FloatingArrow), {
                                ref: ctx.arrowRef,
                                arrowX: ctx.arrowX,
                                arrowY: ctx.arrowY,
                                visible: ctx.withArrow,
                                position: ctx.placement,
                                arrowSize: ctx.arrowSize,
                                arrowRadius: ctx.arrowRadius,
                                arrowOffset: ctx.arrowOffset,
                                arrowPosition: ctx.arrowPosition,
                                ...ctx.getStyles("arrow", {
                                    props,
                                    classNames,
                                    styles
                                })
                            })
                        ]
                    })
                })
        })
    });
});
PopoverDropdown.classes = (0, _popoverModuleCssMjsDefault.default);
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":[["useFocusReturn","lTHUc"],["useMergedRef","3QtIc"]],"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/close-on-escape/close-on-escape.mjs":"hk1kb","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../../utils/Floating/FloatingArrow/FloatingArrow.mjs":"kyZ0h","../../FocusTrap/FocusTrap.mjs":"cRnrU","../../Portal/Portal.mjs":"70ZGD","../../Portal/OptionalPortal.mjs":"dQaeU","../../Transition/Transition.mjs":"3eGlY","../Popover.context.mjs":"7r95O","../Popover.module.css.mjs":"gpVKc","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hk1kb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeOnEscape", ()=>closeOnEscape);
var _noopMjs = require("../noop/noop.mjs");
'use client';
function closeOnEscape(callback, options = {
    active: true
}) {
    if (typeof callback !== "function" || !options.active) return options.onKeyDown || (0, _noopMjs.noop);
    return (event)=>{
        if (event.key === "Escape") {
            callback(event);
            options.onTrigger?.();
        }
    };
}

},{"../noop/noop.mjs":"HCVmB","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"HCVmB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
'use client';
const noop = ()=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cRnrU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusTrap", ()=>FocusTrap);
parcelHelpers.export(exports, "FocusTrapInitialFocus", ()=>FocusTrapInitialFocus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _getSingleElementChildMjs = require("../../core/utils/get-single-element-child/get-single-element-child.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _visuallyHiddenMjs = require("../VisuallyHidden/VisuallyHidden.mjs");
'use client';
function FocusTrap({ children, active = true, refProp = "ref", innerRef }) {
    const focusTrapRef = (0, _hooks.useFocusTrap)(active);
    const ref = (0, _hooks.useMergedRef)(focusTrapRef, innerRef);
    const child = (0, _getSingleElementChildMjs.getSingleElementChild)(children);
    if (!child) return children;
    return (0, _react.cloneElement)(child, {
        [refProp]: ref
    });
}
function FocusTrapInitialFocus(props) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _visuallyHiddenMjs.VisuallyHidden), {
        tabIndex: -1,
        "data-autofocus": true,
        ...props
    });
}
FocusTrap.displayName = "@mantine/core/FocusTrap";
FocusTrapInitialFocus.displayName = "@mantine/core/FocusTrapInitialFocus";
FocusTrap.InitialFocus = FocusTrapInitialFocus;

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useFocusTrap","hpsZx"],["useMergedRef","3QtIc"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","../../core/utils/get-single-element-child/get-single-element-child.mjs":"lgwGR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../VisuallyHidden/VisuallyHidden.mjs":"kkMnN","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lgwGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSingleElementChild", ()=>getSingleElementChild);
var _react = require("react");
var _isElementMjs = require("../is-element/is-element.mjs");
'use client';
function getSingleElementChild(children) {
    const _children = (0, _react.Children).toArray(children);
    if (_children.length !== 1 || !(0, _isElementMjs.isElement)(_children[0])) return null;
    return _children[0];
}

},{"react":"erQJb","../is-element/is-element.mjs":"5Gmmd","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5Gmmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
var _react = require("react");
'use client';
function isElement(value) {
    if (Array.isArray(value) || value === null) return false;
    if (typeof value === "object") {
        if (value.type === (0, _react.Fragment)) return false;
        return true;
    }
    return false;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kkMnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisuallyHidden", ()=>VisuallyHidden);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _visuallyHiddenModuleCssMjs = require("./VisuallyHidden.module.css.mjs");
var _visuallyHiddenModuleCssMjsDefault = parcelHelpers.interopDefault(_visuallyHiddenModuleCssMjs);
'use client';
const VisuallyHidden = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("VisuallyHidden", null, _props);
    const { classNames, className, style, styles, unstyled, vars, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "VisuallyHidden",
        classes: (0, _visuallyHiddenModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "span",
        ref,
        ...getStyles("root"),
        ...others
    });
});
VisuallyHidden.classes = (0, _visuallyHiddenModuleCssMjsDefault.default);
VisuallyHidden.displayName = "@mantine/core/VisuallyHidden";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./VisuallyHidden.module.css.mjs":"feGIB","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"feGIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_515a97f8"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"duafB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopoverTarget", ()=>PopoverTarget);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _getRefPropMjs = require("../../../core/utils/get-ref-prop/get-ref-prop.mjs");
var _getSingleElementChildMjs = require("../../../core/utils/get-single-element-child/get-single-element-child.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverContextMjs = require("../Popover.context.mjs");
'use client';
const defaultProps = {
    refProp: "ref",
    popupType: "dialog"
};
const PopoverTarget = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, refProp, popupType, ...others } = (0, _usePropsMjs.useProps)("PopoverTarget", defaultProps, props);
    const child = (0, _getSingleElementChildMjs.getSingleElementChild)(children);
    if (!child) throw new Error("Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const forwardedProps = others;
    const ctx = (0, _popoverContextMjs.usePopoverContext)();
    const targetRef = (0, _hooks.useMergedRef)(ctx.reference, (0, _getRefPropMjs.getRefProp)(child), ref);
    const accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.opened ? ctx.getDropdownId() : void 0,
        id: ctx.getTargetId()
    } : {};
    const childProps = child.props;
    return (0, _react.cloneElement)(child, {
        ...forwardedProps,
        ...accessibleProps,
        ...ctx.targetProps,
        className: (0, _clsxDefault.default)(ctx.targetProps.className, forwardedProps.className, childProps.className),
        [refProp]: targetRef,
        ...!ctx.controlled ? {
            onClick: ()=>{
                ctx.onToggle();
                childProps.onClick?.();
            }
        } : null
    });
});
PopoverTarget.displayName = "@mantine/core/PopoverTarget";

},{"react":"erQJb","clsx":"9idv4","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","react/jsx-runtime":"1xKTF","../../../core/utils/get-ref-prop/get-ref-prop.mjs":"jLOGP","../../../core/utils/get-single-element-child/get-single-element-child.mjs":"lgwGR","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Popover.context.mjs":"7r95O","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jLOGP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRefProp", ()=>getRefProp);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
'use client';
function getRefProp(element) {
    const version = (0, _reactDefault.default).version;
    if (typeof (0, _reactDefault.default).version !== "string") return element?.ref;
    if (version.startsWith("18.")) return element?.ref;
    return element?.props?.ref;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bkpdM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopover", ()=>usePopover);
var _react = require("react");
var _react1 = require("@floating-ui/react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function getDefaultMiddlewares(middlewares) {
    if (middlewares === void 0) return {
        shift: true,
        flip: true
    };
    const result = {
        ...middlewares
    };
    if (middlewares.shift === void 0) result.shift = true;
    if (middlewares.flip === void 0) result.flip = true;
    return result;
}
function getPopoverMiddlewares(options, getFloating, env) {
    const middlewaresOptions = getDefaultMiddlewares(options.middlewares);
    const middlewares = [
        (0, _react1.offset)(options.offset),
        (0, _react1.hide)()
    ];
    if (options.dropdownVisible && env !== "test" && options.preventPositionChangeWhenVisible) middlewaresOptions.flip = false;
    if (middlewaresOptions.flip) middlewares.push(typeof middlewaresOptions.flip === "boolean" ? (0, _react1.flip)() : (0, _react1.flip)(middlewaresOptions.flip));
    if (middlewaresOptions.shift) middlewares.push((0, _react1.shift)(typeof middlewaresOptions.shift === "boolean" ? {
        limiter: (0, _react1.limitShift)(),
        padding: 5
    } : {
        limiter: (0, _react1.limitShift)(),
        padding: 5,
        ...middlewaresOptions.shift
    }));
    if (middlewaresOptions.inline) middlewares.push(typeof middlewaresOptions.inline === "boolean" ? (0, _react1.inline)() : (0, _react1.inline)(middlewaresOptions.inline));
    middlewares.push((0, _react1.arrow)({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    if (middlewaresOptions.size || options.width === "target") middlewares.push((0, _react1.size)({
        ...typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size,
        apply ({ rects, availableWidth, availableHeight, ...rest }) {
            const floating = getFloating();
            const styles = floating.refs.floating.current?.style ?? {};
            if (middlewaresOptions.size) {
                if (typeof middlewaresOptions.size === "object" && !!middlewaresOptions.size.apply) middlewaresOptions.size.apply({
                    rects,
                    availableWidth,
                    availableHeight,
                    ...rest
                });
                else Object.assign(styles, {
                    maxWidth: `${availableWidth}px`,
                    maxHeight: `${availableHeight}px`
                });
            }
            if (options.width === "target") Object.assign(styles, {
                width: `${rects.reference.width}px`
            });
        }
    }));
    return middlewares;
}
function usePopover(options) {
    const env = (0, _mantineContextMjs.useMantineEnv)();
    const [_opened, setOpened] = (0, _hooks.useUncontrolled)({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    });
    const previouslyOpened = (0, _react.useRef)(_opened);
    const onClose = ()=>{
        if (_opened && !options.disabled) setOpened(false);
    };
    const onToggle = ()=>{
        if (!options.disabled) setOpened(!_opened);
    };
    const floating = (0, _react1.useFloating)({
        strategy: options.strategy,
        placement: options.preventPositionChangeWhenVisible ? options.positionRef.current : options.position,
        middleware: getPopoverMiddlewares(options, ()=>floating, env),
        whileElementsMounted: !options.keepMounted ? (0, _react1.autoUpdate) : void 0
    });
    (0, _react.useEffect)(()=>{
        if (!floating.refs.reference.current || !floating.refs.floating.current) return;
        if (_opened) return (0, _react1.autoUpdate)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
    }, [
        _opened,
        floating.update
    ]);
    (0, _hooks.useDidUpdate)(()=>{
        options.onPositionChange?.(floating.placement);
        options.positionRef.current = floating.placement;
    }, [
        floating.placement,
        options.preventPositionChangeWhenVisible
    ]);
    (0, _hooks.useDidUpdate)(()=>{
        if (_opened !== previouslyOpened.current) {
            if (!_opened) options.onClose?.();
            else options.onOpen?.();
        }
        previouslyOpened.current = _opened;
    }, [
        _opened,
        options.onClose,
        options.onOpen
    ]);
    (0, _hooks.useIsomorphicEffect)(()=>{
        let timeout = -1;
        if (_opened) timeout = window.setTimeout(()=>options.setDropdownVisible(true), 4);
        return ()=>{
            window.clearTimeout(timeout);
        };
    }, [
        _opened,
        options.position
    ]);
    return {
        floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose,
        onToggle
    };
}

},{"react":"erQJb","@floating-ui/react":[["arrow","4iLEj"],["flip","4iLEj"],["hide","4iLEj"],["inline","4iLEj"],["limitShift","4iLEj"],["shift","4iLEj"],["size","4iLEj"],["autoUpdate","7kUOY"],["offset","hCF9Q"],["useFloating","hCF9Q"]],"@mantine/hooks":[["useDidUpdate","bzSpx"],["useIsomorphicEffect","6Cmng"],["useUncontrolled","bBNEa"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","react/jsx-runtime":"1xKTF","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4iLEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _dom.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _dom.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _dom.detectOverflow));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "platform", ()=>(0, _dom.platform));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
var _dom = require("@floating-ui/dom");
var _react = require("react");
var _reactDom = require("react-dom");
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var index = isClient ? (0, _react.useLayoutEffect) : noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    const dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform = true, whileElementsMounted, open } = options;
    const [data, setData] = _react.useState({
        x: 0,
        y: 0,
        strategy,
        placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = _react.useState(middleware);
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = _react.useState(null);
    const [_floating, _setFloating] = _react.useState(null);
    const setReference = _react.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = _react.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = _react.useRef(null);
    const floatingRef = _react.useRef(null);
    const dataRef = _react.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = useLatestRef(whileElementsMounted);
    const platformRef = useLatestRef(platform);
    const openRef = useLatestRef(open);
    const update = _react.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement,
            strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, _dom.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                _reactDom.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = _react.useRef(false);
    index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = _react.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference,
            setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = _react.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = _react.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = roundByDPR(elements.floating, data.x);
        const y = roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return _react.useMemo(()=>({
            ...data,
            update,
            refs,
            elements,
            floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options,
        fn (state) {
            const { element, padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, _dom.arrow)({
                    element: element.current,
                    padding
                }).fn(state);
                return {};
            }
            if (element) return (0, _dom.arrow)({
                element,
                padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (options, deps)=>{
    const result = (0, _dom.offset)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (options, deps)=>{
    const result = (0, _dom.shift)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (options, deps)=>{
    const result = (0, _dom.limitShift)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (options, deps)=>{
    const result = (0, _dom.flip)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (options, deps)=>{
    const result = (0, _dom.size)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (options, deps)=>{
    const result = (0, _dom.autoPlacement)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (options, deps)=>{
    const result = (0, _dom.hide)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (options, deps)=>{
    const result = (0, _dom.inline)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options, deps)=>{
    const result = arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};

},{"@floating-ui/dom":"7kUOY","react":"erQJb","react-dom":"kVyn3","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7kUOY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, _utils.max)(rect.top, top);
        right = (0, _utils.min)(rect.right, right);
        bottom = (0, _utils.min)(rect.bottom, bottom);
        left = (0, _utils.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, _dom.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"bBJjo","@floating-ui/utils":"dT1Eq","@floating-ui/utils/dom":"5EEtI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bBJjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name, fn } = currentMiddleware;
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects, platform } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement, platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"dT1Eq","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dT1Eq":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    const side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5EEtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value)=>!!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hCF9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrow", ()=>(0, _reactDom1.arrow));
parcelHelpers.export(exports, "autoPlacement", ()=>(0, _reactDom1.autoPlacement));
parcelHelpers.export(exports, "autoUpdate", ()=>(0, _reactDom1.autoUpdate));
parcelHelpers.export(exports, "computePosition", ()=>(0, _reactDom1.computePosition));
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _reactDom1.detectOverflow));
parcelHelpers.export(exports, "flip", ()=>(0, _reactDom1.flip));
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _reactDom1.getOverflowAncestors));
parcelHelpers.export(exports, "hide", ()=>(0, _reactDom1.hide));
parcelHelpers.export(exports, "inline", ()=>(0, _reactDom1.inline));
parcelHelpers.export(exports, "limitShift", ()=>(0, _reactDom1.limitShift));
parcelHelpers.export(exports, "offset", ()=>(0, _reactDom1.offset));
parcelHelpers.export(exports, "platform", ()=>(0, _reactDom1.platform));
parcelHelpers.export(exports, "shift", ()=>(0, _reactDom1.shift));
parcelHelpers.export(exports, "size", ()=>(0, _reactDom1.size));
parcelHelpers.export(exports, "Composite", ()=>Composite);
parcelHelpers.export(exports, "CompositeItem", ()=>CompositeItem);
parcelHelpers.export(exports, "FloatingArrow", ()=>FloatingArrow);
parcelHelpers.export(exports, "FloatingDelayGroup", ()=>FloatingDelayGroup);
parcelHelpers.export(exports, "FloatingFocusManager", ()=>FloatingFocusManager);
parcelHelpers.export(exports, "FloatingList", ()=>FloatingList);
parcelHelpers.export(exports, "FloatingNode", ()=>FloatingNode);
parcelHelpers.export(exports, "FloatingOverlay", ()=>FloatingOverlay);
parcelHelpers.export(exports, "FloatingPortal", ()=>FloatingPortal);
parcelHelpers.export(exports, "FloatingTree", ()=>FloatingTree);
parcelHelpers.export(exports, "NextFloatingDelayGroup", ()=>NextFloatingDelayGroup);
parcelHelpers.export(exports, "inner", ()=>inner);
parcelHelpers.export(exports, "safePolygon", ()=>safePolygon);
parcelHelpers.export(exports, "useClick", ()=>useClick);
parcelHelpers.export(exports, "useClientPoint", ()=>useClientPoint);
parcelHelpers.export(exports, "useDelayGroup", ()=>useDelayGroup);
parcelHelpers.export(exports, "useDelayGroupContext", ()=>useDelayGroupContext);
parcelHelpers.export(exports, "useDismiss", ()=>useDismiss);
parcelHelpers.export(exports, "useFloating", ()=>useFloating);
parcelHelpers.export(exports, "useFloatingNodeId", ()=>useFloatingNodeId);
parcelHelpers.export(exports, "useFloatingParentNodeId", ()=>useFloatingParentNodeId);
parcelHelpers.export(exports, "useFloatingPortalNode", ()=>useFloatingPortalNode);
parcelHelpers.export(exports, "useFloatingRootContext", ()=>useFloatingRootContext);
parcelHelpers.export(exports, "useFloatingTree", ()=>useFloatingTree);
parcelHelpers.export(exports, "useFocus", ()=>useFocus);
parcelHelpers.export(exports, "useHover", ()=>useHover);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useInnerOffset", ()=>useInnerOffset);
parcelHelpers.export(exports, "useInteractions", ()=>useInteractions);
parcelHelpers.export(exports, "useListItem", ()=>useListItem);
parcelHelpers.export(exports, "useListNavigation", ()=>useListNavigation);
parcelHelpers.export(exports, "useMergeRefs", ()=>useMergeRefs);
parcelHelpers.export(exports, "useNextDelayGroup", ()=>useNextDelayGroup);
parcelHelpers.export(exports, "useRole", ()=>useRole);
parcelHelpers.export(exports, "useTransitionStatus", ()=>useTransitionStatus);
parcelHelpers.export(exports, "useTransitionStyles", ()=>useTransitionStyles);
parcelHelpers.export(exports, "useTypeahead", ()=>useTypeahead);
var _react = require("react");
var _utils = require("@floating-ui/react/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _dom = require("@floating-ui/utils/dom");
var _tabbable = require("tabbable");
var _reactDom = require("react-dom");
var _reactDom1 = require("@floating-ui/react-dom");
var _utils1 = require("@floating-ui/utils");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function useMergeRefs(refs) {
    const cleanupRef = _react.useRef(undefined);
    const refEffect = _react.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return _react.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const FloatingListContext = /*#__PURE__*/ _react.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function FloatingList(props) {
    const { children, elementsRef, labelsRef } = props;
    const [nodes, setNodes] = _react.useState(()=>new Set());
    const register = _react.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = _react.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = _react.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort(sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingListContext.Provider, {
        value: _react.useMemo(()=>({
                register,
                unregister,
                map,
                elementsRef,
                labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function useListItem(props) {
    if (props === void 0) props = {};
    const { label } = props;
    const { register, unregister, map, elementsRef, labelsRef } = _react.useContext(FloatingListContext);
    const [index, setIndex] = _react.useState(null);
    const componentRef = _react.useRef(null);
    const ref = _react.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return _react.useMemo(()=>({
            ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const ACTIVE_KEY = 'active';
const SELECTED_KEY = 'selected';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
function renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ _react.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...computedProps
    });
}
const CompositeContext = /*#__PURE__*/ _react.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const horizontalKeys = [
    ARROW_LEFT,
    ARROW_RIGHT
];
const verticalKeys = [
    ARROW_UP,
    ARROW_DOWN
];
const allKeys = [
    ...horizontalKeys,
    ...verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const Composite = /*#__PURE__*/ _react.forwardRef(function Composite(props, forwardedRef) {
    const { render, orientation = 'both', loop = true, rtl = false, cols = 1, disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes, dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = _react.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, _utils.useEffectEvent)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = _react.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = _react.useMemo(()=>({
            activeIndex,
            onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, _utils.getMinListIndex)(elementsRef, disabledIndices);
        const maxIndex = (0, _utils.getMaxListIndex)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? ARROW_LEFT : ARROW_RIGHT;
        const horizontalStartKey = rtl ? ARROW_RIGHT : ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, _utils.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, _utils.isListIndexDisabled)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, _utils.isListIndexDisabled)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, _utils.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event,
                orientation,
                loop,
                rtl,
                cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, _utils.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, _utils.isListIndexDisabled)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, _utils.getGridCellIndexOfCorner)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                ARROW_UP
            ],
            both: [
                horizontalStartKey,
                ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? allKeys : ({
            horizontal: horizontalKeys,
            vertical: verticalKeys,
            both: allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, _utils.findNonDisabledListIndex)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, _utils.isIndexOutOfListBounds)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingList, {
            elementsRef: elementsRef,
            children: renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const CompositeItem = /*#__PURE__*/ _react.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render, ...domProps } = props;
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex, onNavigate } = _react.useContext(CompositeContext);
    const { ref, index } = useListItem();
    const mergedRef = useMergeRefs([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
    ..._react
};
let serverHandoffComplete = false;
let count = 0;
const genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++;
function useFloatingId() {
    const [id, setId] = _react.useState(()=>serverHandoffComplete ? genId() : undefined);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (id == null) setId(genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    _react.useEffect(()=>{
        serverHandoffComplete = true;
    }, []);
    return id;
}
const useReactId = SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const useId = useReactId || useFloatingId;
let devMessageSet;
function warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const FloatingArrow = /*#__PURE__*/ _react.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement, elements: { floating }, middlewareData: { arrow, shift } }, width = 14, height = 7, tipRadius = 0, strokeWidth = 0, staticOffset, stroke, d, style: { transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = useId();
    const [isRTL, setIsRTL] = _react.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!floating) return;
        const isRTL = (0, _dom.getComputedStyle)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        ...rest,
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' '),
            ...restStyle
        },
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    });
});
function createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const FloatingNodeContext = /*#__PURE__*/ _react.createContext(null);
const FloatingTreeContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const useFloatingParentNodeId = ()=>{
    var _React$useContext;
    return ((_React$useContext = _react.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const useFloatingTree = ()=>_react.useContext(FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function useFloatingNodeId(customParentId) {
    const id = useId();
    const tree = useFloatingTree();
    const reactParentId = useFloatingParentNodeId();
    const parentId = customParentId || reactParentId;
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!id) return;
        const node = {
            id,
            parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingNode(props) {
    const { children, id } = props;
    const parentId = useFloatingParentNodeId();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingNodeContext.Provider, {
        value: _react.useMemo(()=>({
                id,
                parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function FloatingTree(props) {
    const { children } = props;
    const nodesRef = _react.useRef([]);
    const addNode = _react.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = _react.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = _react.useState(()=>createEventEmitter());
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingTreeContext.Provider, {
        value: _react.useMemo(()=>({
                nodesRef,
                addNode,
                removeNode,
                events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function createAttribute(name) {
    return "data-floating-ui-" + name;
}
function clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const safePolygonIdentifier = /*#__PURE__*/ createAttribute('safe-polygon');
function getDelay(value, prop, pointerType) {
    if (pointerType && !(0, _utils.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function useHover(context, props) {
    if (props === void 0) props = {};
    const { open, onOpenChange, dataRef, events, elements } = context;
    const { enabled = true, delay = 0, handleClose = null, mouseOnly = false, restMs = 0, move = true } = props;
    const tree = useFloatingTree();
    const parentId = useFloatingParentNodeId();
    const handleCloseRef = (0, _utils.useLatestRef)(handleClose);
    const delayRef = (0, _utils.useLatestRef)(delay);
    const openRef = (0, _utils.useLatestRef)(open);
    const restMsRef = (0, _utils.useLatestRef)(restMs);
    const pointerTypeRef = _react.useRef();
    const timeoutRef = _react.useRef(-1);
    const handlerRef = _react.useRef();
    const restTimeoutRef = _react.useRef(-1);
    const blockMouseMoveRef = _react.useRef(true);
    const performedPointerEventsMutationRef = _react.useRef(false);
    const unbindMouseMoveRef = _react.useRef(()=>{});
    const restTimeoutPendingRef = _react.useRef(false);
    const isHoverOpen = (0, _utils.useEffectEvent)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    _react.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open } = _ref;
            if (!open) {
                clearTimeoutIfSet(timeoutRef);
                clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    _react.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, _utils.getDocument)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = _react.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, _utils.useEffectEvent)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, _utils.useEffectEvent)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, _utils.getDocument)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute(safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, _utils.useEffectEvent)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    _react.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current) || getRestMs(restMsRef.current) > 0 && !getDelay(delayRef.current, 'open')) return;
            const openDelay = getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, _utils.getDocument)(elements.floating);
            clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, _utils.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            })(event);
        }
        function onFloatingMouseEnter() {
            clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, _dom.isElement)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, _utils.useModernLayoutEffect)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, _dom.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, _utils.getDocument)(elements.floating).body;
                body.setAttribute(safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    _react.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeoutIfSet(timeoutRef);
            clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = _react.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, _utils.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return _react.useMemo(()=>enabled ? {
            reference
        } : {}, [
        enabled,
        reference
    ]);
}
const NOOP = ()=>{};
const FloatingDelayGroupContext = /*#__PURE__*/ _react.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: NOOP,
    setState: NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const useDelayGroupContext = ()=>_react.useContext(FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function FloatingDelayGroup(props) {
    const { children, delay, timeoutMs = 0 } = props;
    const [state, setState] = _react.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay,
        timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = _react.useRef(null);
    const setCurrentId = _react.useCallback((currentId)=>{
        setState({
            currentId
        });
    }, []);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingDelayGroupContext.Provider, {
        value: _react.useMemo(()=>({
                ...state,
                setState,
                setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function useDelayGroup(context, options) {
    if (options === void 0) options = {};
    const { open, onOpenChange, floatingId } = context;
    const { id: optionId, enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = useDelayGroupContext();
    const { currentId, setCurrentId, initialDelay, setState, timeoutMs } = groupContext;
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (setCurrentId === NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const NextFloatingDelayGroupContext = /*#__PURE__*/ _react.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function NextFloatingDelayGroup(props) {
    const { children, delay, timeoutMs = 0 } = props;
    const delayRef = _react.useRef(delay);
    const initialDelayRef = _react.useRef(delay);
    const currentIdRef = _react.useRef(null);
    const currentContextRef = _react.useRef(null);
    const timeoutIdRef = _react.useRef(-1);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextFloatingDelayGroupContext.Provider, {
        value: _react.useMemo(()=>({
                hasProvider: true,
                delayRef,
                initialDelayRef,
                currentIdRef,
                timeoutMs,
                currentContextRef,
                timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function useNextDelayGroup(context, options) {
    if (options === void 0) options = {};
    const { open, onOpenChange, floatingId } = context;
    const { enabled = true } = options;
    const groupContext = _react.useContext(NextFloatingDelayGroupContext);
    const { currentIdRef, delayRef, timeoutMs, initialDelayRef, currentContextRef, hasProvider, timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = _react.useState(false);
    (0, _utils.useModernLayoutEffect)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange,
            setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return _react.useMemo(()=>({
            hasProvider,
            delayRef,
            isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let rafId = 0;
function enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll = false, cancelPrevious = true, sync = false } = options;
    cancelPrevious && cancelAnimationFrame(rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll
        });
    if (sync) exec();
    else rafId = requestAnimationFrame(exec);
}
function contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, _dom.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function getCounterMap(control) {
    if (control === 'inert') return counters.inert;
    if (control === 'aria-hidden') return counters['aria-hidden'];
    return counters.none;
}
let uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let markerMap = {};
let lockCount$1 = 0;
const supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function unwrapHost(node) {
    if (!node) return null;
    return (0, _dom.isShadowRoot)(node) ? node.host : unwrapHost(node.parentNode);
}
const correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!markerMap[markerName]) markerMap[markerName] = new WeakMap();
    const markerCounter = markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, _dom.getNodeName)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        lockCount$1--;
        if (!lockCount$1) {
            counters.inert = new WeakMap();
            counters['aria-hidden'] = new WeakMap();
            counters.none = new WeakMap();
            uncontrolledElementsSet = new WeakSet();
            markerMap = {};
        }
    };
}
function markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = getDocument(avoidElements[0]).body;
    return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const FocusGuard = /*#__PURE__*/ _react.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = _react.useState();
    (0, _utils.useModernLayoutEffect)(()=>{
        if ((0, _utils.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref,
        tabIndex: 0,
        // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [createAttribute('focus-guard')]: '',
        style: HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        ...props,
        ...restProps
    });
});
const HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const PortalContext = /*#__PURE__*/ _react.createContext(null);
const attr = /*#__PURE__*/ createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function useFloatingPortalNode(props) {
    if (props === void 0) props = {};
    const { id, root } = props;
    const uniqueId = useId();
    const portalContext = usePortalContext();
    const [portalNode, setPortalNode] = _react.useState(null);
    const portalNodeRef = _react.useRef(null);
    (0, _utils.useModernLayoutEffect)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, _dom.isNode)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute(attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function FloatingPortal(props) {
    const { children, id, root, preserveTabOrder = true } = props;
    const portalNode = useFloatingPortalNode({
        id,
        root
    });
    const [focusManagerState, setFocusManagerState] = _react.useState(null);
    const beforeOutsideRef = _react.useRef(null);
    const afterOutsideRef = _react.useRef(null);
    const beforeInsideRef = _react.useRef(null);
    const afterInsideRef = _react.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    _react.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, _utils.isOutsideEvent)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, _utils.enableFocusInside) : (0, _utils.disableFocusInside);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    _react.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, _utils.enableFocusInside)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PortalContext.Provider, {
        value: _react.useMemo(()=>({
                preserveTabOrder,
                beforeOutsideRef,
                afterOutsideRef,
                beforeInsideRef,
                afterInsideRef,
                portalNode,
                setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, _utils.isOutsideEvent)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, _utils.getPreviousTabbable)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                "aria-owns": portalNode.id,
                style: HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ _reactDom.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, _utils.isOutsideEvent)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, _utils.getNextTabbable)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const usePortalContext = ()=>_react.useContext(PortalContext);
function useLiteMergeRefs(refs) {
    return _react.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const LIST_LIMIT = 20;
let previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
    previouslyFocusedElements = previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function addPreviouslyFocusedElement(element) {
    clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, _dom.getNodeName)(element) !== 'body') {
        previouslyFocusedElements.push(new WeakRef(element));
        if (previouslyFocusedElements.length > LIST_LIMIT) previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
}
function getPreviouslyFocusedElement() {
    clearDisconnectedPreviouslyFocusedElements();
    const elementRef = previouslyFocusedElements[previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function getFirstTabbableElement(container) {
    const tabbableOptions = (0, _utils.getTabbableOptions)();
    if ((0, _tabbable.isTabbable)(container, tabbableOptions)) return container;
    return (0, _tabbable.tabbable)(container, tabbableOptions)[0] || container;
}
function handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, _utils.getTabbableOptions)();
    const focusableElements = (0, _tabbable.focusable)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, _tabbable.isTabbable)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const VisuallyHiddenDismiss = /*#__PURE__*/ _react.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ...props,
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: HIDDEN_STYLES
    });
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function FloatingFocusManager(props) {
    const { context, children, disabled = false, order = [
        'content'
    ], guards: _guards = true, initialFocus = 0, returnFocus = true, restoreFocus = false, modal = true, visuallyHiddenDismiss = false, closeOnFocusOut = true, outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open, onOpenChange, events, dataRef, elements: { domReference, floating } } = context;
    const getNodeId = (0, _utils.useEffectEvent)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, _utils.useEffectEvent)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, _utils.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, _utils.useLatestRef)(order);
    const initialFocusRef = (0, _utils.useLatestRef)(initialFocus);
    const returnFocusRef = (0, _utils.useLatestRef)(returnFocus);
    const tree = useFloatingTree();
    const portalContext = usePortalContext();
    const startDismissButtonRef = _react.useRef(null);
    const endDismissButtonRef = _react.useRef(null);
    const preventReturnFocusRef = _react.useRef(false);
    const isPointerDownRef = _react.useRef(false);
    const tabbableIndexRef = _react.useRef(-1);
    const blurTimeoutRef = _react.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, _utils.getFloatingFocusElement)(floating);
    const getTabbableContent = (0, _utils.useEffectEvent)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, _tabbable.tabbable)(container, (0, _utils.getTabbableOptions)()) : [];
    });
    const getTabbableElements = (0, _utils.useEffectEvent)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    _react.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, _utils.contains)(floatingFocusElement, (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, _utils.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, _utils.getTarget)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, _utils.stopEvent)(event);
                    if (event.shiftKey) enqueueFocus(els[els.length - 1]);
                    else enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, _utils.stopEvent)(event);
                    enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, _utils.getDocument)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    _react.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, _utils.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    _react.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, _utils.getTarget)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, _utils.contains)(domReference, relatedTarget) || (0, _utils.contains)(floating, relatedTarget) || (0, _utils.contains)(relatedTarget, floating) || (0, _utils.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute('focus-guard')) || tree && ((0, _utils.getNodeChildren)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, _utils.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, _utils.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, _utils.getNodeAncestors)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, _utils.getFloatingFocusElement)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, _utils.activeElement)((0, _utils.getDocument)(floatingFocusElement)) === (0, _utils.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, _dom.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, _dom.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, _dom.isHTMLElement)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = _react.useRef(null);
    const afterGuardRef = _react.useRef(null);
    const mergedBeforeGuardRef = useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    _react.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, _utils.getNodeAncestors)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, _utils.isTypeableCombobox)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, !useInert, useInert) : markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (disabled || !(0, _dom.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, _utils.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, _utils.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, _utils.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, _utils.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, _utils.activeElement)(doc);
        addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason, event, nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, _utils.isVirtualClick)(event) || (0, _utils.isVirtualPointerEvent)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, _utils.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, _utils.contains)(floating, activeEl) || tree && (0, _utils.getNodeChildren)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, _utils.contains)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, _dom.isHTMLElement)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    _react.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, _utils.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal,
            closeOnFocusOut,
            open,
            onOpenChange,
            domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, _utils.isOutsideEvent)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, _utils.getNextTabbable)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, _utils.isOutsideEvent)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, _utils.getPreviousTabbable)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let lockCount = 0;
const scrollbarProperty = '--floating-ui-scrollbar-width';
function enableScrollLock() {
    const platform = (0, _utils.getPlatform)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty(scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty(scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const FloatingOverlay = /*#__PURE__*/ _react.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll = false, ...rest } = props;
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!lockScroll) return;
        lockCount++;
        if (lockCount === 1) cleanup = enableScrollLock();
        return ()=>{
            lockCount--;
            if (lockCount === 0) cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...rest,
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    });
});
function isButtonTarget(event) {
    return (0, _dom.isHTMLElement)(event.target) && event.target.tagName === 'BUTTON';
}
function isAnchorTarget(event) {
    return (0, _dom.isHTMLElement)(event.target) && event.target.tagName === 'A';
}
function isSpaceIgnored(element) {
    return (0, _utils.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function useClick(context, props) {
    if (props === void 0) props = {};
    const { open, onOpenChange, dataRef, elements: { domReference } } = context;
    const { enabled = true, event: eventOption = 'click', toggle = true, ignoreMouse = false, keyboardHandlers = true, stickIfOpen = true } = props;
    const pointerTypeRef = _react.useRef();
    const didKeyDownRef = _react.useRef(false);
    const reference = _react.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, _utils.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) return;
                if (event.key === ' ' && !isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return _react.useMemo(()=>enabled ? {
            reference
        } : {}, [
        enabled,
        reference
    ]);
}
function createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width,
                height,
                x,
                y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function useClientPoint(context, props) {
    if (props === void 0) props = {};
    const { open, dataRef, elements: { floating, domReference }, refs } = context;
    const { enabled = true, axis = 'both', x = null, y = null } = props;
    const initialRef = _react.useRef(false);
    const cleanupListenerRef = _react.useRef(null);
    const [pointerType, setPointerType] = _react.useState();
    const [reactive, setReactive] = _react.useState([]);
    const setReference = (0, _utils.useEffectEvent)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference(createVirtualElement(domReference, {
            x,
            y,
            axis,
            dataRef,
            pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, _utils.useEffectEvent)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, _utils.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = _react.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, _dom.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, _utils.getTarget)(event);
            if (!(0, _utils.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    _react.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    _react.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    _react.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = _react.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return _react.useMemo(()=>enabled ? {
            reference
        } : {}, [
        enabled,
        reference
    ]);
}
const bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function useDismiss(context, props) {
    if (props === void 0) props = {};
    const { open, onOpenChange, elements, dataRef } = context;
    const { enabled = true, escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent = 'pointerdown', referencePress = false, referencePressEvent = 'pointerdown', ancestorScroll = false, bubbles, capture } = props;
    const tree = useFloatingTree();
    const outsidePressFn = (0, _utils.useEffectEvent)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = _react.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = normalizeProp(capture);
    const isComposingRef = _react.useRef(false);
    const closeOnEscapeKeyDown = (0, _utils.useEffectEvent)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, _utils.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, _utils.isReactEvent)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, _utils.useEffectEvent)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, _utils.getTarget)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, _utils.getTarget)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, _utils.useEffectEvent)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, _utils.getTarget)(event);
        const inertSelector = "[" + createAttribute('inert') + "]";
        const markers = (0, _utils.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, _dom.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, _dom.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, _dom.getParentNode)(targetRootAncestor);
            if ((0, _dom.isLastTraversableNode)(nextParent) || !(0, _dom.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, _dom.isElement)(target) && !(0, _utils.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, _utils.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, _utils.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, _dom.isHTMLElement)(target) && floating) {
            const lastTraversableNode = (0, _dom.isLastTraversableNode)(target);
            const style = (0, _dom.getComputedStyle)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, _utils.getNodeChildren)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, _utils.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, _utils.isEventTargetWithin)(event, elements.floating) || (0, _utils.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, _utils.getNodeChildren)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, _utils.useEffectEvent)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, _utils.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, _utils.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    _react.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, _dom.isWebKit)() ? 5 : 0);
        }
        const doc = (0, _utils.getDocument)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, _dom.isElement)(elements.domReference)) ancestors = (0, _reactDom1.getOverflowAncestors)(elements.domReference);
            if ((0, _dom.isElement)(elements.floating)) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.floating));
            if (!(0, _dom.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, _reactDom1.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    _react.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = _react.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            ...referencePress && {
                [bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                    onOpenChange(false, event.nativeEvent, 'reference-press');
                },
                ...referencePressEvent !== 'click' && {
                    onClick (event) {
                        onOpenChange(false, event.nativeEvent, 'reference-press');
                    }
                }
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = _react.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return _react.useMemo(()=>enabled ? {
            reference,
            floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function useFloatingRootContext(options) {
    const { open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = useId();
    const dataRef = _react.useRef({});
    const [events] = _react.useState(()=>createEventEmitter());
    const nested = useFloatingParentNodeId() != null;
    const [positionReference, setPositionReference] = _react.useState(elementsProp.reference);
    const onOpenChange = (0, _utils.useEffectEvent)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open,
            event,
            reason,
            nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = _react.useMemo(()=>({
            setPositionReference
        }), []);
    const elements = _react.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return _react.useMemo(()=>({
            dataRef,
            open,
            onOpenChange,
            elements,
            events,
            floatingId,
            refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function useFloating(options) {
    if (options === void 0) options = {};
    const { nodeId } = options;
    const internalRootContext = useFloatingRootContext({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = _react.useState(null);
    const [positionReference, _setPositionReference] = _react.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = _react.useRef(null);
    const tree = useFloatingTree();
    (0, _utils.useModernLayoutEffect)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, _reactDom1.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = _react.useCallback((node)=>{
        const computedPositionReference = (0, _dom.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = _react.useCallback((node)=>{
        if ((0, _dom.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, _dom.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, _dom.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = _react.useMemo(()=>({
            ...position.refs,
            setReference,
            setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = _react.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = _react.useMemo(()=>({
            ...position,
            ...rootContext,
            refs,
            elements,
            nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return _react.useMemo(()=>({
            ...position,
            context,
            refs,
            elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function isMacSafari() {
    return (0, _utils.isMac)() && (0, _utils.isSafari)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function useFocus(context, props) {
    if (props === void 0) props = {};
    const { open, onOpenChange, events, dataRef, elements } = context;
    const { enabled = true, visibleOnly = true } = props;
    const blockFocusRef = _react.useRef(false);
    const timeoutRef = _react.useRef(-1);
    const keyboardModalityRef = _react.useRef(true);
    _react.useEffect(()=>{
        if (!enabled) return;
        const win = (0, _dom.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, _dom.isHTMLElement)(elements.domReference) && elements.domReference === (0, _utils.activeElement)((0, _utils.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if (isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if (isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    _react.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    _react.useEffect(()=>{
        return ()=>{
            clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = _react.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, _utils.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, _dom.isElement)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if (isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, _utils.isTypeableElement)(target)) return;
                    } else if (!(0, _utils.matchesFocusVisible)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, _dom.isElement)(relatedTarget) && relatedTarget.hasAttribute(createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, _utils.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, _utils.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, _utils.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return _react.useMemo(()=>enabled ? {
            reference
        } : {}, [
        enabled,
        reference
    ]);
}
function mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [ACTIVE_KEY]: _, [SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1,
            [FOCUSABLE_ATTRIBUTE]: ''
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    ACTIVE_KEY,
                    SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function useInteractions(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = _react.useCallback((userProps)=>mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = _react.useCallback((userProps)=>mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = _react.useCallback((userProps)=>mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return _react.useMemo(()=>({
            getReferenceProps,
            getFloatingProps,
            getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const ESCAPE = 'Escape';
function doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function isMainOrientationKey(key, orientation) {
    const vertical = key === ARROW_UP || key === ARROW_DOWN;
    const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === ARROW_DOWN;
    const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    return doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
    const horizontal = key === ARROW_DOWN;
    return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
    const horizontal = key === ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === ESCAPE;
    return doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function useListNavigation(context, props) {
    const { open, onOpenChange, elements, floatingId } = context;
    const { listRef, activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled = true, selectedIndex = null, allowEscape = false, loop = false, nested = false, rtl = false, virtual = false, focusItemOnOpen = 'auto', focusItemOnHover = true, openOnArrowKeyDown = true, disabledIndices, orientation = 'vertical', parentOrientation, cols = 1, scrollItemIntoView = true, virtualItemRef, itemSizes, dense = false } = props;
    const floatingFocusElement = (0, _utils.getFloatingFocusElement)(elements.floating);
    const floatingFocusElementRef = (0, _utils.useLatestRef)(floatingFocusElement);
    const parentId = useFloatingParentNodeId();
    const tree = useFloatingTree();
    (0, _utils.useModernLayoutEffect)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, _utils.useEffectEvent)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, _utils.isTypeableCombobox)(elements.domReference);
    const focusItemOnOpenRef = _react.useRef(focusItemOnOpen);
    const indexRef = _react.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = _react.useRef(null);
    const isPointerModalityRef = _react.useRef(true);
    const previousOnNavigateRef = _react.useRef(onNavigate);
    const previousMountedRef = _react.useRef(!!elements.floating);
    const previousOpenRef = _react.useRef(open);
    const forceSyncFocusRef = _react.useRef(false);
    const forceScrollIntoViewRef = _react.useRef(false);
    const disabledIndicesRef = (0, _utils.useLatestRef)(disabledIndices);
    const latestOpenRef = (0, _utils.useLatestRef)(open);
    const scrollItemIntoViewRef = (0, _utils.useLatestRef)(scrollItemIntoView);
    const selectedIndexRef = (0, _utils.useLatestRef)(selectedIndex);
    const [activeId, setActiveId] = _react.useState();
    const [virtualId, setVirtualId] = _react.useState();
    const focusItem = (0, _utils.useEffectEvent)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, _utils.getMinListIndex)(listRef, disabledIndicesRef.current) : (0, _utils.getMaxListIndex)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, _utils.isIndexOutOfListBounds)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, _utils.useModernLayoutEffect)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, _utils.activeElement)((0, _utils.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, _utils.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = _react.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = _react.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, _utils.useEffectEvent)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!isMainOrientationKey(event.key, getParentOrientation())) (0, _utils.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, _dom.isHTMLElement)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, _utils.getMinListIndex)(listRef, disabledIndices);
        const maxIndex = (0, _utils.getMaxListIndex)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, _utils.stopEvent)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, _utils.stopEvent)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, _utils.createGridCellMap)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, _utils.isListIndexDisabled)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, _utils.isListIndexDisabled)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, _utils.getGridNavigatedIndex)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event,
                orientation,
                loop,
                rtl,
                cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, _utils.getGridCellIndices)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, _utils.isListIndexDisabled)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, _utils.getGridCellIndexOfCorner)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === ARROW_DOWN ? 'bl' : event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if (isMainOrientationKey(event.key, orientation)) {
            (0, _utils.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, _utils.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, _utils.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, _utils.findNonDisabledListIndex)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, _utils.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, _utils.findNonDisabledListIndex)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices
            }));
            if ((0, _utils.isIndexOutOfListBounds)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = _react.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = _react.useMemo(()=>{
        return {
            'aria-orientation': orientation === 'both' ? undefined : orientation,
            ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = _react.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, _utils.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, _utils.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, _utils.getDeepestNode)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, _utils.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, _utils.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, _utils.stopEvent)(event);
                        if (open) {
                            indexRef.current = (0, _utils.getMinListIndex)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, _utils.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return _react.useMemo(()=>enabled ? {
            reference,
            floating,
            item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function useRole(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open, elements, floatingId: defaultFloatingId } = context;
    const { enabled = true, role = 'dialog' } = props;
    const defaultReferenceId = useId();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = _react.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, _utils.getFloatingFocusElement)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = useFloatingParentNodeId();
    const isNested = parentId != null;
    const reference = _react.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return {
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined,
            ...ariaRole === 'listbox' && {
                role: 'combobox'
            },
            ...ariaRole === 'menu' && {
                id: referenceId
            },
            ...ariaRole === 'menu' && isNested && {
                role: 'menuitem'
            },
            ...role === 'select' && {
                'aria-autocomplete': 'none'
            },
            ...role === 'combobox' && {
                'aria-autocomplete': 'list'
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = _react.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === 'menu' && {
                'aria-labelledby': referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = _react.useCallback((_ref)=>{
        let { active, selected } = _ref;
        const commonProps = {
            role: 'option',
            ...active && {
                id: floatingId + "-fui-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return {
                    ...commonProps,
                    'aria-selected': selected
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return _react.useMemo(()=>enabled ? {
            reference,
            floating,
            item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = _react.useState(open);
    if (open && !isMounted) setIsMounted(true);
    _react.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function useTransitionStatus(context, props) {
    if (props === void 0) props = {};
    const { open, elements: { floating } } = context;
    const { duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = _react.useState('unmounted');
    const isMounted = useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, _utils.useModernLayoutEffect)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                _reactDom.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted,
        status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function useTransitionStyles(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = _react.useMemo(()=>({
            side,
            placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = _react.useState(()=>({
            ...execWithArgsOrReturn(unstable_common, fnArgs),
            ...execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted, status } = useTransitionStatus(context, {
        duration
    });
    const initialRef = (0, _utils.useLatestRef)(unstable_initial);
    const openRef = (0, _utils.useLatestRef)(unstable_open);
    const closeRef = (0, _utils.useLatestRef)(unstable_close);
    const commonRef = (0, _utils.useLatestRef)(unstable_common);
    (0, _utils.useModernLayoutEffect)(()=>{
        const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map(camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted,
        styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function useTypeahead(context, props) {
    var _ref;
    const { open, dataRef } = context;
    const { listRef, activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled = true, findMatch = null, resetMs = 750, ignoreKeys = [], selectedIndex = null } = props;
    const timeoutIdRef = _react.useRef(-1);
    const stringRef = _react.useRef('');
    const prevIndexRef = _react.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = _react.useRef(null);
    const onMatch = (0, _utils.useEffectEvent)(unstable_onMatch);
    const onTypingChange = (0, _utils.useEffectEvent)(unstable_onTypingChange);
    const findMatchRef = (0, _utils.useLatestRef)(findMatch);
    const ignoreKeysRef = (0, _utils.useLatestRef)(ignoreKeys);
    (0, _utils.useModernLayoutEffect)(()=>{
        if (open) {
            clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, _utils.useModernLayoutEffect)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, _utils.useEffectEvent)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, _utils.useEffectEvent)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, _utils.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, _utils.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = _react.useMemo(()=>({
            onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = _react.useMemo(()=>{
        return {
            onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return _react.useMemo(()=>enabled ? {
            reference,
            floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const inner = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef, overflowRef, onFallbackChange, offset: innerOffset = 0, index = 0, minItemsVisible = 4, referenceOverflowThreshold = 0, scrollRef, ...detectOverflowOptions } = (0, _utils1.evaluate)(props, state);
            const { rects, platform, elements: { floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, _reactDom1.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await platform.detectOverflow(getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = (0, _utils1.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, _utils1.round);
            const maxHeight = rounder((0, _utils1.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, _utils1.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, _utils1.min)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                _reactDom.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow(getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function useInnerOffset(context, props) {
    const { open, elements } = context;
    const { enabled = true, overflowRef, scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, _utils.useEffectEvent)(unstable_onChange);
    const controlledScrollingRef = _react.useRef(false);
    const prevScrollTopRef = _react.useRef(null);
    const initialOverflowRef = _react.useRef(null);
    _react.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                _reactDom.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, _utils.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = _react.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) _reactDom.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return _react.useMemo(()=>enabled ? {
            floating
        } : {}, [
        enabled,
        floating
    ]);
}
function getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function safePolygon(options) {
    if (options === void 0) options = {};
    const { buffer = 0.5, blockPointerEvents = false, requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x, y, placement, elements, onClose, nodeId, tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX, clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = contains(elements.floating, target);
            const isOverReferenceEl = contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, _dom.isElement)(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if (isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents
    };
    return fn;
}

},{"react":"erQJb","@floating-ui/react/utils":"3QvVL","react/jsx-runtime":"1xKTF","@floating-ui/utils/dom":"5EEtI","tabbable":"4gNGb","react-dom":"kVyn3","@floating-ui/react-dom":[["arrow","4iLEj"],["flip","4iLEj"],["hide","4iLEj"],["inline","4iLEj"],["limitShift","4iLEj"],["offset","4iLEj"],["shift","4iLEj"],["size","4iLEj"],["useFloating","4iLEj"],["autoUpdate","7kUOY"],["getOverflowAncestors","7kUOY"]],"@floating-ui/utils":"dT1Eq","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3QvVL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "activeElement", ()=>activeElement);
parcelHelpers.export(exports, "contains", ()=>contains);
parcelHelpers.export(exports, "createGridCellMap", ()=>createGridCellMap);
parcelHelpers.export(exports, "disableFocusInside", ()=>disableFocusInside);
parcelHelpers.export(exports, "enableFocusInside", ()=>enableFocusInside);
parcelHelpers.export(exports, "findNonDisabledListIndex", ()=>findNonDisabledListIndex);
parcelHelpers.export(exports, "getDeepestNode", ()=>getDeepestNode);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
parcelHelpers.export(exports, "getFloatingFocusElement", ()=>getFloatingFocusElement);
parcelHelpers.export(exports, "getGridCellIndexOfCorner", ()=>getGridCellIndexOfCorner);
parcelHelpers.export(exports, "getGridCellIndices", ()=>getGridCellIndices);
parcelHelpers.export(exports, "getGridNavigatedIndex", ()=>getGridNavigatedIndex);
parcelHelpers.export(exports, "getMaxListIndex", ()=>getMaxListIndex);
parcelHelpers.export(exports, "getMinListIndex", ()=>getMinListIndex);
parcelHelpers.export(exports, "getNextTabbable", ()=>getNextTabbable);
parcelHelpers.export(exports, "getNodeAncestors", ()=>getNodeAncestors);
parcelHelpers.export(exports, "getNodeChildren", ()=>getNodeChildren);
parcelHelpers.export(exports, "getPlatform", ()=>getPlatform);
parcelHelpers.export(exports, "getPreviousTabbable", ()=>getPreviousTabbable);
parcelHelpers.export(exports, "getTabbableOptions", ()=>getTabbableOptions);
parcelHelpers.export(exports, "getTarget", ()=>getTarget);
parcelHelpers.export(exports, "getUserAgent", ()=>getUserAgent);
parcelHelpers.export(exports, "isAndroid", ()=>isAndroid);
parcelHelpers.export(exports, "isDifferentGridRow", ()=>isDifferentGridRow);
parcelHelpers.export(exports, "isEventTargetWithin", ()=>isEventTargetWithin);
parcelHelpers.export(exports, "isIndexOutOfListBounds", ()=>isIndexOutOfListBounds);
parcelHelpers.export(exports, "isJSDOM", ()=>isJSDOM);
parcelHelpers.export(exports, "isListIndexDisabled", ()=>isListIndexDisabled);
parcelHelpers.export(exports, "isMac", ()=>isMac);
parcelHelpers.export(exports, "isMouseLikePointerType", ()=>isMouseLikePointerType);
parcelHelpers.export(exports, "isOutsideEvent", ()=>isOutsideEvent);
parcelHelpers.export(exports, "isReactEvent", ()=>isReactEvent);
parcelHelpers.export(exports, "isRootElement", ()=>isRootElement);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isTypeableCombobox", ()=>isTypeableCombobox);
parcelHelpers.export(exports, "isTypeableElement", ()=>isTypeableElement);
parcelHelpers.export(exports, "isVirtualClick", ()=>isVirtualClick);
parcelHelpers.export(exports, "isVirtualPointerEvent", ()=>isVirtualPointerEvent);
parcelHelpers.export(exports, "matchesFocusVisible", ()=>matchesFocusVisible);
parcelHelpers.export(exports, "stopEvent", ()=>stopEvent);
parcelHelpers.export(exports, "useEffectEvent", ()=>useEffectEvent);
parcelHelpers.export(exports, "useLatestRef", ()=>useLatestRef);
parcelHelpers.export(exports, "useModernLayoutEffect", ()=>index);
var _dom = require("@floating-ui/utils/dom");
var _react = require("react");
var _utils = require("@floating-ui/utils");
var _tabbable = require("tabbable");
// Avoid Chrome DevTools blue warning.
function getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand, version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function isAndroid() {
    const re = /android/i;
    return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
    return getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function isJSDOM() {
    return getUserAgent().includes('jsdom/');
}
const FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
function activeElement(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, _dom.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function isRootElement(element) {
    return element.matches('html,body');
}
function getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function isTypeableElement(element) {
    return (0, _dom.isHTMLElement)(element) && element.matches(TYPEABLE_SELECTOR);
}
function isTypeableCombobox(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && isTypeableElement(element);
}
function matchesFocusVisible(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || isJSDOM()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = getNodeChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function getNodeAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
function isReactEvent(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function isVirtualClick(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if (isAndroid() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
    if (isJSDOM()) return false;
    return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var isClient = typeof document !== 'undefined';
var noop = function noop() {};
var index = isClient ? (0, _react.useLayoutEffect) : noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const SafeReact = {
    ..._react
};
function useLatestRef(value) {
    const ref = _react.useRef(value);
    index(()=>{
        ref.current = value;
    });
    return ref;
}
const useInsertionEffect = SafeReact.useInsertionEffect;
const useSafeInsertionEffect = useInsertionEffect || ((fn)=>fn());
function useEffectEvent(callback) {
    const ref = _react.useRef(()=>{});
    useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return _react.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function isDifferentGridRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfListBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function getMinListIndex(listRef, disabledIndices) {
    return findNonDisabledListIndex(listRef, {
        disabledIndices
    });
}
function getMaxListIndex(listRef, disabledIndices) {
    return findNonDisabledListIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices
    });
}
function findNonDisabledListIndex(listRef, _temp) {
    let { startingIndex = -1, decrement = false, disabledIndices, amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && isListIndexDisabled(listRef, index, disabledIndices));
    return index;
}
function getGridNavigatedIndex(listRef, _ref) {
    let { event, orientation, loop, rtl, cols, disabledIndices, minIndex, maxIndex, prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === ARROW_UP) {
        stop && stopEvent(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = findNonDisabledListIndex(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if (isIndexOutOfListBounds(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === ARROW_DOWN) {
        stop && stopEvent(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = findNonDisabledListIndex(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = findNonDisabledListIndex(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices
            });
        }
        if (isIndexOutOfListBounds(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, _utils.floor)(prevIndex / cols);
        if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
            stop && stopEvent(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = findNonDisabledListIndex(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices
                });
                if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledListIndex(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledListIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
            });
            if (isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
            stop && stopEvent(event);
            if (prevIndex % cols !== 0) {
                nextIndex = findNonDisabledListIndex(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices
                });
                if (loop && isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = findNonDisabledListIndex(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices
                });
            } else if (loop) nextIndex = findNonDisabledListIndex(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices
            });
            if (isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, _utils.floor)(maxIndex / cols) === prevRow;
        if (isIndexOutOfListBounds(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledListIndex(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function createGridCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width, height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function getGridCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function getGridCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function isListIndexDisabled(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function getTabbableIn(container, dir) {
    const list = (0, _tabbable.tabbable)(container, getTabbableOptions());
    const len = list.length;
    if (len === 0) return;
    const active = activeElement(getDocument(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function getNextTabbable(referenceElement) {
    return getTabbableIn(getDocument(referenceElement).body, 1) || referenceElement;
}
function getPreviousTabbable(referenceElement) {
    return getTabbableIn(getDocument(referenceElement).body, -1) || referenceElement;
}
function isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
    const tabbableElements = (0, _tabbable.tabbable)(container, getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}

},{"@floating-ui/utils/dom":"5EEtI","react":"erQJb","@floating-ui/utils":"dT1Eq","tabbable":"4gNGb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4gNGb":[function(require,module,exports,__globalThis) {
/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusable", ()=>focusable);
parcelHelpers.export(exports, "getTabIndex", ()=>getTabIndex);
parcelHelpers.export(exports, "isFocusable", ()=>isFocusable);
parcelHelpers.export(exports, "isTabbable", ()=>isTabbable);
parcelHelpers.export(exports, "tabbable", ()=>tabbable);
var candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var _isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : _isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if (_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var _getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = _getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = _getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var getTabIndex = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === 'hidden';
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === 'radio';
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var _sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? _sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return _sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = _getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2hVYT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContextProvider", ()=>MenuContextProvider);
parcelHelpers.export(exports, "useMenuContext", ()=>useMenuContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [MenuContextProvider, useMenuContext] = (0, _createSafeContextMjs.createSafeContext)("Menu component was not found in the tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6PtVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "dropdown": "m_dc9b7c9f",
    "label": "m_9bfac126",
    "divider": "m_efdf90cb",
    "item": "m_99ac2aa1",
    "itemLabel": "m_5476e0d3",
    "itemSection": "m_8b75e504",
    "chevron": "m_b85b0bed"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2cpgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuDivider", ()=>MenuDivider);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
'use client';
const MenuDivider = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("MenuDivider", null, props);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("divider", {
            className,
            style,
            styles,
            classNames
        }),
        ...others
    });
});
MenuDivider.classes = (0, _menuModuleCssMjsDefault.default);
MenuDivider.displayName = "@mantine/core/MenuDivider";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5afhz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuDropdown", ()=>MenuDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _createEventHandlerMjs = require("../../../core/utils/create-event-handler/create-event-handler.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
'use client';
const MenuDropdown = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, onMouseEnter, onMouseLeave, onKeyDown, children, ...others } = (0, _usePropsMjs.useProps)("MenuDropdown", null, props);
    const wrapperRef = (0, _react.useRef)(null);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    const handleKeyDown = (0, _createEventHandlerMjs.createEventHandler)(onKeyDown, (event)=>{
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            wrapperRef.current?.querySelectorAll("[data-menu-item]:not(:disabled)")[0]?.focus();
        }
    });
    const handleMouseEnter = (0, _createEventHandlerMjs.createEventHandler)(onMouseEnter, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
    const handleMouseLeave = (0, _createEventHandlerMjs.createEventHandler)(onMouseLeave, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.closeDropdown());
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _popoverMjs.Popover).Dropdown, {
        ...others,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical",
        ref: (0, _hooks.useMergedRef)(ref, wrapperRef),
        ...ctx.getStyles("dropdown", {
            className,
            style,
            styles,
            classNames,
            withStaticClass: false
        }),
        tabIndex: -1,
        "data-menu-dropdown": true,
        onKeyDown: handleKeyDown,
        children: [
            ctx.withInitialFocusPlaceholder && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                tabIndex: -1,
                "data-autofocus": true,
                "data-mantine-stop-propagation": true,
                style: {
                    outline: 0
                }
            }),
            children
        ]
    });
});
MenuDropdown.classes = (0, _menuModuleCssMjsDefault.default);
MenuDropdown.displayName = "@mantine/core/MenuDropdown";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/create-event-handler/create-event-handler.mjs":"flDoH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"flDoH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEventHandler", ()=>createEventHandler);
'use client';
function createEventHandler(parentEventHandler, eventHandler) {
    return (event)=>{
        parentEventHandler?.(event);
        eventHandler?.(event);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"Y1e44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuItem", ()=>MenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _createScopedKeydownHandlerMjs = require("../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs");
var _createEventHandlerMjs = require("../../../core/utils/create-event-handler/create-event-handler.mjs");
var _clsx = require("clsx");
var _parseThemeColorMjs = require("../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonMjs = require("../../UnstyledButton/UnstyledButton.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
var _menuSubContextMjs = require("../MenuSub/MenuSub.context.mjs");
'use client';
const MenuItem = (0, _polymorphicFactoryMjs.polymorphicFactory)((props, ref)=>{
    const { classNames, className, style, styles, vars, color, closeMenuOnClick, leftSection, rightSection, children, disabled, "data-disabled": dataDisabled, ...others } = (0, _usePropsMjs.useProps)("MenuItem", null, props);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    const subCtx = (0, _menuSubContextMjs.useSubMenuContext)();
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const { dir } = (0, _directionProviderMjs.useDirection)();
    const itemRef = (0, _react.useRef)(null);
    const _others = others;
    const handleClick = (0, _createEventHandlerMjs.createEventHandler)(_others.onClick, ()=>{
        if (dataDisabled) return;
        if (typeof closeMenuOnClick === "boolean") closeMenuOnClick && ctx.closeDropdownImmediately();
        else ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    });
    const colors = color ? theme.variantColorResolver({
        color,
        theme,
        variant: "light"
    }) : void 0;
    const parsedThemeColor = color ? (0, _parseThemeColorMjs.parseThemeColor)({
        color,
        theme
    }) : null;
    const handleKeydown = (0, _createEventHandlerMjs.createEventHandler)(_others.onKeyDown, (event)=>{
        if (event.key === "ArrowLeft" && subCtx) {
            subCtx.close();
            subCtx.focusParentItem();
        }
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        onMouseDown: (event)=>event.preventDefault(),
        ...others,
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        ...ctx.getStyles("item", {
            className,
            style,
            styles,
            classNames
        }),
        ref: (0, _hooks.useMergedRef)(itemRef, ref),
        role: "menuitem",
        disabled,
        "data-menu-item": true,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-mantine-stop-propagation": true,
        onClick: handleClick,
        onKeyDown: (0, _createScopedKeydownHandlerMjs.createScopedKeydownHandler)({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir,
            orientation: "vertical",
            onKeyDown: handleKeydown
        }),
        __vars: {
            "--menu-item-color": parsedThemeColor?.isThemeColor && parsedThemeColor?.shade === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors?.color,
            "--menu-item-hover": colors?.hover
        },
        children: [
            leftSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles,
                    classNames
                }),
                "data-position": "left",
                children: leftSection
            }),
            children && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemLabel", {
                    styles,
                    classNames
                }),
                children
            }),
            rightSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles,
                    classNames
                }),
                "data-position": "right",
                children: rightSection
            })
        ]
    });
});
MenuItem.classes = (0, _menuModuleCssMjsDefault.default);
MenuItem.displayName = "@mantine/core/MenuItem";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs":"37qO0","../../../core/utils/create-event-handler/create-event-handler.mjs":"flDoH","clsx":"9idv4","../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs":"4t4fh","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/polymorphic-factory.mjs":"etaNf","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../UnstyledButton/UnstyledButton.mjs":"55gpk","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","../MenuSub/MenuSub.context.mjs":"aIthR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"37qO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createScopedKeydownHandler", ()=>createScopedKeydownHandler);
var _findElementAncestorMjs = require("../find-element-ancestor/find-element-ancestor.mjs");
'use client';
function getPreviousIndex(current, elements, loop) {
    for(let i = current - 1; i >= 0; i -= 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = elements.length - 1; i > -1; i -= 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function getNextIndex(current, elements, loop) {
    for(let i = current + 1; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function onSameLevel(target, sibling, parentSelector) {
    return (0, _findElementAncestorMjs.findElementAncestor)(target, parentSelector) === (0, _findElementAncestorMjs.findElementAncestor)(sibling, parentSelector);
}
function createScopedKeydownHandler({ parentSelector, siblingSelector, onKeyDown, loop = true, activateOnFocus = false, dir = "rtl", orientation }) {
    return (event)=>{
        onKeyDown?.(event);
        const elements = Array.from((0, _findElementAncestorMjs.findElementAncestor)(event.currentTarget, parentSelector)?.querySelectorAll(siblingSelector) || []).filter((node)=>onSameLevel(event.currentTarget, node, parentSelector));
        const current = elements.findIndex((el)=>event.currentTarget === el);
        const _nextIndex = getNextIndex(current, elements, loop);
        const _previousIndex = getPreviousIndex(current, elements, loop);
        const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[nextIndex].focus();
                    activateOnFocus && elements[nextIndex].click();
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[previousIndex].focus();
                    activateOnFocus && elements[previousIndex].click();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_previousIndex].focus();
                    activateOnFocus && elements[_previousIndex].click();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_nextIndex].focus();
                    activateOnFocus && elements[_nextIndex].click();
                }
                break;
            case "Home":
                event.stopPropagation();
                event.preventDefault();
                !elements[0].disabled && elements[0].focus();
                break;
            case "End":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    const last = elements.length - 1;
                    !elements[last].disabled && elements[last].focus();
                    break;
                }
        }
    };
}

},{"../find-element-ancestor/find-element-ancestor.mjs":"kNkgL","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aIthR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubMenuProvider", ()=>SubMenuProvider);
parcelHelpers.export(exports, "useSubMenuContext", ()=>useSubMenuContext);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _createOptionalContextMjs = require("../../../core/utils/create-optional-context/create-optional-context.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [SubMenuProvider, useSubMenuContext] = (0, _createOptionalContextMjs.createOptionalContext)();

},{"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../core/utils/create-optional-context/create-optional-context.mjs":"6Nntc","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6Nntc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOptionalContext", ()=>createOptionalContext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
function createOptionalContext(initialValue = null) {
    const Context = (0, _react.createContext)(initialValue);
    const useOptionalContext = ()=>(0, _react.useContext)(Context);
    const Provider = ({ children, value })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Context.Provider, {
            value,
            children
        });
    return [
        Provider,
        useOptionalContext
    ];
}

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"brO70":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuLabel", ()=>MenuLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
'use client';
const MenuLabel = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("MenuLabel", null, props);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("label", {
            className,
            style,
            styles,
            classNames
        }),
        ...others
    });
});
MenuLabel.classes = (0, _menuModuleCssMjsDefault.default);
MenuLabel.displayName = "@mantine/core/MenuLabel";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2j3WP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuSub", ()=>MenuSub);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _floatingArrowMjs = require("../../../utils/Floating/FloatingArrow/FloatingArrow.mjs");
var _useDelayedHoverMjs = require("../../../utils/Floating/use-delayed-hover.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuSubDropdownMjs = require("../MenuSubDropdown/MenuSubDropdown.mjs");
var _menuSubItemMjs = require("../MenuSubItem/MenuSubItem.mjs");
var _menuSubTargetMjs = require("../MenuSubTarget/MenuSubTarget.mjs");
var _menuSubContextMjs = require("./MenuSub.context.mjs");
'use client';
const defaultProps = {
    offset: 0,
    position: "right-start",
    transitionProps: {
        duration: 0
    },
    openDelay: 0,
    middlewares: {
        shift: {
            // Enable crossAxis shift to keep submenu dropdown within viewport bounds when positioned horizontally
            crossAxis: true
        }
    }
};
function MenuSub(_props) {
    const { children, closeDelay, openDelay, ...others } = (0, _usePropsMjs.useProps)("MenuSub", defaultProps, _props);
    const id = (0, _hooks.useId)();
    const [opened, { open, close }] = (0, _hooks.useDisclosure)(false);
    const ctx = (0, _menuSubContextMjs.useSubMenuContext)();
    const { openDropdown, closeDropdown } = (0, _useDelayedHoverMjs.useDelayedHover)({
        open,
        close,
        closeDelay,
        openDelay
    });
    const focusFirstItem = ()=>window.setTimeout(()=>{
            document.getElementById(`${id}-dropdown`)?.querySelectorAll("[data-menu-item]:not([data-disabled])")[0]?.focus();
        }, 16);
    const focusParentItem = ()=>window.setTimeout(()=>{
            document.getElementById(`${id}-target`)?.focus();
        }, 16);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _menuSubContextMjs.SubMenuProvider), {
        value: {
            opened,
            close: closeDropdown,
            open: openDropdown,
            focusFirstItem,
            focusParentItem,
            parentContext: ctx
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover), {
            opened,
            withinPortal: false,
            withArrow: false,
            id,
            ...others,
            children
        })
    });
}
MenuSub.extend = (input)=>input;
MenuSub.displayName = "@mantine/core/MenuSub";
MenuSub.Target = (0, _menuSubTargetMjs.MenuSubTarget);
MenuSub.Dropdown = (0, _menuSubDropdownMjs.MenuSubDropdown);
MenuSub.Item = (0, _menuSubItemMjs.MenuSubItem);

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":[["useDisclosure","9UqII"],["useId","H2nB9"]],"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../../utils/Floating/FloatingArrow/FloatingArrow.mjs":"kyZ0h","../../../utils/Floating/use-delayed-hover.mjs":"3MZAL","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../MenuSubDropdown/MenuSubDropdown.mjs":"bnwNP","../MenuSubItem/MenuSubItem.mjs":"3wUSM","../MenuSubTarget/MenuSubTarget.mjs":"2vcdv","./MenuSub.context.mjs":"aIthR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bnwNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuSubDropdown", ()=>MenuSubDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _createEventHandlerMjs = require("../../../core/utils/create-event-handler/create-event-handler.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
var _menuSubContextMjs = require("../MenuSub/MenuSub.context.mjs");
'use client';
const MenuSubDropdown = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, onMouseEnter, onMouseLeave, onKeyDown, children, ...others } = (0, _usePropsMjs.useProps)("MenuSubDropdown", null, props);
    const wrapperRef = (0, _react.useRef)(null);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    const subCtx = (0, _menuSubContextMjs.useSubMenuContext)();
    const handleMouseEnter = (0, _createEventHandlerMjs.createEventHandler)(onMouseEnter, subCtx?.open);
    const handleMouseLeave = (0, _createEventHandlerMjs.createEventHandler)(onMouseLeave, subCtx?.close);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Dropdown, {
        ...others,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical",
        ref: (0, _hooks.useMergedRef)(ref, wrapperRef),
        ...ctx.getStyles("dropdown", {
            className,
            style,
            styles,
            classNames,
            withStaticClass: false
        }),
        tabIndex: -1,
        "data-menu-dropdown": true,
        children
    });
});
MenuSubDropdown.classes = (0, _menuModuleCssMjsDefault.default);
MenuSubDropdown.displayName = "@mantine/core/MenuSubDropdown";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/create-event-handler/create-event-handler.mjs":"flDoH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","../MenuSub/MenuSub.context.mjs":"aIthR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3wUSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuSubItem", ()=>MenuSubItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _createScopedKeydownHandlerMjs = require("../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs");
var _createEventHandlerMjs = require("../../../core/utils/create-event-handler/create-event-handler.mjs");
var _clsx = require("clsx");
var _parseThemeColorMjs = require("../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _accordionMjs = require("../../Accordion/Accordion.mjs");
var _accordionChevronMjs = require("../../Accordion/AccordionChevron.mjs");
var _accordionItemMjs = require("../../Accordion/AccordionItem/AccordionItem.mjs");
var _accordionPanelMjs = require("../../Accordion/AccordionPanel/AccordionPanel.mjs");
var _accordionControlMjs = require("../../Accordion/AccordionControl/AccordionControl.mjs");
var _unstyledButtonMjs = require("../../UnstyledButton/UnstyledButton.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
var _menuModuleCssMjs = require("../Menu.module.css.mjs");
var _menuModuleCssMjsDefault = parcelHelpers.interopDefault(_menuModuleCssMjs);
var _menuSubContextMjs = require("../MenuSub/MenuSub.context.mjs");
'use client';
const MenuSubItem = (0, _polymorphicFactoryMjs.polymorphicFactory)((props, ref)=>{
    const { classNames, className, style, styles, vars, color, leftSection, rightSection, children, disabled, "data-disabled": dataDisabled, closeMenuOnClick, ...others } = (0, _usePropsMjs.useProps)("MenuSubItem", null, props);
    const ctx = (0, _menuContextMjs.useMenuContext)();
    const subCtx = (0, _menuSubContextMjs.useSubMenuContext)();
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const { dir } = (0, _directionProviderMjs.useDirection)();
    const itemRef = (0, _react.useRef)(null);
    const _others = others;
    const colors = color ? theme.variantColorResolver({
        color,
        theme,
        variant: "light"
    }) : void 0;
    const parsedThemeColor = color ? (0, _parseThemeColorMjs.parseThemeColor)({
        color,
        theme
    }) : null;
    const handleKeydown = (0, _createEventHandlerMjs.createEventHandler)(_others.onKeyDown, (event)=>{
        if (event.key === "ArrowRight") {
            subCtx?.open();
            subCtx?.focusFirstItem();
        }
        if (event.key === "ArrowLeft" && subCtx?.parentContext) {
            subCtx.parentContext.close();
            subCtx.parentContext.focusParentItem();
        }
    });
    const handleClick = (0, _createEventHandlerMjs.createEventHandler)(_others.onClick, ()=>{
        if (!dataDisabled && closeMenuOnClick) ctx.closeDropdownImmediately();
    });
    const handleMouseEnter = (0, _createEventHandlerMjs.createEventHandler)(_others.onMouseEnter, subCtx?.open);
    const handleMouseLeave = (0, _createEventHandlerMjs.createEventHandler)(_others.onMouseLeave, subCtx?.close);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        onMouseDown: (event)=>event.preventDefault(),
        ...others,
        unstyled: ctx.unstyled,
        tabIndex: ctx.menuItemTabIndex,
        ...ctx.getStyles("item", {
            className,
            style,
            styles,
            classNames
        }),
        ref: (0, _hooks.useMergedRef)(itemRef, ref),
        role: "menuitem",
        disabled,
        "data-menu-item": true,
        "data-sub-menu-item": true,
        "data-disabled": disabled || dataDisabled || void 0,
        "data-mantine-stop-propagation": true,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        onKeyDown: (0, _createScopedKeydownHandlerMjs.createScopedKeydownHandler)({
            siblingSelector: "[data-menu-item]:not([data-disabled])",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir,
            orientation: "vertical",
            onKeyDown: handleKeydown
        }),
        __vars: {
            "--menu-item-color": parsedThemeColor?.isThemeColor && parsedThemeColor?.shade === void 0 ? `var(--mantine-color-${parsedThemeColor.color}-6)` : colors?.color,
            "--menu-item-hover": colors?.hover
        },
        children: [
            leftSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles,
                    classNames
                }),
                "data-position": "left",
                children: leftSection
            }),
            children && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemLabel", {
                    styles,
                    classNames
                }),
                children
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...ctx.getStyles("itemSection", {
                    styles,
                    classNames
                }),
                "data-position": "right",
                children: rightSection || /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _accordionChevronMjs.AccordionChevron), {
                    ...ctx.getStyles("chevron"),
                    size: 14
                })
            })
        ]
    });
});
MenuSubItem.classes = (0, _menuModuleCssMjsDefault.default);
MenuSubItem.displayName = "@mantine/core/MenuSubItem";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs":"37qO0","../../../core/utils/create-event-handler/create-event-handler.mjs":"flDoH","clsx":"9idv4","../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs":"4t4fh","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/polymorphic-factory.mjs":"etaNf","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Accordion/Accordion.mjs":"6Duak","../../Accordion/AccordionChevron.mjs":"9DHGI","../../Accordion/AccordionItem/AccordionItem.mjs":"bLLQb","../../Accordion/AccordionPanel/AccordionPanel.mjs":"k4IxN","../../Accordion/AccordionControl/AccordionControl.mjs":"biFyC","../../UnstyledButton/UnstyledButton.mjs":"55gpk","../Menu.context.mjs":"2hVYT","../Menu.module.css.mjs":"6PtVu","../MenuSub/MenuSub.context.mjs":"aIthR","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6Duak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", ()=>Accordion);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSafeIdMjs = require("../../core/utils/get-safe-id/get-safe-id.mjs");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _accordionContextMjs = require("./Accordion.context.mjs");
var _accordionModuleCssMjs = require("./Accordion.module.css.mjs");
var _accordionModuleCssMjsDefault = parcelHelpers.interopDefault(_accordionModuleCssMjs);
var _accordionChevronMjs = require("./AccordionChevron.mjs");
var _accordionControlMjs = require("./AccordionControl/AccordionControl.mjs");
var _accordionItemMjs = require("./AccordionItem/AccordionItem.mjs");
var _accordionPanelMjs = require("./AccordionPanel/AccordionPanel.mjs");
'use client';
const defaultProps = {
    multiple: false,
    disableChevronRotation: false,
    chevronPosition: "right",
    variant: "default",
    chevronSize: "auto",
    chevronIconSize: 16
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { transitionDuration, chevronSize, radius })=>({
        root: {
            "--accordion-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
            "--accordion-chevron-size": chevronSize === void 0 ? void 0 : (0, _remMjs.rem)(chevronSize),
            "--accordion-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius)
        }
    }));
function Accordion(_props) {
    const props = (0, _usePropsMjs.useProps)("Accordion", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, children, multiple, value, defaultValue, onChange, id, loop, transitionDuration, disableChevronRotation, chevronPosition, chevronSize, order, chevron, variant, radius, chevronIconSize, attributes, ...others } = props;
    const uid = (0, _hooks.useId)(id);
    const [_value, handleChange] = (0, _hooks.useUncontrolled)({
        value,
        defaultValue,
        finalValue: multiple ? [] : null,
        onChange
    });
    const isItemActive = (itemValue)=>Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    const handleItemChange = (itemValue)=>{
        const nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter((selectedValue)=>selectedValue !== itemValue) : [
            ..._value,
            itemValue
        ] : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Accordion",
        classes: (0, _accordionModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _accordionContextMjs.AccordionProvider), {
        value: {
            isItemActive,
            onChange: handleItemChange,
            getControlId: (0, _getSafeIdMjs.getSafeId)(`${uid}-control`, "Accordion.Item component was rendered with invalid value or without value"),
            getRegionId: (0, _getSafeIdMjs.getSafeId)(`${uid}-panel`, "Accordion.Item component was rendered with invalid value or without value"),
            chevron: chevron === null ? null : chevron || /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _accordionChevronMjs.AccordionChevron), {
                size: chevronIconSize
            }),
            transitionDuration,
            disableChevronRotation,
            chevronPosition,
            order,
            loop,
            getStyles,
            variant,
            unstyled
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
            ...getStyles("root"),
            id: uid,
            ...others,
            variant,
            "data-accordion": true,
            children
        })
    });
}
const extendAccordion = (c)=>c;
Accordion.extend = extendAccordion;
Accordion.withProps = (0, _factoryMjs.getWithProps)(Accordion);
Accordion.classes = (0, _accordionModuleCssMjsDefault.default);
Accordion.displayName = "@mantine/core/Accordion";
Accordion.Item = (0, _accordionItemMjs.AccordionItem);
Accordion.Panel = (0, _accordionPanelMjs.AccordionPanel);
Accordion.Control = (0, _accordionControlMjs.AccordionControl);
Accordion.Chevron = (0, _accordionChevronMjs.AccordionChevron);

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":[["useId","H2nB9"],["useUncontrolled","bBNEa"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-safe-id/get-safe-id.mjs":"bsOWg","../../core/utils/get-size/get-size.mjs":"giXTO","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Accordion.context.mjs":"1jXmV","./Accordion.module.css.mjs":"atihZ","./AccordionChevron.mjs":"9DHGI","./AccordionControl/AccordionControl.mjs":"biFyC","./AccordionItem/AccordionItem.mjs":"bLLQb","./AccordionPanel/AccordionPanel.mjs":"k4IxN","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bsOWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSafeId", ()=>getSafeId);
'use client';
function getSafeId(uid, errorMessage) {
    return (value)=>{
        if (typeof value !== "string" || value.trim().length === 0) throw new Error(errorMessage);
        return `${uid}-${value}`;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1jXmV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionProvider", ()=>AccordionProvider);
parcelHelpers.export(exports, "useAccordionContext", ()=>useAccordionContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [AccordionProvider, useAccordionContext] = (0, _createSafeContextMjs.createSafeContext)("Accordion component was not found in the tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"atihZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_9bdbb667",
    "panel": "m_df78851f",
    "content": "m_4ba554d4",
    "itemTitle": "m_8fa820a0",
    "control": "m_4ba585b8",
    "control--default": "m_6939a5e9",
    "control--contained": "m_4271d21b",
    "label": "m_df3ffa0f",
    "chevron": "m_3f35ae96",
    "icon": "m_9bd771fe",
    "item": "m_9bd7b098",
    "item--default": "m_fe19b709",
    "item--contained": "m_1f921b3b",
    "item--filled": "m_2cdf939a",
    "item--separated": "m_9f59b069"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9DHGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionChevron", ()=>AccordionChevron);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function AccordionChevron({ style, size = 16, ...others }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            ...style,
            width: (0, _remMjs.rem)(size),
            height: (0, _remMjs.rem)(size),
            display: "block"
        },
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
            d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}
AccordionChevron.displayName = "@mantine/core/AccordionChevron";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"biFyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionControl", ()=>AccordionControl);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createScopedKeydownHandlerMjs = require("../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonMjs = require("../../UnstyledButton/UnstyledButton.mjs");
var _accordionContextMjs = require("../Accordion.context.mjs");
var _accordionModuleCssMjs = require("../Accordion.module.css.mjs");
var _accordionModuleCssMjsDefault = parcelHelpers.interopDefault(_accordionModuleCssMjs);
var _accordionItemContextMjs = require("../AccordionItem.context.mjs");
'use client';
const AccordionControl = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, chevron, icon, onClick, onKeyDown, children, disabled, mod, ...others } = (0, _usePropsMjs.useProps)("AccordionControl", null, props);
    const { value } = (0, _accordionItemContextMjs.useAccordionItemContext)();
    const ctx = (0, _accordionContextMjs.useAccordionContext)();
    const isActive = ctx.isItemActive(value);
    const shouldWrapWithHeading = typeof ctx.order === "number";
    const Heading = `h${ctx.order}`;
    const content = /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        ...others,
        ...ctx.getStyles("control", {
            className,
            classNames,
            style,
            styles,
            variant: ctx.variant
        }),
        unstyled: ctx.unstyled,
        mod: [
            "accordion-control",
            {
                active: isActive,
                "chevron-position": ctx.chevronPosition,
                disabled
            },
            mod
        ],
        ref,
        onClick: (event)=>{
            onClick?.(event);
            ctx.onChange(value);
        },
        type: "button",
        disabled,
        "aria-expanded": isActive,
        "aria-controls": ctx.getRegionId(value),
        id: ctx.getControlId(value),
        onKeyDown: (0, _createScopedKeydownHandlerMjs.createScopedKeydownHandler)({
            siblingSelector: "[data-accordion-control]",
            parentSelector: "[data-accordion]",
            activateOnFocus: false,
            loop: ctx.loop,
            orientation: "vertical",
            onKeyDown
        }),
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                component: "span",
                mod: {
                    rotate: !ctx.disableChevronRotation && isActive,
                    position: ctx.chevronPosition
                },
                ...ctx.getStyles("chevron", {
                    classNames,
                    styles
                }),
                children: chevron || ctx.chevron
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                ...ctx.getStyles("label", {
                    classNames,
                    styles
                }),
                children
            }),
            icon && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                component: "span",
                mod: {
                    "chevron-position": ctx.chevronPosition
                },
                ...ctx.getStyles("icon", {
                    classNames,
                    styles
                }),
                children: icon
            })
        ]
    });
    return shouldWrapWithHeading ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Heading, {
        ...ctx.getStyles("itemTitle", {
            classNames,
            styles
        }),
        children: content
    }) : content;
});
AccordionControl.displayName = "@mantine/core/AccordionControl";
AccordionControl.classes = (0, _accordionModuleCssMjsDefault.default);

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/create-scoped-keydown-handler/create-scoped-keydown-handler.mjs":"37qO0","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../UnstyledButton/UnstyledButton.mjs":"55gpk","../Accordion.context.mjs":"1jXmV","../Accordion.module.css.mjs":"atihZ","../AccordionItem.context.mjs":"a3F65","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"a3F65":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionItemProvider", ()=>AccordionItemProvider);
parcelHelpers.export(exports, "useAccordionItemContext", ()=>useAccordionItemContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [AccordionItemProvider, useAccordionItemContext] = (0, _createSafeContextMjs.createSafeContext)("Accordion.Item component was not found in the tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bLLQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionItem", ()=>AccordionItem);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _accordionContextMjs = require("../Accordion.context.mjs");
var _accordionModuleCssMjs = require("../Accordion.module.css.mjs");
var _accordionModuleCssMjsDefault = parcelHelpers.interopDefault(_accordionModuleCssMjs);
var _accordionItemContextMjs = require("../AccordionItem.context.mjs");
'use client';
const AccordionItem = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, value, mod, ...others } = (0, _usePropsMjs.useProps)("AccordionItem", null, props);
    const ctx = (0, _accordionContextMjs.useAccordionContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _accordionItemContextMjs.AccordionItemProvider), {
        value: {
            value
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
            ref,
            mod: [
                {
                    active: ctx.isItemActive(value)
                },
                mod
            ],
            ...ctx.getStyles("item", {
                className,
                classNames,
                styles,
                style,
                variant: ctx.variant
            }),
            ...others
        })
    });
});
AccordionItem.displayName = "@mantine/core/AccordionItem";
AccordionItem.classes = (0, _accordionModuleCssMjsDefault.default);

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Accordion.context.mjs":"1jXmV","../Accordion.module.css.mjs":"atihZ","../AccordionItem.context.mjs":"a3F65","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"k4IxN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccordionPanel", ()=>AccordionPanel);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _collapseMjs = require("../../Collapse/Collapse.mjs");
var _accordionContextMjs = require("../Accordion.context.mjs");
var _accordionModuleCssMjs = require("../Accordion.module.css.mjs");
var _accordionModuleCssMjsDefault = parcelHelpers.interopDefault(_accordionModuleCssMjs);
var _accordionItemContextMjs = require("../AccordionItem.context.mjs");
'use client';
const AccordionPanel = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, children, ...others } = (0, _usePropsMjs.useProps)("AccordionPanel", null, props);
    const { value } = (0, _accordionItemContextMjs.useAccordionItemContext)();
    const ctx = (0, _accordionContextMjs.useAccordionContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _collapseMjs.Collapse), {
        ref,
        ...ctx.getStyles("panel", {
            className,
            classNames,
            style,
            styles
        }),
        ...others,
        in: ctx.isItemActive(value),
        transitionDuration: ctx.transitionDuration ?? 200,
        role: "region",
        id: ctx.getRegionId(value),
        "aria-labelledby": ctx.getControlId(value),
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ...ctx.getStyles("content", {
                classNames,
                styles
            }),
            children
        })
    });
});
AccordionPanel.displayName = "@mantine/core/AccordionPanel";
AccordionPanel.classes = (0, _accordionModuleCssMjsDefault.default);

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Collapse/Collapse.mjs":"h2G66","../Accordion.context.mjs":"1jXmV","../Accordion.module.css.mjs":"atihZ","../AccordionItem.context.mjs":"a3F65","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"h2G66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapse", ()=>Collapse);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _getStyleObjectMjs = require("../../core/Box/get-style-object/get-style-object.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _useCollapseMjs = require("./use-collapse.mjs");
'use client';
const defaultProps = {
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    animateOpacity: true
};
const Collapse = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, in: opened, transitionDuration, transitionTimingFunction, style, onTransitionEnd, animateOpacity, keepMounted, ...others } = (0, _usePropsMjs.useProps)("Collapse", defaultProps, props);
    const theme = (0, _mantineThemeProviderMjs.useMantineTheme)();
    const shouldReduceMotion = (0, _hooks.useReducedMotion)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const duration = reduceMotion ? 0 : transitionDuration;
    const getCollapseProps = (0, _useCollapseMjs.useCollapse)({
        opened,
        transitionDuration: duration,
        transitionTimingFunction,
        onTransitionEnd,
        keepMounted
    });
    if (duration === 0) return opened ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...others,
        children
    }) : null;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getCollapseProps({
            style: {
                opacity: opened || !animateOpacity ? 1 : 0,
                transition: animateOpacity ? `opacity ${duration}ms ${transitionTimingFunction}` : "none",
                ...(0, _getStyleObjectMjs.getStyleObject)(style, theme)
            },
            ref,
            ...others
        }),
        children
    });
});
Collapse.displayName = "@mantine/core/Collapse";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"F0OXZ","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/get-style-object/get-style-object.mjs":"4cf8x","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./use-collapse.mjs":"aBfKC","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4cf8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStyleObject", ()=>getStyleObject);
'use client';
function getStyleObject(style, theme) {
    if (Array.isArray(style)) return [
        ...style
    ].reduce((acc, item)=>({
            ...acc,
            ...getStyleObject(item, theme)
        }), {});
    if (typeof style === "function") return style(theme);
    if (style == null) return {};
    return style;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aBfKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getElementHeight", ()=>getElementHeight);
parcelHelpers.export(exports, "useCollapse", ()=>useCollapse);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _hooks = require("@mantine/hooks");
'use client';
function getAutoHeightDuration(height) {
    if (!height || typeof height === "string") return 0;
    const constant = height / 36;
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function getElementHeight(el) {
    return el?.current ? el.current.scrollHeight : "auto";
}
const raf = typeof window !== "undefined" && window.requestAnimationFrame;
const collapsedHeight = 0;
const getCollapsedStyles = (keepMounted)=>({
        height: 0,
        overflow: "hidden",
        ...keepMounted ? {} : {
            display: "none"
        }
    });
function useCollapse({ transitionDuration, transitionTimingFunction = "ease", onTransitionEnd = ()=>{}, opened, keepMounted = false }) {
    const el = (0, _react.useRef)(null);
    const collapsedStyles = getCollapsedStyles(keepMounted);
    const [styles, setStylesRaw] = (0, _react.useState)(opened ? {} : collapsedStyles);
    const setStyles = (newStyles)=>{
        (0, _reactDom.flushSync)(()=>setStylesRaw(newStyles));
    };
    const mergeStyles = (newStyles)=>{
        setStyles((oldStyles)=>({
                ...oldStyles,
                ...newStyles
            }));
    };
    function getTransitionStyles(height) {
        const _duration = transitionDuration || getAutoHeightDuration(height);
        return {
            transition: `height ${_duration}ms ${transitionTimingFunction}, opacity ${_duration}ms ${transitionTimingFunction}`
        };
    }
    (0, _hooks.useDidUpdate)(()=>{
        if (typeof raf === "function") {
            if (opened) raf(()=>{
                mergeStyles({
                    willChange: "height",
                    display: "block",
                    overflow: "hidden"
                });
                raf(()=>{
                    const height = getElementHeight(el);
                    mergeStyles({
                        ...getTransitionStyles(height),
                        height
                    });
                });
            });
            else raf(()=>{
                const height = getElementHeight(el);
                mergeStyles({
                    ...getTransitionStyles(height),
                    willChange: "height",
                    height
                });
                raf(()=>mergeStyles({
                        height: collapsedHeight,
                        overflow: "hidden"
                    }));
            });
        }
    }, [
        opened
    ]);
    const handleTransitionEnd = (e)=>{
        if (e.target !== el.current || e.propertyName !== "height") return;
        if (opened) {
            const height = getElementHeight(el);
            if (height === styles.height) setStyles({});
            else mergeStyles({
                height
            });
            onTransitionEnd();
        } else if (styles.height === collapsedHeight) {
            setStyles(collapsedStyles);
            onTransitionEnd();
        }
    };
    function getCollapseProps({ style = {}, refKey = "ref", ...rest } = {}) {
        const theirRef = rest[refKey];
        const props = {
            "aria-hidden": !opened,
            ...rest,
            [refKey]: (0, _hooks.mergeRefs)(el, theirRef),
            onTransitionEnd: handleTransitionEnd,
            style: {
                boxSizing: "border-box",
                ...style,
                ...styles
            }
        };
        if ((0, _reactDefault.default).version.startsWith("18")) {
            if (!opened) props.inert = "";
        } else props.inert = !opened;
        return props;
    }
    return getCollapseProps;
}

},{"react":"erQJb","react-dom":"kVyn3","@mantine/hooks":[["mergeRefs","3QtIc"],["useDidUpdate","bzSpx"]],"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2vcdv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuSubTarget", ()=>MenuSubTarget);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _isElementMjs = require("../../../core/utils/is-element/is-element.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
'use client';
function MenuSubTarget({ children, refProp }) {
    if (!(0, _isElementMjs.isElement)(children)) throw new Error("Menu.Sub.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    (0, _menuContextMjs.useMenuContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Target, {
        refProp,
        popupType: "menu",
        children
    });
}
MenuSubTarget.displayName = "@mantine/core/MenuSubTarget";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/is-element/is-element.mjs":"5Gmmd","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Menu.context.mjs":"2hVYT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"k2hse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuTarget", ()=>MenuTarget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _createEventHandlerMjs = require("../../../core/utils/create-event-handler/create-event-handler.mjs");
var _hooks = require("@mantine/hooks");
var _getSingleElementChildMjs = require("../../../core/utils/get-single-element-child/get-single-element-child.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _menuContextMjs = require("../Menu.context.mjs");
'use client';
const defaultProps = {
    refProp: "ref"
};
const MenuTarget = (0, _react.forwardRef)((props, ref)=>{
    const { children, refProp, ...others } = (0, _usePropsMjs.useProps)("MenuTarget", defaultProps, props);
    const child = (0, _getSingleElementChildMjs.getSingleElementChild)(children);
    if (!child) throw new Error("Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, _menuContextMjs.useMenuContext)();
    const _childProps = child.props;
    const onClick = (0, _createEventHandlerMjs.createEventHandler)(_childProps.onClick, ()=>{
        if (ctx.trigger === "click") ctx.toggleDropdown();
        else if (ctx.trigger === "click-hover") {
            ctx.setOpenedViaClick(true);
            if (!ctx.opened) ctx.openDropdown();
        }
    });
    const onMouseEnter = (0, _createEventHandlerMjs.createEventHandler)(_childProps.onMouseEnter, ()=>(ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
    const onMouseLeave = (0, _createEventHandlerMjs.createEventHandler)(_childProps.onMouseLeave, ()=>{
        if (ctx.trigger === "hover") ctx.closeDropdown();
        else if (ctx.trigger === "click-hover" && !ctx.openedViaClick) ctx.closeDropdown();
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Target, {
        refProp,
        popupType: "menu",
        ref,
        ...others,
        children: (0, _react.cloneElement)(child, {
            onClick,
            onMouseEnter,
            onMouseLeave,
            "data-expanded": ctx.opened ? true : void 0
        })
    });
});
MenuTarget.displayName = "@mantine/core/MenuTarget";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/create-event-handler/create-event-handler.mjs":"flDoH","@mantine/hooks":"cPWeR","../../../core/utils/get-single-element-child/get-single-element-child.mjs":"lgwGR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Menu.context.mjs":"2hVYT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3nDTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _clsx = require("clsx");
var _useResolvedStylesApiMjs = require("../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _getParsedComboboxDataMjs = require("../Combobox/get-parsed-combobox-data/get-parsed-combobox-data.mjs");
var _getOptionsLockupMjs = require("../Combobox/get-options-lockup/get-options-lockup.mjs");
var _comboboxChevronMjs = require("../Combobox/ComboboxChevron/ComboboxChevron.mjs");
var _comboboxMjs = require("../Combobox/Combobox.mjs");
var _comboboxDropdownMjs = require("../Combobox/ComboboxDropdown/ComboboxDropdown.mjs");
var _comboboxOptionsMjs = require("../Combobox/ComboboxOptions/ComboboxOptions.mjs");
var _comboboxOptionMjs = require("../Combobox/ComboboxOption/ComboboxOption.mjs");
var _comboboxTargetMjs = require("../Combobox/ComboboxTarget/ComboboxTarget.mjs");
var _comboboxSearchMjs = require("../Combobox/ComboboxSearch/ComboboxSearch.mjs");
var _comboboxEmptyMjs = require("../Combobox/ComboboxEmpty/ComboboxEmpty.mjs");
var _comboboxFooterMjs = require("../Combobox/ComboboxFooter/ComboboxFooter.mjs");
var _comboboxHeaderMjs = require("../Combobox/ComboboxHeader/ComboboxHeader.mjs");
var _comboboxEventsTargetMjs = require("../Combobox/ComboboxEventsTarget/ComboboxEventsTarget.mjs");
var _comboboxDropdownTargetMjs = require("../Combobox/ComboboxDropdownTarget/ComboboxDropdownTarget.mjs");
var _comboboxGroupMjs = require("../Combobox/ComboboxGroup/ComboboxGroup.mjs");
var _comboboxClearButtonMjs = require("../Combobox/ComboboxClearButton/ComboboxClearButton.mjs");
var _comboboxHiddenInputMjs = require("../Combobox/ComboboxHiddenInput/ComboboxHiddenInput.mjs");
var _optionsDropdownMjs = require("../Combobox/OptionsDropdown/OptionsDropdown.mjs");
var _useComboboxMjs = require("../Combobox/use-combobox/use-combobox.mjs");
var _comboboxContextMjs = require("../Combobox/Combobox.context.mjs");
var _inputBaseMjs = require("../InputBase/InputBase.mjs");
'use client';
const defaultProps = {
    withCheckIcon: true,
    allowDeselect: true,
    checkIconPosition: "left",
    openOnFocus: true
};
const Select = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Select", defaultProps, _props);
    const { classNames, styles, unstyled, vars, dropdownOpened, defaultDropdownOpened, onDropdownClose, onDropdownOpen, onFocus, onBlur, onClick, onChange, data, value, defaultValue, selectFirstOptionOnChange, selectFirstOptionOnDropdownOpen, onOptionSubmit, comboboxProps, readOnly, disabled, filter, limit, withScrollArea, maxDropdownHeight, size, searchable, rightSection, checkIconPosition, withCheckIcon, withAlignedLabels, nothingFoundMessage, name, form, searchValue, defaultSearchValue, onSearchChange, allowDeselect, error, rightSectionPointerEvents, id, clearable, clearButtonProps, hiddenInputProps, renderOption, onClear, autoComplete, scrollAreaProps, __defaultRightSection, __clearSection, __clearable, chevronColor, autoSelectOnBlur, openOnFocus, attributes, ...others } = props;
    const parsedData = (0, _react.useMemo)(()=>(0, _getParsedComboboxDataMjs.getParsedComboboxData)(data), [
        data
    ]);
    const retainedSelectedOptions = (0, _react.useRef)({});
    const optionsLockup = (0, _react.useMemo)(()=>(0, _getOptionsLockupMjs.getOptionsLockup)(parsedData), [
        parsedData
    ]);
    const _id = (0, _hooks.useId)(id);
    const [_value, setValue, controlled] = (0, _hooks.useUncontrolled)({
        value,
        defaultValue,
        finalValue: null,
        onChange
    });
    const selectedOption = typeof _value === "string" ? _value in optionsLockup ? optionsLockup[_value] : retainedSelectedOptions.current[_value] : void 0;
    const previousSelectedOption = (0, _hooks.usePrevious)(selectedOption);
    const [search, setSearch, searchControlled] = (0, _hooks.useUncontrolled)({
        value: searchValue,
        defaultValue: defaultSearchValue,
        finalValue: selectedOption ? selectedOption.label : "",
        onChange: onSearchChange
    });
    const combobox = (0, _useComboboxMjs.useCombobox)({
        opened: dropdownOpened,
        defaultOpened: defaultDropdownOpened,
        onDropdownOpen: ()=>{
            onDropdownOpen?.();
            if (selectFirstOptionOnDropdownOpen) combobox.selectFirstOption();
            else combobox.updateSelectedOptionIndex("active", {
                scrollIntoView: true
            });
        },
        onDropdownClose: ()=>{
            onDropdownClose?.();
            setTimeout(combobox.resetSelectedOption, 0);
        }
    });
    const handleSearchChange = (value2)=>{
        setSearch(value2);
        combobox.resetSelectedOption();
    };
    const { resolvedClassNames, resolvedStyles } = (0, _useResolvedStylesApiMjs.useResolvedStylesApi)({
        props,
        styles,
        classNames
    });
    (0, _react.useEffect)(()=>{
        if (selectFirstOptionOnChange) combobox.selectFirstOption();
    }, [
        selectFirstOptionOnChange,
        search
    ]);
    (0, _react.useEffect)(()=>{
        if (value === null) handleSearchChange("");
        if (typeof value === "string" && selectedOption && (previousSelectedOption?.value !== selectedOption.value || previousSelectedOption?.label !== selectedOption.label)) handleSearchChange(selectedOption.label);
    }, [
        value,
        selectedOption
    ]);
    (0, _react.useEffect)(()=>{
        if (!controlled && !searchControlled) handleSearchChange(typeof _value === "string" ? _value in optionsLockup ? optionsLockup[_value]?.label : retainedSelectedOptions.current[_value]?.label || "" : "");
    }, [
        optionsLockup,
        _value
    ]);
    (0, _react.useEffect)(()=>{
        if (_value) {
            if (_value in optionsLockup) retainedSelectedOptions.current[_value] = optionsLockup[_value];
        }
    }, [
        optionsLockup,
        _value
    ]);
    const clearButton = /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).ClearButton, {
        ...clearButtonProps,
        onClear: ()=>{
            setValue(null, null);
            handleSearchChange("");
            onClear?.();
        }
    });
    const _clearable = clearable && !!_value && !disabled && !readOnly;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _comboboxMjs.Combobox), {
                store: combobox,
                __staticSelector: "Select",
                classNames: resolvedClassNames,
                styles: resolvedStyles,
                unstyled,
                readOnly,
                size,
                attributes,
                keepMounted: autoSelectOnBlur,
                onOptionSubmit: (val)=>{
                    onOptionSubmit?.(val);
                    const optionLockup = allowDeselect ? optionsLockup[val].value === _value ? null : optionsLockup[val] : optionsLockup[val];
                    const nextValue = optionLockup ? optionLockup.value : null;
                    nextValue !== _value && setValue(nextValue, optionLockup);
                    !controlled && handleSearchChange(typeof nextValue === "string" ? optionLockup?.label || "" : "");
                    combobox.closeDropdown();
                },
                ...comboboxProps,
                children: [
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Target, {
                        targetType: searchable ? "input" : "button",
                        autoComplete,
                        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputBaseMjs.InputBase), {
                            id: _id,
                            ref,
                            __defaultRightSection: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Chevron, {
                                size,
                                error,
                                unstyled,
                                color: chevronColor
                            }),
                            __clearSection: clearButton,
                            __clearable: _clearable,
                            rightSection,
                            rightSectionPointerEvents: rightSectionPointerEvents || "none",
                            ...others,
                            size,
                            __staticSelector: "Select",
                            disabled,
                            readOnly: readOnly || !searchable,
                            value: search,
                            onChange: (event)=>{
                                handleSearchChange(event.currentTarget.value);
                                combobox.openDropdown();
                                selectFirstOptionOnChange && combobox.selectFirstOption();
                            },
                            onFocus: (event)=>{
                                openOnFocus && !!searchable && combobox.openDropdown();
                                onFocus?.(event);
                            },
                            onBlur: (event)=>{
                                if (autoSelectOnBlur) combobox.clickSelectedOption();
                                !!searchable && combobox.closeDropdown();
                                const optionLockup = typeof _value === "string" && (_value in optionsLockup ? optionsLockup[_value] : retainedSelectedOptions.current[_value]);
                                handleSearchChange(optionLockup ? optionLockup.label || "" : "");
                                onBlur?.(event);
                            },
                            onClick: (event)=>{
                                searchable ? combobox.openDropdown() : combobox.toggleDropdown();
                                onClick?.(event);
                            },
                            classNames: resolvedClassNames,
                            styles: resolvedStyles,
                            unstyled,
                            pointer: !searchable,
                            error,
                            attributes
                        })
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _optionsDropdownMjs.OptionsDropdown), {
                        data: parsedData,
                        hidden: readOnly || disabled,
                        filter,
                        search,
                        limit,
                        hiddenWhenEmpty: !nothingFoundMessage,
                        withScrollArea,
                        maxDropdownHeight,
                        filterOptions: !!searchable && selectedOption?.label !== search,
                        value: _value,
                        checkIconPosition,
                        withCheckIcon,
                        withAlignedLabels,
                        nothingFoundMessage,
                        unstyled,
                        labelId: others.label ? `${_id}-label` : void 0,
                        "aria-label": others.label ? void 0 : others["aria-label"],
                        renderOption,
                        scrollAreaProps
                    })
                ]
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).HiddenInput, {
                value: _value,
                name,
                form,
                disabled,
                ...hiddenInputProps
            })
        ]
    });
});
Select.classes = {
    ...(0, _inputBaseMjs.InputBase).classes,
    ...(0, _comboboxMjs.Combobox).classes
};
Select.displayName = "@mantine/core/Select";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useId","H2nB9"],["usePrevious","atULC"],["useUncontrolled","bBNEa"]],"../../core/utils/units-converters/rem.mjs":"c70Xm","clsx":"9idv4","../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs":"jZX9i","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox/get-parsed-combobox-data/get-parsed-combobox-data.mjs":"5XIQD","../Combobox/get-options-lockup/get-options-lockup.mjs":"9gdeU","../Combobox/ComboboxChevron/ComboboxChevron.mjs":"2zagb","../Combobox/Combobox.mjs":"ARnqR","../Combobox/ComboboxDropdown/ComboboxDropdown.mjs":"leres","../Combobox/ComboboxOptions/ComboboxOptions.mjs":"3sX6U","../Combobox/ComboboxOption/ComboboxOption.mjs":"1pvpg","../Combobox/ComboboxTarget/ComboboxTarget.mjs":"4KQxr","../Combobox/ComboboxSearch/ComboboxSearch.mjs":"dffVe","../Combobox/ComboboxEmpty/ComboboxEmpty.mjs":"lGf3D","../Combobox/ComboboxFooter/ComboboxFooter.mjs":"8jDt9","../Combobox/ComboboxHeader/ComboboxHeader.mjs":"bvzpn","../Combobox/ComboboxEventsTarget/ComboboxEventsTarget.mjs":"KpDr4","../Combobox/ComboboxDropdownTarget/ComboboxDropdownTarget.mjs":"dZzsf","../Combobox/ComboboxGroup/ComboboxGroup.mjs":"cWwqR","../Combobox/ComboboxClearButton/ComboboxClearButton.mjs":"6oXwH","../Combobox/ComboboxHiddenInput/ComboboxHiddenInput.mjs":"jdOqL","../Combobox/OptionsDropdown/OptionsDropdown.mjs":"diAXH","../Combobox/use-combobox/use-combobox.mjs":"5dQQx","../Combobox/Combobox.context.mjs":"8DTGg","../InputBase/InputBase.mjs":"3bAxp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5XIQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getParsedComboboxData", ()=>getParsedComboboxData);
'use client';
function parseItem(item) {
    if (typeof item === "string") return {
        value: item,
        label: item
    };
    if ("value" in item && !("label" in item)) return {
        value: item.value,
        label: item.value,
        disabled: item.disabled
    };
    if (typeof item === "number") return {
        value: item.toString(),
        label: item.toString()
    };
    if ("group" in item) return {
        group: item.group,
        items: item.items.map((i)=>parseItem(i))
    };
    return item;
}
function getParsedComboboxData(data) {
    if (!data) return [];
    return data.map((item)=>parseItem(item));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9gdeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLabelsLockup", ()=>getLabelsLockup);
parcelHelpers.export(exports, "getOptionsLockup", ()=>getOptionsLockup);
'use client';
function getOptionsLockup(options) {
    return options.reduce((acc, item)=>{
        if ("group" in item) return {
            ...acc,
            ...getOptionsLockup(item.items)
        };
        acc[item.value] = item;
        return acc;
    }, {});
}
function getLabelsLockup(options) {
    return options.reduce((acc, item)=>{
        if ("group" in item) return {
            ...acc,
            ...getLabelsLockup(item.items)
        };
        acc[item.label] = item;
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2zagb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxChevron", ()=>ComboboxChevron);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _getThemeColorMjs = require("../../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const defaultProps = {
    error: null
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { size, color })=>({
        chevron: {
            "--combobox-chevron-size": (0, _getSizeMjs.getSize)(size, "combobox-chevron-size"),
            "--combobox-chevron-color": color ? (0, _getThemeColorMjs.getThemeColor)(color, theme) : void 0
        }
    }));
const ComboboxChevron = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ComboboxChevron", defaultProps, _props);
    const { size, error, style, className, classNames, styles, unstyled, vars, mod, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ComboboxChevron",
        classes: (0, _comboboxModuleCssMjsDefault.default),
        props,
        style,
        className,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver,
        rootSelector: "chevron"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "svg",
        ...others,
        ...getStyles("chevron"),
        size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        mod: [
            "combobox-chevron",
            {
                error
            },
            mod
        ],
        ref,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
            d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
});
ComboboxChevron.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxChevron.displayName = "@mantine/core/ComboboxChevron";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gl2jP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "dropdown": "m_88b62a41",
    "search": "m_985517d8",
    "options": "m_b2821a6e",
    "option": "m_92253aa5",
    "empty": "m_2530cd1d",
    "header": "m_858f94bd",
    "footer": "m_82b967cb",
    "group": "m_254f3e4f",
    "groupLabel": "m_2bb2e9e5",
    "chevron": "m_2943220b",
    "optionsDropdownOption": "m_390b5f4",
    "optionsDropdownCheckIcon": "m_8ee53fc2",
    "optionsDropdownCheckPlaceholder": "m_a530ee0a"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ARnqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Combobox", ()=>Combobox);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../Popover/PopoverTarget/PopoverTarget.mjs");
var _comboboxContextMjs = require("./Combobox.context.mjs");
var _comboboxModuleCssMjs = require("./Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
var _comboboxChevronMjs = require("./ComboboxChevron/ComboboxChevron.mjs");
var _comboboxClearButtonMjs = require("./ComboboxClearButton/ComboboxClearButton.mjs");
var _comboboxDropdownMjs = require("./ComboboxDropdown/ComboboxDropdown.mjs");
var _comboboxDropdownTargetMjs = require("./ComboboxDropdownTarget/ComboboxDropdownTarget.mjs");
var _comboboxEmptyMjs = require("./ComboboxEmpty/ComboboxEmpty.mjs");
var _comboboxEventsTargetMjs = require("./ComboboxEventsTarget/ComboboxEventsTarget.mjs");
var _comboboxFooterMjs = require("./ComboboxFooter/ComboboxFooter.mjs");
var _comboboxGroupMjs = require("./ComboboxGroup/ComboboxGroup.mjs");
var _comboboxHeaderMjs = require("./ComboboxHeader/ComboboxHeader.mjs");
var _comboboxHiddenInputMjs = require("./ComboboxHiddenInput/ComboboxHiddenInput.mjs");
var _comboboxOptionMjs = require("./ComboboxOption/ComboboxOption.mjs");
var _comboboxOptionsMjs = require("./ComboboxOptions/ComboboxOptions.mjs");
var _comboboxSearchMjs = require("./ComboboxSearch/ComboboxSearch.mjs");
var _comboboxTargetMjs = require("./ComboboxTarget/ComboboxTarget.mjs");
var _useComboboxMjs = require("./use-combobox/use-combobox.mjs");
'use client';
const defaultProps = {
    keepMounted: true,
    withinPortal: true,
    resetSelectionOnOptionHover: false,
    width: "target",
    transitionProps: {
        transition: "fade",
        duration: 0
    },
    size: "sm"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size, dropdownPadding })=>({
        options: {
            "--combobox-option-fz": (0, _getSizeMjs.getFontSize)(size),
            "--combobox-option-padding": (0, _getSizeMjs.getSize)(size, "combobox-option-padding")
        },
        dropdown: {
            "--combobox-padding": dropdownPadding === void 0 ? void 0 : (0, _remMjs.rem)(dropdownPadding),
            "--combobox-option-fz": (0, _getSizeMjs.getFontSize)(size),
            "--combobox-option-padding": (0, _getSizeMjs.getSize)(size, "combobox-option-padding")
        }
    }));
function Combobox(_props) {
    const props = (0, _usePropsMjs.useProps)("Combobox", defaultProps, _props);
    const { classNames, styles, unstyled, children, store: controlledStore, vars, onOptionSubmit, onClose, size, dropdownPadding, resetSelectionOnOptionHover, __staticSelector, readOnly, attributes, ...others } = props;
    const uncontrolledStore = (0, _useComboboxMjs.useCombobox)();
    const store = controlledStore || uncontrolledStore;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: __staticSelector || "Combobox",
        classes: (0, _comboboxModuleCssMjsDefault.default),
        props,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const onDropdownClose = ()=>{
        onClose?.();
        store.closeDropdown();
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxContextMjs.ComboboxProvider), {
        value: {
            getStyles,
            store,
            onOptionSubmit,
            size,
            resetSelectionOnOptionHover,
            readOnly
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover), {
            opened: store.dropdownOpened,
            preventPositionChangeWhenVisible: false,
            ...others,
            onChange: (_opened)=>!_opened && onDropdownClose(),
            withRoles: false,
            unstyled,
            children
        })
    });
}
const extendCombobox = (c)=>c;
Combobox.extend = extendCombobox;
Combobox.classes = (0, _comboboxModuleCssMjsDefault.default);
Combobox.displayName = "@mantine/core/Combobox";
Combobox.Target = (0, _comboboxTargetMjs.ComboboxTarget);
Combobox.Dropdown = (0, _comboboxDropdownMjs.ComboboxDropdown);
Combobox.Options = (0, _comboboxOptionsMjs.ComboboxOptions);
Combobox.Option = (0, _comboboxOptionMjs.ComboboxOption);
Combobox.Search = (0, _comboboxSearchMjs.ComboboxSearch);
Combobox.Empty = (0, _comboboxEmptyMjs.ComboboxEmpty);
Combobox.Chevron = (0, _comboboxChevronMjs.ComboboxChevron);
Combobox.Footer = (0, _comboboxFooterMjs.ComboboxFooter);
Combobox.Header = (0, _comboboxHeaderMjs.ComboboxHeader);
Combobox.EventsTarget = (0, _comboboxEventsTargetMjs.ComboboxEventsTarget);
Combobox.DropdownTarget = (0, _comboboxDropdownTargetMjs.ComboboxDropdownTarget);
Combobox.Group = (0, _comboboxGroupMjs.ComboboxGroup);
Combobox.ClearButton = (0, _comboboxClearButtonMjs.ComboboxClearButton);
Combobox.HiddenInput = (0, _comboboxHiddenInputMjs.ComboboxHiddenInput);

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Popover/Popover.mjs":"7fOmz","../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","./Combobox.context.mjs":"8DTGg","./Combobox.module.css.mjs":"gl2jP","./ComboboxChevron/ComboboxChevron.mjs":"2zagb","./ComboboxClearButton/ComboboxClearButton.mjs":"6oXwH","./ComboboxDropdown/ComboboxDropdown.mjs":"leres","./ComboboxDropdownTarget/ComboboxDropdownTarget.mjs":"dZzsf","./ComboboxEmpty/ComboboxEmpty.mjs":"lGf3D","./ComboboxEventsTarget/ComboboxEventsTarget.mjs":"KpDr4","./ComboboxFooter/ComboboxFooter.mjs":"8jDt9","./ComboboxGroup/ComboboxGroup.mjs":"cWwqR","./ComboboxHeader/ComboboxHeader.mjs":"bvzpn","./ComboboxHiddenInput/ComboboxHiddenInput.mjs":"jdOqL","./ComboboxOption/ComboboxOption.mjs":"1pvpg","./ComboboxOptions/ComboboxOptions.mjs":"3sX6U","./ComboboxSearch/ComboboxSearch.mjs":"dffVe","./ComboboxTarget/ComboboxTarget.mjs":"4KQxr","./use-combobox/use-combobox.mjs":"5dQQx","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8DTGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxProvider", ()=>ComboboxProvider);
parcelHelpers.export(exports, "useComboboxContext", ()=>useComboboxContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [ComboboxProvider, useComboboxContext] = (0, _createSafeContextMjs.createSafeContext)("Combobox component was not found in tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6oXwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxClearButton", ()=>ComboboxClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _inputMjs = require("../../Input/Input.mjs");
var _inputWrapperMjs = require("../../Input/InputWrapper/InputWrapper.mjs");
var _inputDescriptionMjs = require("../../Input/InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../../Input/InputError/InputError.mjs");
var _inputLabelMjs = require("../../Input/InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("../../Input/InputPlaceholder/InputPlaceholder.mjs");
var _inputClearButtonMjs = require("../../Input/InputClearButton/InputClearButton.mjs");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputWrapperContextMjs = require("../../Input/InputWrapper.context.mjs");
'use client';
const ComboboxClearButton = (0, _react.forwardRef)(({ size, onMouseDown, onClick, onClear, ...others }, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input).ClearButton, {
        ref,
        tabIndex: -1,
        "aria-hidden": true,
        ...others,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        onClick: (event)=>{
            onClear();
            onClick?.(event);
        }
    }));
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../Input/Input.mjs":"evliY","../../Input/InputWrapper/InputWrapper.mjs":"cunzA","../../Input/InputDescription/InputDescription.mjs":"4V72r","../../Input/InputError/InputError.mjs":"67YsU","../../Input/InputLabel/InputLabel.mjs":"1lKYS","../../Input/InputPlaceholder/InputPlaceholder.mjs":"76gdH","../../Input/InputClearButton/InputClearButton.mjs":"jtN41","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Input/InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"evliY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", ()=>Input);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _extractStylePropsMjs = require("../../core/Box/style-props/extract-style-props/extract-style-props.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _inputContextMjs = require("./Input.context.mjs");
var _inputModuleCssMjs = require("./Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
var _inputClearButtonMjs = require("./InputClearButton/InputClearButton.mjs");
var _inputClearSectionMjs = require("./InputClearSection/InputClearSection.mjs");
var _inputDescriptionMjs = require("./InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("./InputError/InputError.mjs");
var _inputLabelMjs = require("./InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("./InputPlaceholder/InputPlaceholder.mjs");
var _inputWrapperContextMjs = require("./InputWrapper.context.mjs");
var _inputWrapperMjs = require("./InputWrapper/InputWrapper.mjs");
'use client';
const defaultProps = {
    variant: "default",
    leftSectionPointerEvents: "none",
    rightSectionPointerEvents: "none",
    withAria: true,
    withErrorStyles: true,
    size: "sm"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, props, ctx)=>({
        wrapper: {
            "--input-margin-top": ctx.offsetTop ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-margin-bottom": ctx.offsetBottom ? "calc(var(--mantine-spacing-xs) / 2)" : void 0,
            "--input-height": (0, _getSizeMjs.getSize)(props.size, "input-height"),
            "--input-fz": (0, _getSizeMjs.getFontSize)(props.size),
            "--input-radius": props.radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(props.radius),
            "--input-left-section-width": props.leftSectionWidth !== void 0 ? (0, _remMjs.rem)(props.leftSectionWidth) : void 0,
            "--input-right-section-width": props.rightSectionWidth !== void 0 ? (0, _remMjs.rem)(props.rightSectionWidth) : void 0,
            "--input-padding-y": props.multiline ? (0, _getSizeMjs.getSize)(props.size, "input-padding-y") : void 0,
            "--input-left-section-pointer-events": props.leftSectionPointerEvents,
            "--input-right-section-pointer-events": props.rightSectionPointerEvents
        }
    }));
const Input = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Input", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, required, __staticSelector, __stylesApiProps, size, wrapperProps, error, disabled, leftSection, leftSectionProps, leftSectionWidth, rightSection, rightSectionProps, rightSectionWidth, rightSectionPointerEvents, leftSectionPointerEvents, variant, vars, pointer, multiline, radius, id, withAria, withErrorStyles, mod, inputSize, attributes, __clearSection, __clearable, __defaultRightSection, ...others } = props;
    const { styleProps, rest } = (0, _extractStylePropsMjs.extractStyleProps)(others);
    const ctx = (0, _inputWrapperContextMjs.useInputWrapperContext)();
    const stylesCtx = {
        offsetBottom: ctx?.offsetBottom,
        offsetTop: ctx?.offsetTop
    };
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "Input",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        stylesCtx,
        rootSelector: "wrapper",
        vars,
        varsResolver
    });
    const ariaAttributes = withAria ? {
        required,
        disabled,
        "aria-invalid": !!error,
        "aria-describedby": ctx?.describedBy,
        id: ctx?.inputId || id
    } : {};
    const _rightSection = (0, _inputClearSectionMjs.InputClearSection)({
        __clearable,
        __clearSection,
        rightSection,
        __defaultRightSection,
        size
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputContextMjs.InputContext), {
        value: {
            size: size || "sm"
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
            ...getStyles("wrapper"),
            ...styleProps,
            ...wrapperProps,
            mod: [
                {
                    error: !!error && withErrorStyles,
                    pointer,
                    disabled,
                    multiline,
                    "data-with-right-section": !!_rightSection,
                    "data-with-left-section": !!leftSection
                },
                mod
            ],
            variant,
            size,
            children: [
                leftSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    ...leftSectionProps,
                    "data-position": "left",
                    ...getStyles("section", {
                        className: leftSectionProps?.className,
                        style: leftSectionProps?.style
                    }),
                    children: leftSection
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                    component: "input",
                    ...rest,
                    ...ariaAttributes,
                    ref,
                    required,
                    mod: {
                        disabled,
                        error: !!error && withErrorStyles
                    },
                    variant,
                    __size: inputSize,
                    ...getStyles("input")
                }),
                _rightSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    ...rightSectionProps,
                    "data-position": "right",
                    ...getStyles("section", {
                        className: rightSectionProps?.className,
                        style: rightSectionProps?.style
                    }),
                    children: _rightSection
                })
            ]
        })
    });
});
Input.classes = (0, _inputModuleCssMjsDefault.default);
Input.Wrapper = (0, _inputWrapperMjs.InputWrapper);
Input.Label = (0, _inputLabelMjs.InputLabel);
Input.Error = (0, _inputErrorMjs.InputError);
Input.Description = (0, _inputDescriptionMjs.InputDescription);
Input.Placeholder = (0, _inputPlaceholderMjs.InputPlaceholder);
Input.ClearButton = (0, _inputClearButtonMjs.InputClearButton);
Input.displayName = "@mantine/core/Input";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/style-props/extract-style-props/extract-style-props.mjs":"h5n1i","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./Input.context.mjs":"72zHD","./Input.module.css.mjs":"jjK2S","./InputClearButton/InputClearButton.mjs":"jtN41","./InputClearSection/InputClearSection.mjs":"16McL","./InputDescription/InputDescription.mjs":"4V72r","./InputError/InputError.mjs":"67YsU","./InputLabel/InputLabel.mjs":"1lKYS","./InputPlaceholder/InputPlaceholder.mjs":"76gdH","./InputWrapper.context.mjs":"kSPdi","./InputWrapper/InputWrapper.mjs":"cunzA","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"72zHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputContext", ()=>InputContext);
parcelHelpers.export(exports, "useInputContext", ()=>useInputContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _createOptionalContextMjs = require("../../core/utils/create-optional-context/create-optional-context.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [InputContext, useInputContext] = (0, _createOptionalContextMjs.createOptionalContext)({
    size: "sm"
});

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../core/utils/create-optional-context/create-optional-context.mjs":"6Nntc","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jjK2S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "wrapper": "m_6c018570",
    "input": "m_8fb7ebe7",
    "section": "m_82577fc2",
    "placeholder": "m_88bacfd0",
    "root": "m_46b77525",
    "label": "m_8fdc1311",
    "required": "m_78a94662",
    "error": "m_8f816625",
    "description": "m_fe47ce59"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jtN41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputClearButton", ()=>InputClearButton);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _useResolvedStylesApiMjs = require("../../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _closeIconMjs = require("../../CloseButton/CloseIcon.mjs");
var _closeButtonMjs = require("../../CloseButton/CloseButton.mjs");
var _inputContextMjs = require("../Input.context.mjs");
'use client';
const InputClearButton = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputClearButton", null, _props);
    const { size, variant, vars, classNames, styles, ...others } = props;
    const ctx = (0, _inputContextMjs.useInputContext)();
    const { resolvedClassNames, resolvedStyles } = (0, _useResolvedStylesApiMjs.useResolvedStylesApi)({
        classNames,
        styles,
        props
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _closeButtonMjs.CloseButton), {
        variant: variant || "transparent",
        ref,
        size: size || ctx?.size || "sm",
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        __staticSelector: "InputClearButton",
        style: {
            pointerEvents: "all",
            background: "var(--input-bg)",
            ...others.style
        },
        ...others
    });
});
InputClearButton.displayName = "@mantine/core/InputClearButton";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/styles-api/use-resolved-styles-api/use-resolved-styles-api.mjs":"jZX9i","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../CloseButton/CloseIcon.mjs":"eZugY","../../CloseButton/CloseButton.mjs":"5UCxX","../Input.context.mjs":"72zHD","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eZugY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseIcon", ()=>CloseIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
'use client';
const CloseIcon = (0, _react.forwardRef)(({ size = "var(--cb-icon-size, 70%)", style, ...others }, ref)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            ...style,
            width: size,
            height: size
        },
        ref,
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
            d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    }));
CloseIcon.displayName = "@mantine/core/CloseIcon";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5UCxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseButton", ()=>CloseButton);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonMjs = require("../UnstyledButton/UnstyledButton.mjs");
var _closeButtonModuleCssMjs = require("./CloseButton.module.css.mjs");
var _closeButtonModuleCssMjsDefault = parcelHelpers.interopDefault(_closeButtonModuleCssMjs);
var _closeIconMjs = require("./CloseIcon.mjs");
'use client';
const defaultProps = {
    variant: "subtle"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size, radius, iconSize })=>({
        root: {
            "--cb-size": (0, _getSizeMjs.getSize)(size, "cb-size"),
            "--cb-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--cb-icon-size": (0, _remMjs.rem)(iconSize)
        }
    }));
const CloseButton = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("CloseButton", defaultProps, _props);
    const { iconSize, children, vars, radius, className, classNames, style, styles, unstyled, "data-disabled": dataDisabled, disabled, variant, icon, mod, attributes, __staticSelector, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: __staticSelector || "CloseButton",
        props,
        className,
        style,
        classes: (0, _closeButtonModuleCssMjsDefault.default),
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
        ref,
        ...others,
        unstyled,
        variant,
        disabled,
        mod: [
            {
                disabled: disabled || dataDisabled
            },
            mod
        ],
        ...getStyles("root", {
            variant,
            active: !disabled && !dataDisabled
        }),
        children: [
            icon || /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _closeIconMjs.CloseIcon), {}),
            children
        ]
    });
});
CloseButton.classes = (0, _closeButtonModuleCssMjsDefault.default);
CloseButton.displayName = "@mantine/core/CloseButton";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../UnstyledButton/UnstyledButton.mjs":"55gpk","./CloseButton.module.css.mjs":"hNw7U","./CloseIcon.mjs":"eZugY","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"hNw7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_86a44da5",
    "root--subtle": "m_220c80f2"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"16McL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputClearSection", ()=>InputClearSection);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const clearSectionOffset = {
    xs: 7,
    sm: 8,
    md: 10,
    lg: 12,
    xl: 15
};
function InputClearSection({ __clearable, __clearSection, rightSection, __defaultRightSection, size = "sm" }) {
    const clearSection = __clearable && __clearSection;
    if (clearSection && (rightSection || __defaultRightSection)) return /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
        "data-combined-clear-section": true,
        style: {
            display: "flex",
            gap: 2,
            alignItems: "center",
            paddingInlineEnd: clearSectionOffset[size]
        },
        children: [
            clearSection,
            rightSection || __defaultRightSection
        ]
    });
    return rightSection === null ? null : rightSection || clearSection || __defaultRightSection;
}

},{"react/jsx-runtime":"1xKTF","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4V72r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputDescription", ()=>InputDescription);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputModuleCssMjs = require("../Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
var _inputWrapperContextMjs = require("../InputWrapper.context.mjs");
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size })=>({
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, _getSizeMjs.getFontSize)(size)} - ${(0, _remMjs.rem)(2)})`
        }
    }));
const InputDescription = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputDescription", null, _props);
    const { classNames, className, style, styles, unstyled, vars, size, __staticSelector, __inheritStyles = true, attributes, variant, ...others } = (0, _usePropsMjs.useProps)("InputDescription", null, props);
    const ctx = (0, _inputWrapperContextMjs.useInputWrapperContext)();
    const _getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        rootSelector: "description",
        vars,
        varsResolver
    });
    const getStyles = __inheritStyles && ctx?.getStyles || _getStyles;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "p",
        ref,
        variant,
        size,
        ...getStyles("description", ctx?.getStyles ? {
            className,
            style
        } : void 0),
        ...others
    });
});
InputDescription.classes = (0, _inputModuleCssMjsDefault.default);
InputDescription.displayName = "@mantine/core/InputDescription";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input.module.css.mjs":"jjK2S","../InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kSPdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputWrapperProvider", ()=>InputWrapperProvider);
parcelHelpers.export(exports, "useInputWrapperContext", ()=>useInputWrapperContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _createOptionalContextMjs = require("../../core/utils/create-optional-context/create-optional-context.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [InputWrapperProvider, useInputWrapperContext] = (0, _createOptionalContextMjs.createOptionalContext)({
    offsetBottom: false,
    offsetTop: false,
    describedBy: void 0,
    getStyles: null,
    inputId: void 0,
    labelId: void 0
});

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../core/utils/create-optional-context/create-optional-context.mjs":"6Nntc","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"67YsU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputError", ()=>InputError);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputModuleCssMjs = require("../Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
var _inputWrapperContextMjs = require("../InputWrapper.context.mjs");
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size })=>({
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, _getSizeMjs.getFontSize)(size)} - ${(0, _remMjs.rem)(2)})`
        }
    }));
const InputError = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputError", null, _props);
    const { classNames, className, style, styles, unstyled, vars, size, attributes, __staticSelector, __inheritStyles = true, variant, ...others } = props;
    const _getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        rootSelector: "error",
        vars,
        varsResolver
    });
    const ctx = (0, _inputWrapperContextMjs.useInputWrapperContext)();
    const getStyles = __inheritStyles && ctx?.getStyles || _getStyles;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        component: "p",
        ref,
        variant,
        size,
        ...getStyles("error", ctx?.getStyles ? {
            className,
            style
        } : void 0),
        ...others
    });
});
InputError.classes = (0, _inputModuleCssMjsDefault.default);
InputError.displayName = "@mantine/core/InputError";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input.module.css.mjs":"jjK2S","../InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1lKYS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputLabel", ()=>InputLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputModuleCssMjs = require("../Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
var _inputWrapperContextMjs = require("../InputWrapper.context.mjs");
'use client';
const defaultProps = {
    labelElement: "label"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size })=>({
        label: {
            "--input-label-size": (0, _getSizeMjs.getFontSize)(size),
            "--input-asterisk-color": void 0
        }
    }));
const InputLabel = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputLabel", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, labelElement, size, required, htmlFor, onMouseDown, children, __staticSelector, variant, mod, attributes, ...others } = (0, _usePropsMjs.useProps)("InputLabel", defaultProps, props);
    const _getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        rootSelector: "label",
        vars,
        varsResolver
    });
    const ctx = (0, _inputWrapperContextMjs.useInputWrapperContext)();
    const getStyles = ctx?.getStyles || _getStyles;
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
        ...getStyles("label", ctx?.getStyles ? {
            className,
            style
        } : void 0),
        component: labelElement,
        variant,
        size,
        ref,
        htmlFor: labelElement === "label" ? htmlFor : void 0,
        mod: [
            {
                required
            },
            mod
        ],
        onMouseDown: (event)=>{
            onMouseDown?.(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        },
        ...others,
        children: [
            children,
            required && /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                ...getStyles("required"),
                "aria-hidden": true,
                children: " *"
            })
        ]
    });
});
InputLabel.classes = (0, _inputModuleCssMjsDefault.default);
InputLabel.displayName = "@mantine/core/InputLabel";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input.module.css.mjs":"jjK2S","../InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"76gdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputPlaceholder", ()=>InputPlaceholder);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputModuleCssMjs = require("../Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
'use client';
const InputPlaceholder = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputPlaceholder", null, _props);
    const { classNames, className, style, styles, unstyled, vars, __staticSelector, variant, error, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "InputPlaceholder",
            __staticSelector
        ],
        props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        rootSelector: "placeholder"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("placeholder"),
        mod: [
            {
                error: !!error
            },
            mod
        ],
        component: "span",
        variant,
        ref,
        ...others
    });
});
InputPlaceholder.classes = (0, _inputModuleCssMjsDefault.default);
InputPlaceholder.displayName = "@mantine/core/InputPlaceholder";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input.module.css.mjs":"jjK2S","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cunzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputWrapper", ()=>InputWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputModuleCssMjs = require("../Input.module.css.mjs");
var _inputModuleCssMjsDefault = parcelHelpers.interopDefault(_inputModuleCssMjs);
var _inputDescriptionMjs = require("../InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../InputError/InputError.mjs");
var _inputLabelMjs = require("../InputLabel/InputLabel.mjs");
var _inputWrapperContextMjs = require("../InputWrapper.context.mjs");
var _getInputOffsetsMjs = require("./get-input-offsets/get-input-offsets.mjs");
'use client';
const defaultProps = {
    labelElement: "label",
    inputContainer: (children)=>children,
    inputWrapperOrder: [
        "label",
        "description",
        "input",
        "error"
    ]
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { size })=>({
        label: {
            "--input-label-size": (0, _getSizeMjs.getFontSize)(size),
            "--input-asterisk-color": void 0
        },
        error: {
            "--input-error-size": size === void 0 ? void 0 : `calc(${(0, _getSizeMjs.getFontSize)(size)} - ${(0, _remMjs.rem)(2)})`
        },
        description: {
            "--input-description-size": size === void 0 ? void 0 : `calc(${(0, _getSizeMjs.getFontSize)(size)} - ${(0, _remMjs.rem)(2)})`
        }
    }));
const InputWrapper = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("InputWrapper", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, size, variant, __staticSelector, inputContainer, inputWrapperOrder, label, error, description, labelProps, descriptionProps, errorProps, labelElement, children, withAsterisk, id, required, __stylesApiProps, mod, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: [
            "InputWrapper",
            __staticSelector
        ],
        props: __stylesApiProps || props,
        classes: (0, _inputModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const sharedProps = {
        size,
        variant,
        __staticSelector
    };
    const idBase = (0, _hooks.useId)(id);
    const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
    const errorId = errorProps?.id || `${idBase}-error`;
    const descriptionId = descriptionProps?.id || `${idBase}-description`;
    const inputId = idBase;
    const hasError = !!error && typeof error !== "boolean";
    const hasDescription = !!description;
    const _describedBy = `${hasError ? errorId : ""} ${hasDescription ? descriptionId : ""}`;
    const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    const labelId = labelProps?.id || `${idBase}-label`;
    const _label = label && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputLabelMjs.InputLabel), {
        labelElement,
        id: labelId,
        htmlFor: inputId,
        required: isRequired,
        ...sharedProps,
        ...labelProps,
        children: label
    }, "label");
    const _description = hasDescription && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputDescriptionMjs.InputDescription), {
        ...descriptionProps,
        ...sharedProps,
        size: descriptionProps?.size || sharedProps.size,
        id: descriptionProps?.id || descriptionId,
        children: description
    }, "description");
    const _input = /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
        children: inputContainer(children)
    }, "input");
    const _error = hasError && /* @__PURE__ */ (0, _react.createElement)((0, _inputErrorMjs.InputError), {
        ...errorProps,
        ...sharedProps,
        size: errorProps?.size || sharedProps.size,
        key: "error",
        id: errorProps?.id || errorId
    }, error);
    const content = inputWrapperOrder.map((part)=>{
        switch(part){
            case "label":
                return _label;
            case "input":
                return _input;
            case "description":
                return _description;
            case "error":
                return _error;
            default:
                return null;
        }
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputWrapperContextMjs.InputWrapperProvider), {
        value: {
            getStyles,
            describedBy,
            inputId,
            labelId,
            ...(0, _getInputOffsetsMjs.getInputOffsets)(inputWrapperOrder, {
                hasDescription,
                hasError
            })
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
            ref,
            variant,
            size,
            mod: [
                {
                    error: !!error
                },
                mod
            ],
            ...getStyles("root"),
            ...others,
            children: content
        })
    });
});
InputWrapper.classes = (0, _inputModuleCssMjsDefault.default);
InputWrapper.displayName = "@mantine/core/InputWrapper";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"H2nB9","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/get-size/get-size.mjs":"giXTO","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input.module.css.mjs":"jjK2S","../InputDescription/InputDescription.mjs":"4V72r","../InputError/InputError.mjs":"67YsU","../InputLabel/InputLabel.mjs":"1lKYS","../InputWrapper.context.mjs":"kSPdi","./get-input-offsets/get-input-offsets.mjs":"gpW5E","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gpW5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputOffsets", ()=>getInputOffsets);
'use client';
function getInputOffsets(inputWrapperOrder, { hasDescription, hasError }) {
    const inputIndex = inputWrapperOrder.findIndex((part)=>part === "input");
    const aboveInput = inputWrapperOrder.slice(0, inputIndex);
    const belowInput = inputWrapperOrder.slice(inputIndex + 1);
    const offsetTop = hasDescription && aboveInput.includes("description") || hasError && aboveInput.includes("error");
    const offsetBottom = hasDescription && belowInput.includes("description") || hasError && belowInput.includes("error");
    return {
        offsetBottom,
        offsetTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"leres":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxDropdown", ()=>ComboboxDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxDropdown = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, styles, className, style, hidden, ...others } = (0, _usePropsMjs.useProps)("ComboboxDropdown", null, props);
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Dropdown, {
        ...others,
        ref,
        role: "presentation",
        "data-hidden": hidden || void 0,
        ...ctx.getStyles("dropdown", {
            className,
            style,
            classNames,
            styles
        })
    });
});
ComboboxDropdown.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxDropdown.displayName = "@mantine/core/ComboboxDropdown";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dZzsf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxDropdownTarget", ()=>ComboboxDropdownTarget);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _isElementMjs = require("../../../core/utils/is-element/is-element.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
'use client';
const defaultProps = {
    refProp: "ref"
};
const ComboboxDropdownTarget = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, refProp } = (0, _usePropsMjs.useProps)("ComboboxDropdownTarget", defaultProps, props);
    (0, _comboboxContextMjs.useComboboxContext)();
    if (!(0, _isElementMjs.isElement)(children)) throw new Error("Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Target, {
        ref,
        refProp,
        children
    });
});
ComboboxDropdownTarget.displayName = "@mantine/core/ComboboxDropdownTarget";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/is-element/is-element.mjs":"5Gmmd","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Combobox.context.mjs":"8DTGg","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lGf3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxEmpty", ()=>ComboboxEmpty);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxEmpty = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("ComboboxEmpty", null, props);
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("empty", {
            className,
            classNames,
            styles,
            style
        }),
        ...others
    });
});
ComboboxEmpty.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxEmpty.displayName = "@mantine/core/ComboboxEmpty";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"KpDr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxEventsTarget", ()=>ComboboxEventsTarget);
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _getRefPropMjs = require("../../../core/utils/get-ref-prop/get-ref-prop.mjs");
var _getSingleElementChildMjs = require("../../../core/utils/get-single-element-child/get-single-element-child.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _useComboboxTargetPropsMjs = require("../use-combobox-target-props/use-combobox-target-props.mjs");
'use client';
const defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false,
    autoComplete: "off"
};
const ComboboxEventsTarget = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, refProp, withKeyboardNavigation, withAriaAttributes, withExpandedAttribute, targetType, autoComplete, ...others } = (0, _usePropsMjs.useProps)("ComboboxEventsTarget", defaultProps, props);
    const child = (0, _getSingleElementChildMjs.getSingleElementChild)(children);
    if (!child) throw new Error("Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const targetProps = (0, _useComboboxTargetPropsMjs.useComboboxTargetProps)({
        targetType,
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute,
        onKeyDown: child.props.onKeyDown,
        autoComplete
    });
    return (0, _react.cloneElement)(child, {
        ...targetProps,
        ...others,
        [refProp]: (0, _hooks.useMergedRef)(ref, ctx.store.targetRef, (0, _getRefPropMjs.getRefProp)(child))
    });
});
ComboboxEventsTarget.displayName = "@mantine/core/ComboboxEventsTarget";

},{"react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","react/jsx-runtime":"1xKTF","../../../core/utils/get-ref-prop/get-ref-prop.mjs":"jLOGP","../../../core/utils/get-single-element-child/get-single-element-child.mjs":"lgwGR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../use-combobox-target-props/use-combobox-target-props.mjs":"ilYk1","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ilYk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComboboxTargetProps", ()=>useComboboxTargetProps);
var _react = require("react");
var _comboboxContextMjs = require("../Combobox.context.mjs");
'use client';
function useComboboxTargetProps({ onKeyDown, withKeyboardNavigation, withAriaAttributes, withExpandedAttribute, targetType, autoComplete }) {
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const [selectedOptionId, setSelectedOptionId] = (0, _react.useState)(null);
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (ctx.readOnly) return;
        if (withKeyboardNavigation) {
            if (event.nativeEvent.isComposing) return;
            if (event.nativeEvent.code === "ArrowDown") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                    ctx.store.updateSelectedOptionIndex("selected", {
                        scrollIntoView: true
                    });
                } else setSelectedOptionId(ctx.store.selectNextOption());
            }
            if (event.nativeEvent.code === "ArrowUp") {
                event.preventDefault();
                if (!ctx.store.dropdownOpened) {
                    ctx.store.openDropdown("keyboard");
                    setSelectedOptionId(ctx.store.selectActiveOption());
                    ctx.store.updateSelectedOptionIndex("selected", {
                        scrollIntoView: true
                    });
                } else setSelectedOptionId(ctx.store.selectPreviousOption());
            }
            if (event.nativeEvent.code === "Enter" || event.nativeEvent.code === "NumpadEnter") {
                if (event.nativeEvent.keyCode === 229) return;
                const selectedOptionIndex = ctx.store.getSelectedOptionIndex();
                if (ctx.store.dropdownOpened && selectedOptionIndex !== -1) {
                    event.preventDefault();
                    ctx.store.clickSelectedOption();
                } else if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.openDropdown("keyboard");
                }
            }
            if (event.key === "Escape") ctx.store.closeDropdown("keyboard");
            if (event.nativeEvent.code === "Space") {
                if (targetType === "button") {
                    event.preventDefault();
                    ctx.store.toggleDropdown("keyboard");
                }
            }
        }
    };
    const ariaAttributes = withAriaAttributes ? {
        "aria-haspopup": "listbox",
        "aria-expanded": withExpandedAttribute ? !!(ctx.store.listId && ctx.store.dropdownOpened) : void 0,
        "aria-controls": ctx.store.dropdownOpened && ctx.store.listId ? ctx.store.listId : void 0,
        "aria-activedescendant": ctx.store.dropdownOpened ? selectedOptionId || void 0 : void 0,
        autoComplete,
        "data-expanded": ctx.store.dropdownOpened || void 0,
        "data-mantine-stop-propagation": ctx.store.dropdownOpened || void 0
    } : {};
    return {
        ...ariaAttributes,
        onKeyDown: handleKeyDown
    };
}

},{"react":"erQJb","../Combobox.context.mjs":"8DTGg","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8jDt9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxFooter", ()=>ComboboxFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxFooter = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("ComboboxFooter", null, props);
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("footer", {
            className,
            classNames,
            style,
            styles
        }),
        ...others,
        onMouseDown: (event)=>{
            event.preventDefault();
        }
    });
});
ComboboxFooter.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxFooter.displayName = "@mantine/core/ComboboxFooter";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cWwqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxGroup", ()=>ComboboxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxGroup = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, children, label, id, ...others } = (0, _usePropsMjs.useProps)("ComboboxGroup", null, props);
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const _id = (0, _hooks.useId)(id);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
        ref,
        role: "group",
        "aria-labelledby": label ? _id : void 0,
        ...ctx.getStyles("group", {
            className,
            classNames,
            style,
            styles
        }),
        ...others,
        children: [
            label && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                id: _id,
                ...ctx.getStyles("groupLabel", {
                    classNames,
                    styles
                }),
                children: label
            }),
            children
        ]
    });
});
ComboboxGroup.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxGroup.displayName = "@mantine/core/ComboboxGroup";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"H2nB9","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bvzpn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxHeader", ()=>ComboboxHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxHeader = (0, _factoryMjs.factory)((props, ref)=>{
    const { classNames, className, style, styles, vars, ...others } = (0, _usePropsMjs.useProps)("ComboboxHeader", null, props);
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("header", {
            className,
            classNames,
            style,
            styles
        }),
        ...others,
        onMouseDown: (event)=>{
            event.preventDefault();
        }
    });
});
ComboboxHeader.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxHeader.displayName = "@mantine/core/ComboboxHeader";

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jdOqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxHiddenInput", ()=>ComboboxHiddenInput);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function ComboboxHiddenInput({ value, valuesDivider = ",", ...others }) {
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("input", {
        type: "hidden",
        value: Array.isArray(value) ? value.join(valuesDivider) : value || "",
        ...others
    });
}
ComboboxHiddenInput.displayName = "@mantine/core/ComboboxHiddenInput";

},{"react/jsx-runtime":"1xKTF","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1pvpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxOption", ()=>ComboboxOption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxOption = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ComboboxOption", null, _props);
    const { classNames, className, style, styles, vars, onClick, id, active, onMouseDown, onMouseOver, disabled, selected, mod, ...others } = props;
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const uuid = (0, _react.useId)();
    const _id = id || uuid;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...ctx.getStyles("option", {
            className,
            classNames,
            styles,
            style
        }),
        ...others,
        ref,
        id: _id,
        mod: [
            "combobox-option",
            {
                "combobox-active": active,
                "combobox-disabled": disabled,
                "combobox-selected": selected
            },
            mod
        ],
        role: "option",
        onClick: (event)=>{
            if (!disabled) {
                ctx.onOptionSubmit?.(props.value, props);
                onClick?.(event);
            } else event.preventDefault();
        },
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        onMouseOver: (event)=>{
            if (ctx.resetSelectionOnOptionHover) ctx.store.resetSelectedOption();
            onMouseOver?.(event);
        }
    });
});
ComboboxOption.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxOption.displayName = "@mantine/core/ComboboxOption";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3sX6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxOptions", ()=>ComboboxOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
'use client';
const ComboboxOptions = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ComboboxOptions", null, _props);
    const { classNames, className, style, styles, id, onMouseDown, labelledBy, ...others } = props;
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const _id = (0, _hooks.useId)(id);
    (0, _react.useEffect)(()=>{
        ctx.store.setListId(_id);
    }, [
        _id
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...ctx.getStyles("options", {
            className,
            style,
            classNames,
            styles
        }),
        ...others,
        id: _id,
        role: "listbox",
        "aria-labelledby": labelledBy,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        }
    });
});
ComboboxOptions.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxOptions.displayName = "@mantine/core/ComboboxOptions";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"H2nB9","../../../core/utils/units-converters/rem.mjs":"c70Xm","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dffVe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxSearch", ()=>ComboboxSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputMjs = require("../../Input/Input.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
var _useComboboxTargetPropsMjs = require("../use-combobox-target-props/use-combobox-target-props.mjs");
'use client';
const defaultProps = {
    withAriaAttributes: true,
    withKeyboardNavigation: true
};
const ComboboxSearch = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ComboboxSearch", defaultProps, _props);
    const { classNames, styles, unstyled, vars, withAriaAttributes, onKeyDown, withKeyboardNavigation, size, ...others } = props;
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const _styles = ctx.getStyles("search");
    const targetProps = (0, _useComboboxTargetPropsMjs.useComboboxTargetProps)({
        targetType: "input",
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute: false,
        onKeyDown,
        autoComplete: "off"
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input), {
        ref: (0, _hooks.useMergedRef)(ref, ctx.store.searchRef),
        classNames: [
            {
                input: _styles.className
            },
            classNames
        ],
        styles: [
            {
                input: _styles.style
            },
            styles
        ],
        size: size || ctx.size,
        ...targetProps,
        ...others,
        __staticSelector: "Combobox"
    });
});
ComboboxSearch.classes = (0, _comboboxModuleCssMjsDefault.default);
ComboboxSearch.displayName = "@mantine/core/ComboboxSearch";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Input/Input.mjs":"evliY","../Combobox.context.mjs":"8DTGg","../Combobox.module.css.mjs":"gl2jP","../use-combobox-target-props/use-combobox-target-props.mjs":"ilYk1","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4KQxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboboxTarget", ()=>ComboboxTarget);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _getSingleElementChildMjs = require("../../../core/utils/get-single-element-child/get-single-element-child.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _popoverMjs = require("../../Popover/Popover.mjs");
var _popoverDropdownMjs = require("../../Popover/PopoverDropdown/PopoverDropdown.mjs");
var _popoverTargetMjs = require("../../Popover/PopoverTarget/PopoverTarget.mjs");
var _comboboxContextMjs = require("../Combobox.context.mjs");
var _useComboboxTargetPropsMjs = require("../use-combobox-target-props/use-combobox-target-props.mjs");
'use client';
const defaultProps = {
    refProp: "ref",
    targetType: "input",
    withKeyboardNavigation: true,
    withAriaAttributes: true,
    withExpandedAttribute: false,
    autoComplete: "off"
};
const ComboboxTarget = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, refProp, withKeyboardNavigation, withAriaAttributes, withExpandedAttribute, targetType, autoComplete, ...others } = (0, _usePropsMjs.useProps)("ComboboxTarget", defaultProps, props);
    const child = (0, _getSingleElementChildMjs.getSingleElementChild)(children);
    if (!child) throw new Error("Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported");
    const ctx = (0, _comboboxContextMjs.useComboboxContext)();
    const targetProps = (0, _useComboboxTargetPropsMjs.useComboboxTargetProps)({
        targetType,
        withAriaAttributes,
        withKeyboardNavigation,
        withExpandedAttribute,
        onKeyDown: child.props.onKeyDown,
        autoComplete
    });
    const clonedElement = (0, _react.cloneElement)(child, {
        ...targetProps,
        ...others
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _popoverMjs.Popover).Target, {
        ref: (0, _hooks.useMergedRef)(ref, ctx.store.targetRef),
        children: clonedElement
    });
});
ComboboxTarget.displayName = "@mantine/core/ComboboxTarget";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","../../../core/utils/get-single-element-child/get-single-element-child.mjs":"lgwGR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../Popover/Popover.mjs":"7fOmz","../../Popover/PopoverDropdown/PopoverDropdown.mjs":"4plSF","../../Popover/PopoverTarget/PopoverTarget.mjs":"duafB","../Combobox.context.mjs":"8DTGg","../use-combobox-target-props/use-combobox-target-props.mjs":"ilYk1","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5dQQx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCombobox", ()=>useCombobox);
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _findElementInShadowDomMjs = require("../../../core/utils/find-element-in-shadow-dom/find-element-in-shadow-dom.mjs");
var _getIndexMjs = require("./get-index/get-index.mjs");
'use client';
function useCombobox({ defaultOpened, opened, onOpenedChange, onDropdownClose, onDropdownOpen, loop = true, scrollBehavior = "instant" } = {}) {
    const [dropdownOpened, setDropdownOpened] = (0, _hooks.useUncontrolled)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onOpenedChange
    });
    const listId = (0, _react.useRef)(null);
    const selectedOptionIndex = (0, _react.useRef)(-1);
    const searchRef = (0, _react.useRef)(null);
    const targetRef = (0, _react.useRef)(null);
    const focusSearchTimeout = (0, _react.useRef)(-1);
    const focusTargetTimeout = (0, _react.useRef)(-1);
    const selectedIndexUpdateTimeout = (0, _react.useRef)(-1);
    const openDropdown = (0, _react.useCallback)((eventSource = "unknown")=>{
        if (!dropdownOpened) {
            setDropdownOpened(true);
            onDropdownOpen?.(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownOpen,
        dropdownOpened
    ]);
    const closeDropdown = (0, _react.useCallback)((eventSource = "unknown")=>{
        if (dropdownOpened) {
            setDropdownOpened(false);
            onDropdownClose?.(eventSource);
        }
    }, [
        setDropdownOpened,
        onDropdownClose,
        dropdownOpened
    ]);
    const toggleDropdown = (0, _react.useCallback)((eventSource = "unknown")=>{
        if (dropdownOpened) closeDropdown(eventSource);
        else openDropdown(eventSource);
    }, [
        closeDropdown,
        openDropdown,
        dropdownOpened
    ]);
    const clearSelectedItem = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const selected = (0, _findElementInShadowDomMjs.findElementBySelector)(`#${listId.current} [data-combobox-selected]`, root);
        selected?.removeAttribute("data-combobox-selected");
        selected?.removeAttribute("aria-selected");
    }, []);
    const selectOption = (0, _react.useCallback)((index)=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const list = (0, _findElementInShadowDomMjs.findElementBySelector)(`#${listId.current}`, root);
        const items = list ? (0, _findElementInShadowDomMjs.findElementsBySelector)("[data-combobox-option]", list) : null;
        if (!items) return null;
        const nextIndex = index >= items.length ? 0 : index < 0 ? items.length - 1 : index;
        selectedOptionIndex.current = nextIndex;
        if (items?.[nextIndex] && !items[nextIndex].hasAttribute("data-combobox-disabled")) {
            clearSelectedItem();
            items[nextIndex].setAttribute("data-combobox-selected", "true");
            items[nextIndex].setAttribute("aria-selected", "true");
            items[nextIndex].scrollIntoView({
                block: "nearest",
                behavior: scrollBehavior
            });
            return items[nextIndex].id;
        }
        return null;
    }, [
        scrollBehavior,
        clearSelectedItem
    ]);
    const selectActiveOption = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const activeOption = (0, _findElementInShadowDomMjs.findElementBySelector)(`#${listId.current} [data-combobox-active]`, root);
        if (activeOption) {
            const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
            const index = items.findIndex((option)=>option === activeOption);
            return selectOption(index);
        }
        return selectOption(0);
    }, [
        selectOption
    ]);
    const selectNextOption = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
        return selectOption((0, _getIndexMjs.getNextIndex)(selectedOptionIndex.current, items, loop));
    }, [
        selectOption,
        loop
    ]);
    const selectPreviousOption = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
        return selectOption((0, _getIndexMjs.getPreviousIndex)(selectedOptionIndex.current, items, loop));
    }, [
        selectOption,
        loop
    ]);
    const selectFirstOption = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
        return selectOption((0, _getIndexMjs.getFirstIndex)(items));
    }, [
        selectOption
    ]);
    const updateSelectedOptionIndex = (0, _react.useCallback)((target = "selected", options)=>{
        selectedIndexUpdateTimeout.current = window.setTimeout(()=>{
            const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
            const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
            const index = items.findIndex((option)=>option.hasAttribute(`data-combobox-${target}`));
            selectedOptionIndex.current = index;
            if (options?.scrollIntoView) items[index]?.scrollIntoView({
                block: "nearest",
                behavior: scrollBehavior
            });
        }, 0);
    }, []);
    const resetSelectedOption = (0, _react.useCallback)(()=>{
        selectedOptionIndex.current = -1;
        clearSelectedItem();
    }, [
        clearSelectedItem
    ]);
    const clickSelectedOption = (0, _react.useCallback)(()=>{
        const root = (0, _findElementInShadowDomMjs.getRootElement)(targetRef.current);
        const items = (0, _findElementInShadowDomMjs.findElementsBySelector)(`#${listId.current} [data-combobox-option]`, root);
        const item = items?.[selectedOptionIndex.current];
        item?.click();
    }, []);
    const setListId = (0, _react.useCallback)((id)=>{
        listId.current = id;
    }, []);
    const focusSearchInput = (0, _react.useCallback)(()=>{
        focusSearchTimeout.current = window.setTimeout(()=>searchRef.current?.focus(), 0);
    }, []);
    const focusTarget = (0, _react.useCallback)(()=>{
        focusTargetTimeout.current = window.setTimeout(()=>targetRef.current?.focus(), 0);
    }, []);
    const getSelectedOptionIndex = (0, _react.useCallback)(()=>selectedOptionIndex.current, []);
    (0, _react.useEffect)(()=>()=>{
            window.clearTimeout(focusSearchTimeout.current);
            window.clearTimeout(focusTargetTimeout.current);
            window.clearTimeout(selectedIndexUpdateTimeout.current);
        }, []);
    return {
        dropdownOpened,
        openDropdown,
        closeDropdown,
        toggleDropdown,
        selectedOptionIndex: selectedOptionIndex.current,
        getSelectedOptionIndex,
        selectOption,
        selectFirstOption,
        selectActiveOption,
        selectNextOption,
        selectPreviousOption,
        resetSelectedOption,
        updateSelectedOptionIndex,
        listId: listId.current,
        setListId,
        clickSelectedOption,
        searchRef,
        focusSearchInput,
        targetRef,
        focusTarget
    };
}

},{"react":"erQJb","@mantine/hooks":"bBNEa","../../../core/utils/units-converters/rem.mjs":"c70Xm","react/jsx-runtime":"1xKTF","../../../core/utils/find-element-in-shadow-dom/find-element-in-shadow-dom.mjs":"5s9gR","./get-index/get-index.mjs":"8ytUI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5s9gR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findElementBySelector", ()=>findElementBySelector);
parcelHelpers.export(exports, "findElementsBySelector", ()=>findElementsBySelector);
parcelHelpers.export(exports, "getRootElement", ()=>getRootElement);
'use client';
function findElementBySelector(selector, root = document) {
    const element = root.querySelector(selector);
    if (element) return element;
    const allElements = root.querySelectorAll("*");
    for(let i = 0; i < allElements.length; i += 1){
        const el = allElements[i];
        if (el.shadowRoot) {
            const shadowElement = findElementBySelector(selector, el.shadowRoot);
            if (shadowElement) return shadowElement;
        }
    }
    return null;
}
function findElementsBySelector(selector, root = document) {
    const results = [];
    const elements = root.querySelectorAll(selector);
    results.push(...Array.from(elements));
    const allElements = root.querySelectorAll("*");
    for(let i = 0; i < allElements.length; i += 1){
        const el = allElements[i];
        if (el.shadowRoot) {
            const shadowElements = findElementsBySelector(selector, el.shadowRoot);
            results.push(...shadowElements);
        }
    }
    return results;
}
function getRootElement(targetElement) {
    if (!targetElement) return document;
    const root = targetElement.getRootNode();
    return root instanceof ShadowRoot || root instanceof Document ? root : document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8ytUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFirstIndex", ()=>getFirstIndex);
parcelHelpers.export(exports, "getNextIndex", ()=>getNextIndex);
parcelHelpers.export(exports, "getPreviousIndex", ()=>getPreviousIndex);
'use client';
function getPreviousIndex(currentIndex, elements, loop) {
    for(let i = currentIndex - 1; i >= 0; i -= 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(let i = elements.length - 1; i > -1; i -= 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return currentIndex;
}
function getNextIndex(currentIndex, elements, loop) {
    for(let i = currentIndex + 1; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    if (loop) for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return currentIndex;
}
function getFirstIndex(elements) {
    for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].hasAttribute("data-combobox-disabled")) return i;
    }
    return -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"diAXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionsDropdown", ()=>OptionsDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _checkboxMjs = require("../../Checkbox/Checkbox.mjs");
var _checkboxGroupMjs = require("../../Checkbox/CheckboxGroup/CheckboxGroup.mjs");
var _checkIconMjs = require("../../Checkbox/CheckIcon.mjs");
var _checkboxIndicatorMjs = require("../../Checkbox/CheckboxIndicator/CheckboxIndicator.mjs");
var _checkboxCardMjs = require("../../Checkbox/CheckboxCard/CheckboxCard.mjs");
var _checkboxCardContextMjs = require("../../Checkbox/CheckboxCard/CheckboxCard.context.mjs");
var _checkboxGroupContextMjs = require("../../Checkbox/CheckboxGroup.context.mjs");
var _scrollAreaMjs = require("../../ScrollArea/ScrollArea.mjs");
var _comboboxMjs = require("../Combobox.mjs");
var _comboboxModuleCssMjs = require("../Combobox.module.css.mjs");
var _comboboxModuleCssMjsDefault = parcelHelpers.interopDefault(_comboboxModuleCssMjs);
var _defaultOptionsFilterMjs = require("./default-options-filter.mjs");
var _isEmptyComboboxDataMjs = require("./is-empty-combobox-data.mjs");
var _isOptionsGroupMjs = require("./is-options-group.mjs");
var _validateOptionsMjs = require("./validate-options.mjs");
'use client';
function isValueChecked(value, optionValue) {
    return Array.isArray(value) ? value.includes(optionValue) : value === optionValue;
}
function Option({ data, withCheckIcon, withAlignedLabels, value, checkIconPosition, unstyled, renderOption }) {
    if (!(0, _isOptionsGroupMjs.isOptionsGroup)(data)) {
        const checked = isValueChecked(value, data.value);
        const check = withCheckIcon && (checked ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _checkIconMjs.CheckIcon), {
            className: (0, _comboboxModuleCssMjsDefault.default).optionsDropdownCheckIcon
        }) : withAlignedLabels ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            className: (0, _comboboxModuleCssMjsDefault.default).optionsDropdownCheckPlaceholder
        }) : null);
        const defaultContent = /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                checkIconPosition === "left" && check,
                /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
                    children: data.label
                }),
                checkIconPosition === "right" && check
            ]
        });
        return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Option, {
            value: data.value,
            disabled: data.disabled,
            className: (0, _clsxDefault.default)({
                [(0, _comboboxModuleCssMjsDefault.default).optionsDropdownOption]: !unstyled
            }),
            "data-reverse": checkIconPosition === "right" || void 0,
            "data-checked": checked || void 0,
            "aria-selected": checked,
            active: checked,
            children: typeof renderOption === "function" ? renderOption({
                option: data,
                checked
            }) : defaultContent
        });
    }
    const options = data.items.map((item)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Option, {
            data: item,
            value,
            unstyled,
            withCheckIcon,
            withAlignedLabels,
            checkIconPosition,
            renderOption
        }, item.value));
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Group, {
        label: data.group,
        children: options
    });
}
function OptionsDropdown({ data, hidden, hiddenWhenEmpty, filter, search, limit, maxDropdownHeight, withScrollArea = true, filterOptions = true, withCheckIcon = false, withAlignedLabels = false, value, checkIconPosition, nothingFoundMessage, unstyled, labelId, renderOption, scrollAreaProps, "aria-label": ariaLabel }) {
    (0, _validateOptionsMjs.validateOptions)(data);
    const shouldFilter = typeof search === "string";
    const filteredData = shouldFilter ? (filter || (0, _defaultOptionsFilterMjs.defaultOptionsFilter))({
        options: data,
        search: filterOptions ? search : "",
        limit: limit ?? Infinity
    }) : data;
    const isEmpty = (0, _isEmptyComboboxDataMjs.isEmptyComboboxData)(filteredData);
    const options = filteredData.map((item)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Option, {
            data: item,
            withCheckIcon,
            withAlignedLabels,
            value,
            checkIconPosition,
            unstyled,
            renderOption
        }, (0, _isOptionsGroupMjs.isOptionsGroup)(item) ? item.group : item.value));
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Dropdown, {
        hidden: hidden || hiddenWhenEmpty && isEmpty,
        "data-composed": true,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _comboboxMjs.Combobox).Options, {
            labelledBy: labelId,
            "aria-label": ariaLabel,
            children: [
                withScrollArea ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaMjs.ScrollArea).Autosize, {
                    mah: maxDropdownHeight ?? 220,
                    type: "scroll",
                    scrollbarSize: "var(--combobox-padding)",
                    offsetScrollbars: "y",
                    ...scrollAreaProps,
                    children: options
                }) : options,
                isEmpty && nothingFoundMessage && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _comboboxMjs.Combobox).Empty, {
                    children: nothingFoundMessage
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1xKTF","clsx":"9idv4","../../Checkbox/Checkbox.mjs":"9nLHn","../../Checkbox/CheckboxGroup/CheckboxGroup.mjs":"8zGd2","../../Checkbox/CheckIcon.mjs":"7d3zC","../../Checkbox/CheckboxIndicator/CheckboxIndicator.mjs":"bK8xi","../../Checkbox/CheckboxCard/CheckboxCard.mjs":"eCddo","../../Checkbox/CheckboxCard/CheckboxCard.context.mjs":"eQXqa","../../Checkbox/CheckboxGroup.context.mjs":"5LpLv","../../ScrollArea/ScrollArea.mjs":"d9DI8","../Combobox.mjs":"ARnqR","../Combobox.module.css.mjs":"gl2jP","./default-options-filter.mjs":"DJ6A9","./is-empty-combobox-data.mjs":"4QuHN","./is-options-group.mjs":"2tFFp","./validate-options.mjs":"bYG3j","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9nLHn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _parseThemeColorMjs = require("../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs");
var _getThemeColorMjs = require("../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _getContrastColorMjs = require("../../core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.mjs");
var _getAutoContrastValueMjs = require("../../core/MantineProvider/color-functions/get-auto-contrast-value/get-auto-contrast-value.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _extractStylePropsMjs = require("../../core/Box/style-props/extract-style-props/extract-style-props.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _inlineInputMjs = require("../../utils/InlineInput/InlineInput.mjs");
var _checkboxModuleCssMjs = require("./Checkbox.module.css.mjs");
var _checkboxModuleCssMjsDefault = parcelHelpers.interopDefault(_checkboxModuleCssMjs);
var _checkboxCardMjs = require("./CheckboxCard/CheckboxCard.mjs");
var _checkboxGroupContextMjs = require("./CheckboxGroup.context.mjs");
var _checkboxGroupMjs = require("./CheckboxGroup/CheckboxGroup.mjs");
var _checkboxIndicatorMjs = require("./CheckboxIndicator/CheckboxIndicator.mjs");
var _checkIconMjs = require("./CheckIcon.mjs");
'use client';
const defaultProps = {
    labelPosition: "right",
    icon: (0, _checkIconMjs.CheckboxIcon),
    variant: "filled"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color, size, iconColor, variant, autoContrast })=>{
    const parsedColor = (0, _parseThemeColorMjs.parseThemeColor)({
        color: color || theme.primaryColor,
        theme
    });
    const outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        root: {
            "--checkbox-size": (0, _getSizeMjs.getSize)(size, "checkbox-size"),
            "--checkbox-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--checkbox-color": variant === "outline" ? outlineColor : (0, _getThemeColorMjs.getThemeColor)(color, theme),
            "--checkbox-icon-color": iconColor ? (0, _getThemeColorMjs.getThemeColor)(iconColor, theme) : (0, _getAutoContrastValueMjs.getAutoContrastValue)(autoContrast, theme) ? (0, _getContrastColorMjs.getContrastColor)({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
const Checkbox = (0, _factoryMjs.factory)((_props, forwardedRef)=>{
    const props = (0, _usePropsMjs.useProps)("Checkbox", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, color, label, id, size, radius, wrapperProps, checked, labelPosition, description, error, disabled, variant, indeterminate, icon: Icon, rootRef, iconColor, onChange, autoContrast, mod, attributes, ...others } = props;
    const ctx = (0, _checkboxGroupContextMjs.useCheckboxGroupContext)();
    const _size = size || ctx?.size;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Checkbox",
        props,
        classes: (0, _checkboxModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const { styleProps, rest } = (0, _extractStylePropsMjs.extractStyleProps)(others);
    const uuid = (0, _hooks.useId)(id);
    const withContextProps = {
        checked: ctx?.value.includes(rest.value) ?? checked,
        onChange: (event)=>{
            ctx?.onChange(event);
            onChange?.(event);
        },
        disabled: ctx?.disabled ?? disabled
    };
    const fallbackRef = (0, _react.useRef)(null);
    const ref = forwardedRef || fallbackRef;
    (0, _react.useEffect)(()=>{
        if (ref && "current" in ref && ref.current) {
            ref.current.indeterminate = indeterminate || false;
            if (indeterminate) ref.current.setAttribute("data-indeterminate", "true");
            else ref.current.removeAttribute("data-indeterminate");
        }
    }, [
        indeterminate,
        ref
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inlineInputMjs.InlineInput), {
        ...getStyles("root"),
        __staticSelector: "Checkbox",
        __stylesApiProps: props,
        id: uuid,
        size: _size,
        labelPosition,
        label,
        description,
        error,
        disabled: withContextProps.disabled,
        classNames,
        styles,
        unstyled,
        "data-checked": withContextProps.checked || checked || void 0,
        variant,
        ref: rootRef,
        mod,
        inert: rest.inert,
        ...styleProps,
        ...wrapperProps,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
            ...getStyles("inner"),
            mod: {
                "data-label-position": labelPosition
            },
            children: [
                /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                    component: "input",
                    id: uuid,
                    ref,
                    mod: {
                        error: !!error
                    },
                    ...getStyles("input", {
                        focusable: true,
                        variant
                    }),
                    ...rest,
                    ...withContextProps,
                    inert: rest.inert,
                    type: "checkbox"
                }),
                /* @__PURE__ */ (0, _jsxRuntime.jsx)(Icon, {
                    indeterminate,
                    ...getStyles("icon")
                })
            ]
        })
    });
});
Checkbox.classes = {
    ...(0, _checkboxModuleCssMjsDefault.default),
    ...(0, _inlineInputMjs.InlineInputClasses)
};
Checkbox.displayName = "@mantine/core/Checkbox";
Checkbox.Group = (0, _checkboxGroupMjs.CheckboxGroup);
Checkbox.Indicator = (0, _checkboxIndicatorMjs.CheckboxIndicator);
Checkbox.Card = (0, _checkboxCardMjs.CheckboxCard);

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"H2nB9","../../core/utils/units-converters/rem.mjs":"c70Xm","../../core/utils/get-size/get-size.mjs":"giXTO","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs":"4t4fh","../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.mjs":"3hO4e","../../core/MantineProvider/color-functions/get-auto-contrast-value/get-auto-contrast-value.mjs":"gqPWF","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/style-props/extract-style-props/extract-style-props.mjs":"h5n1i","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../utils/InlineInput/InlineInput.mjs":"lkpo1","./Checkbox.module.css.mjs":"8DpWE","./CheckboxCard/CheckboxCard.mjs":"eCddo","./CheckboxGroup.context.mjs":"5LpLv","./CheckboxGroup/CheckboxGroup.mjs":"8zGd2","./CheckboxIndicator/CheckboxIndicator.mjs":"bK8xi","./CheckIcon.mjs":"7d3zC","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gqPWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAutoContrastValue", ()=>getAutoContrastValue);
'use client';
function getAutoContrastValue(autoContrast, theme) {
    return typeof autoContrast === "boolean" ? autoContrast : theme.autoContrast;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lkpo1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineInput", ()=>InlineInput);
parcelHelpers.export(exports, "InlineInputClasses", ()=>InlineInputClasses);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _inputMjs = require("../../components/Input/Input.mjs");
var _inputWrapperMjs = require("../../components/Input/InputWrapper/InputWrapper.mjs");
var _inputDescriptionMjs = require("../../components/Input/InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../../components/Input/InputError/InputError.mjs");
var _inputLabelMjs = require("../../components/Input/InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("../../components/Input/InputPlaceholder/InputPlaceholder.mjs");
var _inputClearButtonMjs = require("../../components/Input/InputClearButton/InputClearButton.mjs");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _inputWrapperContextMjs = require("../../components/Input/InputWrapper.context.mjs");
var _inlineInputModuleCssMjs = require("./InlineInput.module.css.mjs");
var _inlineInputModuleCssMjsDefault = parcelHelpers.interopDefault(_inlineInputModuleCssMjs);
'use client';
const InlineInputClasses = (0, _inlineInputModuleCssMjsDefault.default);
const InlineInput = (0, _react.forwardRef)(({ __staticSelector, __stylesApiProps, className, classNames, styles, unstyled, children, label, description, id, disabled, error, size, labelPosition = "left", bodyElement = "div", labelElement = "label", variant, style, vars, mod, attributes, ...others }, ref)=>{
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: __staticSelector,
        props: __stylesApiProps,
        className,
        style,
        classes: (0, _inlineInputModuleCssMjsDefault.default),
        classNames,
        styles,
        unstyled,
        attributes
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...getStyles("root"),
        ref,
        __vars: {
            "--label-fz": (0, _getSizeMjs.getFontSize)(size),
            "--label-lh": (0, _getSizeMjs.getSize)(size, "label-lh")
        },
        mod: [
            {
                "label-position": labelPosition
            },
            mod
        ],
        variant,
        size,
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
            component: bodyElement,
            htmlFor: bodyElement === "label" ? id : void 0,
            ...getStyles("body"),
            children: [
                children,
                /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                    ...getStyles("labelWrapper"),
                    "data-disabled": disabled || void 0,
                    children: [
                        label && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                            component: labelElement,
                            htmlFor: labelElement === "label" ? id : void 0,
                            ...getStyles("label"),
                            "data-disabled": disabled || void 0,
                            children: label
                        }),
                        description && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input).Description, {
                            size,
                            __inheritStyles: false,
                            ...getStyles("description"),
                            children: description
                        }),
                        error && typeof error !== "boolean" && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input).Error, {
                            size,
                            __inheritStyles: false,
                            ...getStyles("error"),
                            children: error
                        })
                    ]
                })
            ]
        })
    });
});
InlineInput.displayName = "@mantine/core/InlineInput";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../components/Input/Input.mjs":"evliY","../../components/Input/InputWrapper/InputWrapper.mjs":"cunzA","../../components/Input/InputDescription/InputDescription.mjs":"4V72r","../../components/Input/InputError/InputError.mjs":"67YsU","../../components/Input/InputLabel/InputLabel.mjs":"1lKYS","../../components/Input/InputPlaceholder/InputPlaceholder.mjs":"76gdH","../../components/Input/InputClearButton/InputClearButton.mjs":"jtN41","../../core/utils/units-converters/rem.mjs":"c70Xm","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../components/Input/InputWrapper.context.mjs":"kSPdi","./InlineInput.module.css.mjs":"4lD0C","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4lD0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_5f75b09e",
    "body": "m_5f6e695e",
    "labelWrapper": "m_d3ea56bb",
    "label": "m_8ee546b8",
    "description": "m_328f68c0",
    "error": "m_8e8a99cc"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8DpWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_bf2d988c",
    "inner": "m_26062bec",
    "input": "m_26063560",
    "icon": "m_bf295423",
    "input--outline": "m_215c4542"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eCddo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxCard", ()=>CheckboxCard);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _unstyledButtonMjs = require("../../UnstyledButton/UnstyledButton.mjs");
var _checkboxGroupContextMjs = require("../CheckboxGroup.context.mjs");
var _checkboxCardContextMjs = require("./CheckboxCard.context.mjs");
var _checkboxCardModuleCssMjs = require("./CheckboxCard.module.css.mjs");
var _checkboxCardModuleCssMjsDefault = parcelHelpers.interopDefault(_checkboxCardModuleCssMjs);
'use client';
const defaultProps = {
    withBorder: true
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { radius })=>({
        card: {
            "--card-radius": (0, _getSizeMjs.getRadius)(radius)
        }
    }));
const CheckboxCard = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("CheckboxCard", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, checked, mod, withBorder, value, onClick, defaultChecked, onChange, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "CheckboxCard",
        classes: (0, _checkboxCardModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "card"
    });
    const ctx = (0, _checkboxGroupContextMjs.useCheckboxGroupContext)();
    const _checked = typeof checked === "boolean" ? checked : ctx ? ctx.value.includes(value || "") : void 0;
    const [_value, setValue] = (0, _hooks.useUncontrolled)({
        value: _checked,
        defaultValue: defaultChecked,
        finalValue: false,
        onChange
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _checkboxCardContextMjs.CheckboxCardProvider), {
        value: {
            checked: _value
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _unstyledButtonMjs.UnstyledButton), {
            ref,
            mod: [
                {
                    "with-border": withBorder,
                    checked: _value
                },
                mod
            ],
            ...getStyles("card"),
            ...others,
            role: "checkbox",
            "aria-checked": _value,
            onClick: (event)=>{
                onClick?.(event);
                ctx?.onChange(value || "");
                setValue(!_value);
            }
        })
    });
});
CheckboxCard.displayName = "@mantine/core/CheckboxCard";
CheckboxCard.classes = (0, _checkboxCardModuleCssMjsDefault.default);

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"bBNEa","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../UnstyledButton/UnstyledButton.mjs":"55gpk","../CheckboxGroup.context.mjs":"5LpLv","./CheckboxCard.context.mjs":"eQXqa","./CheckboxCard.module.css.mjs":"ysPiU","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5LpLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroupProvider", ()=>CheckboxGroupProvider);
parcelHelpers.export(exports, "useCheckboxGroupContext", ()=>useCheckboxGroupContext);
var _react = require("react");
'use client';
const CheckboxGroupContext = (0, _react.createContext)(null);
const CheckboxGroupProvider = CheckboxGroupContext.Provider;
const useCheckboxGroupContext = ()=>(0, _react.useContext)(CheckboxGroupContext);

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eQXqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxCardProvider", ()=>CheckboxCardProvider);
parcelHelpers.export(exports, "useCheckboxCardContext", ()=>useCheckboxCardContext);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _createOptionalContextMjs = require("../../../core/utils/create-optional-context/create-optional-context.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [CheckboxCardProvider, useCheckboxCardContext] = (0, _createOptionalContextMjs.createOptionalContext)();

},{"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","../../../core/utils/create-optional-context/create-optional-context.mjs":"6Nntc","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ysPiU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "card": "m_26775b0a"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8zGd2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxGroup", ()=>CheckboxGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _inputsGroupFieldsetMjs = require("../../../utils/InputsGroupFieldset/InputsGroupFieldset.mjs");
var _inputMjs = require("../../Input/Input.mjs");
var _inputWrapperMjs = require("../../Input/InputWrapper/InputWrapper.mjs");
var _inputDescriptionMjs = require("../../Input/InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../../Input/InputError/InputError.mjs");
var _inputLabelMjs = require("../../Input/InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("../../Input/InputPlaceholder/InputPlaceholder.mjs");
var _inputClearButtonMjs = require("../../Input/InputClearButton/InputClearButton.mjs");
var _inputWrapperContextMjs = require("../../Input/InputWrapper.context.mjs");
var _checkboxGroupContextMjs = require("../CheckboxGroup.context.mjs");
'use client';
const CheckboxGroup = (0, _factoryMjs.factory)((props, ref)=>{
    const { value, defaultValue, onChange, size, wrapperProps, children, readOnly, disabled, ...others } = (0, _usePropsMjs.useProps)("CheckboxGroup", null, props);
    const [_value, setValue] = (0, _hooks.useUncontrolled)({
        value,
        defaultValue,
        finalValue: [],
        onChange
    });
    const handleChange = (event)=>{
        const itemValue = typeof event === "string" ? event : event.currentTarget.value;
        !readOnly && setValue(_value.includes(itemValue) ? _value.filter((item)=>item !== itemValue) : [
            ..._value,
            itemValue
        ]);
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _checkboxGroupContextMjs.CheckboxGroupProvider), {
        value: {
            value: _value,
            onChange: handleChange,
            size,
            disabled
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input).Wrapper, {
            size,
            ref,
            ...wrapperProps,
            ...others,
            labelElement: "div",
            __staticSelector: "CheckboxGroup",
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputsGroupFieldsetMjs.InputsGroupFieldset), {
                role: "group",
                children
            })
        })
    });
});
CheckboxGroup.classes = (0, _inputMjs.Input).Wrapper.classes;
CheckboxGroup.displayName = "@mantine/core/CheckboxGroup";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"bBNEa","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../../utils/InputsGroupFieldset/InputsGroupFieldset.mjs":"iJfZB","../../Input/Input.mjs":"evliY","../../Input/InputWrapper/InputWrapper.mjs":"cunzA","../../Input/InputDescription/InputDescription.mjs":"4V72r","../../Input/InputError/InputError.mjs":"67YsU","../../Input/InputLabel/InputLabel.mjs":"1lKYS","../../Input/InputPlaceholder/InputPlaceholder.mjs":"76gdH","../../Input/InputClearButton/InputClearButton.mjs":"jtN41","../../Input/InputWrapper.context.mjs":"kSPdi","../CheckboxGroup.context.mjs":"5LpLv","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"iJfZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputsGroupFieldset", ()=>InputsGroupFieldset);
var _jsxRuntime = require("react/jsx-runtime");
var _inputMjs = require("../../components/Input/Input.mjs");
var _inputWrapperMjs = require("../../components/Input/InputWrapper/InputWrapper.mjs");
var _inputDescriptionMjs = require("../../components/Input/InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../../components/Input/InputError/InputError.mjs");
var _inputLabelMjs = require("../../components/Input/InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("../../components/Input/InputPlaceholder/InputPlaceholder.mjs");
var _inputClearButtonMjs = require("../../components/Input/InputClearButton/InputClearButton.mjs");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _inputWrapperContextMjs = require("../../components/Input/InputWrapper.context.mjs");
'use client';
function InputsGroupFieldset({ children, role }) {
    const ctx = (0, _inputWrapperContextMjs.useInputWrapperContext)();
    if (!ctx) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        role,
        "aria-labelledby": ctx.labelId,
        "aria-describedby": ctx.describedBy,
        children
    });
}

},{"react/jsx-runtime":"1xKTF","../../components/Input/Input.mjs":"evliY","../../components/Input/InputWrapper/InputWrapper.mjs":"cunzA","../../components/Input/InputDescription/InputDescription.mjs":"4V72r","../../components/Input/InputError/InputError.mjs":"67YsU","../../components/Input/InputLabel/InputLabel.mjs":"1lKYS","../../components/Input/InputPlaceholder/InputPlaceholder.mjs":"76gdH","../../components/Input/InputClearButton/InputClearButton.mjs":"jtN41","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../../components/Input/InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bK8xi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckboxIndicator", ()=>CheckboxIndicator);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _parseThemeColorMjs = require("../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs");
var _getThemeColorMjs = require("../../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _getContrastColorMjs = require("../../../core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.mjs");
var _getAutoContrastValueMjs = require("../../../core/MantineProvider/color-functions/get-auto-contrast-value/get-auto-contrast-value.mjs");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _factoryMjs = require("../../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _checkboxCardContextMjs = require("../CheckboxCard/CheckboxCard.context.mjs");
var _checkIconMjs = require("../CheckIcon.mjs");
var _checkboxIndicatorModuleCssMjs = require("./CheckboxIndicator.module.css.mjs");
var _checkboxIndicatorModuleCssMjsDefault = parcelHelpers.interopDefault(_checkboxIndicatorModuleCssMjs);
'use client';
const defaultProps = {
    icon: (0, _checkIconMjs.CheckboxIcon),
    variant: "filled"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color, size, iconColor, variant, autoContrast })=>{
    const parsedColor = (0, _parseThemeColorMjs.parseThemeColor)({
        color: color || theme.primaryColor,
        theme
    });
    const outlineColor = parsedColor.isThemeColor && parsedColor.shade === void 0 ? `var(--mantine-color-${parsedColor.color}-outline)` : parsedColor.color;
    return {
        indicator: {
            "--checkbox-size": (0, _getSizeMjs.getSize)(size, "checkbox-size"),
            "--checkbox-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--checkbox-color": variant === "outline" ? outlineColor : (0, _getThemeColorMjs.getThemeColor)(color, theme),
            "--checkbox-icon-color": iconColor ? (0, _getThemeColorMjs.getThemeColor)(iconColor, theme) : (0, _getAutoContrastValueMjs.getAutoContrastValue)(autoContrast, theme) ? (0, _getContrastColorMjs.getContrastColor)({
                color,
                theme,
                autoContrast
            }) : void 0
        }
    };
});
const CheckboxIndicator = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("CheckboxIndicator", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, icon: Icon, indeterminate, radius, color, iconColor, autoContrast, checked, mod, variant, disabled, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "CheckboxIndicator",
        classes: (0, _checkboxIndicatorModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver,
        rootSelector: "indicator"
    });
    const ctx = (0, _checkboxCardContextMjs.useCheckboxCardContext)();
    const _checked = typeof checked === "boolean" || typeof indeterminate === "boolean" ? checked || indeterminate : ctx?.checked || false;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ref,
        ...getStyles("indicator", {
            variant
        }),
        variant,
        mod: [
            {
                checked: _checked,
                disabled
            },
            mod
        ],
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(Icon, {
            indeterminate,
            ...getStyles("icon")
        })
    });
});
CheckboxIndicator.displayName = "@mantine/core/CheckboxIndicator";
CheckboxIndicator.classes = (0, _checkboxIndicatorModuleCssMjsDefault.default);

},{"react/jsx-runtime":"1xKTF","../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../../core/MantineProvider/color-functions/parse-theme-color/parse-theme-color.mjs":"4t4fh","../../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../../core/MantineProvider/color-functions/get-contrast-color/get-contrast-color.mjs":"3hO4e","../../../core/MantineProvider/color-functions/get-auto-contrast-value/get-auto-contrast-value.mjs":"gqPWF","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../../core/Box/Box.mjs":"eq62v","../../../core/factory/factory.mjs":"lBP7N","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../CheckboxCard/CheckboxCard.context.mjs":"eQXqa","../CheckIcon.mjs":"7d3zC","./CheckboxIndicator.module.css.mjs":"boFtI","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7d3zC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckIcon", ()=>CheckIcon);
parcelHelpers.export(exports, "CheckboxIcon", ()=>CheckboxIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function CheckIcon({ size, style, ...others }) {
    const _style = size !== void 0 ? {
        width: (0, _remMjs.rem)(size),
        height: (0, _remMjs.rem)(size),
        ...style
    } : style;
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: _style,
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("path", {
            d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })
    });
}
function CheckboxIcon({ indeterminate, ...others }) {
    if (indeterminate) return /* @__PURE__ */ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6",
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("rect", {
            width: "32",
            height: "6",
            fill: "currentColor",
            rx: "3"
        })
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CheckIcon, {
        ...others
    });
}

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"boFtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "indicator": "m_5e5256ee",
    "icon": "m_1b1c543a",
    "indicator--outline": "m_76e20374"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d9DI8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollArea", ()=>ScrollArea);
parcelHelpers.export(exports, "ScrollAreaAutosize", ()=>ScrollAreaAutosize);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _react1 = require("@floating-ui/react");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _scrollAreaModuleCssMjs = require("./ScrollArea.module.css.mjs");
var _scrollAreaModuleCssMjsDefault = parcelHelpers.interopDefault(_scrollAreaModuleCssMjs);
var _scrollAreaCornerMjs = require("./ScrollAreaCorner/ScrollAreaCorner.mjs");
var _scrollAreaRootMjs = require("./ScrollAreaRoot/ScrollAreaRoot.mjs");
var _scrollAreaScrollbarMjs = require("./ScrollAreaScrollbar/ScrollAreaScrollbar.mjs");
var _scrollAreaThumbMjs = require("./ScrollAreaThumb/ScrollAreaThumb.mjs");
var _scrollAreaViewportMjs = require("./ScrollAreaViewport/ScrollAreaViewport.mjs");
'use client';
const defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover",
    scrollbars: "xy"
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((_, { scrollbarSize, overscrollBehavior, scrollbars })=>{
    let overrideOverscrollBehavior = overscrollBehavior;
    if (overscrollBehavior && scrollbars) {
        if (scrollbars === "x") overrideOverscrollBehavior = `${overscrollBehavior} auto`;
        else if (scrollbars === "y") overrideOverscrollBehavior = `auto ${overscrollBehavior}`;
    }
    return {
        root: {
            "--scrollarea-scrollbar-size": (0, _remMjs.rem)(scrollbarSize),
            "--scrollarea-over-scroll-behavior": overrideOverscrollBehavior
        }
    };
});
const ScrollArea = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("ScrollArea", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, scrollbarSize, vars, type, scrollHideDelay, viewportProps, viewportRef, onScrollPositionChange, children, offsetScrollbars, scrollbars, onBottomReached, onTopReached, overscrollBehavior, attributes, ...others } = props;
    const [scrollbarHovered, setScrollbarHovered] = (0, _react.useState)(false);
    const [verticalThumbVisible, setVerticalThumbVisible] = (0, _react.useState)(false);
    const [horizontalThumbVisible, setHorizontalThumbVisible] = (0, _react.useState)(false);
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "ScrollArea",
        props,
        classes: (0, _scrollAreaModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const localViewportRef = (0, _react.useRef)(null);
    const combinedViewportRef = (0, _react1.useMergeRefs)([
        viewportRef,
        localViewportRef
    ]);
    (0, _react.useEffect)(()=>{
        if (!localViewportRef.current) return;
        if (offsetScrollbars !== "present") return;
        const element = localViewportRef.current;
        const observer = new ResizeObserver(()=>{
            const { scrollHeight, clientHeight, scrollWidth, clientWidth } = element;
            setVerticalThumbVisible(scrollHeight > clientHeight);
            setHorizontalThumbVisible(scrollWidth > clientWidth);
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        localViewportRef,
        offsetScrollbars
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _scrollAreaRootMjs.ScrollAreaRoot), {
        getStyles,
        type: type === "never" ? "always" : type,
        scrollHideDelay,
        ref,
        scrollbars,
        ...getStyles("root"),
        ...others,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaViewportMjs.ScrollAreaViewport), {
                ...viewportProps,
                ...getStyles("viewport", {
                    style: viewportProps?.style
                }),
                ref: combinedViewportRef,
                "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
                "data-scrollbars": scrollbars || void 0,
                "data-horizontal-hidden": offsetScrollbars === "present" && !horizontalThumbVisible ? "true" : void 0,
                "data-vertical-hidden": offsetScrollbars === "present" && !verticalThumbVisible ? "true" : void 0,
                onScroll: (e)=>{
                    viewportProps?.onScroll?.(e);
                    onScrollPositionChange?.({
                        x: e.currentTarget.scrollLeft,
                        y: e.currentTarget.scrollTop
                    });
                    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                    if (scrollTop - (scrollHeight - clientHeight) >= -0.8) onBottomReached?.();
                    if (scrollTop === 0) onTopReached?.();
                },
                children
            }),
            (scrollbars === "xy" || scrollbars === "x") && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarMjs.ScrollAreaScrollbar), {
                ...getStyles("scrollbar"),
                orientation: "horizontal",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !horizontalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: ()=>setScrollbarHovered(true),
                onMouseLeave: ()=>setScrollbarHovered(false),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaThumbMjs.ScrollAreaThumb), {
                    ...getStyles("thumb")
                })
            }),
            (scrollbars === "xy" || scrollbars === "y") && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarMjs.ScrollAreaScrollbar), {
                ...getStyles("scrollbar"),
                orientation: "vertical",
                "data-hidden": type === "never" || offsetScrollbars === "present" && !verticalThumbVisible ? true : void 0,
                forceMount: true,
                onMouseEnter: ()=>setScrollbarHovered(true),
                onMouseLeave: ()=>setScrollbarHovered(false),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaThumbMjs.ScrollAreaThumb), {
                    ...getStyles("thumb")
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaCornerMjs.ScrollAreaCorner), {
                ...getStyles("corner"),
                "data-hovered": scrollbarHovered || void 0,
                "data-hidden": type === "never" || void 0
            })
        ]
    });
});
ScrollArea.displayName = "@mantine/core/ScrollArea";
const ScrollAreaAutosize = (0, _factoryMjs.factory)((props, ref)=>{
    const { children, classNames, styles, scrollbarSize, scrollHideDelay, type, dir, offsetScrollbars, overscrollBehavior, viewportRef, onScrollPositionChange, unstyled, variant, viewportProps, scrollbars, style, vars, onBottomReached, onTopReached, onOverflowChange, ...others } = (0, _usePropsMjs.useProps)("ScrollAreaAutosize", defaultProps, props);
    const viewportObserverRef = (0, _react.useRef)(null);
    const combinedViewportRef = (0, _react1.useMergeRefs)([
        viewportRef,
        viewportObserverRef
    ]);
    const [overflowing, setOverflowing] = (0, _react.useState)(false);
    const didMount = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!onOverflowChange) return;
        const el = viewportObserverRef.current;
        if (!el) return;
        const update = ()=>{
            const isOverflowing = el.scrollHeight > el.clientHeight;
            if (isOverflowing !== overflowing) {
                if (didMount.current) onOverflowChange?.(isOverflowing);
                else {
                    didMount.current = true;
                    if (isOverflowing) onOverflowChange?.(true);
                }
                setOverflowing(isOverflowing);
            }
        };
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return ()=>ro.disconnect();
    }, [
        onOverflowChange,
        overflowing
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...others,
        ref,
        style: [
            {
                display: "flex",
                overflow: "hidden"
            },
            style
        ],
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
            style: {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                overflow: "hidden",
                ...scrollbars === "y" && {
                    minWidth: 0
                },
                ...scrollbars === "x" && {
                    minHeight: 0
                },
                ...scrollbars === "xy" && {
                    minWidth: 0,
                    minHeight: 0
                },
                ...scrollbars === false && {
                    minWidth: 0,
                    minHeight: 0
                }
            },
            children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(ScrollArea, {
                classNames,
                styles,
                scrollHideDelay,
                scrollbarSize,
                type,
                dir,
                offsetScrollbars,
                overscrollBehavior,
                viewportRef: combinedViewportRef,
                onScrollPositionChange,
                unstyled,
                variant,
                viewportProps,
                vars,
                scrollbars,
                onBottomReached,
                onTopReached,
                "data-autosize": "true",
                children
            })
        })
    });
});
ScrollArea.classes = (0, _scrollAreaModuleCssMjsDefault.default);
ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
ScrollAreaAutosize.classes = (0, _scrollAreaModuleCssMjsDefault.default);
ScrollArea.Autosize = ScrollAreaAutosize;

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@floating-ui/react":"hCF9Q","../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","./ScrollArea.module.css.mjs":"iRtdh","./ScrollAreaCorner/ScrollAreaCorner.mjs":"lWRhS","./ScrollAreaRoot/ScrollAreaRoot.mjs":"1vAGO","./ScrollAreaScrollbar/ScrollAreaScrollbar.mjs":"4SvWo","./ScrollAreaThumb/ScrollAreaThumb.mjs":"eOj8A","./ScrollAreaViewport/ScrollAreaViewport.mjs":"atMde","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"iRtdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_d57069b5",
    "content": "m_b1336c6",
    "viewport": "m_c0783ff9",
    "viewportInner": "m_f8f631dd",
    "scrollbar": "m_c44ba933",
    "thumb": "m_d8b5e363",
    "corner": "m_21657268"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lWRhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Corner", ()=>Corner);
parcelHelpers.export(exports, "ScrollAreaCorner", ()=>ScrollAreaCorner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _useResizeObserverMjs = require("../use-resize-observer.mjs");
'use client';
const Corner = (0, _react.forwardRef)((props, ref)=>{
    const { style, ...others } = props;
    const ctx = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const [width, setWidth] = (0, _react.useState)(0);
    const [height, setHeight] = (0, _react.useState)(0);
    const hasSize = Boolean(width && height);
    (0, _useResizeObserverMjs.useResizeObserver)(ctx.scrollbarX, ()=>{
        const h = ctx.scrollbarX?.offsetHeight || 0;
        ctx.onCornerHeightChange(h);
        setHeight(h);
    });
    (0, _useResizeObserverMjs.useResizeObserver)(ctx.scrollbarY, ()=>{
        const w = ctx.scrollbarY?.offsetWidth || 0;
        ctx.onCornerWidthChange(w);
        setWidth(w);
    });
    return hasSize ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        ...others,
        ref,
        style: {
            ...style,
            width,
            height
        }
    }) : null;
});
const ScrollAreaCorner = (0, _react.forwardRef)((props, ref)=>{
    const ctx = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const hasBothScrollbarsVisible = Boolean(ctx.scrollbarX && ctx.scrollbarY);
    const hasCorner = ctx.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(Corner, {
        ...props,
        ref
    }) : null;
});

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../ScrollArea.context.mjs":"05aId","../use-resize-observer.mjs":"eFjRk","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"05aId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaProvider", ()=>ScrollAreaProvider);
parcelHelpers.export(exports, "useScrollAreaContext", ()=>useScrollAreaContext);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [ScrollAreaProvider, useScrollAreaContext] = (0, _createSafeContextMjs.createSafeContext)("ScrollArea.Root component was not found in tree");

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eFjRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResizeObserver", ()=>useResizeObserver);
var _hooks = require("@mantine/hooks");
'use client';
function useResizeObserver(element, onResize) {
    const handleResize = (0, _hooks.useCallbackRef)(onResize);
    (0, _hooks.useIsomorphicEffect)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
        return void 0;
    }, [
        element,
        handleResize
    ]);
}

},{"@mantine/hooks":[["useCallbackRef","1inGi"],["useIsomorphicEffect","6Cmng"]],"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"1vAGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaRoot", ()=>ScrollAreaRoot);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
'use client';
const defaultProps = {
    scrollHideDelay: 1e3,
    type: "hover"
};
const ScrollAreaRoot = (0, _react.forwardRef)((_props, ref)=>{
    const { type, scrollHideDelay, scrollbars, getStyles, ...others } = (0, _usePropsMjs.useProps)("ScrollAreaRoot", defaultProps, _props);
    const [scrollArea, setScrollArea] = (0, _react.useState)(null);
    const [viewport, setViewport] = (0, _react.useState)(null);
    const [content, setContent] = (0, _react.useState)(null);
    const [scrollbarX, setScrollbarX] = (0, _react.useState)(null);
    const [scrollbarY, setScrollbarY] = (0, _react.useState)(null);
    const [cornerWidth, setCornerWidth] = (0, _react.useState)(0);
    const [cornerHeight, setCornerHeight] = (0, _react.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0, _react.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0, _react.useState)(false);
    const rootRef = (0, _hooks.useMergedRef)(ref, (node)=>setScrollArea(node));
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaContextMjs.ScrollAreaProvider), {
        value: {
            type,
            scrollHideDelay,
            scrollArea,
            viewport,
            onViewportChange: setViewport,
            content,
            onContentChange: setContent,
            scrollbarX,
            onScrollbarXChange: setScrollbarX,
            scrollbarXEnabled,
            onScrollbarXEnabledChange: setScrollbarXEnabled,
            scrollbarY,
            onScrollbarYChange: setScrollbarY,
            scrollbarYEnabled,
            onScrollbarYEnabledChange: setScrollbarYEnabled,
            onCornerWidthChange: setCornerWidth,
            onCornerHeightChange: setCornerHeight,
            getStyles
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
            ...others,
            ref: rootRef,
            __vars: {
                "--sa-corner-width": scrollbars !== "xy" ? "0px" : `${cornerWidth}px`,
                "--sa-corner-height": scrollbars !== "xy" ? "0px" : `${cornerHeight}px`
            }
        })
    });
});
ScrollAreaRoot.displayName = "@mantine/core/ScrollAreaRoot";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../ScrollArea.context.mjs":"05aId","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4SvWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbar", ()=>ScrollAreaScrollbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _scrollAreaScrollbarAutoMjs = require("./ScrollAreaScrollbarAuto.mjs");
var _scrollAreaScrollbarHoverMjs = require("./ScrollAreaScrollbarHover.mjs");
var _scrollAreaScrollbarScrollMjs = require("./ScrollAreaScrollbarScroll.mjs");
var _scrollAreaScrollbarVisibleMjs = require("./ScrollAreaScrollbarVisible.mjs");
'use client';
const ScrollAreaScrollbar = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { forceMount, ...scrollbarProps } = props;
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const { onScrollbarXEnabledChange, onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    (0, _react.useEffect)(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarHoverMjs.ScrollAreaScrollbarHover), {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount
    }) : context.type === "scroll" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarScrollMjs.ScrollAreaScrollbarScroll), {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount
    }) : context.type === "auto" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarAutoMjs.ScrollAreaScrollbarAuto), {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount
    }) : context.type === "always" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarVisibleMjs.ScrollAreaScrollbarVisible), {
        ...scrollbarProps,
        ref: forwardedRef
    }) : null;
});
ScrollAreaScrollbar.displayName = "@mantine/core/ScrollAreaScrollbar";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../ScrollArea.context.mjs":"05aId","./ScrollAreaScrollbarAuto.mjs":"8NRs4","./ScrollAreaScrollbarHover.mjs":"kBlJZ","./ScrollAreaScrollbarScroll.mjs":"k4jg2","./ScrollAreaScrollbarVisible.mjs":"rlIBG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8NRs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarAuto", ()=>ScrollAreaScrollbarAuto);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _useResizeObserverMjs = require("../use-resize-observer.mjs");
var _scrollAreaScrollbarVisibleMjs = require("./ScrollAreaScrollbarVisible.mjs");
'use client';
const ScrollAreaScrollbarAuto = (0, _react.forwardRef)((props, ref)=>{
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const { forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = (0, _react.useState)(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = (0, _hooks.useDebouncedCallback)(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    (0, _useResizeObserverMjs.useResizeObserver)(context.viewport, handleResize);
    (0, _useResizeObserverMjs.useResizeObserver)(context.content, handleResize);
    if (forceMount || visible) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarVisibleMjs.ScrollAreaScrollbarVisible), {
        "data-state": visible ? "visible" : "hidden",
        ...scrollbarProps,
        ref
    });
    return null;
});
ScrollAreaScrollbarAuto.displayName = "@mantine/core/ScrollAreaScrollbarAuto";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"9VIlA","../ScrollArea.context.mjs":"05aId","../use-resize-observer.mjs":"eFjRk","./ScrollAreaScrollbarVisible.mjs":"rlIBG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"rlIBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarVisible", ()=>ScrollAreaScrollbarVisible);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _getThumbRatioMjs = require("../utils/get-thumb-ratio.mjs");
var _getThumbOffsetFromScrollMjs = require("../utils/get-thumb-offset-from-scroll.mjs");
var _getScrollPositionFromPointerMjs = require("../utils/get-scroll-position-from-pointer.mjs");
var _scrollbarXMjs = require("./ScrollbarX.mjs");
var _scrollbarYMjs = require("./ScrollbarY.mjs");
'use client';
const ScrollAreaScrollbarVisible = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { orientation = "vertical", ...scrollbarProps } = props;
    const { dir } = (0, _directionProviderMjs.useDirection)();
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const thumbRef = (0, _react.useRef)(null);
    const pointerOffsetRef = (0, _react.useRef)(0);
    const [sizes, setSizes] = (0, _react.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = (0, _getThumbRatioMjs.getThumbRatio)(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>{
            thumbRef.current = thumb;
        },
        onThumbPointerUp: ()=>{
            pointerOffsetRef.current = 0;
        },
        onThumbPointerDown: (pointerPos)=>{
            pointerOffsetRef.current = pointerPos;
        }
    };
    const getScrollPosition = (pointerPos, direction)=>(0, _getScrollPositionFromPointerMjs.getScrollPositionFromPointer)(pointerPos, pointerOffsetRef.current, sizes, direction);
    if (orientation === "horizontal") return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollbarXMjs.ScrollAreaScrollbarX), {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = (0, _getThumbOffsetFromScrollMjs.getThumbOffsetFromScroll)(scrollPos, sizes, dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
    });
    if (orientation === "vertical") return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollbarYMjs.ScrollAreaScrollbarY), {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = (0, _getThumbOffsetFromScrollMjs.getThumbOffsetFromScroll)(scrollPos, sizes);
                if (sizes.scrollbar.size === 0) thumbRef.current.style.setProperty("--thumb-opacity", "0");
                else thumbRef.current.style.setProperty("--thumb-opacity", "1");
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    });
    return null;
});
ScrollAreaScrollbarVisible.displayName = "@mantine/core/ScrollAreaScrollbarVisible";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../../../core/utils/units-converters/rem.mjs":"c70Xm","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../ScrollArea.context.mjs":"05aId","../utils/get-thumb-ratio.mjs":"aUe8q","../utils/get-thumb-offset-from-scroll.mjs":"d3NOR","../utils/get-scroll-position-from-pointer.mjs":"4EIoW","./ScrollbarX.mjs":"7FYhi","./ScrollbarY.mjs":"lg8Fd","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aUe8q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThumbRatio", ()=>getThumbRatio);
'use client';
function getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return Number.isNaN(ratio) ? 0 : ratio;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d3NOR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThumbOffsetFromScroll", ()=>getThumbOffsetFromScroll);
var _getThumbSizeMjs = require("./get-thumb-size.mjs");
var _linearScaleMjs = require("./linear-scale.mjs");
'use client';
function clamp(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}
function getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = (0, _getThumbSizeMjs.getThumbSize)(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = clamp(scrollPos, scrollClampRange);
    const interpolate = (0, _linearScaleMjs.linearScale)([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}

},{"./get-thumb-size.mjs":"bGm4t","./linear-scale.mjs":"7kyYz","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bGm4t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getThumbSize", ()=>getThumbSize);
var _getThumbRatioMjs = require("./get-thumb-ratio.mjs");
'use client';
function getThumbSize(sizes) {
    const ratio = (0, _getThumbRatioMjs.getThumbRatio)(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}

},{"./get-thumb-ratio.mjs":"aUe8q","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7kyYz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearScale", ()=>linearScale);
'use client';
function linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4EIoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getScrollPositionFromPointer", ()=>getScrollPositionFromPointer);
var _getThumbSizeMjs = require("./get-thumb-size.mjs");
var _linearScaleMjs = require("./linear-scale.mjs");
'use client';
function getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = (0, _getThumbSizeMjs.getThumbSize)(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = (0, _linearScaleMjs.linearScale)([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}

},{"./get-thumb-size.mjs":"bGm4t","./linear-scale.mjs":"7kyYz","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7FYhi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarX", ()=>ScrollAreaScrollbarX);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _isScrollingWithinScrollbarBoundsMjs = require("../utils/is-scrolling-within-scrollbar-bounds.mjs");
var _getThumbSizeMjs = require("../utils/get-thumb-size.mjs");
var _toIntMjs = require("../utils/to-int.mjs");
var _scrollbarMjs = require("./Scrollbar.mjs");
'use client';
const ScrollAreaScrollbarX = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { sizes, onSizesChange, style, ...others } = props;
    const ctx = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const [computedStyle, setComputedStyle] = (0, _react.useState)();
    const ref = (0, _react.useRef)(null);
    const composeRefs = (0, _hooks.useMergedRef)(forwardedRef, ref, ctx.onScrollbarXChange);
    (0, _react.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollbarMjs.Scrollbar), {
        "data-orientation": "horizontal",
        ...others,
        ref: composeRefs,
        sizes,
        style: {
            ...style,
            ["--sa-thumb-width"]: `${(0, _getThumbSizeMjs.getThumbSize)(sizes)}px`
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (ctx.viewport) {
                const scrollPos = ctx.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ((0, _isScrollingWithinScrollbarBoundsMjs.isScrollingWithinScrollbarBounds)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && ctx.viewport && computedStyle) onSizesChange({
                content: ctx.viewport.scrollWidth,
                viewport: ctx.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: (0, _toIntMjs.toInt)(computedStyle.paddingLeft),
                    paddingEnd: (0, _toIntMjs.toInt)(computedStyle.paddingRight)
                }
            });
        }
    });
});
ScrollAreaScrollbarX.displayName = "@mantine/core/ScrollAreaScrollbarX";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../ScrollArea.context.mjs":"05aId","../utils/is-scrolling-within-scrollbar-bounds.mjs":"l17Gr","../utils/get-thumb-size.mjs":"bGm4t","../utils/to-int.mjs":"loj3B","./Scrollbar.mjs":"lO8Bp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"l17Gr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScrollingWithinScrollbarBounds", ()=>isScrollingWithinScrollbarBounds);
'use client';
function isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"loj3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toInt", ()=>toInt);
'use client';
function toInt(value) {
    return value ? parseInt(value, 10) : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lO8Bp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scrollbar", ()=>Scrollbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _useResizeObserverMjs = require("../use-resize-observer.mjs");
var _composeEventHandlersMjs = require("../utils/compose-event-handlers.mjs");
var _scrollbarContextMjs = require("./Scrollbar.context.mjs");
'use client';
const Scrollbar = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { sizes, hasThumb, onThumbChange, onThumbPointerUp, onThumbPointerDown, onThumbPositionChange, onDragScroll, onWheelScroll, onResize, ...scrollbarProps } = props;
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const [scrollbar, setScrollbar] = (0, _react.useState)(null);
    const composeRefs = (0, _hooks.useMergedRef)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = (0, _react.useRef)(null);
    const prevWebkitUserSelectRef = (0, _react.useRef)("");
    const { viewport } = context;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, _hooks.useCallbackRef)(onWheelScroll);
    const handleThumbPositionChange = (0, _hooks.useCallbackRef)(onThumbPositionChange);
    const handleResize = (0, _hooks.useDebouncedCallback)(onResize, 10);
    const handleDragScroll = (event)=>{
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x,
                y
            });
        }
    };
    (0, _react.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar?.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    (0, _react.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    (0, _useResizeObserverMjs.useResizeObserver)(scrollbar, handleResize);
    (0, _useResizeObserverMjs.useResizeObserver)(context.content, handleResize);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollbarContextMjs.ScrollbarProvider), {
        value: {
            scrollbar,
            hasThumb,
            onThumbChange: (0, _hooks.useCallbackRef)(onThumbChange),
            onThumbPointerUp: (0, _hooks.useCallbackRef)(onThumbPointerUp),
            onThumbPositionChange: handleThumbPositionChange,
            onThumbPointerDown: (0, _hooks.useCallbackRef)(onThumbPointerDown)
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ...scrollbarProps,
            ref: composeRefs,
            "data-mantine-scrollbar": true,
            style: {
                position: "absolute",
                ...scrollbarProps.style
            },
            onPointerDown: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerDown, (event)=>{
                event.preventDefault();
                const mainPointer = 0;
                if (event.button === mainPointer) {
                    const element = event.target;
                    element.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerMove, handleDragScroll),
            onPointerUp: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerUp, (event)=>{
                const element = event.target;
                if (element.hasPointerCapture(event.pointerId)) {
                    event.preventDefault();
                    element.releasePointerCapture(event.pointerId);
                }
            }),
            onLostPointerCapture: ()=>{
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                rectRef.current = null;
            }
        })
    });
});

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useCallbackRef","1inGi"],["useDebouncedCallback","9VIlA"],["useMergedRef","3QtIc"]],"../ScrollArea.context.mjs":"05aId","../use-resize-observer.mjs":"eFjRk","../utils/compose-event-handlers.mjs":"gkQzS","./Scrollbar.context.mjs":"10hob","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gkQzS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
'use client';
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
    return (event)=>{
        originalEventHandler?.(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) ourEventHandler?.(event);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"10hob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollbarProvider", ()=>ScrollbarProvider);
parcelHelpers.export(exports, "useScrollbarContext", ()=>useScrollbarContext);
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _createSafeContextMjs = require("../../../core/utils/create-safe-context/create-safe-context.mjs");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
const [ScrollbarProvider, useScrollbarContext] = (0, _createSafeContextMjs.createSafeContext)("ScrollAreaScrollbar was not found in tree");

},{"../../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../../core/utils/create-safe-context/create-safe-context.mjs":"lbm6S","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"lg8Fd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarY", ()=>ScrollAreaScrollbarY);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _isScrollingWithinScrollbarBoundsMjs = require("../utils/is-scrolling-within-scrollbar-bounds.mjs");
var _getThumbSizeMjs = require("../utils/get-thumb-size.mjs");
var _toIntMjs = require("../utils/to-int.mjs");
var _scrollbarMjs = require("./Scrollbar.mjs");
'use client';
const ScrollAreaScrollbarY = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { sizes, onSizesChange, style, ...others } = props;
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const [computedStyle, setComputedStyle] = (0, _react.useState)();
    const ref = (0, _react.useRef)(null);
    const composeRefs = (0, _hooks.useMergedRef)(forwardedRef, ref, context.onScrollbarYChange);
    (0, _react.useEffect)(()=>{
        if (ref.current) setComputedStyle(window.getComputedStyle(ref.current));
    }, []);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollbarMjs.Scrollbar), {
        ...others,
        "data-orientation": "vertical",
        ref: composeRefs,
        sizes,
        style: {
            ["--sa-thumb-height"]: `${(0, _getThumbSizeMjs.getThumbSize)(sizes)}px`,
            ...style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ((0, _isScrollingWithinScrollbarBoundsMjs.isScrollingWithinScrollbarBounds)(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: (0, _toIntMjs.toInt)(computedStyle.paddingTop),
                    paddingEnd: (0, _toIntMjs.toInt)(computedStyle.paddingBottom)
                }
            });
        }
    });
});
ScrollAreaScrollbarY.displayName = "@mantine/core/ScrollAreaScrollbarY";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../ScrollArea.context.mjs":"05aId","../utils/is-scrolling-within-scrollbar-bounds.mjs":"l17Gr","../utils/get-thumb-size.mjs":"bGm4t","../utils/to-int.mjs":"loj3B","./Scrollbar.mjs":"lO8Bp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kBlJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarHover", ()=>ScrollAreaScrollbarHover);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _scrollAreaScrollbarAutoMjs = require("./ScrollAreaScrollbarAuto.mjs");
'use client';
const ScrollAreaScrollbarHover = (0, _react.forwardRef)((props, ref)=>{
    const { forceMount, ...scrollbarProps } = props;
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const [visible, setVisible] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const { scrollArea } = context;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
        return void 0;
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    if (forceMount || visible) return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarAutoMjs.ScrollAreaScrollbarAuto), {
        "data-state": visible ? "visible" : "hidden",
        ...scrollbarProps,
        ref
    });
    return null;
});
ScrollAreaScrollbarHover.displayName = "@mantine/core/ScrollAreaScrollbarHover";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","../ScrollArea.context.mjs":"05aId","./ScrollAreaScrollbarAuto.mjs":"8NRs4","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"k4jg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaScrollbarScroll", ()=>ScrollAreaScrollbarScroll);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _composeEventHandlersMjs = require("../utils/compose-event-handlers.mjs");
var _scrollAreaScrollbarVisibleMjs = require("./ScrollAreaScrollbarVisible.mjs");
'use client';
const ScrollAreaScrollbarScroll = (0, _react.forwardRef)((props, red)=>{
    const { forceMount, ...scrollbarProps } = props;
    const context = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const isHorizontal = props.orientation === "horizontal";
    const [state, setState] = (0, _react.useState)("hidden");
    const debounceScrollEnd = (0, _hooks.useDebouncedCallback)(()=>setState("idle"), 100);
    (0, _react.useEffect)(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>setState("hidden"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
        return void 0;
    }, [
        state,
        context.scrollHideDelay
    ]);
    (0, _react.useEffect)(()=>{
        const { viewport } = context;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    setState("scrolling");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
        return void 0;
    }, [
        context.viewport,
        isHorizontal,
        debounceScrollEnd
    ]);
    if (forceMount || state !== "hidden") return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _scrollAreaScrollbarVisibleMjs.ScrollAreaScrollbarVisible), {
        "data-state": state === "hidden" ? "hidden" : "visible",
        ...scrollbarProps,
        ref: red,
        onPointerEnter: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerEnter, ()=>setState("interacting")),
        onPointerLeave: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerLeave, ()=>setState("idle"))
    });
    return null;
});

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"9VIlA","../ScrollArea.context.mjs":"05aId","../utils/compose-event-handlers.mjs":"gkQzS","./ScrollAreaScrollbarVisible.mjs":"rlIBG","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eOj8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaThumb", ()=>ScrollAreaThumb);
parcelHelpers.export(exports, "Thumb", ()=>Thumb);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
var _scrollbarContextMjs = require("../ScrollAreaScrollbar/Scrollbar.context.mjs");
var _composeEventHandlersMjs = require("../utils/compose-event-handlers.mjs");
var _addUnlinkedScrollListenerMjs = require("../utils/add-unlinked-scroll-listener.mjs");
'use client';
const Thumb = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { style, ...others } = props;
    const scrollAreaContext = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const scrollbarContext = (0, _scrollbarContextMjs.useScrollbarContext)();
    const { onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, _hooks.useMergedRef)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = (0, _react.useRef)(void 0);
    const debounceScrollEnd = (0, _hooks.useDebouncedCallback)(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    (0, _react.useEffect)(()=>{
        const { viewport } = scrollAreaContext;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = (0, _addUnlinkedScrollListenerMjs.addUnlinkedScrollListener)(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
        return void 0;
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...others,
        ref: composedRef,
        style: {
            width: "var(--sa-thumb-width)",
            height: "var(--sa-thumb-height)",
            ...style
        },
        onPointerDownCapture: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x,
                y
            });
        }),
        onPointerUp: (0, _composeEventHandlersMjs.composeEventHandlers)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    });
});
Thumb.displayName = "@mantine/core/ScrollAreaThumb";
const ScrollAreaThumb = (0, _react.forwardRef)((props, forwardedRef)=>{
    const { forceMount, ...thumbProps } = props;
    const scrollbarContext = (0, _scrollbarContextMjs.useScrollbarContext)();
    if (forceMount || scrollbarContext.hasThumb) return /* @__PURE__ */ (0, _jsxRuntime.jsx)(Thumb, {
        ref: forwardedRef,
        ...thumbProps
    });
    return null;
});
ScrollAreaThumb.displayName = "@mantine/core/ScrollAreaThumb";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":[["useDebouncedCallback","9VIlA"],["useMergedRef","3QtIc"]],"../ScrollArea.context.mjs":"05aId","../ScrollAreaScrollbar/Scrollbar.context.mjs":"10hob","../utils/compose-event-handlers.mjs":"gkQzS","../utils/add-unlinked-scroll-listener.mjs":"3e48X","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3e48X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUnlinkedScrollListener", ()=>addUnlinkedScrollListener);
'use client';
function addUnlinkedScrollListener(node, handler = ()=>{}) {
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"atMde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollAreaViewport", ()=>ScrollAreaViewport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../../core/utils/units-converters/rem.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../../core/DirectionProvider/DirectionProvider.mjs");
var _scrollAreaContextMjs = require("../ScrollArea.context.mjs");
'use client';
const ScrollAreaViewport = (0, _react.forwardRef)(({ children, style, onWheel, ...others }, ref)=>{
    const ctx = (0, _scrollAreaContextMjs.useScrollAreaContext)();
    const rootRef = (0, _hooks.useMergedRef)(ref, ctx.onViewportChange);
    const handleWheel = (event)=>{
        onWheel?.(event);
        if (ctx.scrollbarXEnabled && ctx.viewport && event.shiftKey) {
            const { scrollTop, scrollHeight, clientHeight, scrollWidth, clientWidth } = ctx.viewport;
            const isAtTop = scrollTop < 1;
            const isAtBottom = scrollTop >= scrollHeight - clientHeight - 1;
            const canScrollHorizontally = scrollWidth > clientWidth;
            if (canScrollHorizontally && (isAtTop || isAtBottom)) event.stopPropagation();
        }
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
        ...others,
        ref: rootRef,
        onWheel: handleWheel,
        style: {
            overflowX: ctx.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: ctx.scrollbarYEnabled ? "scroll" : "hidden",
            ...style
        },
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
            ...ctx.getStyles("content"),
            ref: ctx.onContentChange,
            children
        })
    });
});
ScrollAreaViewport.displayName = "@mantine/core/ScrollAreaViewport";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/hooks":"3QtIc","../../../core/utils/units-converters/rem.mjs":"c70Xm","clsx":"9idv4","../../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../../core/Box/Box.mjs":"eq62v","../../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../ScrollArea.context.mjs":"05aId","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"DJ6A9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOptionsFilter", ()=>defaultOptionsFilter);
var _isOptionsGroupMjs = require("./is-options-group.mjs");
'use client';
function defaultOptionsFilter({ options, search, limit }) {
    const parsedSearch = search.trim().toLowerCase();
    const result = [];
    for(let i = 0; i < options.length; i += 1){
        const item = options[i];
        if (result.length === limit) return result;
        if ((0, _isOptionsGroupMjs.isOptionsGroup)(item)) result.push({
            group: item.group,
            items: defaultOptionsFilter({
                options: item.items,
                search,
                limit: limit - result.length
            })
        });
        if (!(0, _isOptionsGroupMjs.isOptionsGroup)(item)) {
            if (item.label.toLowerCase().includes(parsedSearch)) result.push(item);
        }
    }
    return result;
}

},{"./is-options-group.mjs":"2tFFp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2tFFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isOptionsGroup", ()=>isOptionsGroup);
'use client';
function isOptionsGroup(item) {
    return "group" in item;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4QuHN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyComboboxData", ()=>isEmptyComboboxData);
'use client';
function isEmptyComboboxData(data) {
    if (data.length === 0) return true;
    for (const item of data){
        if (!("group" in item)) return false;
        if (item.items.length > 0) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bYG3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateOptions", ()=>validateOptions);
var _isOptionsGroupMjs = require("./is-options-group.mjs");
'use client';
function validateOptions(options, valuesSet = /* @__PURE__ */ new Set()) {
    if (!Array.isArray(options)) return;
    for (const option of options)if ((0, _isOptionsGroupMjs.isOptionsGroup)(option)) validateOptions(option.items, valuesSet);
    else {
        if (typeof option.value === "undefined") throw new Error("[@mantine/core] Each option must have value property");
        if (typeof option.value !== "string") throw new Error(`[@mantine/core] Option value must be a string, other data formats are not supported, got ${typeof option.value}`);
        if (valuesSet.has(option.value)) throw new Error(`[@mantine/core] Duplicate options are not supported. Option with value "${option.value}" was provided more than once`);
        valuesSet.add(option.value);
    }
}

},{"./is-options-group.mjs":"2tFFp","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"3bAxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputBase", ()=>InputBase);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _inputMjs = require("../Input/Input.mjs");
var _inputWrapperMjs = require("../Input/InputWrapper/InputWrapper.mjs");
var _inputDescriptionMjs = require("../Input/InputDescription/InputDescription.mjs");
var _inputErrorMjs = require("../Input/InputError/InputError.mjs");
var _inputLabelMjs = require("../Input/InputLabel/InputLabel.mjs");
var _inputPlaceholderMjs = require("../Input/InputPlaceholder/InputPlaceholder.mjs");
var _inputClearButtonMjs = require("../Input/InputClearButton/InputClearButton.mjs");
var _useInputPropsMjs = require("../Input/use-input-props.mjs");
var _inputWrapperContextMjs = require("../Input/InputWrapper.context.mjs");
'use client';
const defaultProps = {
    __staticSelector: "InputBase",
    withAria: true,
    size: "sm"
};
const InputBase = (0, _polymorphicFactoryMjs.polymorphicFactory)((props, ref)=>{
    const { inputProps, wrapperProps, ...others } = (0, _useInputPropsMjs.useInputProps)("InputBase", defaultProps, props);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input).Wrapper, {
        ...wrapperProps,
        children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _inputMjs.Input), {
            ...inputProps,
            ...others,
            ref
        })
    });
});
InputBase.classes = {
    ...(0, _inputMjs.Input).classes,
    ...(0, _inputMjs.Input).Wrapper.classes
};
InputBase.displayName = "@mantine/core/InputBase";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Input/Input.mjs":"evliY","../Input/InputWrapper/InputWrapper.mjs":"cunzA","../Input/InputDescription/InputDescription.mjs":"4V72r","../Input/InputError/InputError.mjs":"67YsU","../Input/InputLabel/InputLabel.mjs":"1lKYS","../Input/InputPlaceholder/InputPlaceholder.mjs":"76gdH","../Input/InputClearButton/InputClearButton.mjs":"jtN41","../Input/use-input-props.mjs":"9Fgrp","../Input/InputWrapper.context.mjs":"kSPdi","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"9Fgrp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInputProps", ()=>useInputProps);
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _extractStylePropsMjs = require("../../core/Box/style-props/extract-style-props/extract-style-props.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
'use client';
function useInputProps(component, defaultProps, _props) {
    const props = (0, _usePropsMjs.useProps)(component, defaultProps, _props);
    const { label, description, error, required, classNames, styles, className, unstyled, __staticSelector, __stylesApiProps, errorProps, labelProps, descriptionProps, wrapperProps: _wrapperProps, id, size, style, inputContainer, inputWrapperOrder, withAsterisk, variant, vars, mod, attributes, ...others } = props;
    const { styleProps, rest } = (0, _extractStylePropsMjs.extractStyleProps)(others);
    const wrapperProps = {
        label,
        description,
        error,
        required,
        classNames,
        className,
        __staticSelector,
        __stylesApiProps: __stylesApiProps || props,
        errorProps,
        labelProps,
        descriptionProps,
        unstyled,
        styles,
        size,
        style,
        inputContainer,
        inputWrapperOrder,
        withAsterisk,
        variant,
        id,
        mod,
        attributes,
        ..._wrapperProps
    };
    return {
        ...rest,
        classNames,
        styles,
        unstyled,
        wrapperProps: {
            ...wrapperProps,
            ...styleProps
        },
        inputProps: {
            required,
            classNames,
            styles,
            unstyled,
            size,
            __staticSelector,
            __stylesApiProps: __stylesApiProps || props,
            error,
            variant,
            id,
            attributes
        }
    };
}

},{"../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","react/jsx-runtime":"1xKTF","@mantine/hooks":"cPWeR","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/Box/style-props/extract-style-props/extract-style-props.mjs":"h5n1i","../../core/Box/Box.mjs":"eq62v","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"a2Nak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notifications", ()=>Notifications);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _core = require("@mantine/core");
var _hooks = require("@mantine/hooks");
var _getGroupedNotificationsMjs = require("./get-grouped-notifications/get-grouped-notifications.mjs");
var _getNotificationStateStylesMjs = require("./get-notification-state-styles.mjs");
var _notificationContainerMjs = require("./NotificationContainer.mjs");
var _notificationsModuleCssMjs = require("./Notifications.module.css.mjs");
var _notificationsModuleCssMjsDefault = parcelHelpers.interopDefault(_notificationsModuleCssMjs);
var _notificationsStoreMjs = require("./notifications.store.mjs");
'use client';
const Transition = (0, _reactTransitionGroup.Transition);
const defaultProps = {
    position: "bottom-right",
    autoClose: 4e3,
    transitionDuration: 250,
    containerWidth: 440,
    notificationMaxHeight: 200,
    limit: 5,
    zIndex: (0, _core.getDefaultZIndex)("overlay"),
    store: (0, _notificationsStoreMjs.notificationsStore),
    withinPortal: true
};
const varsResolver = (0, _core.createVarsResolver)((_, { zIndex, containerWidth })=>({
        root: {
            "--notifications-z-index": zIndex?.toString(),
            "--notifications-container-width": (0, _core.rem)(containerWidth)
        }
    }));
const Notifications = (0, _core.factory)((_props, ref)=>{
    const props = (0, _core.useProps)("Notifications", defaultProps, _props);
    const { classNames, className, style, styles, unstyled, vars, position, autoClose, transitionDuration, containerWidth, notificationMaxHeight, limit, zIndex, store, portalProps, withinPortal, ...others } = props;
    const theme = (0, _core.useMantineTheme)();
    const data = (0, _notificationsStoreMjs.useNotifications)(store);
    const forceUpdate = (0, _hooks.useForceUpdate)();
    const shouldReduceMotion = (0, _hooks.useReducedMotion)();
    const refs = (0, _react.useRef)({});
    const previousLength = (0, _react.useRef)(0);
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const duration = reduceMotion ? 1 : transitionDuration;
    const getStyles = (0, _core.useStyles)({
        name: "Notifications",
        classes: (0, _notificationsModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        vars,
        varsResolver
    });
    (0, _react.useEffect)(()=>{
        store?.updateState((current)=>({
                ...current,
                limit: limit || 5,
                defaultPosition: position
            }));
    }, [
        limit,
        position
    ]);
    (0, _hooks.useDidUpdate)(()=>{
        if (data.notifications.length > previousLength.current) setTimeout(()=>forceUpdate(), 0);
        previousLength.current = data.notifications.length;
    }, [
        data.notifications
    ]);
    const grouped = (0, _getGroupedNotificationsMjs.getGroupedNotifications)(data.notifications, position);
    const groupedComponents = (0, _getGroupedNotificationsMjs.positions).reduce((acc, pos)=>{
        acc[pos] = grouped[pos].map(({ style: notificationStyle, ...notification })=>/* @__PURE__ */ (0, _jsxRuntime.jsx)(Transition, {
                timeout: duration,
                onEnter: ()=>refs.current[notification.id].offsetHeight,
                nodeRef: {
                    current: refs.current[notification.id]
                },
                children: (state)=>/* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _notificationContainerMjs.NotificationContainer), {
                        ref: (node)=>{
                            if (node) refs.current[notification.id] = node;
                        },
                        data: notification,
                        onHide: (id)=>(0, _notificationsStoreMjs.hideNotification)(id, store),
                        autoClose,
                        ...getStyles("notification", {
                            style: {
                                ...(0, _getNotificationStateStylesMjs.getNotificationStateStyles)({
                                    state,
                                    position: pos,
                                    transitionDuration: duration,
                                    maxHeight: notificationMaxHeight
                                }),
                                ...notificationStyle
                            }
                        })
                    })
            }, notification.id));
        return acc;
    }, {});
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _core.OptionalPortal), {
        withinPortal,
        ...portalProps,
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root"),
                "data-position": "top-center",
                ref,
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["top-center"]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root"),
                "data-position": "top-left",
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["top-left"]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root", {
                    className: (0, _core.RemoveScroll).classNames.fullWidth
                }),
                "data-position": "top-right",
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["top-right"]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root", {
                    className: (0, _core.RemoveScroll).classNames.fullWidth
                }),
                "data-position": "bottom-right",
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["bottom-right"]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root"),
                "data-position": "bottom-left",
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["bottom-left"]
                })
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Box), {
                ...getStyles("root"),
                "data-position": "bottom-center",
                ...others,
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
                    children: groupedComponents["bottom-center"]
                })
            })
        ]
    });
});
Notifications.classes = (0, _notificationsModuleCssMjsDefault.default);
Notifications.displayName = "@mantine/notifications/Notifications";
Notifications.show = (0, _notificationsStoreMjs.notifications).show;
Notifications.hide = (0, _notificationsStoreMjs.notifications).hide;
Notifications.update = (0, _notificationsStoreMjs.notifications).update;
Notifications.clean = (0, _notificationsStoreMjs.notifications).clean;
Notifications.cleanQueue = (0, _notificationsStoreMjs.notifications).cleanQueue;
Notifications.updateState = (0, _notificationsStoreMjs.notifications).updateState;

},{"react/jsx-runtime":"1xKTF","react":"erQJb","react-transition-group":[["Transition","4erQe","default"],["TransitionGroup","99x7R","default"]],"@mantine/core":[["Box","eq62v"],["createVarsResolver","b5eiH"],["factory","lBP7N"],["getDefaultZIndex","4YtNJ"],["OptionalPortal","dQaeU"],["rem","c70Xm"],["RemoveScroll","dBeBD","default"],["useMantineTheme","bajsd"],["useProps","kSa6M"],["useStyles","8urVe"]],"@mantine/hooks":[["useDidUpdate","bzSpx"],["useForceUpdate","3vpJH"],["useReducedMotion","F0OXZ"]],"./get-grouped-notifications/get-grouped-notifications.mjs":"5NopQ","./get-notification-state-styles.mjs":"2EWGS","./NotificationContainer.mjs":"d0t3T","./Notifications.module.css.mjs":"a7vTC","./notifications.store.mjs":"47qTT","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4erQe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"bx4vN","@babel/runtime/helpers/esm/inheritsLoose":"32hCt","prop-types":"6KSFf","react":"erQJb","react-dom":"kVyn3","./config":"fh4Oc","./utils/PropTypes":"ebn4L","./TransitionGroupContext":"dFhLv","./utils/reflow":"f376K","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bx4vN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"32hCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"eGvEo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"eGvEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6KSFf":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("ec56c2c14d36aeb0")();

},{"ec56c2c14d36aeb0":"55zuJ"}],"55zuJ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("5378f1047c18e058");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"5378f1047c18e058":"6Vk1j"}],"6Vk1j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"fh4Oc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ebn4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"6KSFf","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dFhLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"f376K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"99x7R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"bx4vN","@babel/runtime/helpers/esm/extends":"kHVsu","@babel/runtime/helpers/esm/assertThisInitialized":"bHQ80","@babel/runtime/helpers/esm/inheritsLoose":"32hCt","prop-types":"6KSFf","react":"erQJb","./TransitionGroupContext":"dFhLv","./utils/ChildMapping":"dZaRe","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kHVsu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"bHQ80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dZaRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"5NopQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGroupedNotifications", ()=>getGroupedNotifications);
parcelHelpers.export(exports, "positions", ()=>positions);
'use client';
const positions = [
    "bottom-center",
    "bottom-left",
    "bottom-right",
    "top-center",
    "top-left",
    "top-right"
];
function getGroupedNotifications(notifications, defaultPosition) {
    return notifications.reduce((acc, notification)=>{
        acc[notification.position || defaultPosition].push(notification);
        return acc;
    }, positions.reduce((acc, item)=>{
        acc[item] = [];
        return acc;
    }, {}));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2EWGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNotificationStateStyles", ()=>getNotificationStateStyles);
'use client';
const transforms = {
    left: "translateX(-100%)",
    right: "translateX(100%)",
    "top-center": "translateY(-100%)",
    "bottom-center": "translateY(100%)"
};
const noTransform = {
    left: "translateX(0)",
    right: "translateX(0)",
    "top-center": "translateY(0)",
    "bottom-center": "translateY(0)"
};
function getNotificationStateStyles({ state, maxHeight, position, transitionDuration }) {
    const [vertical, horizontal] = position.split("-");
    const property = horizontal === "center" ? `${vertical}-center` : horizontal;
    const commonStyles = {
        opacity: 0,
        maxHeight,
        transform: transforms[property],
        transitionDuration: `${transitionDuration}ms, ${transitionDuration}ms, ${transitionDuration}ms`,
        transitionTimingFunction: "cubic-bezier(.51,.3,0,1.21), cubic-bezier(.51,.3,0,1.21), linear",
        transitionProperty: "opacity, transform, max-height"
    };
    const inState = {
        opacity: 1,
        transform: noTransform[property]
    };
    const outState = {
        opacity: 0,
        maxHeight: 0,
        transform: transforms[property]
    };
    const transitionStyles = {
        entering: inState,
        entered: inState,
        exiting: outState,
        exited: outState
    };
    return {
        ...commonStyles,
        ...transitionStyles[state]
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"d0t3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationContainer", ()=>NotificationContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@mantine/core");
var _getAutoCloseMjs = require("./get-auto-close/get-auto-close.mjs");
'use client';
const NotificationContainer = (0, _react.forwardRef)(({ data, onHide, autoClose, ...others }, ref)=>{
    const { autoClose: _autoClose, message, ...notificationProps } = data;
    const autoCloseDuration = (0, _getAutoCloseMjs.getAutoClose)(autoClose, data.autoClose);
    const autoCloseTimeout = (0, _react.useRef)(-1);
    const cancelAutoClose = ()=>window.clearTimeout(autoCloseTimeout.current);
    const handleHide = ()=>{
        onHide(data.id);
        cancelAutoClose();
    };
    const handleAutoClose = ()=>{
        if (typeof autoCloseDuration === "number") autoCloseTimeout.current = window.setTimeout(handleHide, autoCloseDuration);
    };
    (0, _react.useEffect)(()=>{
        data.onOpen?.(data);
    }, []);
    (0, _react.useEffect)(()=>{
        handleAutoClose();
        return cancelAutoClose;
    }, [
        autoCloseDuration
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _core.Notification), {
        ...others,
        ...notificationProps,
        onClose: handleHide,
        ref,
        onMouseEnter: cancelAutoClose,
        onMouseLeave: handleAutoClose,
        children: message
    });
});
NotificationContainer.displayName = "@mantine/notifications/NotificationContainer";

},{"react/jsx-runtime":"1xKTF","react":"erQJb","@mantine/core":"fFzhj","./get-auto-close/get-auto-close.mjs":"6LgLr","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"fFzhj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _jsxRuntime = require("react/jsx-runtime");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _hooks = require("@mantine/hooks");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _getThemeColorMjs = require("../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _factoryMjs = require("../../core/factory/factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _closeIconMjs = require("../CloseButton/CloseIcon.mjs");
var _closeButtonMjs = require("../CloseButton/CloseButton.mjs");
var _loaderMjs = require("../Loader/Loader.mjs");
var _notificationModuleCssMjs = require("./Notification.module.css.mjs");
var _notificationModuleCssMjsDefault = parcelHelpers.interopDefault(_notificationModuleCssMjs);
'use client';
const defaultProps = {
    withCloseButton: true
};
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { radius, color })=>({
        root: {
            "--notification-radius": radius === void 0 ? void 0 : (0, _getSizeMjs.getRadius)(radius),
            "--notification-color": color ? (0, _getThemeColorMjs.getThemeColor)(color, theme) : void 0
        }
    }));
const Notification = (0, _factoryMjs.factory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("Notification", defaultProps, _props);
    const { className, color, radius, loading, withCloseButton, withBorder, title, icon, children, onClose, closeButtonProps, classNames, style, styles, unstyled, vars, mod, loaderProps, role, attributes, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "Notification",
        classes: (0, _notificationModuleCssMjsDefault.default),
        props,
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
        ...getStyles("root"),
        mod: [
            {
                "data-with-icon": !!icon || loading,
                "data-with-border": withBorder
            },
            mod
        ],
        ref,
        role: role || "alert",
        ...others,
        children: [
            icon && !loading && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                ...getStyles("icon"),
                children: icon
            }),
            loading && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _loaderMjs.Loader), {
                size: 28,
                color,
                ...loaderProps,
                ...getStyles("loader")
            }),
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)("div", {
                ...getStyles("body"),
                children: [
                    title && /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                        ...getStyles("title"),
                        children: title
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        ...getStyles("description"),
                        mod: {
                            "data-with-title": !!title
                        },
                        children
                    })
                ]
            }),
            withCloseButton && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _closeButtonMjs.CloseButton), {
                iconSize: 16,
                color: "gray",
                ...closeButtonProps,
                unstyled,
                onClick: onClose,
                ...getStyles("closeButton")
            })
        ]
    });
});
Notification.classes = (0, _notificationModuleCssMjsDefault.default);
Notification.displayName = "@mantine/core/Notification";

},{"react/jsx-runtime":"1xKTF","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","@mantine/hooks":"cPWeR","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs":"1o8C6","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/factory.mjs":"lBP7N","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../CloseButton/CloseIcon.mjs":"eZugY","../CloseButton/CloseButton.mjs":"5UCxX","../Loader/Loader.mjs":"7aA6l","./Notification.module.css.mjs":"8XNsb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8XNsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_a513464",
    "icon": "m_a4ceffb",
    "loader": "m_b0920b15",
    "body": "m_a49ed24",
    "title": "m_3feedf16",
    "description": "m_3d733a3a",
    "closeButton": "m_919a4d88"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"6LgLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAutoClose", ()=>getAutoClose);
'use client';
function getAutoClose(autoClose, notificationAutoClose) {
    if (typeof notificationAutoClose === "number") return notificationAutoClose;
    if (notificationAutoClose === false || autoClose === false) return false;
    return autoClose;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"a7vTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_b37d9ac7",
    "notification": "m_5ed0edd0"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"47qTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanNotifications", ()=>cleanNotifications);
parcelHelpers.export(exports, "cleanNotificationsQueue", ()=>cleanNotificationsQueue);
parcelHelpers.export(exports, "createNotificationsStore", ()=>createNotificationsStore);
parcelHelpers.export(exports, "hideNotification", ()=>hideNotification);
parcelHelpers.export(exports, "notifications", ()=>notifications);
parcelHelpers.export(exports, "notificationsStore", ()=>notificationsStore);
parcelHelpers.export(exports, "showNotification", ()=>showNotification);
parcelHelpers.export(exports, "updateNotification", ()=>updateNotification);
parcelHelpers.export(exports, "updateNotificationsState", ()=>updateNotificationsState);
parcelHelpers.export(exports, "useNotifications", ()=>useNotifications);
var _hooks = require("@mantine/hooks");
var _store = require("@mantine/store");
'use client';
function getDistributedNotifications(data, defaultPosition, limit) {
    const queue = [];
    const notifications2 = [];
    const count = {};
    for (const item of data){
        const position = item.position || defaultPosition;
        count[position] = count[position] || 0;
        count[position] += 1;
        if (count[position] <= limit) notifications2.push(item);
        else queue.push(item);
    }
    return {
        notifications: notifications2,
        queue
    };
}
const createNotificationsStore = ()=>(0, _store.createStore)({
        notifications: [],
        queue: [],
        defaultPosition: "bottom-right",
        limit: 5
    });
const notificationsStore = createNotificationsStore();
const useNotifications = (store = notificationsStore)=>(0, _store.useStore)(store);
function updateNotificationsState(store, update) {
    const state = store.getState();
    const notifications2 = update([
        ...state.notifications,
        ...state.queue
    ]);
    const updated = getDistributedNotifications(notifications2, state.defaultPosition, state.limit);
    store.setState({
        notifications: updated.notifications,
        queue: updated.queue,
        limit: state.limit,
        defaultPosition: state.defaultPosition
    });
}
function showNotification(notification, store = notificationsStore) {
    const id = notification.id || (0, _hooks.randomId)();
    updateNotificationsState(store, (notifications2)=>{
        if (notification.id && notifications2.some((n)=>n.id === notification.id)) return notifications2;
        return [
            ...notifications2,
            {
                ...notification,
                id
            }
        ];
    });
    return id;
}
function hideNotification(id, store = notificationsStore) {
    updateNotificationsState(store, (notifications2)=>notifications2.filter((notification)=>{
            if (notification.id === id) {
                notification.onClose?.(notification);
                return false;
            }
            return true;
        }));
    return id;
}
function updateNotification(notification, store = notificationsStore) {
    updateNotificationsState(store, (notifications2)=>notifications2.map((item)=>{
            if (item.id === notification.id) return {
                ...item,
                ...notification
            };
            return item;
        }));
    return notification.id;
}
function cleanNotifications(store = notificationsStore) {
    updateNotificationsState(store, ()=>[]);
}
function cleanNotificationsQueue(store = notificationsStore) {
    updateNotificationsState(store, (notifications2)=>notifications2.slice(0, store.getState().limit));
}
const notifications = {
    show: showNotification,
    hide: hideNotification,
    update: updateNotification,
    clean: cleanNotifications,
    cleanQueue: cleanNotificationsQueue,
    updateState: updateNotificationsState
};

},{"@mantine/hooks":"3bLBD","@mantine/store":"zRA3p","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"zRA3p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
'use client';
function createStore(initialState) {
    let state = initialState;
    let initialized = false;
    const listeners = /* @__PURE__ */ new Set();
    return {
        getState () {
            return state;
        },
        updateState (value) {
            state = typeof value === "function" ? value(state) : value;
        },
        setState (value) {
            this.updateState(value);
            listeners.forEach((listener)=>listener(state));
        },
        initialize (value) {
            if (!initialized) {
                state = value;
                initialized = true;
            }
        },
        subscribe (callback) {
            listeners.add(callback);
            return ()=>listeners.delete(callback);
        }
    };
}
function useStore(store) {
    return (0, _react.useSyncExternalStore)(store.subscribe, ()=>store.getState(), ()=>store.getState());
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"i1TZS":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconCalendarEvent);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 3l0 4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 3l0 4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 11l16 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M8 15h2v2h-2l0 -2",
            "key": "svg-4"
        }
    ]
];
const IconCalendarEvent = (0, _createReactComponentMjsDefault.default)("outline", "calendar-event", "CalendarEvent", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"kPvhJ":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createReactComponent);
var _react = require("react");
var _defaultAttributesMjs = require("./defaultAttributes.mjs");
var _defaultAttributesMjsDefault = parcelHelpers.interopDefault(_defaultAttributesMjs);
const createReactComponent = (type, iconName, iconNamePascal, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref)=>(0, _react.createElement)("svg", {
            ref,
            ...(0, _defaultAttributesMjsDefault.default)[type],
            width: size,
            height: size,
            className: [
                `tabler-icon`,
                `tabler-icon-${iconName}`,
                className
            ].join(" "),
            ...type === "filled" ? {
                fill: color
            } : {
                strokeWidth: stroke,
                stroke: color
            },
            ...rest
        }, [
            title && (0, _react.createElement)("title", {
                key: "svg-title"
            }, title),
            ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
            ...Array.isArray(children) ? children : [
                children
            ]
        ]));
    Component.displayName = `${iconNamePascal}`;
    return Component;
};

},{"react":"erQJb","./defaultAttributes.mjs":"4okEZ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"4okEZ":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    outline: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    },
    filled: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "none"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"04DKa":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconLogout);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12h12l-3 -3",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18 15l3 -3",
            "key": "svg-2"
        }
    ]
];
const IconLogout = (0, _createReactComponentMjsDefault.default)("outline", "logout", "Logout", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8SbdW":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconUser);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2",
            "key": "svg-1"
        }
    ]
];
const IconUser = (0, _createReactComponentMjsDefault.default)("outline", "user", "User", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"b7jEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AdminSidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _iconsReact = require("@tabler/icons-react");
var _sidebarNavLink = require("./SidebarNavLink");
var _sidebarNavLinkDefault = parcelHelpers.interopDefault(_sidebarNavLink);
function AdminSidebar() {
    const $ = (0, _compilerRuntime.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
            size: "xs",
            fw: 600,
            c: "dimmed",
            mb: "xs",
            mt: "sm",
            tt: "uppercase",
            px: "md",
            children: "Event Management"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
            href: "/",
            label: "Dashboard",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconHome), {
                size: 20
            })
        });
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
            size: "xs",
            fw: 600,
            c: "dimmed",
            mb: "xs",
            mt: "lg",
            tt: "uppercase",
            px: "md",
            children: "Queue & Processing"
        });
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
            href: "/queue-jobs",
            label: "Queue Jobs",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconClock), {
                size: 20
            })
        });
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
            href: "/data-archives",
            label: "Data Archives",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconArchive), {
                size: 20
            })
        });
        t5 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
            size: "xs",
            fw: 600,
            c: "dimmed",
            mb: "xs",
            mt: "lg",
            tt: "uppercase",
            px: "md",
            children: "Reports"
        });
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
            href: "/stats",
            label: "Stats Reports",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconChartBar), {
                size: 20
            })
        });
        t7 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Text), {
            size: "xs",
            fw: 600,
            c: "dimmed",
            mb: "xs",
            mt: "lg",
            tt: "uppercase",
            px: "md",
            children: "System & Testing"
        });
        $[6] = t6;
        $[7] = t7;
    } else {
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
            href: "/test-gemini",
            label: "Test Gemini",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconBrain), {
                size: 20
            })
        });
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.AppShell).Section, {
            grow: true,
            component: (0, _core.ScrollArea),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.Stack), {
                gap: 0,
                children: [
                    t0,
                    t1,
                    t2,
                    t3,
                    t4,
                    t5,
                    t6,
                    t7,
                    t8,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavLinkDefault.default), {
                        href: "/configs",
                        label: "Configs",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconsReact.IconAdjustments), {
                            size: 20
                        })
                    })
                ]
            })
        });
        $[9] = t9;
    } else t9 = $[9];
    return t9;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["AppShell","7QHq9"],["ScrollArea","d9DI8"],["Stack","29e8E"],["Text","1QStM"]],"@tabler/icons-react":[["IconAdjustments","alRR4","default"],["IconArchive","aq6Ei","default"],["IconBrain","82nje","default"],["IconChartBar","cU8U2","default"],["IconClock","gTqdZ","default"],["IconHome","8H3RT","default"]],"./SidebarNavLink":"2G8Vd","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"alRR4":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconAdjustments);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 4v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 12v8",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12 4v10",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M12 18v2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M18 4v1",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M18 9v11",
            "key": "svg-8"
        }
    ]
];
const IconAdjustments = (0, _createReactComponentMjsDefault.default)("outline", "adjustments", "Adjustments", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"aq6Ei":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconArchive);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M10 12l4 0",
            "key": "svg-2"
        }
    ]
];
const IconArchive = (0, _createReactComponentMjsDefault.default)("outline", "archive", "Archive", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"82nje":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconBrain);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M6.5 16a3.5 3.5 0 0 1 0 -7h.5",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10",
            "key": "svg-5"
        }
    ]
];
const IconBrain = (0, _createReactComponentMjsDefault.default)("outline", "brain", "Brain", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cU8U2":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconChartBar);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -6",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -10",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -14",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 20h14",
            "key": "svg-3"
        }
    ]
];
const IconChartBar = (0, _createReactComponentMjsDefault.default)("outline", "chart-bar", "ChartBar", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"gTqdZ":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconClock);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 7v5l3 3",
            "key": "svg-1"
        }
    ]
];
const IconClock = (0, _createReactComponentMjsDefault.default)("outline", "clock", "Clock", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"8H3RT":[function(require,module,exports,__globalThis) {
/**
 * @license @tabler/icons-react v3.40.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>IconHome);
var _createReactComponentMjs = require("../createReactComponent.mjs");
var _createReactComponentMjsDefault = parcelHelpers.interopDefault(_createReactComponentMjs);
const __iconNode = [
    [
        "path",
        {
            "d": "M5 12l-2 0l9 -9l9 9l-2 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6",
            "key": "svg-2"
        }
    ]
];
const IconHome = (0, _createReactComponentMjsDefault.default)("outline", "home", "Home", __iconNode);

},{"../createReactComponent.mjs":"kPvhJ","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"2G8Vd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SidebarNavLink);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
var _wouter = require("wouter");
var _adminNavContext = require("@/features/admin/contexts/AdminNavContext");
function SidebarNavLink(t0) {
    const $ = (0, _compilerRuntime.c)(9);
    const { href, label, icon } = t0;
    const [isActive] = (0, _wouter.useRoute)(href);
    const [, setLocation] = (0, _wouter.useLocation)();
    const { closeMobileNav } = (0, _adminNavContext.useAdminNav)();
    let t1;
    if ($[0] !== closeMobileNav || $[1] !== href || $[2] !== setLocation) {
        t1 = ()=>{
            setLocation(href);
            closeMobileNav();
        };
        $[0] = closeMobileNav;
        $[1] = href;
        $[2] = setLocation;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== handleClick || $[5] !== icon || $[6] !== isActive || $[7] !== label) {
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.NavLink), {
            label: label,
            leftSection: icon,
            active: isActive,
            onClick: handleClick
        });
        $[4] = handleClick;
        $[5] = icon;
        $[6] = isActive;
        $[7] = label;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":"cZuII","wouter":"3dLPT","@/features/admin/contexts/AdminNavContext":"dAN6f","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"cZuII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("@mantine/hooks");
var _remMjs = require("../../core/utils/units-converters/rem.mjs");
var _react = require("react");
var _getSizeMjs = require("../../core/utils/get-size/get-size.mjs");
var _createVarsResolverMjs = require("../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs");
var _clsx = require("clsx");
var _mantineContextMjs = require("../../core/MantineProvider/Mantine.context.mjs");
var _defaultThemeMjs = require("../../core/MantineProvider/default-theme.mjs");
var _mantineProviderMjs = require("../../core/MantineProvider/MantineProvider.mjs");
var _mantineThemeProviderMjs = require("../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs");
var _usePropsMjs = require("../../core/MantineProvider/use-props/use-props.mjs");
var _mantineCssVariablesMjs = require("../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs");
var _useStylesMjs = require("../../core/styles-api/use-styles/use-styles.mjs");
var _boxMjs = require("../../core/Box/Box.mjs");
var _polymorphicFactoryMjs = require("../../core/factory/polymorphic-factory.mjs");
var _directionProviderMjs = require("../../core/DirectionProvider/DirectionProvider.mjs");
var _accordionMjs = require("../Accordion/Accordion.mjs");
var _accordionChevronMjs = require("../Accordion/AccordionChevron.mjs");
var _accordionItemMjs = require("../Accordion/AccordionItem/AccordionItem.mjs");
var _accordionPanelMjs = require("../Accordion/AccordionPanel/AccordionPanel.mjs");
var _accordionControlMjs = require("../Accordion/AccordionControl/AccordionControl.mjs");
var _collapseMjs = require("../Collapse/Collapse.mjs");
var _unstyledButtonMjs = require("../UnstyledButton/UnstyledButton.mjs");
var _navLinkModuleCssMjs = require("./NavLink.module.css.mjs");
var _navLinkModuleCssMjsDefault = parcelHelpers.interopDefault(_navLinkModuleCssMjs);
'use client';
const varsResolver = (0, _createVarsResolverMjs.createVarsResolver)((theme, { variant, color, childrenOffset, autoContrast })=>{
    const colors = theme.variantColorResolver({
        color: color || theme.primaryColor,
        theme,
        variant: variant || "light",
        autoContrast
    });
    return {
        root: {
            "--nl-bg": color || variant ? colors.background : void 0,
            "--nl-hover": color || variant ? colors.hover : void 0,
            "--nl-color": color || variant ? colors.color : void 0
        },
        children: {
            "--nl-offset": (0, _getSizeMjs.getSpacing)(childrenOffset)
        }
    };
});
const NavLink = (0, _polymorphicFactoryMjs.polymorphicFactory)((_props, ref)=>{
    const props = (0, _usePropsMjs.useProps)("NavLink", null, _props);
    const { classNames, className, style, styles, unstyled, vars, opened, defaultOpened, onChange, children, active, disabled, leftSection, rightSection, label, description, disableRightSectionRotation, noWrap, childrenOffset, autoContrast, mod, attributes, onClick, onKeyDown, ...others } = props;
    const getStyles = (0, _useStylesMjs.useStyles)({
        name: "NavLink",
        props,
        classes: (0, _navLinkModuleCssMjsDefault.default),
        className,
        style,
        classNames,
        styles,
        unstyled,
        attributes,
        vars,
        varsResolver
    });
    const [_opened, setOpened] = (0, _hooks.useUncontrolled)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange
    });
    const withChildren = !!children;
    const handleClick = (event)=>{
        onClick?.(event);
        if (withChildren) {
            event.preventDefault();
            setOpened(!_opened);
        }
    };
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _unstyledButtonMjs.UnstyledButton), {
                ...getStyles("root"),
                component: "a",
                ref,
                onClick: handleClick,
                onKeyDown: (event)=>{
                    onKeyDown?.(event);
                    if (event.nativeEvent.code === "Space" && withChildren) {
                        event.preventDefault();
                        setOpened(!_opened);
                    }
                },
                unstyled,
                mod: [
                    {
                        disabled,
                        active,
                        expanded: _opened
                    },
                    mod
                ],
                ...others,
                children: [
                    leftSection && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        component: "span",
                        ...getStyles("section"),
                        mod: {
                            position: "left"
                        },
                        children: leftSection
                    }),
                    /* @__PURE__ */ (0, _jsxRuntime.jsxs)((0, _boxMjs.Box), {
                        ...getStyles("body"),
                        mod: {
                            "no-wrap": noWrap
                        },
                        children: [
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                                component: "span",
                                ...getStyles("label"),
                                children: label
                            }),
                            /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                                component: "span",
                                mod: {
                                    active
                                },
                                ...getStyles("description"),
                                children: description
                            })
                        ]
                    }),
                    (withChildren || rightSection !== void 0) && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _boxMjs.Box), {
                        ...getStyles("section"),
                        component: "span",
                        mod: {
                            rotate: _opened && !disableRightSectionRotation,
                            position: "right"
                        },
                        children: withChildren ? rightSection !== void 0 ? rightSection : /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _accordionChevronMjs.AccordionChevron), {
                            ...getStyles("chevron")
                        }) : rightSection
                    })
                ]
            }),
            withChildren && /* @__PURE__ */ (0, _jsxRuntime.jsx)((0, _collapseMjs.Collapse), {
                in: _opened,
                ...getStyles("collapse"),
                children: /* @__PURE__ */ (0, _jsxRuntime.jsx)("div", {
                    ...getStyles("children"),
                    children
                })
            })
        ]
    });
});
NavLink.classes = (0, _navLinkModuleCssMjsDefault.default);
NavLink.displayName = "@mantine/core/NavLink";

},{"react/jsx-runtime":"1xKTF","@mantine/hooks":"bBNEa","../../core/utils/units-converters/rem.mjs":"c70Xm","react":"erQJb","../../core/utils/get-size/get-size.mjs":"giXTO","../../core/styles-api/create-vars-resolver/create-vars-resolver.mjs":"b5eiH","clsx":"9idv4","../../core/MantineProvider/Mantine.context.mjs":"7oXOX","../../core/MantineProvider/default-theme.mjs":"ixgDZ","../../core/MantineProvider/MantineProvider.mjs":"2TSc8","../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs":"bajsd","../../core/MantineProvider/use-props/use-props.mjs":"kSa6M","../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs":"iF9wl","../../core/styles-api/use-styles/use-styles.mjs":"8urVe","../../core/Box/Box.mjs":"eq62v","../../core/factory/polymorphic-factory.mjs":"etaNf","../../core/DirectionProvider/DirectionProvider.mjs":"dNrdm","../Accordion/Accordion.mjs":"6Duak","../Accordion/AccordionChevron.mjs":"9DHGI","../Accordion/AccordionItem/AccordionItem.mjs":"bLLQb","../Accordion/AccordionPanel/AccordionPanel.mjs":"k4IxN","../Accordion/AccordionControl/AccordionControl.mjs":"biFyC","../Collapse/Collapse.mjs":"h2G66","../UnstyledButton/UnstyledButton.mjs":"55gpk","./NavLink.module.css.mjs":"c4uqx","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"c4uqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classes);
'use client';
var classes = {
    "root": "m_f0824112",
    "description": "m_57492dcc",
    "section": "m_690090b5",
    "label": "m_1f6ac4c4",
    "body": "m_f07af9d2",
    "children": "m_e17b862f",
    "chevron": "m_1fd8a00b"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"dAN6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdminNavProvider", ()=>AdminNavProvider);
parcelHelpers.export(exports, "useAdminNav", ()=>useAdminNav);
var _react = require("react");
const AdminNavContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AdminNavProvider = AdminNavContext.Provider;
function useAdminNav() {
    const context = (0, _react.useContext)(AdminNavContext);
    if (!context) throw new Error("useAdminNav must be used within AdminNavProvider");
    return context;
}

},{"react":"erQJb","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"ffS8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillAndCenter);
var _jsxRuntime = require("react/jsx-runtime");
var _compilerRuntime = require("react/compiler-runtime");
var _core = require("@mantine/core");
function FillAndCenter(t0) {
    const $ = (0, _compilerRuntime.c)(3);
    const { children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            position: "absolute",
            inset: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Box), {
            style: t1,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.Center), {
                h: "100%",
                children: children
            })
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
}

},{"react/jsx-runtime":"1xKTF","react/compiler-runtime":"6JKhP","@mantine/core":[["Box","eq62v"],["Center","haski"]],"@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"7J6Ue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAdminEventDataStore", ()=>useAdminEventDataStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _adminApi = require("@/shared/api/AdminApi");
const useAdminEventDataStore = (0, _zustand.create)()((0, _middleware.persist)((set, get)=>({
        // Initial state
        selectedEventId: null,
        events: [],
        submissions: {},
        composites: {},
        queueJobs: {},
        dataArchives: {},
        lastFetchTimestamp: null,
        isLoading: false,
        error: null,
        pollingTimeoutId: null,
        // Event selection
        setSelectedEventId: (eventId)=>{
            set({
                selectedEventId: eventId
            });
            get().clear();
            get().fetchChanges();
        },
        // Fetch event list
        fetchEventList: async ()=>{
            try {
                const response = await (0, _adminApi.fetchEvents)();
                set({
                    events: response.events
                });
            } catch (error) {
                console.error("Failed to fetch events:", error);
            }
        },
        // Archive current event
        archiveEvent: async (name)=>{
            set({
                isLoading: true,
                error: null
            });
            try {
                const response = await (0, _adminApi.createEvent)(name);
                if (!response.event) throw new Error("No event returned from archive");
                set((state)=>({
                        events: [
                            response.event,
                            ...state.events
                        ],
                        isLoading: false
                    }));
                get().clear();
                return response.event;
            } catch (error) {
                set({
                    error: error instanceof Error ? error.message : "Failed to archive event",
                    isLoading: false
                });
                throw error;
            }
        },
        // Fetch only changes since last update
        fetchChanges: async ()=>{
            const state = get();
            const changesSince = state.lastFetchTimestamp ?? 0;
            const selectedEventId = state.selectedEventId;
            set({
                isLoading: true,
                error: null
            });
            try {
                const response = await (0, _adminApi.fetchAdminEventData)(changesSince, selectedEventId);
                if (get().pollingTimeoutId === null) return;
                set({
                    submissions: {
                        ...state.submissions,
                        ...Object.fromEntries(response.submissions.map((submission)=>[
                                submission.submission_id,
                                submission
                            ]))
                    },
                    composites: {
                        ...state.composites,
                        ...Object.fromEntries(response.composites.map((c)=>[
                                c.composite_id,
                                c
                            ]))
                    },
                    queueJobs: {
                        ...state.queueJobs,
                        ...Object.fromEntries(response.queue_jobs.map((j)=>[
                                j.queue_job_id,
                                j
                            ]))
                    },
                    dataArchives: {
                        ...state.dataArchives,
                        ...Object.fromEntries(response.data_archives.map((a)=>[
                                a.data_archive_id,
                                a
                            ]))
                    },
                    lastFetchTimestamp: response.metadata.timestamp,
                    isLoading: false
                });
            } catch (error) {
                set({
                    error: error instanceof Error ? error.message : "Failed to fetch changes",
                    isLoading: false
                });
            }
        },
        // Clear all data
        clear: ()=>{
            set({
                submissions: {},
                composites: {},
                queueJobs: {},
                dataArchives: {},
                lastFetchTimestamp: null,
                error: null
            });
        },
        // Start automatic polling
        startPolling: async ()=>{
            if (get().pollingTimeoutId !== null) return;
            const poll = async ()=>{
                await get().fetchChanges().catch((error)=>{
                    console.error("Failed to fetch changes during polling:", error);
                });
                if (get().pollingTimeoutId !== null) set({
                    pollingTimeoutId: setTimeout(poll, 5000)
                });
            };
            set({
                pollingTimeoutId: setTimeout(poll, 5000)
            });
            get().fetchChanges().catch((error)=>{
                console.error("Failed to fetch changes during polling:", error);
            });
        },
        // Stop automatic polling
        stopPolling: ()=>{
            const { pollingTimeoutId } = get();
            if (pollingTimeoutId !== null) {
                clearTimeout(pollingTimeoutId);
                set({
                    pollingTimeoutId: null
                });
            }
        },
        // Getters
        getSubmissionById: (submissionId)=>get().submissions[submissionId],
        getCompositeById: (compositeId)=>get().composites[compositeId],
        getQueueJobById: (jobId)=>get().queueJobs[jobId],
        getDataArchiveById: (id)=>get().dataArchives[id],
        removeDataArchive: (id)=>{
            set((state)=>{
                const next = {
                    ...state.dataArchives
                };
                delete next[id];
                return {
                    dataArchives: next
                };
            });
        },
        // Filtered getters
        getCompositesBySubmissionId: (submissionId)=>{
            return Object.values(get().composites).filter((comp)=>comp.submission_id === submissionId);
        }
    }), {
    name: "admin-event-data-store",
    partialize: (state)=>({
            selectedEventId: state.selectedEventId
        })
}));

},{"zustand":"fnNkQ","zustand/middleware":"jbOcO","@/shared/api/AdminApi":"10FIo","@parcel/transformer-js/src/esmodule-helpers.js":"8c1Nw"}],"jZifc":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("2dWnX"),
    import("68Ae9"),
    import("4XfdH")
]).then(()=>module.bundle.root('bTM3R'));

},{}],"dLZ70":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("68Ae9"),
    import("70BC0")
]).then(()=>module.bundle.root('ccVm5'));

},{}],"1vE0l":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("7aifV"),
    import("2dWnX"),
    import("4dcSb")
]).then(()=>module.bundle.root('ezCM5'));

},{}],"dQUU1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8q9ng"),
    import("jSnXj"),
    import("7aifV"),
    import("2dWnX"),
    import("919rI")
]).then(()=>module.bundle.root('jMqTx'));

},{}],"2KPu7":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jSnXj"),
    import("idHaJ")
]).then(()=>module.bundle.root('g4ZAt'));

},{}],"cPaHf":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("SRj60"),
    import("2Sj83")
]).then(()=>module.bundle.root('3Ko4B'));

},{}],"3P1Jb":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("jSnXj"),
    import("1yuW0")
]).then(()=>module.bundle.root('jKlYC'));

},{}],"1hmSF":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("SRj60"),
    import("8q9ng"),
    import("6Cpld")
]).then(()=>module.bundle.root('8ohrs'));

},{}],"7rAYb":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("68Ae9"),
    import("avEnC")
]).then(()=>module.bundle.root('g2Yk2'));

},{}],"kVNTm":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("8q9ng"),
    import("dcZxe")
]).then(()=>module.bundle.root('kXln3'));

},{}],"8E3pS":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("4a4e846a828fcb3e")(import.meta.resolve("Ip6Of")),
    import("hWaTU")
]).then(()=>module.bundle.root('cMh0N'));

},{"4a4e846a828fcb3e":"9m0te"}],"9m0te":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("bf72d7d7e0d4f9ce");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"bf72d7d7e0d4f9ce":"3mLUC"}],"3mLUC":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"goWE4":[function(require,module,exports,__globalThis) {
module.exports = import("bX8FC").then(()=>module.bundle.root('4ILbA'));

},{}]},["gDrcj"], "gDrcj", "parcelRequire15ac", {})

//# sourceMappingURL=frontend.ffda84a7.js.map
